var Lv = Object.defineProperty;
var Dv = Object.getPrototypeOf;
var Nv = Reflect.get;
var Ld = (e) => {
  throw TypeError(e);
};
var zv = (e, t, n) => t in e ? Lv(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Le = (e, t, n) => zv(e, typeof t != "symbol" ? t + "" : t, n), pu = (e, t, n) => t.has(e) || Ld("Cannot " + n);
var F = (e, t, n) => (pu(e, t, "read from private field"), n ? n.call(e) : t.get(e)), te = (e, t, n) => t.has(e) ? Ld("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Te = (e, t, n, r) => (pu(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), qt = (e, t, n) => (pu(e, t, "access private method"), n);
var hu = (e, t, n, r) => ({
  set _(a) {
    Te(e, t, a, n);
  },
  get _() {
    return F(e, t, r);
  }
}), Dd = (e, t, n) => Nv(Dv(e), n, t);
const Bt = Symbol(), Jp = "http://www.w3.org/2000/svg", Qp = !1;
var jl = Array.isArray, kc = Array.from, Vv = Object.defineProperty, pr = Object.getOwnPropertyDescriptor, $p = Object.getOwnPropertyDescriptors, Bv = Object.prototype, jv = Array.prototype, Os = Object.getPrototypeOf;
function ya(e) {
  return typeof e == "function";
}
const De = () => {
};
function Wv(e) {
  return e();
}
function Fu(e) {
  for (var t = 0; t < e.length; t++)
    e[t]();
}
const cn = 2, eh = 4, Uo = 8, Wl = 16, hn = 32, qo = 64, Ru = 128, ea = 256, Fs = 512, Wt = 1024, vr = 2048, $a = 4096, En = 8192, ei = 16384, th = 32768, ta = 65536, Hv = 1 << 17, Uv = 1 << 19, nh = 1 << 20, hr = Symbol("$state"), rh = Symbol("legacy props"), qv = Symbol("");
function ah(e) {
  return e === this.v;
}
function Hl(e, t) {
  return e != e ? t == t : e !== t || e !== null && typeof e == "object" || typeof e == "function";
}
function Gv(e, t) {
  return e !== t;
}
function Sc(e) {
  return !Hl(e, this.v);
}
function Kv(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Zv() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Yv(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Xv() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Jv(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function Qv() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function $v() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function em() {
  throw new Error("https://svelte.dev/e/state_unsafe_local_read");
}
function tm() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let ti = !1;
function nm() {
  ti = !0;
}
function Et(e) {
  return {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: ah,
    version: 0
  };
}
function de(e) {
  return /* @__PURE__ */ ih(Et(e));
}
// @__NO_SIDE_EFFECTS__
function Ul(e, t = !1) {
  var r;
  const n = Et(e);
  return t || (n.equals = Sc), ti && Ze !== null && Ze.l !== null && ((r = Ze.l).s ?? (r.s = [])).push(n), n;
}
function We(e, t = !1) {
  return /* @__PURE__ */ ih(/* @__PURE__ */ Ul(e, t));
}
// @__NO_SIDE_EFFECTS__
function ih(e) {
  return $e !== null && $e.f & cn && (Tn === null ? fm([e]) : Tn.push(e)), e;
}
function z(e, t) {
  return $e !== null && Zo() && $e.f & (cn | Wl) && // If the source was created locally within the current derived, then
  // we allow the mutation.
  (Tn === null || !Tn.includes(e)) && tm(), Lu(e, t);
}
function Lu(e, t) {
  return e.equals(t) || (e.v = t, e.version = Ch(), oh(e, vr), Zo() && Be !== null && Be.f & Wt && !(Be.f & hn) && (Lt !== null && Lt.includes(e) ? (yn(Be, vr), Yl(Be)) : yr === null ? pm([e]) : yr.push(e))), t;
}
function oh(e, t) {
  var n = e.reactions;
  if (n !== null)
    for (var r = Zo(), a = n.length, i = 0; i < a; i++) {
      var o = n[i], s = o.f;
      s & vr || !r && o === Be || (yn(o, t), s & (Wt | ea) && (s & cn ? oh(
        /** @type {Derived} */
        o,
        $a
      ) : Yl(
        /** @type {Effect} */
        o
      )));
    }
}
let sh = !1;
function oe(e, t = null, n) {
  if (typeof e != "object" || e === null || hr in e)
    return e;
  const r = Os(e);
  if (r !== Bv && r !== jv)
    return e;
  var a = /* @__PURE__ */ new Map(), i = jl(e), o = Et(0);
  i && a.set("length", Et(
    /** @type {any[]} */
    e.length
  ));
  var s;
  return new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, u, d) {
        (!("value" in d) || d.configurable === !1 || d.enumerable === !1 || d.writable === !1) && Qv();
        var f = a.get(u);
        return f === void 0 ? (f = Et(d.value), a.set(u, f)) : z(f, oe(d.value, s)), !0;
      },
      deleteProperty(l, u) {
        var d = a.get(u);
        if (d === void 0)
          u in l && a.set(u, Et(Bt));
        else {
          if (i && typeof u == "string") {
            var f = (
              /** @type {Source<number>} */
              a.get("length")
            ), p = Number(u);
            Number.isInteger(p) && p < f.v && z(f, p);
          }
          z(d, Bt), Nd(o);
        }
        return !0;
      },
      get(l, u, d) {
        var y;
        if (u === hr)
          return e;
        var f = a.get(u), p = u in l;
        if (f === void 0 && (!p || (y = pr(l, u)) != null && y.writable) && (f = Et(oe(p ? l[u] : Bt, s)), a.set(u, f)), f !== void 0) {
          var h = c(f);
          return h === Bt ? void 0 : h;
        }
        return Reflect.get(l, u, d);
      },
      getOwnPropertyDescriptor(l, u) {
        var d = Reflect.getOwnPropertyDescriptor(l, u);
        if (d && "value" in d) {
          var f = a.get(u);
          f && (d.value = c(f));
        } else if (d === void 0) {
          var p = a.get(u), h = p == null ? void 0 : p.v;
          if (p !== void 0 && h !== Bt)
            return {
              enumerable: !0,
              configurable: !0,
              value: h,
              writable: !0
            };
        }
        return d;
      },
      has(l, u) {
        var h;
        if (u === hr)
          return !0;
        var d = a.get(u), f = d !== void 0 && d.v !== Bt || Reflect.has(l, u);
        if (d !== void 0 || Be !== null && (!f || (h = pr(l, u)) != null && h.writable)) {
          d === void 0 && (d = Et(f ? oe(l[u], s) : Bt), a.set(u, d));
          var p = c(d);
          if (p === Bt)
            return !1;
        }
        return f;
      },
      set(l, u, d, f) {
        var C;
        var p = a.get(u), h = u in l;
        if (i && u === "length")
          for (var y = d; y < /** @type {Source<number>} */
          p.v; y += 1) {
            var g = a.get(y + "");
            g !== void 0 ? z(g, Bt) : y in l && (g = Et(Bt), a.set(y + "", g));
          }
        p === void 0 ? (!h || (C = pr(l, u)) != null && C.writable) && (p = Et(void 0), z(p, oe(d, s)), a.set(u, p)) : (h = p.v !== Bt, z(p, oe(d, s)));
        var w = Reflect.getOwnPropertyDescriptor(l, u);
        if (w != null && w.set && w.set.call(f, d), !h) {
          if (i && typeof u == "string") {
            var m = (
              /** @type {Source<number>} */
              a.get("length")
            ), v = Number(u);
            Number.isInteger(v) && v >= m.v && z(m, v + 1);
          }
          Nd(o);
        }
        return !0;
      },
      ownKeys(l) {
        c(o);
        var u = Reflect.ownKeys(l).filter((p) => {
          var h = a.get(p);
          return h === void 0 || h.v !== Bt;
        });
        for (var [d, f] of a)
          f.v !== Bt && !(d in l) && u.push(d);
        return u;
      },
      setPrototypeOf() {
        $v();
      }
    }
  );
}
function Nd(e, t = 1) {
  z(e, e.v + t);
}
var Ti, lh, uh;
function rm() {
  if (Ti === void 0) {
    Ti = window;
    var e = Element.prototype, t = Node.prototype;
    lh = pr(t, "firstChild").get, uh = pr(t, "nextSibling").get, e.__click = void 0, e.__className = "", e.__attributes = null, e.__styles = null, e.__e = void 0, Text.prototype.__t = void 0;
  }
}
function Go(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function Ur(e) {
  return lh.call(e);
}
// @__NO_SIDE_EFFECTS__
function ql(e) {
  return uh.call(e);
}
function T(e, t) {
  return /* @__PURE__ */ Ur(e);
}
function V(e, t) {
  {
    var n = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ Ur(
        /** @type {Node} */
        e
      )
    );
    return n instanceof Comment && n.data === "" ? /* @__PURE__ */ ql(n) : n;
  }
}
function Q(e, t = 1, n = !1) {
  let r = e;
  for (; t--; )
    r = /** @type {TemplateNode} */
    /* @__PURE__ */ ql(r);
  return r;
}
function am(e) {
  e.textContent = "";
}
// @__NO_SIDE_EFFECTS__
function R(e) {
  var t = cn | vr;
  Be === null ? t |= ea : Be.f |= nh;
  var n = $e !== null && $e.f & cn ? (
    /** @type {Derived} */
    $e
  ) : null;
  const r = {
    children: null,
    ctx: Ze,
    deps: null,
    equals: ah,
    f: t,
    fn: e,
    reactions: null,
    v: (
      /** @type {V} */
      null
    ),
    version: 0,
    parent: n ?? Be
  };
  return n !== null && (n.children ?? (n.children = [])).push(r), r;
}
// @__NO_SIDE_EFFECTS__
function St(e) {
  const t = /* @__PURE__ */ R(e);
  return t.equals = Sc, t;
}
function ch(e) {
  var t = e.children;
  if (t !== null) {
    e.children = null;
    for (var n = 0; n < t.length; n += 1) {
      var r = t[n];
      r.f & cn ? Cc(
        /** @type {Derived} */
        r
      ) : Fn(
        /** @type {Effect} */
        r
      );
    }
  }
}
function im(e) {
  for (var t = e.parent; t !== null; ) {
    if (!(t.f & cn))
      return (
        /** @type {Effect} */
        t
      );
    t = t.parent;
  }
  return null;
}
function dh(e) {
  var t, n = Be;
  Zt(im(e));
  try {
    ch(e), t = Eh(e);
  } finally {
    Zt(n);
  }
  return t;
}
function fh(e) {
  var t = dh(e), n = (Lr || e.f & ea) && e.deps !== null ? $a : Wt;
  yn(e, n), e.equals(t) || (e.v = t, e.version = Ch());
}
function Cc(e) {
  ch(e), Fi(e, 0), yn(e, ei), e.v = e.children = e.deps = e.ctx = e.reactions = null;
}
function ph(e) {
  Be === null && $e === null && Yv(), $e !== null && $e.f & ea && Zv(), Tc && Kv();
}
function om(e, t) {
  var n = t.last;
  n === null ? t.last = t.first = e : (n.next = e, e.prev = n, t.last = e);
}
function ni(e, t, n, r = !0) {
  var a = (e & qo) !== 0, i = Be, o = {
    ctx: Ze,
    deps: null,
    deriveds: null,
    nodes_start: null,
    nodes_end: null,
    f: e | vr,
    first: null,
    fn: t,
    last: null,
    next: null,
    parent: a ? null : i,
    prev: null,
    teardown: null,
    transitions: null,
    version: 0
  };
  if (n) {
    var s = wa;
    try {
      zd(!0), Yo(o), o.f |= th;
    } catch (d) {
      throw Fn(o), d;
    } finally {
      zd(s);
    }
  } else t !== null && Yl(o);
  var l = n && o.deps === null && o.first === null && o.nodes_start === null && o.teardown === null && (o.f & nh) === 0;
  if (!l && !a && r && (i !== null && om(o, i), $e !== null && $e.f & cn)) {
    var u = (
      /** @type {Derived} */
      $e
    );
    (u.children ?? (u.children = [])).push(o);
  }
  return o;
}
function sm() {
  return $e === null ? !1 : !Lr;
}
function hh(e) {
  const t = ni(Uo, null, !1);
  return yn(t, Wt), t.teardown = e, t;
}
function Se(e) {
  ph();
  var t = Be !== null && (Be.f & hn) !== 0 && Ze !== null && !Ze.m;
  if (t) {
    var n = (
      /** @type {ComponentContext} */
      Ze
    );
    (n.e ?? (n.e = [])).push({
      fn: e,
      effect: Be,
      reaction: $e
    });
  } else {
    var r = ri(e);
    return r;
  }
}
function lm(e) {
  return ph(), ai(e);
}
function yh(e) {
  const t = ni(qo, e, !0);
  return () => {
    Fn(t);
  };
}
function ri(e) {
  return ni(eh, e, !1);
}
function Xe(e, t, n, r) {
  var a = (
    /** @type {ComponentContextLegacy} */
    Ze
  ), i = { effect: null, ran: !1 };
  a.l.r1.push(i), i.effect = ai(() => {
    e(), !i.ran && (i.ran = !0, z(a.l.r2, !0), _t(t));
  });
}
function Gl() {
  var e = (
    /** @type {ComponentContextLegacy} */
    Ze
  );
  ai(() => {
    if (c(e.l.r2)) {
      for (var t of e.l.r1) {
        var n = t.effect;
        n.f & Wt && yn(n, $a), ii(n) && Yo(n), t.ran = !1;
      }
      e.l.r2.v = !1;
    }
  });
}
function ai(e) {
  return ni(Uo, e, !0);
}
function ee(e) {
  return Cr(e);
}
function Cr(e, t = 0) {
  return ni(Uo | Wl | t, e, !0);
}
function Mn(e, t = !0) {
  return ni(Uo | hn, e, !0, t);
}
function gh(e) {
  var t = e.teardown;
  if (t !== null) {
    const n = Tc, r = $e;
    Vd(!0), an(null);
    try {
      t.call(null);
    } finally {
      Vd(n), an(r);
    }
  }
}
function vh(e) {
  var t = e.deriveds;
  if (t !== null) {
    e.deriveds = null;
    for (var n = 0; n < t.length; n += 1)
      Cc(t[n]);
  }
}
function mh(e, t = !1) {
  var n = e.first;
  for (e.first = e.last = null; n !== null; ) {
    var r = n.next;
    Fn(n, t), n = r;
  }
}
function um(e) {
  for (var t = e.first; t !== null; ) {
    var n = t.next;
    t.f & hn || Fn(t), t = n;
  }
}
function Fn(e, t = !0) {
  var n = !1;
  if ((t || e.f & Uv) && e.nodes_start !== null) {
    for (var r = e.nodes_start, a = e.nodes_end; r !== null; ) {
      var i = r === a ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ql(r)
      );
      r.remove(), r = i;
    }
    n = !0;
  }
  mh(e, t && !n), vh(e), Fi(e, 0), yn(e, ei);
  var o = e.transitions;
  if (o !== null)
    for (const l of o)
      l.stop();
  gh(e);
  var s = e.parent;
  s !== null && s.first !== null && wh(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function wh(e) {
  var t = e.parent, n = e.prev, r = e.next;
  n !== null && (n.next = r), r !== null && (r.prev = n), t !== null && (t.first === e && (t.first = r), t.last === e && (t.last = n));
}
function Ua(e, t) {
  var n = [];
  Ec(e, n, !0), bh(n, () => {
    Fn(e), t && t();
  });
}
function bh(e, t) {
  var n = e.length;
  if (n > 0) {
    var r = () => --n || t();
    for (var a of e)
      a.out(r);
  } else
    t();
}
function Ec(e, t, n) {
  if (!(e.f & En)) {
    if (e.f ^= En, e.transitions !== null)
      for (const o of e.transitions)
        (o.is_global || n) && t.push(o);
    for (var r = e.first; r !== null; ) {
      var a = r.next, i = (r.f & ta) !== 0 || (r.f & hn) !== 0;
      Ec(r, t, i ? n : !1), r = a;
    }
  }
}
function Mi(e) {
  _h(e, !0);
}
function _h(e, t) {
  if (e.f & En) {
    ii(e) && Yo(e), e.f ^= En;
    for (var n = e.first; n !== null; ) {
      var r = n.next, a = (n.f & ta) !== 0 || (n.f & hn) !== 0;
      _h(n, a ? t : !1), n = r;
    }
    if (e.transitions !== null)
      for (const i of e.transitions)
        (i.is_global || t) && i.in();
  }
}
let Rs = !1, Du = [];
function xh() {
  Rs = !1;
  const e = Du.slice();
  Du = [], Fu(e);
}
function Ko(e) {
  Rs || (Rs = !0, queueMicrotask(xh)), Du.push(e);
}
function cm() {
  Rs && xh();
}
function Kl(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
const kh = 0, dm = 1;
let _s = !1, xs = kh, Ii = !1, Oi = null, wa = !1, Tc = !1;
function zd(e) {
  wa = e;
}
function Vd(e) {
  Tc = e;
}
let Rr = [], ba = 0;
let $e = null;
function an(e) {
  $e = e;
}
let Be = null;
function Zt(e) {
  Be = e;
}
let Tn = null;
function fm(e) {
  Tn = e;
}
let Lt = null, Xt = 0, yr = null;
function pm(e) {
  yr = e;
}
let Sh = 0, Lr = !1, Ze = null;
function Ch() {
  return ++Sh;
}
function Zo() {
  return !ti || Ze !== null && Ze.l === null;
}
function ii(e) {
  var o, s;
  var t = e.f;
  if (t & vr)
    return !0;
  if (t & $a) {
    var n = e.deps, r = (t & ea) !== 0;
    if (n !== null) {
      var a;
      if (t & Fs) {
        for (a = 0; a < n.length; a++)
          ((o = n[a]).reactions ?? (o.reactions = [])).push(e);
        e.f ^= Fs;
      }
      for (a = 0; a < n.length; a++) {
        var i = n[a];
        if (ii(
          /** @type {Derived} */
          i
        ) && fh(
          /** @type {Derived} */
          i
        ), r && Be !== null && !Lr && !((s = i == null ? void 0 : i.reactions) != null && s.includes(e)) && (i.reactions ?? (i.reactions = [])).push(e), i.version > e.version)
          return !0;
      }
    }
    r || yn(e, Wt);
  }
  return !1;
}
function hm(e, t) {
  for (var n = t; n !== null; ) {
    if (n.f & Ru)
      try {
        n.fn(e);
        return;
      } catch {
        n.f ^= Ru;
      }
    n = n.parent;
  }
  throw _s = !1, e;
}
function ym(e) {
  return (e.f & ei) === 0 && (e.parent === null || (e.parent.f & Ru) === 0);
}
function Zl(e, t, n, r) {
  if (_s) {
    if (n === null && (_s = !1), ym(t))
      throw e;
    return;
  }
  n !== null && (_s = !0);
  {
    hm(e, t);
    return;
  }
}
function Eh(e) {
  var p;
  var t = Lt, n = Xt, r = yr, a = $e, i = Lr, o = Tn, s = Ze, l = e.f;
  Lt = /** @type {null | Value[]} */
  null, Xt = 0, yr = null, $e = l & (hn | qo) ? null : e, Lr = !wa && (l & ea) !== 0, Tn = null, Ze = e.ctx;
  try {
    var u = (
      /** @type {Function} */
      (0, e.fn)()
    ), d = e.deps;
    if (Lt !== null) {
      var f;
      if (Fi(e, Xt), d !== null && Xt > 0)
        for (d.length = Xt + Lt.length, f = 0; f < Lt.length; f++)
          d[Xt + f] = Lt[f];
      else
        e.deps = d = Lt;
      if (!Lr)
        for (f = Xt; f < d.length; f++)
          ((p = d[f]).reactions ?? (p.reactions = [])).push(e);
    } else d !== null && Xt < d.length && (Fi(e, Xt), d.length = Xt);
    return u;
  } finally {
    Lt = t, Xt = n, yr = r, $e = a, Lr = i, Tn = o, Ze = s;
  }
}
function gm(e, t) {
  let n = t.reactions;
  if (n !== null) {
    var r = n.indexOf(e);
    if (r !== -1) {
      var a = n.length - 1;
      a === 0 ? n = t.reactions = null : (n[r] = n[a], n.pop());
    }
  }
  n === null && t.f & cn && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Lt === null || !Lt.includes(t)) && (yn(t, $a), t.f & (ea | Fs) || (t.f ^= Fs), Fi(
    /** @type {Derived} **/
    t,
    0
  ));
}
function Fi(e, t) {
  var n = e.deps;
  if (n !== null)
    for (var r = t; r < n.length; r++)
      gm(e, n[r]);
}
function Yo(e) {
  var t = e.f;
  if (!(t & ei)) {
    yn(e, Wt);
    var n = Be, r = Ze;
    Be = e;
    try {
      t & Wl ? um(e) : mh(e), vh(e), gh(e);
      var a = Eh(e);
      e.teardown = typeof a == "function" ? a : null, e.version = Sh;
    } catch (i) {
      Zl(i, e, n, r || e.ctx);
    } finally {
      Be = n;
    }
  }
}
function Th() {
  if (ba > 1e3) {
    ba = 0;
    try {
      Xv();
    } catch (e) {
      if (Oi !== null)
        Zl(e, Oi, null);
      else
        throw e;
    }
  }
  ba++;
}
function Ah(e) {
  var t = e.length;
  if (t !== 0) {
    Th();
    var n = wa;
    wa = !0;
    try {
      for (var r = 0; r < t; r++) {
        var a = e[r];
        a.f & Wt || (a.f ^= Wt);
        var i = [];
        Ph(a, i), vm(i);
      }
    } finally {
      wa = n;
    }
  }
}
function vm(e) {
  var t = e.length;
  if (t !== 0)
    for (var n = 0; n < t; n++) {
      var r = e[n];
      if (!(r.f & (ei | En)))
        try {
          ii(r) && (Yo(r), r.deps === null && r.first === null && r.nodes_start === null && (r.teardown === null ? wh(r) : r.fn = null));
        } catch (a) {
          Zl(a, r, null, r.ctx);
        }
    }
}
function mm() {
  if (Ii = !1, ba > 1001)
    return;
  const e = Rr;
  Rr = [], Ah(e), Ii || (ba = 0, Oi = null);
}
function Yl(e) {
  xs === kh && (Ii || (Ii = !0, queueMicrotask(mm))), Oi = e;
  for (var t = e; t.parent !== null; ) {
    t = t.parent;
    var n = t.f;
    if (n & (qo | hn)) {
      if (!(n & Wt)) return;
      t.f ^= Wt;
    }
  }
  Rr.push(t);
}
function Ph(e, t) {
  var n = e.first, r = [];
  e: for (; n !== null; ) {
    var a = n.f, i = (a & hn) !== 0, o = i && (a & Wt) !== 0, s = n.next;
    if (!o && !(a & En))
      if (a & Uo) {
        if (i)
          n.f ^= Wt;
        else
          try {
            ii(n) && Yo(n);
          } catch (f) {
            Zl(f, n, null, n.ctx);
          }
        var l = n.first;
        if (l !== null) {
          n = l;
          continue;
        }
      } else a & eh && r.push(n);
    if (s === null) {
      let f = n.parent;
      for (; f !== null; ) {
        if (e === f)
          break e;
        var u = f.next;
        if (u !== null) {
          n = u;
          continue e;
        }
        f = f.parent;
      }
    }
    n = s;
  }
  for (var d = 0; d < r.length; d++)
    l = r[d], t.push(l), Ph(l, t);
}
function Mh(e) {
  var t = xs, n = Rr;
  try {
    Th();
    const a = [];
    xs = dm, Rr = a, Ii = !1, Ah(n);
    var r = e == null ? void 0 : e();
    return cm(), (Rr.length > 0 || a.length > 0) && Mh(), ba = 0, Oi = null, r;
  } finally {
    xs = t, Rr = n;
  }
}
async function Ac() {
  await Promise.resolve(), Mh();
}
function c(e) {
  var d;
  var t = e.f, n = (t & cn) !== 0;
  if (n && t & ei) {
    var r = dh(
      /** @type {Derived} */
      e
    );
    return Cc(
      /** @type {Derived} */
      e
    ), r;
  }
  if ($e !== null) {
    Tn !== null && Tn.includes(e) && em();
    var a = $e.deps;
    Lt === null && a !== null && a[Xt] === e ? Xt++ : Lt === null ? Lt = [e] : Lt.push(e), yr !== null && Be !== null && Be.f & Wt && !(Be.f & hn) && yr.includes(e) && (yn(Be, vr), Yl(Be));
  } else if (n && /** @type {Derived} */
  e.deps === null)
    for (var i = (
      /** @type {Derived} */
      e
    ), o = i.parent, s = i; o !== null; )
      if (o.f & cn) {
        var l = (
          /** @type {Derived} */
          o
        );
        s = l, o = l.parent;
      } else {
        var u = (
          /** @type {Effect} */
          o
        );
        (d = u.deriveds) != null && d.includes(s) || (u.deriveds ?? (u.deriveds = [])).push(s);
        break;
      }
  return n && (i = /** @type {Derived} */
  e, ii(i) && fh(i)), e.v;
}
function _t(e) {
  const t = $e;
  try {
    return $e = null, e();
  } finally {
    $e = t;
  }
}
const wm = ~(vr | $a | Wt);
function yn(e, t) {
  e.f = e.f & wm | t;
}
function Xl(e) {
  return (
    /** @type {T} */
    Jl().get(e)
  );
}
function Ih(e, t) {
  return Jl().set(e, t), t;
}
function bm(e) {
  return Jl().has(e);
}
function _m() {
  return Jl();
}
function Jl(e) {
  return Ze === null && Kl(), Ze.c ?? (Ze.c = new Map(xm(Ze) || void 0));
}
function xm(e) {
  let t = e.p;
  for (; t !== null; ) {
    const n = t.c;
    if (n !== null)
      return n;
    t = t.p;
  }
  return null;
}
function Nu(e, t = 1) {
  var n = c(e), r = t === 1 ? n++ : n--;
  return z(e, n), r;
}
function be(e, t = !1, n) {
  Ze = {
    p: Ze,
    c: null,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  }, ti && !t && (Ze.l = {
    s: null,
    u: null,
    r1: [],
    r2: Et(!1)
  });
}
function _e(e) {
  const t = Ze;
  if (t !== null) {
    const o = t.e;
    if (o !== null) {
      var n = Be, r = $e;
      t.e = null;
      try {
        for (var a = 0; a < o.length; a++) {
          var i = o[a];
          Zt(i.effect), an(i.reaction), ri(i.fn);
        }
      } finally {
        Zt(n), an(r);
      }
    }
    Ze = t.p, t.m = !0;
  }
  return (
    /** @type {T} */
    {}
  );
}
function Qe(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (hr in e)
      zu(e);
    else if (!Array.isArray(e))
      for (let t in e) {
        const n = e[t];
        typeof n == "object" && n && hr in n && zu(n);
      }
  }
}
function zu(e, t = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !t.has(e)) {
    t.add(e), e instanceof Date && e.getTime();
    for (let r in e)
      try {
        zu(e[r], t);
      } catch {
      }
    const n = Os(e);
    if (n !== Object.prototype && n !== Array.prototype && n !== Map.prototype && n !== Set.prototype && n !== Date.prototype) {
      const r = $p(n);
      for (let a in r) {
        const i = r[a].get;
        if (i)
          try {
            i.call(e);
          } catch {
          }
      }
    }
  }
}
function km(e, t) {
  if (t) {
    const n = document.body;
    e.autofocus = !0, Ko(() => {
      document.activeElement === n && e.focus();
    });
  }
}
let Bd = !1;
function Sm() {
  Bd || (Bd = !0, document.addEventListener(
    "reset",
    (e) => {
      Promise.resolve().then(() => {
        var t;
        if (!e.defaultPrevented)
          for (
            const n of
            /**@type {HTMLFormElement} */
            e.target.elements
          )
            (t = n.__on_r) == null || t.call(n);
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function Oh(e) {
  var t = $e, n = Be;
  an(null), Zt(null);
  try {
    return e();
  } finally {
    an(t), Zt(n);
  }
}
function Cm(e, t, n, r = n) {
  e.addEventListener(t, () => Oh(n));
  const a = e.__on_r;
  a ? e.__on_r = () => {
    a(), r(!0);
  } : e.__on_r = () => r(!0), Sm();
}
const Fh = /* @__PURE__ */ new Set(), Vu = /* @__PURE__ */ new Set();
function Rh(e, t, n, r) {
  function a(i) {
    if (r.capture || ki.call(t, i), !i.cancelBubble)
      return Oh(() => n.call(this, i));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? Ko(() => {
    t.addEventListener(e, a, r);
  }) : t.addEventListener(e, a, r), a;
}
function ct(e, t, n, r, a) {
  var i = { capture: r, passive: a }, o = Rh(e, t, n, i);
  (t === document.body || t === window || t === document) && hh(() => {
    t.removeEventListener(e, o, i);
  });
}
function Er(e) {
  for (var t = 0; t < e.length; t++)
    Fh.add(e[t]);
  for (var n of Vu)
    n(e);
}
function ki(e) {
  var v;
  var t = this, n = (
    /** @type {Node} */
    t.ownerDocument
  ), r = e.type, a = ((v = e.composedPath) == null ? void 0 : v.call(e)) || [], i = (
    /** @type {null | Element} */
    a[0] || e.target
  ), o = 0, s = e.__root;
  if (s) {
    var l = a.indexOf(s);
    if (l !== -1 && (t === document || t === /** @type {any} */
    window)) {
      e.__root = t;
      return;
    }
    var u = a.indexOf(t);
    if (u === -1)
      return;
    l <= u && (o = l);
  }
  if (i = /** @type {Element} */
  a[o] || e.target, i !== t) {
    Vv(e, "currentTarget", {
      configurable: !0,
      get() {
        return i || n;
      }
    });
    var d = $e, f = Be;
    an(null), Zt(null);
    try {
      for (var p, h = []; i !== null; ) {
        var y = i.assignedSlot || i.parentNode || /** @type {any} */
        i.host || null;
        try {
          var g = i["__" + r];
          if (g !== void 0 && !/** @type {any} */
          i.disabled)
            if (jl(g)) {
              var [w, ...m] = g;
              w.apply(i, [e, ...m]);
            } else
              g.call(i, e);
        } catch (C) {
          p ? h.push(C) : p = C;
        }
        if (e.cancelBubble || y === t || y === null)
          break;
        i = y;
      }
      if (p) {
        for (let C of h)
          queueMicrotask(() => {
            throw C;
          });
        throw p;
      }
    } finally {
      e.__root = t, delete e.currentTarget, an(d), Zt(f);
    }
  }
}
function Pc(e) {
  var t = document.createElement("template");
  return t.innerHTML = e, t.content;
}
function qr(e, t) {
  var n = (
    /** @type {Effect} */
    Be
  );
  n.nodes_start === null && (n.nodes_start = e, n.nodes_end = t);
}
// @__NO_SIDE_EFFECTS__
function O(e, t) {
  var n = (t & 1) !== 0, r = (t & 2) !== 0, a, i = !e.startsWith("<!>");
  return () => {
    a === void 0 && (a = Pc(i ? e : "<!>" + e), n || (a = /** @type {Node} */
    /* @__PURE__ */ Ur(a)));
    var o = (
      /** @type {TemplateNode} */
      r ? document.importNode(a, !0) : a.cloneNode(!0)
    );
    if (n) {
      var s = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Ur(o)
      ), l = (
        /** @type {TemplateNode} */
        o.lastChild
      );
      qr(s, l);
    } else
      qr(o, o);
    return o;
  };
}
// @__NO_SIDE_EFFECTS__
function vt(e, t, n = "svg") {
  var r = !e.startsWith("<!>"), a = `<${n}>${r ? e : "<!>" + e}</${n}>`, i;
  return () => {
    if (!i) {
      var o = (
        /** @type {DocumentFragment} */
        Pc(a)
      ), s = (
        /** @type {Element} */
        /* @__PURE__ */ Ur(o)
      );
      i = /** @type {Element} */
      /* @__PURE__ */ Ur(s);
    }
    var l = (
      /** @type {TemplateNode} */
      i.cloneNode(!0)
    );
    return qr(l, l), l;
  };
}
function qa(e = "") {
  {
    var t = Go(e + "");
    return qr(t, t), t;
  }
}
function Z() {
  var e = document.createDocumentFragment(), t = document.createComment(""), n = Go();
  return e.append(t, n), qr(t, n), e;
}
function _(e, t) {
  e !== null && e.before(
    /** @type {Node} */
    t
  );
}
function Em(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const Tm = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function Am(e) {
  return Tm.includes(e);
}
const Pm = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject"
};
function Mm(e) {
  return e = e.toLowerCase(), Pm[e] ?? e;
}
const Im = ["touchstart", "touchmove"];
function Om(e) {
  return Im.includes(e);
}
let Ls = !0;
function jd(e) {
  Ls = e;
}
function ke(e, t) {
  var n = t == null ? "" : typeof t == "object" ? t + "" : t;
  n !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = n, e.nodeValue = n == null ? "" : n + "");
}
function Mc(e, t) {
  return Fm(e, t);
}
const oa = /* @__PURE__ */ new Map();
function Fm(e, { target: t, anchor: n, props: r = {}, events: a, context: i, intro: o = !0 }) {
  rm();
  var s = /* @__PURE__ */ new Set(), l = (f) => {
    for (var p = 0; p < f.length; p++) {
      var h = f[p];
      if (!s.has(h)) {
        s.add(h);
        var y = Om(h);
        t.addEventListener(h, ki, { passive: y });
        var g = oa.get(h);
        g === void 0 ? (document.addEventListener(h, ki, { passive: y }), oa.set(h, 1)) : oa.set(h, g + 1);
      }
    }
  };
  l(kc(Fh)), Vu.add(l);
  var u = void 0, d = yh(() => {
    var f = n ?? t.appendChild(Go());
    return Mn(() => {
      if (i) {
        be({});
        var p = (
          /** @type {ComponentContext} */
          Ze
        );
        p.c = i;
      }
      a && (r.$$events = a), Ls = o, u = e(f, r) || {}, Ls = !0, i && _e();
    }), () => {
      var y;
      for (var p of s) {
        t.removeEventListener(p, ki);
        var h = (
          /** @type {number} */
          oa.get(p)
        );
        --h === 0 ? (document.removeEventListener(p, ki), oa.delete(p)) : oa.set(p, h);
      }
      Vu.delete(l), Bu.delete(u), f !== n && ((y = f.parentNode) == null || y.removeChild(f));
    };
  });
  return Bu.set(u, d), u;
}
let Bu = /* @__PURE__ */ new WeakMap();
function ju(e) {
  const t = Bu.get(e);
  t && t();
}
function H(e, t, n = !1) {
  var r = e, a = null, i = null, o = Bt, s = n ? ta : 0, l = !1;
  const u = (f, p = !0) => {
    l = !0, d(p, f);
  }, d = (f, p) => {
    o !== (o = f) && (o ? (a ? Mi(a) : p && (a = Mn(() => p(r))), i && Ua(i, () => {
      i = null;
    })) : (i ? Mi(i) : p && (i = Mn(() => p(r))), a && Ua(a, () => {
      a = null;
    })));
  };
  Cr(() => {
    l = !1, t(u), l || d(null, null);
  }, s);
}
function Gr(e, t, n) {
  var r = e, a = Bt, i, o = Zo() ? Gv : Hl;
  Cr(() => {
    o(a, a = t()) && (i && Ua(i), i = Mn(() => n(r)));
  });
}
let Wr = null;
function Wd(e) {
  Wr = e;
}
function gt(e, t) {
  return t;
}
function Rm(e, t, n, r) {
  for (var a = [], i = t.length, o = 0; o < i; o++)
    Ec(t[o].e, a, !0);
  var s = i > 0 && a.length === 0 && n !== null;
  if (s) {
    var l = (
      /** @type {Element} */
      /** @type {Element} */
      n.parentNode
    );
    am(l), l.append(
      /** @type {Element} */
      n
    ), r.clear(), or(e, t[0].prev, t[i - 1].next);
  }
  bh(a, () => {
    for (var u = 0; u < i; u++) {
      var d = t[u];
      s || (r.delete(d.k), or(e, d.prev, d.next)), Fn(d.e, !s);
    }
  });
}
function at(e, t, n, r, a, i = null) {
  var o = e, s = { flags: t, items: /* @__PURE__ */ new Map(), first: null }, l = (t & 4) !== 0;
  if (l) {
    var u = (
      /** @type {Element} */
      e
    );
    o = u.appendChild(Go());
  }
  var d = null, f = !1;
  Cr(() => {
    var p = n(), h = jl(p) ? p : p == null ? [] : kc(p), y = h.length;
    if (!(f && y === 0)) {
      f = y === 0;
      {
        var g = (
          /** @type {Effect} */
          $e
        );
        Lm(h, s, o, a, t, (g.f & En) !== 0, r);
      }
      i !== null && (y === 0 ? d ? Mi(d) : d = Mn(() => i(o)) : d !== null && Ua(d, () => {
        d = null;
      })), n();
    }
  });
}
function Lm(e, t, n, r, a, i, o) {
  var P, Y, G, q;
  var s = (a & 8) !== 0, l = (a & 3) !== 0, u = e.length, d = t.items, f = t.first, p = f, h, y = null, g, w = [], m = [], v, C, S, b;
  if (s)
    for (b = 0; b < u; b += 1)
      v = e[b], C = o(v, b), S = d.get(C), S !== void 0 && ((P = S.a) == null || P.measure(), (g ?? (g = /* @__PURE__ */ new Set())).add(S));
  for (b = 0; b < u; b += 1) {
    if (v = e[b], C = o(v, b), S = d.get(C), S === void 0) {
      var x = p ? (
        /** @type {TemplateNode} */
        p.e.nodes_start
      ) : n;
      y = Nm(
        x,
        t,
        y,
        y === null ? t.first : y.next,
        v,
        C,
        b,
        r,
        a
      ), d.set(C, y), w = [], m = [], p = y.next;
      continue;
    }
    if (l && Dm(S, v, b, a), S.e.f & En && (Mi(S.e), s && ((Y = S.a) == null || Y.unfix(), (g ?? (g = /* @__PURE__ */ new Set())).delete(S))), S !== p) {
      if (h !== void 0 && h.has(S)) {
        if (w.length < m.length) {
          var E = m[0], k;
          y = E.prev;
          var I = w[0], D = w[w.length - 1];
          for (k = 0; k < w.length; k += 1)
            Hd(w[k], E, n);
          for (k = 0; k < m.length; k += 1)
            h.delete(m[k]);
          or(t, I.prev, D.next), or(t, y, I), or(t, D, E), p = E, y = D, b -= 1, w = [], m = [];
        } else
          h.delete(S), Hd(S, p, n), or(t, S.prev, S.next), or(t, S, y === null ? t.first : y.next), or(t, y, S), y = S;
        continue;
      }
      for (w = [], m = []; p !== null && p.k !== C; )
        (i || !(p.e.f & En)) && (h ?? (h = /* @__PURE__ */ new Set())).add(p), m.push(p), p = p.next;
      if (p === null)
        continue;
      S = p;
    }
    w.push(S), y = S, p = S.next;
  }
  if (p !== null || h !== void 0) {
    for (var A = h === void 0 ? [] : kc(h); p !== null; )
      (i || !(p.e.f & En)) && A.push(p), p = p.next;
    var M = A.length;
    if (M > 0) {
      var N = a & 4 && u === 0 ? n : null;
      if (s) {
        for (b = 0; b < M; b += 1)
          (G = A[b].a) == null || G.measure();
        for (b = 0; b < M; b += 1)
          (q = A[b].a) == null || q.fix();
      }
      Rm(t, A, N, d);
    }
  }
  s && Ko(() => {
    var J;
    if (g !== void 0)
      for (S of g)
        (J = S.a) == null || J.apply();
  }), Be.first = t.first && t.first.e, Be.last = y && y.e;
}
function Dm(e, t, n, r) {
  r & 1 && Lu(e.v, t), r & 2 ? Lu(
    /** @type {Value<number>} */
    e.i,
    n
  ) : e.i = n;
}
function Nm(e, t, n, r, a, i, o, s, l) {
  var u = Wr, d = (l & 1) !== 0, f = (l & 16) === 0, p = d ? f ? /* @__PURE__ */ Ul(a) : Et(a) : a, h = l & 2 ? Et(o) : o, y = {
    i: h,
    v: p,
    k: i,
    a: null,
    // @ts-expect-error
    e: null,
    prev: n,
    next: r
  };
  Wr = y;
  try {
    return y.e = Mn(() => s(e, p, h), sh), y.e.prev = n && n.e, y.e.next = r && r.e, n === null ? t.first = y : (n.next = y, n.e.next = y.e), r !== null && (r.prev = y, r.e.prev = y.e), y;
  } finally {
    Wr = u;
  }
}
function Hd(e, t, n) {
  for (var r = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : n, a = t ? (
    /** @type {TemplateNode} */
    t.e.nodes_start
  ) : n, i = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); i !== r; ) {
    var o = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ ql(i)
    );
    a.before(i), i = o;
  }
}
function or(e, t, n) {
  t === null ? e.first = n : (t.next = n, t.e.next = n && n.e), n !== null && (n.prev = t, n.e.prev = t && t.e);
}
function dn(e, t, n, r, a) {
  var i = e, o = "", s;
  Cr(() => {
    o !== (o = t() ?? "") && (s !== void 0 && (Fn(s), s = void 0), o !== "" && (s = Mn(() => {
      var l = o + "", u = Pc(l);
      qr(
        /** @type {TemplateNode} */
        /* @__PURE__ */ Ur(u),
        /** @type {TemplateNode} */
        u.lastChild
      ), i.before(u);
    })));
  });
}
function He(e, t, n, r, a) {
  var s;
  var i = (s = t.$$slots) == null ? void 0 : s[n], o = !1;
  i === !0 && (i = t[n === "default" ? "children" : n], o = !0), i === void 0 ? a !== null && a(e) : i(e, o ? () => r : r);
}
function lt(e, t, ...n) {
  var r = e, a = De, i;
  Cr(() => {
    a !== (a = t()) && (i && (Fn(i), i = null), i = Mn(() => (
      /** @type {SnippetFn} */
      a(r, ...n)
    )));
  }, ta);
}
function rt(e, t, n) {
  var r = e, a, i;
  Cr(() => {
    a !== (a = t()) && (i && (Ua(i), i = null), a && (i = Mn(() => n(r, a))));
  }, ta);
}
function zm(e, t, n, r, a, i) {
  var o, s, l = null, u = (
    /** @type {TemplateNode} */
    e
  ), d, f = Wr;
  Cr(() => {
    const p = t() || null;
    var h = Jp;
    if (p !== o) {
      var y = Wr;
      Wd(f), d && (p === null ? Ua(d, () => {
        d = null, s = null;
      }) : p === s ? Mi(d) : (Fn(d), jd(!1))), p && p !== s && (d = Mn(() => {
        if (l = document.createElementNS(h, p), qr(l, l), r) {
          var g = (
            /** @type {TemplateNode} */
            l.appendChild(Go())
          );
          r(l, g);
        }
        Be.nodes_end = l, u.before(l);
      })), o = p, o && (s = o), jd(!0), Wd(y);
    }
  }, ta);
}
function _a(e, t, n) {
  ri(() => {
    var r = _t(() => t(e, n == null ? void 0 : n()) || {});
    if (n && (r != null && r.update)) {
      var a = !1, i = (
        /** @type {any} */
        {}
      );
      ai(() => {
        var o = n();
        Qe(o), a && Hl(i, o) && (i = o, r.update(o));
      }), a = !0;
    }
    if (r != null && r.destroy)
      return () => (
        /** @type {Function} */
        r.destroy()
      );
  });
}
function he(e, t, n, r) {
  var a = e.__attributes ?? (e.__attributes = {});
  a[t] !== (a[t] = n) && (t === "style" && "__styles" in e && (e.__styles = {}), t === "loading" && (e[qv] = n), n == null ? e.removeAttribute(t) : typeof n != "string" && Ic(e).includes(t) ? e[t] = n : e.setAttribute(t, n));
}
function Ud(e, t, n) {
  var r = $e, a = Be;
  an(null), Zt(null);
  try {
    Ic(e).includes(t) ? e[t] = n : he(e, t, n);
  } finally {
    an(r), Zt(a);
  }
}
function Je(e, t, n, r, a = !1, i = !1, o = !1) {
  var s = t || {}, l = e.tagName === "OPTION";
  for (var u in t)
    u in n || (n[u] = null);
  r !== void 0 && (n.class = n.class ? n.class + " " + r : r);
  var d = Ic(e), f = (
    /** @type {Record<string, unknown>} **/
    e.__attributes ?? (e.__attributes = {})
  );
  for (const w in n) {
    let m = n[w];
    if (l && w === "value" && m == null) {
      e.value = e.__value = "", s[w] = m;
      continue;
    }
    var p = s[w];
    if (m !== p) {
      s[w] = m;
      var h = w[0] + w[1];
      if (h !== "$$") {
        if (h === "on") {
          const v = {}, C = "$$" + w;
          let S = w.slice(2);
          var y = Am(S);
          if (Em(S) && (S = S.slice(0, -7), v.capture = !0), !y && p) {
            if (m != null) continue;
            e.removeEventListener(S, s[C], v), s[C] = null;
          }
          if (m != null)
            if (y)
              e[`__${S}`] = m, Er([S]);
            else {
              let b = function(x) {
                s[w].call(this, x);
              };
              s[C] = Rh(S, e, b, v);
            }
          else y && (e[`__${S}`] = void 0);
        } else if (w === "style" && m != null)
          e.style.cssText = m + "";
        else if (w === "autofocus")
          km(
            /** @type {HTMLElement} */
            e,
            !!m
          );
        else if (w === "__value" || w === "value" && m != null)
          e.value = e[w] = e.__value = m;
        else {
          var g = w;
          a || (g = Mm(g)), m == null && !i ? (f[w] = null, e.removeAttribute(w)) : d.includes(g) && (i || typeof m != "string") ? e[g] = m : typeof m != "function" && he(e, g, m);
        }
        w === "style" && "__styles" in e && (e.__styles = {});
      }
    }
  }
  return s;
}
var qd = /* @__PURE__ */ new Map();
function Ic(e) {
  var t = qd.get(e.nodeName);
  if (t) return t;
  qd.set(e.nodeName, t = []);
  for (var n, r = Os(e), a = Element.prototype; a !== r; ) {
    n = $p(r);
    for (var i in n)
      n[i].set && t.push(i);
    r = Os(r);
  }
  return t;
}
function Ve(e, t) {
  var n = e.__className, r = Vm(t);
  (n !== r || sh) && (t == null ? e.removeAttribute("class") : e.className = r, e.__className = r);
}
function Vm(e) {
  return e ?? "";
}
function os(e, t, n) {
  if (n) {
    if (e.classList.contains(t)) return;
    e.classList.add(t);
  } else {
    if (!e.classList.contains(t)) return;
    e.classList.remove(t);
  }
}
function Kn(e, t, n, r) {
  var a = e.__styles ?? (e.__styles = {});
  a[t] !== n && (a[t] = n, n == null ? e.style.removeProperty(t) : e.style.setProperty(t, n, ""));
}
const Bm = () => performance.now(), Zn = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => Bm(),
  tasks: /* @__PURE__ */ new Set()
};
function Lh() {
  const e = Zn.now();
  Zn.tasks.forEach((t) => {
    t.c(e) || (Zn.tasks.delete(t), t.f());
  }), Zn.tasks.size !== 0 && Zn.tick(Lh);
}
function jm(e) {
  let t;
  return Zn.tasks.size === 0 && Zn.tick(Lh), {
    promise: new Promise((n) => {
      Zn.tasks.add(t = { c: e, f: n });
    }),
    abort() {
      Zn.tasks.delete(t);
    }
  };
}
function ss(e, t) {
  e.dispatchEvent(new CustomEvent(t));
}
function Wm(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const t = e.split("-");
  return t.length === 1 ? t[0] : t[0] + t.slice(1).map(
    /** @param {any} word */
    (n) => n[0].toUpperCase() + n.slice(1)
  ).join("");
}
function Gd(e) {
  const t = {}, n = e.split(";");
  for (const r of n) {
    const [a, i] = r.split(":");
    if (!a || i === void 0) break;
    const o = Wm(a.trim());
    t[o] = i.trim();
  }
  return t;
}
const Hm = (e) => e;
function Um(e, t, n) {
  var r = (
    /** @type {EachItem} */
    Wr
  ), a, i, o, s = null;
  r.a ?? (r.a = {
    element: e,
    measure() {
      a = this.element.getBoundingClientRect();
    },
    apply() {
      if (o == null || o.abort(), i = this.element.getBoundingClientRect(), a.left !== i.left || a.right !== i.right || a.top !== i.top || a.bottom !== i.bottom) {
        const l = t()(this.element, { from: a, to: i }, n == null ? void 0 : n());
        o = Ds(this.element, l, void 0, 1, () => {
          o == null || o.abort(), o = void 0;
        });
      }
    },
    fix() {
      if (!e.getAnimations().length) {
        var { position: l, width: u, height: d } = getComputedStyle(e);
        if (l !== "absolute" && l !== "fixed") {
          var f = (
            /** @type {HTMLElement | SVGElement} */
            e.style
          );
          s = {
            position: f.position,
            width: f.width,
            height: f.height,
            transform: f.transform
          }, f.position = "absolute", f.width = u, f.height = d;
          var p = e.getBoundingClientRect();
          if (a.left !== p.left || a.top !== p.top) {
            var h = `translate(${a.left - p.left}px, ${a.top - p.top}px)`;
            f.transform = f.transform ? `${f.transform} ${h}` : h;
          }
        }
      }
    },
    unfix() {
      if (s) {
        var l = (
          /** @type {HTMLElement | SVGElement} */
          e.style
        );
        l.position = s.position, l.width = s.width, l.height = s.height, l.transform = s.transform;
      }
    }
  }), r.a.element = e;
}
function bt(e, t, n, r) {
  var a = (e & 1) !== 0, i = (e & 2) !== 0, o = a && i, s = (e & 4) !== 0, l = o ? "both" : a ? "in" : "out", u, d = t.inert, f, p;
  function h() {
    var v = $e, C = Be;
    an(null), Zt(null);
    try {
      return u ?? (u = n()(t, (r == null ? void 0 : r()) ?? /** @type {P} */
      {}, {
        direction: l
      }));
    } finally {
      an(v), Zt(C);
    }
  }
  var y = {
    is_global: s,
    in() {
      var v;
      if (t.inert = d, !a) {
        p == null || p.abort(), (v = p == null ? void 0 : p.reset) == null || v.call(p);
        return;
      }
      i || f == null || f.abort(), ss(t, "introstart"), f = Ds(t, h(), p, 1, () => {
        ss(t, "introend"), f == null || f.abort(), f = u = void 0;
      });
    },
    out(v) {
      if (!i) {
        v == null || v(), u = void 0;
        return;
      }
      t.inert = !0, ss(t, "outrostart"), p = Ds(t, h(), f, 0, () => {
        ss(t, "outroend"), v == null || v();
      });
    },
    stop: () => {
      f == null || f.abort(), p == null || p.abort();
    }
  }, g = (
    /** @type {Effect} */
    Be
  );
  if ((g.transitions ?? (g.transitions = [])).push(y), a && Ls) {
    var w = s;
    if (!w) {
      for (var m = (
        /** @type {Effect | null} */
        g.parent
      ); m && m.f & ta; )
        for (; (m = m.parent) && !(m.f & Wl); )
          ;
      w = !m || (m.f & th) !== 0;
    }
    w && ri(() => {
      _t(() => y.in());
    });
  }
}
function Ds(e, t, n, r, a) {
  var i = r === 1;
  if (ya(t)) {
    var o, s = !1;
    return Ko(() => {
      if (!s) {
        var w = t({ direction: i ? "in" : "out" });
        o = Ds(e, w, n, r, a);
      }
    }), {
      abort: () => {
        s = !0, o == null || o.abort();
      },
      deactivate: () => o.deactivate(),
      reset: () => o.reset(),
      t: () => o.t()
    };
  }
  if (n == null || n.deactivate(), !(t != null && t.duration))
    return a(), {
      abort: De,
      deactivate: De,
      reset: De,
      t: () => r
    };
  const { delay: l = 0, css: u, tick: d, easing: f = Hm } = t;
  var p = [];
  if (i && n === void 0 && (d && d(0, 1), u)) {
    var h = Gd(u(0, 1));
    p.push(h, h);
  }
  var y = () => 1 - r, g = e.animate(p, { duration: l });
  return g.onfinish = () => {
    var w = (n == null ? void 0 : n.t()) ?? 1 - r;
    n == null || n.abort();
    var m = r - w, v = (
      /** @type {number} */
      t.duration * Math.abs(m)
    ), C = [];
    if (v > 0) {
      if (u)
        for (var S = Math.ceil(v / 16.666666666666668), b = 0; b <= S; b += 1) {
          var x = w + m * f(b / S), E = u(x, 1 - x);
          C.push(Gd(E));
        }
      y = () => {
        var k = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          g.currentTime
        );
        return w + m * f(k / v);
      }, d && jm(() => {
        if (g.playState !== "running") return !1;
        var k = y();
        return d(k, 1 - k), !0;
      });
    }
    g = e.animate(C, { duration: v, fill: "forwards" }), g.onfinish = () => {
      y = () => r, d == null || d(r, 1 - r), a();
    };
  }, {
    abort: () => {
      g && (g.cancel(), g.effect = null, g.onfinish = De);
    },
    deactivate: () => {
      a = De;
    },
    reset: () => {
      r === 0 && (d == null || d(1, 0));
    },
    t: () => y()
  };
}
function qm(e, t, n = t) {
  var r = Zo();
  Cm(e, "input", (a) => {
    var i = a ? e.defaultValue : e.value;
    if (i = yu(e) ? gu(i) : i, n(i), r && i !== (i = t())) {
      var o = e.selectionStart, s = e.selectionEnd;
      e.value = i ?? "", s !== null && (e.selectionStart = o, e.selectionEnd = Math.min(s, e.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  _t(t) == null && e.value && n(yu(e) ? gu(e.value) : e.value), ai(() => {
    var a = t();
    yu(e) && a === gu(e.value) || e.type === "date" && !a && !e.value || a !== e.value && (e.value = a ?? "");
  });
}
function yu(e) {
  var t = e.type;
  return t === "number" || t === "range";
}
function gu(e) {
  return e === "" ? null : +e;
}
function Kd(e, t) {
  return e === t || (e == null ? void 0 : e[hr]) === t;
}
function tn(e = {}, t, n, r) {
  return ri(() => {
    var a, i;
    return ai(() => {
      a = i, i = (r == null ? void 0 : r()) || [], _t(() => {
        e !== n(...i) && (t(e, ...i), a && Kd(n(...a), e) && t(null, ...a));
      });
    }), () => {
      Ko(() => {
        i && Kd(n(...i), e) && t(null, ...i);
      });
    };
  }), e;
}
function gn(e = !1) {
  const t = (
    /** @type {ComponentContextLegacy} */
    Ze
  ), n = t.l.u;
  if (!n) return;
  let r = () => Qe(t.s);
  if (e) {
    let a = 0, i = (
      /** @type {Record<string, any>} */
      {}
    );
    const o = /* @__PURE__ */ R(() => {
      let s = !1;
      const l = t.s;
      for (const u in l)
        l[u] !== i[u] && (i[u] = l[u], s = !0);
      return s && a++, a;
    });
    r = () => c(o);
  }
  n.b.length && lm(() => {
    Zd(t, r), Fu(n.b);
  }), Se(() => {
    const a = _t(() => n.m.map(Wv));
    return () => {
      for (const i of a)
        typeof i == "function" && i();
    };
  }), n.a.length && Se(() => {
    Zd(t, r), Fu(n.a);
  });
}
function Zd(e, t) {
  if (e.l.s)
    for (const n of e.l.s) c(n);
  t();
}
function Rn(e) {
  Ze === null && Kl(), ti && Ze.l !== null ? Zm(Ze).m.push(e) : Se(() => {
    const t = _t(e);
    if (typeof t == "function") return (
      /** @type {() => void} */
      t
    );
  });
}
function Oc(e) {
  Ze === null && Kl(), Rn(() => () => _t(e));
}
function Gm(e, t, { bubbles: n = !1, cancelable: r = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: n, cancelable: r });
}
function Km() {
  const e = Ze;
  return e === null && Kl(), (t, n, r) => {
    var i;
    const a = (
      /** @type {Record<string, Function | Function[]>} */
      (i = e.s.$$events) == null ? void 0 : i[
        /** @type {any} */
        t
      ]
    );
    if (a) {
      const o = jl(a) ? a.slice() : [a], s = Gm(
        /** @type {string} */
        t,
        n,
        r
      );
      for (const l of o)
        l.call(e.x, s);
      return !s.defaultPrevented;
    }
    return !0;
  };
}
function Zm(e) {
  var t = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return t.u ?? (t.u = { a: [], b: [], m: [] });
}
function Dh(e, t, n) {
  if (e == null)
    return t(void 0), De;
  const r = _t(
    () => e.subscribe(
      t,
      // @ts-expect-error
      n
    )
  );
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
let ls = !1;
function un(e, t, n) {
  const r = n[t] ?? (n[t] = {
    store: null,
    source: /* @__PURE__ */ Ul(void 0),
    unsubscribe: De
  });
  if (r.store !== e)
    if (r.unsubscribe(), r.store = e ?? null, e == null)
      r.source.v = void 0, r.unsubscribe = De;
    else {
      var a = !0;
      r.unsubscribe = Dh(e, (i) => {
        a ? r.source.v = i : z(r.source, i);
      }), a = !1;
    }
  return c(r.source);
}
function Ym(e, t, n) {
  let r = n[t];
  return r && r.store !== e && (r.unsubscribe(), r.unsubscribe = De), e;
}
function Tr() {
  const e = {};
  return hh(() => {
    for (var t in e)
      e[t].unsubscribe();
  }), e;
}
function Xm(e) {
  var t = ls;
  try {
    return ls = !1, [e(), ls];
  } finally {
    ls = t;
  }
}
const Jm = {
  get(e, t) {
    if (!e.exclude.includes(t))
      return e.props[t];
  },
  set(e, t) {
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    if (!e.exclude.includes(t) && t in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[t]
      };
  },
  has(e, t) {
    return e.exclude.includes(t) ? !1 : t in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((t) => !e.exclude.includes(t));
  }
};
// @__NO_SIDE_EFFECTS__
function et(e, t, n) {
  return new Proxy(
    { props: e, exclude: t },
    Jm
  );
}
const Qm = {
  get(e, t) {
    if (!e.exclude.includes(t))
      return c(e.version), t in e.special ? e.special[t]() : e.props[t];
  },
  set(e, t, n) {
    return t in e.special || (e.special[t] = L(
      {
        get [t]() {
          return e.props[t];
        }
      },
      /** @type {string} */
      t,
      4
    )), e.special[t](n), Nu(e.version), !0;
  },
  getOwnPropertyDescriptor(e, t) {
    if (!e.exclude.includes(t) && t in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[t]
      };
  },
  deleteProperty(e, t) {
    return e.exclude.includes(t) || (e.exclude.push(t), Nu(e.version)), !0;
  },
  has(e, t) {
    return e.exclude.includes(t) ? !1 : t in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((t) => !e.exclude.includes(t));
  }
};
function Dt(e, t) {
  return new Proxy({ props: e, exclude: t, special: {}, version: Et(0) }, Qm);
}
const $m = {
  get(e, t) {
    let n = e.props.length;
    for (; n--; ) {
      let r = e.props[n];
      if (ya(r) && (r = r()), typeof r == "object" && r !== null && t in r) return r[t];
    }
  },
  set(e, t, n) {
    let r = e.props.length;
    for (; r--; ) {
      let a = e.props[r];
      ya(a) && (a = a());
      const i = pr(a, t);
      if (i && i.set)
        return i.set(n), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    let n = e.props.length;
    for (; n--; ) {
      let r = e.props[n];
      if (ya(r) && (r = r()), typeof r == "object" && r !== null && t in r) {
        const a = pr(r, t);
        return a && !a.configurable && (a.configurable = !0), a;
      }
    }
  },
  has(e, t) {
    if (t === hr || t === rh) return !1;
    for (let n of e.props)
      if (ya(n) && (n = n()), n != null && t in n) return !0;
    return !1;
  },
  ownKeys(e) {
    const t = [];
    for (let n of e.props) {
      ya(n) && (n = n());
      for (const r in n)
        t.includes(r) || t.push(r);
    }
    return t;
  }
};
function ot(...e) {
  return new Proxy({ props: e }, $m);
}
function Yd(e) {
  for (var t = Be, n = Be; t !== null && !(t.f & (hn | qo)); )
    t = t.parent;
  try {
    return Zt(t), e();
  } finally {
    Zt(n);
  }
}
function L(e, t, n, r) {
  var E;
  var a = (n & 1) !== 0, i = !ti || (n & 2) !== 0, o = (n & 8) !== 0, s = (n & 16) !== 0, l = !1, u;
  o ? [u, l] = Xm(() => (
    /** @type {V} */
    e[t]
  )) : u = /** @type {V} */
  e[t];
  var d = hr in e || rh in e, f = ((E = pr(e, t)) == null ? void 0 : E.set) ?? (d && o && t in e ? (k) => e[t] = k : void 0), p = (
    /** @type {V} */
    r
  ), h = !0, y = !1, g = () => (y = !0, h && (h = !1, s ? p = _t(
    /** @type {() => V} */
    r
  ) : p = /** @type {V} */
  r), p);
  u === void 0 && r !== void 0 && (f && i && Jv(), u = g(), f && f(u));
  var w;
  if (i)
    w = () => {
      var k = (
        /** @type {V} */
        e[t]
      );
      return k === void 0 ? g() : (h = !0, y = !1, k);
    };
  else {
    var m = Yd(
      () => (a ? R : St)(() => (
        /** @type {V} */
        e[t]
      ))
    );
    m.f |= Hv, w = () => {
      var k = c(m);
      return k !== void 0 && (p = /** @type {V} */
      void 0), k === void 0 ? p : k;
    };
  }
  if (!(n & 4))
    return w;
  if (f) {
    var v = e.$$legacy;
    return function(k, I) {
      return arguments.length > 0 ? ((!i || !I || v || l) && f(I ? w() : k), k) : w();
    };
  }
  var C = !1, S = !1, b = /* @__PURE__ */ Ul(u), x = Yd(
    () => /* @__PURE__ */ R(() => {
      var k = w(), I = c(b);
      return C ? (C = !1, S = !0, I) : (S = !1, b.v = k);
    })
  );
  return a || (x.equals = Sc), function(k, I) {
    if (arguments.length > 0) {
      const D = I ? c(x) : i && o ? oe(k) : k;
      return x.equals(D) || (C = !0, z(b, D), y && p !== void 0 && (p = D), _t(() => c(x))), k;
    }
    return c(x);
  };
}
const e1 = () => {
  let e = de(oe({ api_key: void 0, platform_id: void 0 })), t = de(oe({
    api_host: "https://api.layuplabs.ai",
    platform_user_data: {},
    group_id: void 0,
    theme: void 0,
    debug: !1,
    URLpath: "",
    variant: "sidebar",
    name: "Layup",
    styles: void 0,
    show_widget: !0,
    onClose: () => {
    },
    onInit: () => {
    }
  }));
  return {
    get config() {
      return c(t);
    },
    set config(n) {
      z(t, oe(n));
    },
    get internal_config() {
      return c(e);
    },
    set internal_config(n) {
      z(e, oe(n));
    }
  };
}, X = e1();
function Nh(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Nh(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function zh() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Nh(e)) && (r && (r += " "), r += t);
  return r;
}
const Fc = "-", t1 = (e) => {
  const t = r1(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(Fc);
      return s[0] === "" && s.length !== 1 && s.shift(), Vh(s, t) || n1(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = n[o] || [];
      return s && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, Vh = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? Vh(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(Fc);
  return (o = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, Xd = /^\[(.+)\]$/, n1 = (e) => {
  if (Xd.test(e)) {
    const t = Xd.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, r1 = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return i1(Object.entries(e.classGroups), n).forEach(([i, o]) => {
    Wu(o, r, i, t);
  }), r;
}, Wu = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : Jd(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (a1(a)) {
        Wu(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      Wu(o, Jd(t, i), n, r);
    });
  });
}, Jd = (e, t) => {
  let n = e;
  return t.split(Fc).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, a1 = (e) => e.isThemeGetter, i1 = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [n, a];
}) : e, o1 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}, Bh = "!", s1 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], i = t.length, o = (s) => {
    const l = [];
    let u = 0, d = 0, f;
    for (let w = 0; w < s.length; w++) {
      let m = s[w];
      if (u === 0) {
        if (m === a && (r || s.slice(w, w + i) === t)) {
          l.push(s.slice(d, w)), d = w + i;
          continue;
        }
        if (m === "/") {
          f = w;
          continue;
        }
      }
      m === "[" ? u++ : m === "]" && u--;
    }
    const p = l.length === 0 ? s : s.substring(d), h = p.startsWith(Bh), y = h ? p.substring(1) : p, g = f && f > d ? f - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: y,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, l1 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, u1 = (e) => ({
  cache: o1(e.cacheSize),
  parseClassName: s1(e),
  ...t1(e)
}), c1 = /\s+/, d1 = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split(c1);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const u = o[l], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(u);
    let y = !!h, g = r(y ? p.substring(0, h) : p);
    if (!g) {
      if (!y) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = r(p), !g) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      y = !1;
    }
    const w = l1(d).join(":"), m = f ? w + Bh : w, v = m + g;
    if (i.includes(v))
      continue;
    i.push(v);
    const C = a(g, y);
    for (let S = 0; S < C.length; ++S) {
      const b = C[S];
      i.push(m + b);
    }
    s = u + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function f1() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = jh(t)) && (r && (r += " "), r += n);
  return r;
}
const jh = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = jh(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Hu(e, ...t) {
  let n, r, a, i = o;
  function o(l) {
    const u = t.reduce((d, f) => f(d), e());
    return n = u1(u), r = n.cache.get, a = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const u = r(l);
    if (u)
      return u;
    const d = d1(l, n);
    return a(l, d), d;
  }
  return function() {
    return i(f1.apply(null, arguments));
  };
}
const ht = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Wh = /^\[(?:([a-z-]+):)?(.+)\]$/i, p1 = /^\d+\/\d+$/, h1 = /* @__PURE__ */ new Set(["px", "full", "screen"]), y1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, g1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, v1 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, m1 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, w1 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Bn = (e) => xa(e) || h1.has(e) || p1.test(e), tr = (e) => oi(e, "length", T1), xa = (e) => !!e && !Number.isNaN(Number(e)), vu = (e) => oi(e, "number", xa), gi = (e) => !!e && Number.isInteger(Number(e)), b1 = (e) => e.endsWith("%") && xa(e.slice(0, -1)), ze = (e) => Wh.test(e), nr = (e) => y1.test(e), _1 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), x1 = (e) => oi(e, _1, Hh), k1 = (e) => oi(e, "position", Hh), S1 = /* @__PURE__ */ new Set(["image", "url"]), C1 = (e) => oi(e, S1, P1), E1 = (e) => oi(e, "", A1), vi = () => !0, oi = (e, t, n) => {
  const r = Wh.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, T1 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  g1.test(e) && !v1.test(e)
), Hh = () => !1, A1 = (e) => m1.test(e), P1 = (e) => w1.test(e), Uu = () => {
  const e = ht("colors"), t = ht("spacing"), n = ht("blur"), r = ht("brightness"), a = ht("borderColor"), i = ht("borderRadius"), o = ht("borderSpacing"), s = ht("borderWidth"), l = ht("contrast"), u = ht("grayscale"), d = ht("hueRotate"), f = ht("invert"), p = ht("gap"), h = ht("gradientColorStops"), y = ht("gradientColorStopPositions"), g = ht("inset"), w = ht("margin"), m = ht("opacity"), v = ht("padding"), C = ht("saturate"), S = ht("scale"), b = ht("sepia"), x = ht("skew"), E = ht("space"), k = ht("translate"), I = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", ze, t], M = () => [ze, t], N = () => ["", Bn, tr], P = () => ["auto", xa, ze], Y = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], G = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], J = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], $ = () => ["", "0", ze], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], j = () => [xa, ze];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [vi],
      spacing: [Bn, tr],
      blur: ["none", "", nr, ze],
      brightness: j(),
      borderColor: [e],
      borderRadius: ["none", "", "full", nr, ze],
      borderSpacing: M(),
      borderWidth: N(),
      contrast: j(),
      grayscale: $(),
      hueRotate: j(),
      invert: $(),
      gap: M(),
      gradientColorStops: [e],
      gradientColorStopPositions: [b1, tr],
      inset: A(),
      margin: A(),
      opacity: j(),
      padding: M(),
      saturate: j(),
      scale: j(),
      sepia: $(),
      skew: j(),
      space: M(),
      translate: M()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ze]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [nr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Y(), ze]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", gi, ze]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ze]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: $()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: $()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", gi, ze]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [vi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", gi, ze]
        }, ze]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": P()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": P()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [vi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [gi, ze]
        }, ze]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": P()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": P()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...J()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...J(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...J(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [w]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [w]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [w]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [w]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [w]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [w]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [w]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [w]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [w]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ze, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ze, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ze, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [nr]
        }, nr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ze, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ze, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ze, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ze, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", nr, tr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", vu]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [vi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ze]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", xa, vu]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Bn, ze]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ze]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ze]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...G(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Bn, tr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Bn, ze]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ze]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ze]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Y(), k1]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", x1]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, C1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...G(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: G()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...G()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Bn, ze]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Bn, tr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: N()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Bn, tr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", nr, E1]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [vi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", nr, ze]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ze]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: j()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ze]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: j()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ze]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [gi, ze]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [k]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [k]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [x]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [x]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ze]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ze]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ze]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Bn, tr, vu]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, M1 = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: a,
  extend: i = {},
  override: o = {}
}) => {
  Si(e, "cacheSize", t), Si(e, "prefix", n), Si(e, "separator", r), Si(e, "experimentalParseClassName", a);
  for (const s in o)
    I1(e[s], o[s]);
  for (const s in i)
    O1(e[s], i[s]);
  return e;
}, Si = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, I1 = (e, t) => {
  if (t)
    for (const n in t)
      Si(e, n, t[n]);
}, O1 = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, F1 = (e, ...t) => typeof e == "function" ? Hu(Uu, e, ...t) : Hu(() => M1(Uu(), e), ...t), Uh = /* @__PURE__ */ Hu(Uu);
function Ee(...e) {
  return Uh(zh(e));
}
function Rc(e) {
  let t = 0, n = 0, r = 0;
  e.length == 4 ? (t = "0x" + e[1] + e[1], n = "0x" + e[2] + e[2], r = "0x" + e[3] + e[3]) : e.length == 7 && (t = "0x" + e[1] + e[2], n = "0x" + e[3] + e[4], r = "0x" + e[5] + e[6]), t /= 255, n /= 255, r /= 255;
  let a = Math.min(t, n, r), i = Math.max(t, n, r), o = i - a, s = 0, l = 0, u = 0;
  return o == 0 ? s = 0 : i == t ? s = (n - r) / o % 6 : i == n ? s = (r - t) / o + 2 : s = (t - n) / o + 4, s = Math.round(s * 60), s < 0 && (s += 360), u = (i + a) / 2, l = o == 0 ? 0 : o / (1 - Math.abs(2 * u - 1)), l = +(l * 100).toFixed(1), u = +(u * 100).toFixed(1), s + " " + l + "% " + u + "%";
}
function R1(e) {
  const t = Rc(e).split(" "), n = t[0], r = t[1];
  let a = parseFloat(t[2].replace("%", ""));
  return a = 90, `${n} ${r} ${a}%`;
}
function L1(e) {
  const t = Rc(e).split(" "), n = t[0], r = t[1];
  let a = parseFloat(t[2].replace("%", ""));
  return a = a > 50 ? 90 : 20, `${n} ${r} ${a}%`;
}
const ks = (e, t) => {
  let n = `--layup-radius: ${e.border_radius}px; --layup-font-family: ${e.font_family};`;
  return t && Object.entries(t).forEach(([r, a]) => {
    n += ` --layup-${r}: ${Rc(a)};`, n += ` --layup-${r}-light: ${R1(a)};`, n += ` --layup-${r}-hover: ${L1(a)};`;
  }), n;
}, qh = function(e) {
  return e && e.filter((t) => t.state.status === "NotStarted").length || 0;
}, Gh = function(e) {
  return e ? e.onboarding_flows.length - e.onboarding_flows.filter((t) => t.state.status === "Completed").length : 0;
};
function D1(e, t) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}
const Ss = (e, t) => {
  ["#layup-app"].forEach((r) => {
    var a, i;
    (a = document.querySelector(r)) == null || a.style.setProperty("--layup-radius", `${e.border_radius}px`), (i = document.documentElement) == null || i.style.setProperty(
      "--layup-radius",
      `${e.border_radius}px`
    ), Object.entries(t).forEach(([o, s]) => {
      var l;
      (l = document.querySelector(r)) == null || l.style.setProperty(`--layup-${o}`, `hsla(${s})`), document.documentElement.style.setProperty(
        `--layup-${o}`,
        `hsla(${s})`
      );
    });
  });
}, Qd = async () => {
  var n, r;
  if (!((n = X.internal_config) != null && n.api_key) || !((r = X.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${X.config.api_host}/platform-user/announcements?platform_user_id=${X.config.platform_user_data.user_id}`,
    {
      headers: {
        "x-api-token": X.internal_config.api_key
      }
    }
  )).json();
}, N1 = async () => {
  var e, t;
  if (!((e = X.internal_config) != null && e.api_key) || !((t = X.config) != null && t.api_host))
    throw new Error("API key or host is not defined");
  try {
    console.log("initWidget", X.config.platform_user_data);
    const n = await fetch(
      `${X.config.api_host}/platform-user/widget/init`,
      {
        method: "POST",
        headers: {
          "x-api-token": X.internal_config.api_key,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          group_id: X.config.group_id,
          platform_user_data: X.config.platform_user_data
        })
      }
    );
    return n.ok ? n.json() : null;
  } catch (n) {
    return console.error("Error initializing widget:", n), null;
  }
}, $d = async () => {
  var n, r;
  if (!((n = X.internal_config) != null && n.api_key) || !((r = X.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  const e = await fetch(
    `${X.config.api_host}/platform-user/onboarding-plan?platform_user_id=${X.config.platform_user_data.user_id}`,
    {
      headers: {
        "x-api-token": X.internal_config.api_key
      }
    }
  );
  if (!e.ok)
    throw new Error("Something went wrong");
  return await e.json();
}, z1 = async () => {
  var n, r;
  if (!((n = X.internal_config) != null && n.api_key) || !((r = X.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  const e = await fetch(
    `${X.config.api_host}/platform-user/query-history?user_id=${X.config.platform_user_data.user_id}&platform_id=${X.internal_config.platform_id}`,
    {
      headers: {
        "x-api-token": X.internal_config.api_key
      }
    }
  );
  if (!e.ok)
    throw new Error("Something went wrong");
  return await e.json();
}, V1 = async (e) => {
  var r, a;
  if (!((r = X.internal_config) != null && r.api_key) || !((a = X.config) != null && a.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${X.config.api_host}/platform-user/platforms/onboarding-flow/get_selected_flow?template_onboarding_flow_id=${e}&user_id=${X.config.platform_user_data.user_id}`,
    {
      headers: {
        "x-api-token": X.internal_config.api_key
      }
    }
  )).json();
}, ef = async (e, t) => {
  var a, i;
  if (!((a = X.internal_config) != null && a.api_key) || !((i = X.config) != null && i.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${X.config.api_host}/platform-user/platforms/${X.internal_config.platform_id}/query-history/${e}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-api-token": X.internal_config.api_key
      },
      body: JSON.stringify({
        status: t
      })
    }
  )).json();
}, us = async (e, t) => await (await fetch(
  `${X.config.api_host}/users/platforms/announcement/${e}/status`,
  {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": X.internal_config.api_key
    },
    body: JSON.stringify({
      status: t,
      platform_user_data: X.config.platform_user_data,
      group_id: X.config.group_id
    })
  }
)).json(), mi = async (e, t) => await (await fetch(
  `${X.config.api_host}/users/platforms/onboarding-flow/${e}/status`,
  {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": X.internal_config.api_key
    },
    body: JSON.stringify({
      status: t,
      platform_user_data: X.config.platform_user_data,
      group_id: X.config.group_id
    })
  }
)).json(), B1 = async (e) => await fetch(
  `${X.config.api_host}/automation/platforms/${X.internal_config.platform_id}/queries/${e}`,
  {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": X.internal_config.api_key
    },
    body: JSON.stringify({
      platform_user_data: X.config.platform_user_data,
      group_id: X.config.group_id
    })
  }
), j1 = async ({
  flow: e,
  query: t,
  had_full_run: n,
  from_cache: r,
  is_helpful: a
}) => await (await fetch(
  `${X.config.api_host}/users/platforms/${X.internal_config.platform_id}/query-history/feedback`,
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": X.internal_config.api_key
    },
    body: JSON.stringify({
      flow_id: e,
      query_id: t,
      is_helpful: a,
      had_full_run: n,
      from_cache: r
    })
  }
)).json(), tf = async (e) => await (await fetch(
  `${X.config.api_host}/automation/platforms/${X.internal_config.platform_id}/guidance-flows/${e}`,
  {
    headers: {
      "x-api-token": X.internal_config.api_key
    }
  }
)).json(), W1 = async (e) => await (await fetch(
  `${X.config.api_host}/automation/platforms/${X.internal_config.platform_id}/guidance-flows?name=${e}&limit=3&include_context=false`,
  {
    headers: {
      "x-api-token": X.internal_config.api_key
    }
  }
)).json(), mu = async () => {
  try {
    return await (await fetch(
      `${X.config.api_host}/automation/platforms/${X.internal_config.platform_id}/queries/top?starting_url=${encodeURIComponent(window.location.href)}`,
      {
        headers: {
          "x-api-token": X.internal_config.api_key
        }
      }
    )).json();
  } catch {
    return [];
  }
}, H1 = async (e) => {
  var r, a;
  if (!((r = X.internal_config) != null && r.api_key) || !((a = X.config) != null && a.api_host))
    throw new Error("API key or host is not defined");
  const t = await fetch(
    `${X.config.api_host}/automation/platforms/${X.internal_config.platform_id}/knowledge/query?query=${e}`,
    {
      headers: {
        "x-api-token": X.internal_config.api_key
      }
    }
  );
  if (!t.ok)
    throw new Error("Something went wrong");
  return await t.json();
}, U1 = "5";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(U1);
nm();
var q1 = /* @__PURE__ */ vt('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>'), G1 = /* @__PURE__ */ vt('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>'), K1 = /* @__PURE__ */ vt('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"></path></svg>'), Z1 = /* @__PURE__ */ vt('<svg viewBox="0 0 64 64" fill="currentColor" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M32.427,7.987c2.183,0.124 4,1.165 5.096,3.281l17.936,36.208c1.739,3.66 -0.954,8.585 -5.373,8.656l-36.119,0c-4.022,-0.064 -7.322,-4.631 -5.352,-8.696l18.271,-36.207c0.342,-0.65 0.498,-0.838 0.793,-1.179c1.186,-1.375 2.483,-2.111 4.748,-2.063Zm-0.295,3.997c-0.687,0.034 -1.316,0.419 -1.659,1.017c-6.312,11.979 -12.397,24.081 -18.301,36.267c-0.546,1.225 0.391,2.797 1.762,2.863c12.06,0.195 24.125,0.195 36.185,0c1.325,-0.064 2.321,-1.584 1.769,-2.85c-5.793,-12.184 -11.765,-24.286 -17.966,-36.267c-0.366,-0.651 -0.903,-1.042 -1.79,-1.03Z"></path><path d="M33.631,40.581l-3.348,0l-0.368,-16.449l4.1,0l-0.384,16.449Zm-3.828,5.03c0,-0.609 0.197,-1.113 0.592,-1.514c0.396,-0.4 0.935,-0.601 1.618,-0.601c0.684,0 1.223,0.201 1.618,0.601c0.395,0.401 0.593,0.905 0.593,1.514c0,0.587 -0.193,1.078 -0.577,1.473c-0.385,0.395 -0.929,0.593 -1.634,0.593c-0.705,0 -1.249,-0.198 -1.634,-0.593c-0.384,-0.395 -0.576,-0.886 -0.576,-1.473Z"></path></svg>');
function cs(e, t) {
  let n = L(t, "type", 8, "success");
  var r = Z(), a = V(r);
  {
    var i = (s) => {
      var l = q1();
      _(s, l);
    }, o = (s) => {
      var l = Z(), u = V(l);
      {
        var d = (p) => {
          var h = G1();
          _(p, h);
        }, f = (p) => {
          var h = Z(), y = V(h);
          {
            var g = (m) => {
              var v = K1();
              _(m, v);
            }, w = (m) => {
              var v = Z(), C = V(v);
              {
                var S = (x) => {
                  var E = Z1();
                  _(x, E);
                }, b = (x) => {
                };
                H(
                  C,
                  (x) => {
                    n() === "warning" ? x(S) : x(b, !1);
                  },
                  !0
                );
              }
              _(m, v);
            };
            H(
              y,
              (m) => {
                n() === "info" ? m(g) : m(w, !1);
              },
              !0
            );
          }
          _(p, h);
        };
        H(
          u,
          (p) => {
            n() === "error" ? p(d) : p(f, !1);
          },
          !0
        );
      }
      _(s, l);
    };
    H(a, (s) => {
      n() === "success" ? s(i) : s(o, !1);
    });
  }
  _(e, r);
}
var Y1 = /* @__PURE__ */ O('<div class="sonner-loading-bar"></div>'), X1 = /* @__PURE__ */ O('<div class="sonner-loading-wrapper"><div class="sonner-spinner"></div></div>');
function J1(e, t) {
  be(t, !1);
  let n = L(t, "visible", 8);
  const r = Array(12).fill(0);
  gn();
  var a = X1(), i = T(a);
  at(i, 5, () => r, gt, (o, s) => {
    var l = Y1();
    _(o, l);
  }), ee(() => he(a, "data-visible", n())), _(e, a), _e();
}
const sa = [];
function Q1(e, t) {
  return {
    subscribe: Kh(e, t).subscribe
  };
}
function Kh(e, t = De) {
  let n = null;
  const r = /* @__PURE__ */ new Set();
  function a(s) {
    if (Hl(e, s) && (e = s, n)) {
      const l = !sa.length;
      for (const u of r)
        u[1](), sa.push(u, e);
      if (l) {
        for (let u = 0; u < sa.length; u += 2)
          sa[u][0](sa[u + 1]);
        sa.length = 0;
      }
    }
  }
  function i(s) {
    a(s(
      /** @type {T} */
      e
    ));
  }
  function o(s, l = De) {
    const u = [s, l];
    return r.add(u), r.size === 1 && (n = t(a, i) || De), s(
      /** @type {T} */
      e
    ), () => {
      r.delete(u), r.size === 0 && n && (n(), n = null);
    };
  }
  return { set: a, update: i, subscribe: o };
}
function nf(e) {
  let t;
  return Dh(e, (n) => t = n)(), t;
}
function wi(e) {
  z(e, e.v + 1);
}
function la(...e) {
  return e.filter(Boolean).join(" ");
}
const rf = typeof document < "u";
function af(e) {
  const t = Kh(e);
  function n(a) {
    rf && t.set(a);
  }
  function r(a) {
    rf && t.update(a);
  }
  return {
    subscribe: t.subscribe,
    set: n,
    update: r
  };
}
let of = 0;
function $1() {
  const e = af([]), t = af([]);
  function n(m) {
    e.update((v) => [m, ...v]);
  }
  function r(m) {
    var I;
    const { message: v, ...C } = m, S = typeof (m == null ? void 0 : m.id) == "number" || m.id && ((I = m.id) == null ? void 0 : I.length) > 0 ? m.id : of++, b = m.dismissable === void 0 ? !0 : m.dismissable, x = m.type === void 0 ? "default" : m.type;
    return nf(e).find((D) => D.id === S) ? e.update((D) => D.map((A) => A.id === S ? {
      ...A,
      ...m,
      id: S,
      title: v,
      dismissable: b,
      type: x,
      updated: !0
    } : {
      ...A,
      updated: !1
    })) : n({ ...C, id: S, title: v, dismissable: b, type: x }), S;
  }
  function a(m) {
    if (m === void 0) {
      e.update((v) => v.map((C) => ({ ...C, dismiss: !0 })));
      return;
    }
    return e.update((v) => v.map((C) => C.id === m ? { ...C, dismiss: !0 } : C)), m;
  }
  function i(m) {
    if (m === void 0) {
      e.set([]);
      return;
    }
    return e.update((v) => v.filter((C) => C.id !== m)), m;
  }
  function o(m, v) {
    return r({ ...v, type: "default", message: m });
  }
  function s(m, v) {
    return r({ ...v, type: "error", message: m });
  }
  function l(m, v) {
    return r({ ...v, type: "success", message: m });
  }
  function u(m, v) {
    return r({ ...v, type: "info", message: m });
  }
  function d(m, v) {
    return r({ ...v, type: "warning", message: m });
  }
  function f(m, v) {
    return r({ ...v, type: "loading", message: m });
  }
  function p(m, v) {
    if (!v)
      return;
    let C;
    v.loading !== void 0 && (C = r({
      ...v,
      promise: m,
      type: "loading",
      message: v.loading
    }));
    const S = m instanceof Promise ? m : m();
    let b = C !== void 0;
    return S.then((x) => {
      if (x && typeof x.ok == "boolean" && !x.ok) {
        b = !1;
        const E = typeof v.error == "function" ? (
          // @ts-expect-error: Incorrect response type
          v.error(`HTTP error! status: ${x.status}`)
        ) : v.error;
        r({ id: C, type: "error", message: E });
      } else if (v.success !== void 0) {
        b = !1;
        const E = (
          // @ts-expect-error: TODO: Better function checking
          typeof v.success == "function" ? v.success(x) : v.success
        );
        r({ id: C, type: "success", message: E });
      }
    }).catch((x) => {
      if (v.error !== void 0) {
        b = !1;
        const E = (
          // @ts-expect-error: TODO: Better function checking
          typeof v.error == "function" ? v.error(x) : v.error
        );
        r({ id: C, type: "error", message: E });
      }
    }).finally(() => {
      var x;
      b && (a(C), C = void 0), (x = v.finally) == null || x.call(v);
    }), C;
  }
  function h(m, v) {
    const C = (v == null ? void 0 : v.id) || of++;
    return r({ component: m, id: C, ...v }), C;
  }
  function y(m) {
    t.update((v) => v.filter((C) => C.toastId !== m));
  }
  function g(m) {
    if (nf(t).find((C) => C.toastId === m.toastId) === void 0) {
      t.update((C) => [m, ...C]);
      return;
    }
    t.update((C) => C.map((S) => S.toastId === m.toastId ? m : S));
  }
  function w() {
    e.set([]), t.set([]);
  }
  return {
    // methods
    create: r,
    addToast: n,
    dismiss: a,
    remove: i,
    message: o,
    error: s,
    success: l,
    info: u,
    warning: d,
    loading: f,
    promise: p,
    custom: h,
    removeHeight: y,
    setHeight: g,
    reset: w,
    // stores
    toasts: e,
    heights: t
  };
}
const rn = $1();
function e0(e, t) {
  return rn.create({
    message: e,
    ...t
  });
}
const t0 = e0, ua = Object.assign(t0, {
  success: rn.success,
  info: rn.info,
  warning: rn.warning,
  error: rn.error,
  custom: rn.custom,
  message: rn.message,
  promise: rn.promise,
  dismiss: rn.dismiss,
  loading: rn.loading
}), n0 = (e) => ({ subscribe: e });
var r0 = /* @__PURE__ */ O('<button aria-label="Close toast" data-close-button=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>'), a0 = /* @__PURE__ */ O('<div data-icon=""><!> <!></div>'), i0 = /* @__PURE__ */ O('<div data-title=""><!></div>'), o0 = /* @__PURE__ */ O('<div data-description=""><!></div>'), s0 = /* @__PURE__ */ O('<button data-button="" data-cancel=""> </button>'), l0 = /* @__PURE__ */ O('<button data-button=""> </button>'), u0 = /* @__PURE__ */ O('<!> <div data-content=""><!> <!></div> <!> <!>', 1), c0 = /* @__PURE__ */ O('<li aria-atomic="true" role="status" data-sonner-toast=""><!> <!></li>');
function d0(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  be(t, !1);
  const r = Tr(), a = () => un(D, "$heights", r), i = () => un(c(re), "$effect", r), o = () => un(I, "$toasts", r), s = We(void 0, !0), l = We(void 0, !0), u = We(void 0, !0), d = We(void 0, !0), f = We(void 0, !0), p = We(void 0, !0), h = We(void 0, !0), y = We(void 0, !0), g = We(void 0, !0), w = We(void 0, !0), m = We(void 0, !0), v = We(void 0, !0), C = 4e3, S = 14, b = 20, x = 200, E = 0.05, k = {
    toast: "",
    title: "",
    description: "",
    loader: "",
    closeButton: "",
    cancelButton: "",
    actionButton: "",
    action: "",
    warning: "",
    error: "",
    success: "",
    default: "",
    info: "",
    loading: ""
  }, {
    toasts: I,
    heights: D,
    removeHeight: A,
    setHeight: M,
    remove: N
  } = rn;
  let P = L(t, "toast", 9), Y = L(t, "index", 9), G = L(t, "expanded", 9), q = L(t, "invert", 13), J = L(t, "position", 9), $ = L(t, "visibleToasts", 9), W = L(t, "expandByDefault", 9), j = L(t, "closeButton", 9), B = L(t, "interacting", 9), K = L(t, "cancelButtonStyle", 9, ""), U = L(t, "actionButtonStyle", 9, ""), ne = L(t, "duration", 9, 4e3), ue = L(t, "descriptionClass", 9, ""), ae = L(t, "classes", 29, () => ({})), se = L(t, "unstyled", 9, !1), ge = We(!1, !0), pe = We(!1, !0), ve = We(!1, !0), me = We(!1, !0), we = We(0, !0), fe = We(0, !0), Oe = We(void 0, !0), Ue = We(0, !0), Fe = 0, qe = 0, tt = null;
  async function pt() {
    if (!c(ge))
      return;
    await Ac();
    let Me;
    G() || W() ? Me = 1 : Me = 1 - Y() * E, c(Oe).style.setProperty("height", "auto");
    const Ye = c(Oe).offsetHeight, Pt = c(Oe).getBoundingClientRect().height, Nt = Math.round((Pt / Me + Number.EPSILON) * 100) / 100;
    c(Oe).style.removeProperty("height");
    let xt;
    Math.abs(Nt - Ye) < 1 ? xt = Nt : xt = Ye, z(fe, xt), M({ toastId: P().id, height: xt });
  }
  function je() {
    z(pe, !0), z(we, c(Ue)), A(P().id), setTimeout(
      () => {
        N(P().id);
      },
      x
    );
  }
  let Ge = We(void 0, !0), mt = We(P().duration || ne() || C, !0);
  function Ke() {
    if (qe < Fe) {
      const Me = (/* @__PURE__ */ new Date()).getTime() - Fe;
      z(mt, c(mt) - Me);
    }
    qe = (/* @__PURE__ */ new Date()).getTime();
  }
  function Ae() {
    Fe = (/* @__PURE__ */ new Date()).getTime(), z(Ge, setTimeout(
      () => {
        var Me, Ye;
        (Ye = (Me = P()).onAutoClose) == null || Ye.call(Me, P()), je();
      },
      c(mt)
    ));
  }
  let re = We(void 0, !0);
  Rn(() => {
    z(ge, !0);
    const Me = c(Oe).getBoundingClientRect().height;
    return z(fe, Me), M({ toastId: P().id, height: Me }), () => A(P().id);
  });
  function le(Me) {
    if (c(m))
      return;
    z(we, c(Ue));
    const Ye = Me.target;
    Ye.setPointerCapture(Me.pointerId), Ye.tagName !== "BUTTON" && (z(ve, !0), tt = { x: Me.clientX, y: Me.clientY });
  }
  function Pe() {
    var Ye, Pt, Nt;
    if (c(me))
      return;
    tt = null;
    const Me = Number(((Ye = c(Oe)) == null ? void 0 : Ye.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0);
    if (Math.abs(Me) >= b) {
      z(we, c(Ue)), (Nt = (Pt = P()).onDismiss) == null || Nt.call(Pt, P()), je(), z(me, !0);
      return;
    }
    c(Oe).style.setProperty("--swipe-amount", "0px"), z(ve, !1);
  }
  function Ne(Me) {
    if (!tt)
      return;
    const Ye = Me.clientY - tt.y, Pt = Me.clientX - tt.x, xt = (c(g)[0] === "top" ? Math.min : Math.max)(0, Ye), Mt = Me.pointerType === "touch" ? 10 : 2;
    Math.abs(xt) > Mt ? c(Oe).style.setProperty("--swipe-amount", `${Ye}px`) : Math.abs(Pt) > Mt && (tt = null);
  }
  Xe(() => Qe(ae()), () => {
    ae({ ...k, ...ae() });
  }), Xe(() => Qe(Y()), () => {
    z(s, Y() === 0);
  }), Xe(
    () => (Qe(Y()), Qe($())),
    () => {
      z(l, Y() + 1 <= $());
    }
  ), Xe(() => Qe(P()), () => {
    z(u, P().title);
  }), Xe(() => Qe(P()), () => {
    z(d, P().description);
  }), Xe(() => Qe(P()), () => {
    z(f, P().type);
  }), Xe(() => Qe(P()), () => {
    z(p, P().class || "");
  }), Xe(() => Qe(P()), () => {
    z(h, P().descriptionClass || "");
  }), Xe(
    () => (a(), Qe(P())),
    () => {
      z(y, a().findIndex((Me) => Me.toastId === P().id) || 0);
    }
  ), Xe(() => Qe(J()), () => {
    z(g, J().split("-"));
  }), Xe(() => (a(), c(y)), () => {
    z(w, a().reduce(
      (Me, Ye, Pt) => Pt >= c(y) ? Me : Me + Ye.height,
      0
    ));
  }), Xe(
    () => (Qe(q()), Qe(P())),
    () => {
      q(P().invert || q());
    }
  ), Xe(() => c(f), () => {
    z(m, c(f) === "loading");
  }), Xe(
    () => (c(y), c(w)),
    () => {
      z(Ue, Math.round(c(y) * S + c(w)));
    }
  ), Xe(
    () => (c(u), c(d)),
    () => {
      c(u), c(d), pt();
    }
  ), Xe(
    () => (Qe(P()), c(Ge), Qe(ne())),
    () => {
      P().updated && (clearTimeout(c(Ge)), z(mt, P().duration || ne() || C), Ae());
    }
  ), Xe(
    () => (Qe(P()), c(f)),
    () => {
      z(v, P().promise && c(f) === "loading" || P().duration === Number.POSITIVE_INFINITY);
    }
  ), Xe(
    () => (c(v), Qe(G()), Qe(B()), c(Ge)),
    () => {
      Ym(
        z(re, n0(() => (c(v) || (G() || B() ? Ke() : Ae()), () => clearTimeout(c(Ge))))),
        "$effect",
        r
      );
    }
  ), Xe(() => i(), () => {
    i();
  }), Xe(() => Qe(P()), () => {
    P().delete && je();
  }), Gl(), gn(!0);
  var xe = c0();
  he(xe, "tabindex", 0);
  const ft = /* @__PURE__ */ St(() => {
    var Me, Ye, Pt, Nt, xt, Mt;
    return la(n.class, c(p), (Me = ae()) == null ? void 0 : Me.toast, (Pt = (Ye = P()) == null ? void 0 : Ye.classes) == null ? void 0 : Pt.toast, (Nt = ae()) == null ? void 0 : Nt[c(f)], (Mt = (xt = P()) == null ? void 0 : xt.classes) == null ? void 0 : Mt[c(f)]);
  });
  ee(() => he(xe, "data-promise", !!P().promise)), ee(() => he(xe, "data-expanded", !!(G() || W() && c(ge))));
  var At = T(xe);
  {
    var mn = (Me) => {
      var Ye = r0(), Pt = /* @__PURE__ */ R(() => c(m) ? void 0 : () => {
        var xt, Mt;
        je(), (Mt = (xt = P()).onDismiss) == null || Mt.call(xt, P());
      });
      const Nt = /* @__PURE__ */ St(() => {
        var xt, Mt, fi;
        return la((xt = ae()) == null ? void 0 : xt.closeButton, (fi = (Mt = P()) == null ? void 0 : Mt.classes) == null ? void 0 : fi.closeButton);
      });
      ee(() => {
        he(Ye, "data-disabled", c(m)), Ve(Ye, c(Nt));
      }), ct("click", Ye, function(...xt) {
        var Mt;
        (Mt = c(Pt)) == null || Mt.apply(this, xt);
      }), _(Me, Ye);
    };
    H(At, (Me) => {
      j() && !P().component && Me(mn);
    });
  }
  var on = Q(At, 2);
  {
    var wn = (Me) => {
      var Ye = Z(), Pt = V(Ye);
      rt(Pt, () => P().component, (Nt, xt) => {
        xt(Nt, ot(() => P().componentProps, { $$events: { closeToast: je } }));
      }), _(Me, Ye);
    }, er = (Me) => {
      var Ye = u0(), Pt = V(Ye);
      {
        var Nt = (Tt) => {
          var kt = a0(), bn = T(kt);
          {
            var zn = (ut) => {
              var zt = Z(), Vn = V(zt);
              He(Vn, t, "loading-icon", {}, null), _(ut, zt);
            };
            H(bn, (ut) => {
              (P().promise || c(f) === "loading") && !P().icon && ut(zn);
            });
          }
          var It = Q(bn, 2);
          {
            var Ut = (ut) => {
              var zt = Z(), Vn = V(zt);
              rt(Vn, () => P().icon, (Pr, lu) => {
                lu(Pr, {});
              }), _(ut, zt);
            }, dt = (ut) => {
              var zt = Z(), Vn = V(zt);
              {
                var Pr = (ra) => {
                  var pi = Z(), uu = V(pi);
                  He(uu, t, "success-icon", {}, null), _(ra, pi);
                }, lu = (ra) => {
                  var pi = Z(), uu = V(pi);
                  {
                    var Pv = (aa) => {
                      var hi = Z(), cu = V(hi);
                      He(cu, t, "error-icon", {}, null), _(aa, hi);
                    }, Mv = (aa) => {
                      var hi = Z(), cu = V(hi);
                      {
                        var Iv = (ia) => {
                          var yi = Z(), du = V(yi);
                          He(du, t, "warning-icon", {}, null), _(ia, yi);
                        }, Ov = (ia) => {
                          var yi = Z(), du = V(yi);
                          {
                            var Fv = (fu) => {
                              var Rd = Z(), Rv = V(Rd);
                              He(Rv, t, "info-icon", {}, null), _(fu, Rd);
                            };
                            H(
                              du,
                              (fu) => {
                                c(f) === "info" && fu(Fv);
                              },
                              !0
                            );
                          }
                          _(ia, yi);
                        };
                        H(
                          cu,
                          (ia) => {
                            c(f) === "warning" ? ia(Iv) : ia(Ov, !1);
                          },
                          !0
                        );
                      }
                      _(aa, hi);
                    };
                    H(
                      uu,
                      (aa) => {
                        c(f) === "error" ? aa(Pv) : aa(Mv, !1);
                      },
                      !0
                    );
                  }
                  _(ra, pi);
                };
                H(
                  Vn,
                  (ra) => {
                    c(f) === "success" ? ra(Pr) : ra(lu, !1);
                  },
                  !0
                );
              }
              _(ut, zt);
            };
            H(It, (ut) => {
              P().icon ? ut(Ut) : ut(dt, !1);
            });
          }
          _(Tt, kt);
        };
        H(Pt, (Tt) => {
          (c(f) !== "default" || P().icon || P().promise) && Tt(Nt);
        });
      }
      var xt = Q(Pt, 2), Mt = T(xt);
      {
        var fi = (Tt) => {
          var kt = i0();
          const bn = /* @__PURE__ */ St(() => {
            var dt, ut, zt;
            return la((dt = ae()) == null ? void 0 : dt.title, (zt = (ut = P()) == null ? void 0 : ut.classes) == null ? void 0 : zt.title);
          });
          var zn = T(kt);
          {
            var It = (dt) => {
              var ut = Z(), zt = V(ut);
              rt(zt, () => P().title, (Vn, Pr) => {
                Pr(Vn, ot(() => P().componentProps));
              }), _(dt, ut);
            }, Ut = (dt) => {
              var ut = qa();
              ee(() => ke(ut, P().title)), _(dt, ut);
            };
            H(zn, (dt) => {
              typeof P().title != "string" ? dt(It) : dt(Ut, !1);
            });
          }
          ee(() => Ve(kt, c(bn))), _(Tt, kt);
        };
        H(Mt, (Tt) => {
          P().title && Tt(fi);
        });
      }
      var Sv = Q(Mt, 2);
      {
        var Cv = (Tt) => {
          var kt = o0();
          const bn = /* @__PURE__ */ St(() => {
            var dt, ut;
            return la(ue(), c(h), (dt = ae()) == null ? void 0 : dt.description, (ut = P().classes) == null ? void 0 : ut.description);
          });
          var zn = T(kt);
          {
            var It = (dt) => {
              var ut = Z(), zt = V(ut);
              rt(zt, () => P().description, (Vn, Pr) => {
                Pr(Vn, ot(() => P().componentProps));
              }), _(dt, ut);
            }, Ut = (dt) => {
              var ut = qa();
              ee(() => ke(ut, P().description)), _(dt, ut);
            };
            H(zn, (dt) => {
              typeof P().description != "string" ? dt(It) : dt(Ut, !1);
            });
          }
          ee(() => Ve(kt, c(bn))), _(Tt, kt);
        };
        H(Sv, (Tt) => {
          P().description && Tt(Cv);
        });
      }
      var Fd = Q(xt, 2);
      {
        var Ev = (Tt) => {
          var kt = s0();
          const bn = /* @__PURE__ */ St(() => {
            var It, Ut, dt;
            return la((It = ae()) == null ? void 0 : It.cancelButton, (dt = (Ut = P()) == null ? void 0 : Ut.classes) == null ? void 0 : dt.cancelButton);
          });
          var zn = T(kt);
          ee(() => {
            he(kt, "style", K()), Ve(kt, c(bn)), ke(zn, P().cancel.label);
          }), ct("click", kt, () => {
            var It;
            je(), (It = P().cancel) != null && It.onClick && P().cancel.onClick();
          }), _(Tt, kt);
        };
        H(Fd, (Tt) => {
          P().cancel && Tt(Ev);
        });
      }
      var Tv = Q(Fd, 2);
      {
        var Av = (Tt) => {
          var kt = l0();
          const bn = /* @__PURE__ */ St(() => {
            var It, Ut, dt;
            return la((It = ae()) == null ? void 0 : It.actionButton, (dt = (Ut = P()) == null ? void 0 : Ut.classes) == null ? void 0 : dt.actionButton);
          });
          var zn = T(kt);
          ee(() => {
            he(kt, "style", U()), Ve(kt, c(bn)), ke(zn, P().action.label);
          }), ct("click", kt, (It) => {
            var Ut;
            (Ut = P().action) == null || Ut.onClick(It), !It.defaultPrevented && je();
          }), _(Tt, kt);
        };
        H(Tv, (Tt) => {
          P().action && Tt(Av);
        });
      }
      _(Me, Ye);
    };
    H(on, (Me) => {
      P().component ? Me(wn) : Me(er, !1);
    });
  }
  tn(xe, (Me) => z(Oe, Me), () => c(Oe)), ee(() => {
    var Me;
    he(xe, "aria-live", P().important ? "assertive" : "polite"), Ve(xe, c(ft)), he(xe, "data-styled", !(P().component || (Me = P()) != null && Me.unstyled || se())), he(xe, "data-mounted", c(ge)), he(xe, "data-removed", c(pe)), he(xe, "data-visible", c(l)), he(xe, "data-y-position", c(g)[0]), he(xe, "data-x-position", c(g)[1]), he(xe, "data-index", Y()), he(xe, "data-front", c(s)), he(xe, "data-swiping", c(ve)), he(xe, "data-type", c(f)), he(xe, "data-invert", q()), he(xe, "data-swipe-out", c(me)), he(xe, "style", `${n.style} ${P().style}`), Kn(xe, "--index", Y()), Kn(xe, "--toasts-before", Y()), Kn(xe, "--z-index", o().length - Y()), Kn(xe, "--offset", `${c(pe) ? c(we) : c(Ue)}px`), Kn(xe, "--initial-height", `${c(fe)}px`);
  }), ct("pointerdown", xe, le), ct("pointerup", xe, Pe), ct("pointermove", xe, Ne), _(e, xe), _e();
}
var f0 = /* @__PURE__ */ O("<ol></ol>"), p0 = /* @__PURE__ */ O('<section class="svelte-1fo5d1m"></section>');
function h0(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, [
    "invert",
    "theme",
    "position",
    "hotkey",
    "containerAriaLabel",
    "richColors",
    "expand",
    "duration",
    "visibleToasts",
    "closeButton",
    "toastOptions",
    "offset",
    "dir"
  ]);
  be(t, !1);
  const a = Tr(), i = () => un(P, "$toasts", a), o = () => un(Y, "$heights", a), s = We(), l = We(), u = 3, d = "32px", f = 356, p = 14, h = "dark", y = "light";
  function g(se) {
    return se !== "system" ? se : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? h : y;
  }
  function w() {
    if (typeof window > "u" || typeof document > "u") return "ltr";
    const se = document.documentElement.getAttribute("dir");
    return se === "auto" || !se ? window.getComputedStyle(document.documentElement).direction : se;
  }
  let m = L(t, "invert", 8, !1), v = L(t, "theme", 8, "light"), C = L(t, "position", 8, "bottom-right"), S = L(t, "hotkey", 24, () => ["altKey", "KeyT"]), b = L(t, "containerAriaLabel", 8, "Notifications"), x = L(t, "richColors", 8, !1), E = L(t, "expand", 8, !1), k = L(t, "duration", 8, 4e3), I = L(t, "visibleToasts", 8, u), D = L(t, "closeButton", 8, !1), A = L(t, "toastOptions", 24, () => ({})), M = L(t, "offset", 8, null), N = L(t, "dir", 24, w);
  const { toasts: P, heights: Y, reset: G } = rn;
  let q = We(!1), J = We(!1), $ = We(g(v())), W = We(), j = null, B = !1;
  Oc(() => {
    c(W) && j && (j.focus({ preventScroll: !0 }), j = null, B = !1);
  }), Rn(() => {
    G();
    const se = (ge) => {
      var ve, me;
      S().every((we) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ge[we] || ge.code === we
      )) && (z(q, !0), (ve = c(W)) == null || ve.focus()), ge.code === "Escape" && (document.activeElement === c(W) || (me = c(W)) != null && me.contains(document.activeElement)) && z(q, !1);
    };
    return document.addEventListener("keydown", se), () => {
      document.removeEventListener("keydown", se);
    };
  });
  function K(se) {
    B && !se.currentTarget.contains(se.relatedTarget) && (B = !1, j && (j.focus({ preventScroll: !0 }), j = null));
  }
  function U(se) {
    B || (B = !0, j = se.relatedTarget);
  }
  Xe(
    () => (Qe(C()), i()),
    () => {
      z(s, Array.from(new Set([
        C(),
        ...i().filter((se) => se.position).map((se) => se.position)
      ].filter(Boolean))));
    }
  ), Xe(() => Qe(S()), () => {
    z(l, S().join("+").replace(/Key/g, "").replace(/Digit/g, ""));
  }), Xe(() => i(), () => {
    i().length <= 1 && z(q, !1);
  }), Xe(() => i(), () => {
    const se = i().filter((ge) => ge.dismiss && !ge.delete);
    if (se.length > 0) {
      const ge = i().map((pe) => se.find((me) => me.id === pe.id) ? { ...pe, delete: !0 } : pe);
      P.set(ge);
    }
  }), Xe(() => Qe(v()), () => {
    if (v() !== "system" && z($, v()), typeof window < "u") {
      v() === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? z($, h) : z($, y));
      const se = window.matchMedia("(prefers-color-scheme: dark)"), ge = ({ matches: pe }) => {
        z($, pe ? h : y);
      };
      "addEventListener" in se ? se.addEventListener("change", ge) : se.addListener(ge);
    }
  }), Gl(), gn();
  var ne = Z(), ue = V(ne);
  {
    var ae = (se) => {
      var ge = p0();
      he(ge, "tabindex", -1), at(ge, 5, () => c(s), gt, (ve, me, we) => {
        var fe = f0();
        let Oe;
        at(fe, 7, () => i().filter((Fe) => !Fe.position && we === 0 || Fe.position === c(me)), (Fe) => Fe.id, (Fe, qe, tt) => {
          var pt = /* @__PURE__ */ St(() => {
            var le;
            return ((le = A()) == null ? void 0 : le.actionButtonStyle) || "";
          }), je = /* @__PURE__ */ St(() => {
            var le;
            return ((le = A()) == null ? void 0 : le.cancelButtonStyle) || "";
          }), Ge = /* @__PURE__ */ St(() => {
            var le;
            return ((le = A()) == null ? void 0 : le.class) || "";
          }), mt = /* @__PURE__ */ St(() => {
            var le;
            return ((le = A()) == null ? void 0 : le.descriptionClass) || "";
          }), Ke = /* @__PURE__ */ St(() => A().classes || {}), Ae = /* @__PURE__ */ St(() => {
            var le;
            return ((le = A()) == null ? void 0 : le.duration) ?? k();
          }), re = /* @__PURE__ */ St(() => A().unstyled || !1);
          d0(Fe, {
            get index() {
              return c(tt);
            },
            get toast() {
              return c(qe);
            },
            get invert() {
              return m();
            },
            get visibleToasts() {
              return I();
            },
            get closeButton() {
              return D();
            },
            get interacting() {
              return c(J);
            },
            get position() {
              return c(me);
            },
            get expandByDefault() {
              return E();
            },
            get expanded() {
              return c(q);
            },
            get actionButtonStyle() {
              return c(pt);
            },
            get cancelButtonStyle() {
              return c(je);
            },
            get class() {
              return c(Ge);
            },
            get descriptionClass() {
              return c(mt);
            },
            get classes() {
              return c(Ke);
            },
            get duration() {
              return c(Ae);
            },
            get unstyled() {
              return c(re);
            },
            $$slots: {
              "loading-icon": (le, Pe) => {
                var Ne = Z(), xe = V(Ne);
                He(xe, t, "loading-icon", {}, (ft) => {
                  var At = /* @__PURE__ */ St(() => c(qe).type === "loading");
                  J1(ft, {
                    get visible() {
                      return c(At);
                    }
                  });
                }), _(le, Ne);
              },
              "success-icon": (le, Pe) => {
                var Ne = Z(), xe = V(Ne);
                He(xe, t, "success-icon", {}, (ft) => {
                  cs(ft, { type: "success" });
                }), _(le, Ne);
              },
              "error-icon": (le, Pe) => {
                var Ne = Z(), xe = V(Ne);
                He(xe, t, "error-icon", {}, (ft) => {
                  cs(ft, { type: "error" });
                }), _(le, Ne);
              },
              "warning-icon": (le, Pe) => {
                var Ne = Z(), xe = V(Ne);
                He(xe, t, "warning-icon", {}, (ft) => {
                  cs(ft, { type: "warning" });
                }), _(le, Ne);
              },
              "info-icon": (le, Pe) => {
                var Ne = Z(), xe = V(Ne);
                He(xe, t, "info-icon", {}, (ft) => {
                  cs(ft, { type: "info" });
                }), _(le, Ne);
              }
            }
          });
        }), tn(fe, (Fe) => z(W, Fe), () => c(W)), ee(() => {
          var Fe;
          Oe = Je(
            fe,
            Oe,
            {
              tabIndex: -1,
              class: n.class,
              "data-sonner-toaster": !0,
              "data-theme": c($),
              "data-rich-colors": x(),
              dir: N() === "auto" ? w() : N(),
              "data-y-position": c(me).split("-")[0],
              "data-x-position": c(me).split("-")[1],
              style: n.style,
              ...r
            },
            "svelte-1fo5d1m"
          ), Kn(fe, "--front-toast-height", `${(Fe = o()[0]) == null ? void 0 : Fe.height}px`), Kn(fe, "--offset", typeof M() == "number" ? `${M()}px` : M() || d), Kn(fe, "--width", `${f}px`), Kn(fe, "--gap", `${p}px`), fe.dir = fe.dir;
        }), ct("blur", fe, K), ct("focus", fe, U), ct("mouseenter", fe, () => z(q, !0)), ct("mousemove", fe, () => z(q, !0)), ct("mouseleave", fe, () => {
          c(J) || z(q, !1);
        }), ct("pointerdown", fe, () => z(J, !0)), ct("pointerup", fe, () => z(J, !1)), _(ve, fe);
      }), ee(() => he(ge, "aria-label", `${b()} ${c(l)}`)), _(se, ge);
    };
    H(ue, (se) => {
      i().length > 0 && se(ae);
    });
  }
  _(e, ne), _e();
}
function y0(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, []);
  h0(e, ot(
    {
      class: "toaster group",
      toastOptions: {
        classes: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      }
    },
    () => r
  ));
}
async function g0(e, t) {
  const n = e.getReader();
  let r;
  for (; !(r = await n.read()).done; )
    t(r.value);
}
function v0(e) {
  let t, n, r, a = !1;
  return function(o) {
    t === void 0 ? (t = o, n = 0, r = -1) : t = w0(t, o);
    const s = t.length;
    let l = 0;
    for (; n < s; ) {
      a && (t[n] === 10 && (l = ++n), a = !1);
      let u = -1;
      for (; n < s && u === -1; ++n)
        switch (t[n]) {
          case 58:
            r === -1 && (r = n - l);
            break;
          case 13:
            a = !0;
          case 10:
            u = n;
            break;
        }
      if (u === -1)
        break;
      e(t.subarray(l, u), r), l = n, r = -1;
    }
    l === s ? t = void 0 : l !== 0 && (t = t.subarray(l), n -= l);
  };
}
function m0(e, t, n) {
  let r = sf();
  const a = new TextDecoder();
  return function(o, s) {
    if (o.length === 0)
      n == null || n(r), r = sf();
    else if (s > 0) {
      const l = a.decode(o.subarray(0, s)), u = s + (o[s + 1] === 32 ? 2 : 1), d = a.decode(o.subarray(u));
      switch (l) {
        case "data":
          r.data = r.data ? r.data + `
` + d : d;
          break;
        case "event":
          r.event = d;
          break;
        case "id":
          e(r.id = d);
          break;
        case "retry":
          const f = parseInt(d, 10);
          isNaN(f) || t(r.retry = f);
          break;
      }
    }
  };
}
function w0(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e), n.set(t, e.length), n;
}
function sf() {
  return {
    data: "",
    event: "",
    id: "",
    retry: void 0
  };
}
var b0 = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const qu = "text/event-stream", _0 = 1e3, lf = "last-event-id";
function x0(e, t) {
  var { signal: n, headers: r, onopen: a, onmessage: i, onclose: o, onerror: s, openWhenHidden: l, fetch: u } = t, d = b0(t, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
  return new Promise((f, p) => {
    const h = Object.assign({}, r);
    h.accept || (h.accept = qu);
    let y;
    function g() {
      y.abort(), document.hidden || b();
    }
    l || document.addEventListener("visibilitychange", g);
    let w = _0, m = 0;
    function v() {
      document.removeEventListener("visibilitychange", g), window.clearTimeout(m), y.abort();
    }
    n == null || n.addEventListener("abort", () => {
      v(), f();
    });
    const C = u ?? window.fetch, S = a ?? k0;
    async function b() {
      var x;
      y = new AbortController();
      try {
        const E = await C(e, Object.assign(Object.assign({}, d), { headers: h, signal: y.signal }));
        await S(E), await g0(E.body, v0(m0((k) => {
          k ? h[lf] = k : delete h[lf];
        }, (k) => {
          w = k;
        }, i))), o == null || o(), v(), f();
      } catch (E) {
        if (!y.signal.aborted)
          try {
            const k = (x = s == null ? void 0 : s(E)) !== null && x !== void 0 ? x : w;
            window.clearTimeout(m), m = window.setTimeout(b, k);
          } catch (k) {
            v(), p(k);
          }
      }
    }
    b();
  });
}
function k0(e) {
  const t = e.headers.get("content-type");
  if (!(t != null && t.startsWith(qu)))
    throw new Error(`Expected content-type to be ${qu}, Actual: ${t}`);
}
function S0() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function C0() {
  const e = S0();
  if (e.__xstate__)
    return e.__xstate__;
}
const E0 = (e) => {
  if (typeof window > "u")
    return;
  const t = C0();
  t && t.register(e);
};
class uf {
  constructor(t) {
    this._process = t, this._active = !1, this._current = null, this._last = null;
  }
  start() {
    this._active = !0, this.flush();
  }
  clear() {
    this._current && (this._current.next = null, this._last = this._current);
  }
  enqueue(t) {
    const n = {
      value: t,
      next: null
    };
    if (this._current) {
      this._last.next = n, this._last = n;
      return;
    }
    this._current = n, this._last = n, this._active && this.flush();
  }
  flush() {
    for (; this._current; ) {
      const t = this._current;
      this._process(t.value), this._current = t.next;
    }
    this._last = null;
  }
}
const Zh = ".", T0 = "", Yh = "", A0 = "#", P0 = "*", Xh = "xstate.init", M0 = "xstate.error", Ri = "xstate.stop";
function I0(e, t) {
  return {
    type: `xstate.after.${e}.${t}`
  };
}
function Gu(e, t) {
  return {
    type: `xstate.done.state.${e}`,
    output: t
  };
}
function O0(e, t) {
  return {
    type: `xstate.done.actor.${e}`,
    output: t,
    actorId: e
  };
}
function Jh(e, t) {
  return {
    type: `xstate.error.actor.${e}`,
    error: t,
    actorId: e
  };
}
function Qh(e) {
  return {
    type: Xh,
    input: e
  };
}
function jn(e) {
  setTimeout(() => {
    throw e;
  });
}
const F0 = typeof Symbol == "function" && Symbol.observable || "@@observable";
function $h(e, t) {
  const n = cf(e), r = cf(t);
  return typeof r == "string" ? typeof n == "string" ? r === n : !1 : typeof n == "string" ? n in r : Object.keys(n).every((a) => a in r ? $h(n[a], r[a]) : !1);
}
function Lc(e) {
  if (ty(e))
    return e;
  const t = [];
  let n = "";
  for (let r = 0; r < e.length; r++) {
    switch (e.charCodeAt(r)) {
      case 92:
        n += e[r + 1], r++;
        continue;
      case 46:
        t.push(n), n = "";
        continue;
    }
    n += e[r];
  }
  return t.push(n), t;
}
function cf(e) {
  if (mw(e))
    return e.value;
  if (typeof e != "string")
    return e;
  const t = Lc(e);
  return R0(t);
}
function R0(e) {
  if (e.length === 1)
    return e[0];
  const t = {};
  let n = t;
  for (let r = 0; r < e.length - 1; r++)
    if (r === e.length - 2)
      n[e[r]] = e[r + 1];
    else {
      const a = n;
      n = {}, a[e[r]] = n;
    }
  return t;
}
function df(e, t) {
  const n = {}, r = Object.keys(e);
  for (let a = 0; a < r.length; a++) {
    const i = r[a];
    n[i] = t(e[i], i, e, a);
  }
  return n;
}
function ey(e) {
  return ty(e) ? e : [e];
}
function fr(e) {
  return e === void 0 ? [] : ey(e);
}
function Ku(e, t, n, r) {
  return typeof e == "function" ? e({
    context: t,
    event: n,
    self: r
  }) : e;
}
function ty(e) {
  return Array.isArray(e);
}
function L0(e) {
  return e.type.startsWith("xstate.error.actor");
}
function ga(e) {
  return ey(e).map((t) => typeof t > "u" || typeof t == "string" ? {
    target: t
  } : t);
}
function ny(e) {
  if (!(e === void 0 || e === T0))
    return fr(e);
}
function Zu(e, t, n) {
  var i, o, s;
  const r = typeof e == "object", a = r ? e : void 0;
  return {
    next: (i = r ? e.next : e) == null ? void 0 : i.bind(a),
    error: (o = r ? e.error : t) == null ? void 0 : o.bind(a),
    complete: (s = r ? e.complete : n) == null ? void 0 : s.bind(a)
  };
}
function ff(e, t) {
  return `${t}.${e}`;
}
function Dc(e, t) {
  const n = t.match(/^xstate\.invoke\.(\d+)\.(.*)/);
  if (!n)
    return e.implementations.actors[t];
  const [, r, a] = n, o = e.getStateNodeById(a).config.invoke;
  return (Array.isArray(o) ? o[r] : o).src;
}
function pf(e, t) {
  return `${e.sessionId}.${t}`;
}
let D0 = 0;
function N0(e, t) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new Set(), o = {}, {
    clock: s,
    logger: l
  } = t, u = {
    schedule: (p, h, y, g, w = Math.random().toString(36).slice(2)) => {
      const m = {
        source: p,
        target: h,
        event: y,
        delay: g,
        id: w,
        startedAt: Date.now()
      }, v = pf(p, w);
      f._snapshot._scheduledEvents[v] = m;
      const C = s.setTimeout(() => {
        delete o[v], delete f._snapshot._scheduledEvents[v], f._relay(p, h, y);
      }, g);
      o[v] = C;
    },
    cancel: (p, h) => {
      const y = pf(p, h), g = o[y];
      delete o[y], delete f._snapshot._scheduledEvents[y], g !== void 0 && s.clearTimeout(g);
    },
    cancelAll: (p) => {
      for (const h in f._snapshot._scheduledEvents) {
        const y = f._snapshot._scheduledEvents[h];
        y.source === p && u.cancel(p, y.id);
      }
    }
  }, d = (p) => {
    if (!i.size)
      return;
    const h = {
      ...p,
      rootId: e.sessionId
    };
    i.forEach((y) => {
      var g;
      return (g = y.next) == null ? void 0 : g.call(y, h);
    });
  }, f = {
    _snapshot: {
      _scheduledEvents: ((t == null ? void 0 : t.snapshot) && t.snapshot.scheduler) ?? {}
    },
    _bookId: () => `x:${D0++}`,
    _register: (p, h) => (n.set(p, h), p),
    _unregister: (p) => {
      n.delete(p.sessionId);
      const h = a.get(p);
      h !== void 0 && (r.delete(h), a.delete(p));
    },
    get: (p) => r.get(p),
    _set: (p, h) => {
      const y = r.get(p);
      if (y && y !== h)
        throw new Error(`Actor with system ID '${p}' already exists.`);
      r.set(p, h), a.set(h, p);
    },
    inspect: (p) => {
      const h = Zu(p);
      return i.add(h), {
        unsubscribe() {
          i.delete(h);
        }
      };
    },
    _sendInspectionEvent: d,
    _relay: (p, h, y) => {
      f._sendInspectionEvent({
        type: "@xstate.event",
        sourceRef: p,
        actorRef: h,
        event: y
      }), h._send(y);
    },
    scheduler: u,
    getSnapshot: () => ({
      _scheduledEvents: {
        ...f._snapshot._scheduledEvents
      }
    }),
    start: () => {
      const p = f._snapshot._scheduledEvents;
      f._snapshot._scheduledEvents = {};
      for (const h in p) {
        const {
          source: y,
          target: g,
          event: w,
          delay: m,
          id: v
        } = p[h];
        u.schedule(y, g, w, m, v);
      }
    },
    _clock: s,
    _logger: l
  };
  return f;
}
let wu = !1;
const Nc = 1;
let Kt = /* @__PURE__ */ function(e) {
  return e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped", e;
}({});
const z0 = {
  clock: {
    setTimeout: (e, t) => setTimeout(e, t),
    clearTimeout: (e) => clearTimeout(e)
  },
  logger: console.log.bind(console),
  devTools: !1
};
class V0 {
  /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */
  constructor(t, n) {
    this.logic = t, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new uf(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = Kt.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this._systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
    const r = {
      ...z0,
      ...n
    }, {
      clock: a,
      logger: i,
      parent: o,
      syncSnapshot: s,
      id: l,
      systemId: u,
      inspect: d
    } = r;
    this.system = o ? o.system : N0(this, {
      clock: a,
      logger: i
    }), d && !o && this.system.inspect(Zu(d)), this.sessionId = this.system._bookId(), this.id = l ?? this.sessionId, this.logger = (n == null ? void 0 : n.logger) ?? this.system._logger, this.clock = (n == null ? void 0 : n.clock) ?? this.system._clock, this._parent = o, this._syncSnapshot = s, this.options = r, this.src = r.src ?? t, this.ref = this, this._actorScope = {
      self: this,
      id: this.id,
      sessionId: this.sessionId,
      logger: this.logger,
      defer: (f) => {
        this._deferred.push(f);
      },
      system: this.system,
      stopChild: (f) => {
        if (f._parent !== this)
          throw new Error(`Cannot stop child actor ${f.id} of ${this.id} because it is not a child`);
        f._stop();
      },
      emit: (f) => {
        const p = this.eventListeners.get(f.type), h = this.eventListeners.get("*");
        if (!p && !h)
          return;
        const y = [...p ? p.values() : [], ...h ? h.values() : []];
        for (const g of y)
          g(f);
      },
      actionExecutor: (f) => {
        const p = () => {
          if (this._actorScope.system._sendInspectionEvent({
            type: "@xstate.action",
            actorRef: this,
            action: {
              type: f.type,
              params: f.params
            }
          }), !f.exec)
            return;
          const h = wu;
          try {
            wu = !0, f.exec(f.info, f.params);
          } finally {
            wu = h;
          }
        };
        this._processingStatus === Kt.Running ? p() : this._deferred.push(p);
      }
    }, this.send = this.send.bind(this), this.system._sendInspectionEvent({
      type: "@xstate.actor",
      actorRef: this
    }), u && (this._systemId = u, this.system._set(u, this)), this._initState((n == null ? void 0 : n.snapshot) ?? (n == null ? void 0 : n.state)), u && this._snapshot.status !== "active" && this.system._unregister(this);
  }
  _initState(t) {
    var n;
    try {
      this._snapshot = t ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(t, this._actorScope) : t : this.logic.getInitialSnapshot(this._actorScope, (n = this.options) == null ? void 0 : n.input);
    } catch (r) {
      this._snapshot = {
        status: "error",
        output: void 0,
        error: r
      };
    }
  }
  update(t, n) {
    var a, i;
    this._snapshot = t;
    let r;
    for (; r = this._deferred.shift(); )
      try {
        r();
      } catch (o) {
        this._deferred.length = 0, this._snapshot = {
          ...t,
          status: "error",
          error: o
        };
      }
    switch (this._snapshot.status) {
      case "active":
        for (const o of this.observers)
          try {
            (a = o.next) == null || a.call(o, t);
          } catch (s) {
            jn(s);
          }
        break;
      case "done":
        for (const o of this.observers)
          try {
            (i = o.next) == null || i.call(o, t);
          } catch (s) {
            jn(s);
          }
        this._stopProcedure(), this._complete(), this._doneEvent = O0(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
        break;
      case "error":
        this._error(this._snapshot.error);
        break;
    }
    this.system._sendInspectionEvent({
      type: "@xstate.snapshot",
      actorRef: this,
      event: n,
      snapshot: t
    });
  }
  /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */
  subscribe(t, n, r) {
    var i;
    const a = Zu(t, n, r);
    if (this._processingStatus !== Kt.Stopped)
      this.observers.add(a);
    else
      switch (this._snapshot.status) {
        case "done":
          try {
            (i = a.complete) == null || i.call(a);
          } catch (o) {
            jn(o);
          }
          break;
        case "error": {
          const o = this._snapshot.error;
          if (!a.error)
            jn(o);
          else
            try {
              a.error(o);
            } catch (s) {
              jn(s);
            }
          break;
        }
      }
    return {
      unsubscribe: () => {
        this.observers.delete(a);
      }
    };
  }
  on(t, n) {
    let r = this.eventListeners.get(t);
    r || (r = /* @__PURE__ */ new Set(), this.eventListeners.set(t, r));
    const a = n.bind(void 0);
    return r.add(a), {
      unsubscribe: () => {
        r.delete(a);
      }
    };
  }
  /** Starts the Actor from the initial state */
  start() {
    if (this._processingStatus === Kt.Running)
      return this;
    this._syncSnapshot && this.subscribe({
      next: (r) => {
        r.status === "active" && this.system._relay(this, this._parent, {
          type: `xstate.snapshot.${this.id}`,
          snapshot: r
        });
      },
      error: () => {
      }
    }), this.system._register(this.sessionId, this), this._systemId && this.system._set(this._systemId, this), this._processingStatus = Kt.Running;
    const t = Qh(this.options.input);
    switch (this.system._sendInspectionEvent({
      type: "@xstate.event",
      sourceRef: this._parent,
      actorRef: this,
      event: t
    }), this._snapshot.status) {
      case "done":
        return this.update(this._snapshot, t), this;
      case "error":
        return this._error(this._snapshot.error), this;
    }
    if (this._parent || this.system.start(), this.logic.start)
      try {
        this.logic.start(this._snapshot, this._actorScope);
      } catch (r) {
        return this._snapshot = {
          ...this._snapshot,
          status: "error",
          error: r
        }, this._error(r), this;
      }
    return this.update(this._snapshot, t), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
  }
  _process(t) {
    let n, r;
    try {
      n = this.logic.transition(this._snapshot, t, this._actorScope);
    } catch (a) {
      r = {
        err: a
      };
    }
    if (r) {
      const {
        err: a
      } = r;
      this._snapshot = {
        ...this._snapshot,
        status: "error",
        error: a
      }, this._error(a);
      return;
    }
    this.update(n, t), t.type === Ri && (this._stopProcedure(), this._complete());
  }
  _stop() {
    return this._processingStatus === Kt.Stopped ? this : (this.mailbox.clear(), this._processingStatus === Kt.NotStarted ? (this._processingStatus = Kt.Stopped, this) : (this.mailbox.enqueue({
      type: Ri
    }), this));
  }
  /** Stops the Actor and unsubscribe all listeners. */
  stop() {
    if (this._parent)
      throw new Error("A non-root actor cannot be stopped directly.");
    return this._stop();
  }
  _complete() {
    var t;
    for (const n of this.observers)
      try {
        (t = n.complete) == null || t.call(n);
      } catch (r) {
        jn(r);
      }
    this.observers.clear();
  }
  _reportError(t) {
    if (!this.observers.size) {
      this._parent || jn(t);
      return;
    }
    let n = !1;
    for (const r of this.observers) {
      const a = r.error;
      n || (n = !a);
      try {
        a == null || a(t);
      } catch (i) {
        jn(i);
      }
    }
    this.observers.clear(), n && jn(t);
  }
  _error(t) {
    this._stopProcedure(), this._reportError(t), this._parent && this.system._relay(this, this._parent, Jh(this.id, t));
  }
  // TODO: atm children don't belong entirely to the actor so
  // in a way - it's not even super aware of them
  // so we can't stop them from here but we really should!
  // right now, they are being stopped within the machine's transition
  // but that could throw and leave us with "orphaned" active actors
  _stopProcedure() {
    return this._processingStatus !== Kt.Running ? this : (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new uf(this._process.bind(this)), this._processingStatus = Kt.Stopped, this.system._unregister(this), this);
  }
  /** @internal */
  _send(t) {
    this._processingStatus !== Kt.Stopped && this.mailbox.enqueue(t);
  }
  /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */
  send(t) {
    this.system._relay(void 0, this, t);
  }
  attachDevTools() {
    const {
      devTools: t
    } = this.options;
    t && (typeof t == "function" ? t : E0)(this);
  }
  toJSON() {
    return {
      xstate$$type: Nc,
      id: this.id
    };
  }
  /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */
  getPersistedSnapshot(t) {
    return this.logic.getPersistedSnapshot(this._snapshot, t);
  }
  [F0]() {
    return this;
  }
  /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */
  getSnapshot() {
    return this._snapshot;
  }
}
function Li(e, ...[t]) {
  return new V0(e, t);
}
function B0(e, t, n, r, {
  sendId: a
}) {
  const i = typeof a == "function" ? a(n, r) : a;
  return [t, {
    sendId: i
  }, void 0];
}
function j0(e, t) {
  e.defer(() => {
    e.system.scheduler.cancel(e.self, t.sendId);
  });
}
function W0(e) {
  function t(n, r) {
  }
  return t.type = "xstate.cancel", t.sendId = e, t.resolve = B0, t.execute = j0, t;
}
function H0(e, t, n, r, {
  id: a,
  systemId: i,
  src: o,
  input: s,
  syncSnapshot: l
}) {
  const u = typeof o == "string" ? Dc(t.machine, o) : o, d = typeof a == "function" ? a(n) : a;
  let f, p;
  return u && (p = typeof s == "function" ? s({
    context: t.context,
    event: n.event,
    self: e.self
  }) : s, f = Li(u, {
    id: d,
    src: o,
    parent: e.self,
    syncSnapshot: l,
    systemId: i,
    input: p
  })), [Kr(t, {
    children: {
      ...t.children,
      [d]: f
    }
  }), {
    id: a,
    systemId: i,
    actorRef: f,
    src: o,
    input: p
  }, void 0];
}
function U0(e, {
  actorRef: t
}) {
  t && e.defer(() => {
    t._processingStatus !== Kt.Stopped && t.start();
  });
}
function q0(...[e, {
  id: t,
  systemId: n,
  input: r,
  syncSnapshot: a = !1
} = {}]) {
  function i(o, s) {
  }
  return i.type = "xstate.spawnChild", i.id = t, i.systemId = n, i.src = e, i.input = r, i.syncSnapshot = a, i.resolve = H0, i.execute = U0, i;
}
function G0(e, t, n, r, {
  actorRef: a
}) {
  const i = typeof a == "function" ? a(n, r) : a, o = typeof i == "string" ? t.children[i] : i;
  let s = t.children;
  return o && (s = {
    ...s
  }, delete s[o.id]), [Kr(t, {
    children: s
  }), o, void 0];
}
function K0(e, t) {
  if (t) {
    if (e.system._unregister(t), t._processingStatus !== Kt.Running) {
      e.stopChild(t);
      return;
    }
    e.defer(() => {
      e.stopChild(t);
    });
  }
}
function ry(e) {
  function t(n, r) {
  }
  return t.type = "xstate.stopChild", t.actorRef = e, t.resolve = G0, t.execute = K0, t;
}
function Z0(e, {
  context: t,
  event: n
}, {
  guards: r
}) {
  return !si(r[0], t, n, e);
}
function Y0(e) {
  function t(n, r) {
    return !1;
  }
  return t.check = Z0, t.guards = [e], t;
}
function X0(e, {
  context: t,
  event: n
}, {
  guards: r
}) {
  return r.every((a) => si(a, t, n, e));
}
function Mr(e) {
  function t(n, r) {
    return !1;
  }
  return t.check = X0, t.guards = e, t;
}
function J0(e, {
  context: t,
  event: n
}, {
  guards: r
}) {
  return r.some((a) => si(a, t, n, e));
}
function Q0(e) {
  function t(n, r) {
    return !1;
  }
  return t.check = J0, t.guards = e, t;
}
function si(e, t, n, r) {
  const {
    machine: a
  } = r, i = typeof e == "function", o = i ? e : a.implementations.guards[typeof e == "string" ? e : e.type];
  if (!i && !o)
    throw new Error(`Guard '${typeof e == "string" ? e : e.type}' is not implemented.'.`);
  if (typeof o != "function")
    return si(o, t, n, r);
  const s = {
    context: t,
    event: n
  }, l = i || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
    context: t,
    event: n
  }) : e.params : void 0;
  return "check" in o ? o.check(
    r,
    s,
    o
    // this holds all params
  ) : o(s, l);
}
const zc = (e) => e.type === "atomic" || e.type === "final";
function Ga(e) {
  return Object.values(e.states).filter((t) => t.type !== "history");
}
function Xo(e, t) {
  const n = [];
  if (t === e)
    return n;
  let r = e.parent;
  for (; r && r !== t; )
    n.push(r), r = r.parent;
  return n;
}
function Ns(e) {
  const t = new Set(e), n = iy(t);
  for (const r of t)
    if (r.type === "compound" && (!n.get(r) || !n.get(r).length))
      hf(r).forEach((a) => t.add(a));
    else if (r.type === "parallel") {
      for (const a of Ga(r))
        if (a.type !== "history" && !t.has(a)) {
          const i = hf(a);
          for (const o of i)
            t.add(o);
        }
    }
  for (const r of t) {
    let a = r.parent;
    for (; a; )
      t.add(a), a = a.parent;
  }
  return t;
}
function ay(e, t) {
  const n = t.get(e);
  if (!n)
    return {};
  if (e.type === "compound") {
    const a = n[0];
    if (a) {
      if (zc(a))
        return a.key;
    } else
      return {};
  }
  const r = {};
  for (const a of n)
    r[a.key] = ay(a, t);
  return r;
}
function iy(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.has(n) || t.set(n, []), n.parent && (t.has(n.parent) || t.set(n.parent, []), t.get(n.parent).push(n));
  return t;
}
function oy(e, t) {
  const n = Ns(t);
  return ay(e, iy(n));
}
function Vc(e, t) {
  return t.type === "compound" ? Ga(t).some((n) => n.type === "final" && e.has(n)) : t.type === "parallel" ? Ga(t).every((n) => Vc(e, n)) : t.type === "final";
}
const Ql = (e) => e[0] === A0;
function $0(e, t) {
  return e.transitions.get(t) || [...e.transitions.keys()].filter((r) => {
    if (r === P0)
      return !0;
    if (!r.endsWith(".*"))
      return !1;
    const a = r.split("."), i = t.split(".");
    for (let o = 0; o < a.length; o++) {
      const s = a[o], l = i[o];
      if (s === "*")
        return o === a.length - 1;
      if (s !== l)
        return !1;
    }
    return !0;
  }).sort((r, a) => a.length - r.length).flatMap((r) => e.transitions.get(r));
}
function ew(e) {
  const t = e.config.after;
  if (!t)
    return [];
  const n = (a) => {
    const i = I0(a, e.id), o = i.type;
    return e.entry.push(Tw(i, {
      id: o,
      delay: a
    })), e.exit.push(W0(o)), o;
  };
  return Object.keys(t).flatMap((a) => {
    const i = t[a], o = typeof i == "string" ? {
      target: i
    } : i, s = Number.isNaN(+a) ? a : +a, l = n(s);
    return fr(o).map((u) => ({
      ...u,
      event: l,
      delay: s
    }));
  }).map((a) => {
    const {
      delay: i
    } = a;
    return {
      ...Or(e, a.event, a),
      delay: i
    };
  });
}
function Or(e, t, n) {
  const r = ny(n.target), a = n.reenter ?? !1, i = rw(e, r), o = {
    ...n,
    actions: fr(n.actions),
    guard: n.guard,
    target: i,
    source: e,
    reenter: a,
    eventType: t,
    toJSON: () => ({
      ...o,
      source: `#${e.id}`,
      target: i ? i.map((s) => `#${s.id}`) : void 0
    })
  };
  return o;
}
function tw(e) {
  const t = /* @__PURE__ */ new Map();
  if (e.config.on)
    for (const n of Object.keys(e.config.on)) {
      if (n === Yh)
        throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
      const r = e.config.on[n];
      t.set(n, ga(r).map((a) => Or(e, n, a)));
    }
  if (e.config.onDone) {
    const n = `xstate.done.state.${e.id}`;
    t.set(n, ga(e.config.onDone).map((r) => Or(e, n, r)));
  }
  for (const n of e.invoke) {
    if (n.onDone) {
      const r = `xstate.done.actor.${n.id}`;
      t.set(r, ga(n.onDone).map((a) => Or(e, r, a)));
    }
    if (n.onError) {
      const r = `xstate.error.actor.${n.id}`;
      t.set(r, ga(n.onError).map((a) => Or(e, r, a)));
    }
    if (n.onSnapshot) {
      const r = `xstate.snapshot.${n.id}`;
      t.set(r, ga(n.onSnapshot).map((a) => Or(e, r, a)));
    }
  }
  for (const n of e.after) {
    let r = t.get(n.eventType);
    r || (r = [], t.set(n.eventType, r)), r.push(n);
  }
  return t;
}
function nw(e, t) {
  const n = typeof t == "string" ? e.states[t] : t ? e.states[t.target] : void 0;
  if (!n && t)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
      `Initial state node "${t}" not found on parent state node #${e.id}`
    );
  const r = {
    source: e,
    actions: !t || typeof t == "string" ? [] : fr(t.actions),
    eventType: null,
    reenter: !1,
    target: n ? [n] : [],
    toJSON: () => ({
      ...r,
      source: `#${e.id}`,
      target: n ? [`#${n.id}`] : []
    })
  };
  return r;
}
function rw(e, t) {
  if (t !== void 0)
    return t.map((n) => {
      if (typeof n != "string")
        return n;
      if (Ql(n))
        return e.machine.getStateNodeById(n);
      const r = n[0] === Zh;
      if (r && !e.parent)
        return zs(e, n.slice(1));
      const a = r ? e.key + n : n;
      if (e.parent)
        try {
          return zs(e.parent, a);
        } catch (i) {
          throw new Error(`Invalid transition definition for state node '${e.id}':
${i.message}`);
        }
      else
        throw new Error(`Invalid target: "${n}" is not a valid target from the root node. Did you mean ".${n}"?`);
    });
}
function sy(e) {
  const t = ny(e.config.target);
  return t ? {
    target: t.map((n) => typeof n == "string" ? zs(e.parent, n) : n)
  } : e.parent.initial;
}
function Dr(e) {
  return e.type === "history";
}
function hf(e) {
  const t = ly(e);
  for (const n of t)
    for (const r of Xo(n, e))
      t.add(r);
  return t;
}
function ly(e) {
  const t = /* @__PURE__ */ new Set();
  function n(r) {
    if (!t.has(r)) {
      if (t.add(r), r.type === "compound")
        n(r.initial.target[0]);
      else if (r.type === "parallel")
        for (const a of Ga(r))
          n(a);
    }
  }
  return n(e), t;
}
function Ka(e, t) {
  if (Ql(t))
    return e.machine.getStateNodeById(t);
  if (!e.states)
    throw new Error(`Unable to retrieve child state '${t}' from '${e.id}'; no child states exist.`);
  const n = e.states[t];
  if (!n)
    throw new Error(`Child state '${t}' does not exist on '${e.id}'`);
  return n;
}
function zs(e, t) {
  if (typeof t == "string" && Ql(t))
    try {
      return e.machine.getStateNodeById(t);
    } catch {
    }
  const n = Lc(t).slice();
  let r = e;
  for (; n.length; ) {
    const a = n.shift();
    if (!a.length)
      break;
    r = Ka(r, a);
  }
  return r;
}
function Vs(e, t) {
  if (typeof t == "string") {
    const a = e.states[t];
    if (!a)
      throw new Error(`State '${t}' does not exist on '${e.id}'`);
    return [e, a];
  }
  const n = Object.keys(t), r = n.map((a) => Ka(e, a)).filter(Boolean);
  return [e.machine.root, e].concat(r, n.reduce((a, i) => {
    const o = Ka(e, i);
    if (!o)
      return a;
    const s = Vs(o, t[i]);
    return a.concat(s);
  }, []));
}
function aw(e, t, n, r) {
  const i = Ka(e, t).next(n, r);
  return !i || !i.length ? e.next(n, r) : i;
}
function iw(e, t, n, r) {
  const a = Object.keys(t), i = Ka(e, a[0]), o = Bc(i, t[a[0]], n, r);
  return !o || !o.length ? e.next(n, r) : o;
}
function ow(e, t, n, r) {
  const a = [];
  for (const i of Object.keys(t)) {
    const o = t[i];
    if (!o)
      continue;
    const s = Ka(e, i), l = Bc(s, o, n, r);
    l && a.push(...l);
  }
  return a.length ? a : e.next(n, r);
}
function Bc(e, t, n, r) {
  return typeof t == "string" ? aw(e, t, n, r) : Object.keys(t).length === 1 ? iw(e, t, n, r) : ow(e, t, n, r);
}
function sw(e) {
  return Object.keys(e.states).map((t) => e.states[t]).filter((t) => t.type === "history");
}
function mr(e, t) {
  let n = e;
  for (; n.parent && n.parent !== t; )
    n = n.parent;
  return n.parent === t;
}
function lw(e, t) {
  const n = new Set(e), r = new Set(t);
  for (const a of n)
    if (r.has(a))
      return !0;
  for (const a of r)
    if (n.has(a))
      return !0;
  return !1;
}
function uy(e, t, n) {
  const r = /* @__PURE__ */ new Set();
  for (const a of e) {
    let i = !1;
    const o = /* @__PURE__ */ new Set();
    for (const s of r)
      if (lw(Yu([a], t, n), Yu([s], t, n)))
        if (mr(a.source, s.source))
          o.add(s);
        else {
          i = !0;
          break;
        }
    if (!i) {
      for (const s of o)
        r.delete(s);
      r.add(a);
    }
  }
  return Array.from(r);
}
function uw(e) {
  const [t, ...n] = e;
  for (const r of Xo(t, void 0))
    if (n.every((a) => mr(a, r)))
      return r;
}
function jc(e, t) {
  if (!e.target)
    return [];
  const n = /* @__PURE__ */ new Set();
  for (const r of e.target)
    if (Dr(r))
      if (t[r.id])
        for (const a of t[r.id])
          n.add(a);
      else
        for (const a of jc(sy(r), t))
          n.add(a);
    else
      n.add(r);
  return [...n];
}
function cy(e, t) {
  const n = jc(e, t);
  if (!n)
    return;
  if (!e.reenter && n.every((a) => a === e.source || mr(a, e.source)))
    return e.source;
  const r = uw(n.concat(e.source));
  if (r)
    return r;
  if (!e.reenter)
    return e.source.machine.root;
}
function Yu(e, t, n) {
  var a;
  const r = /* @__PURE__ */ new Set();
  for (const i of e)
    if ((a = i.target) != null && a.length) {
      const o = cy(i, n);
      i.reenter && i.source === o && r.add(o);
      for (const s of t)
        mr(s, o) && r.add(s);
    }
  return [...r];
}
function cw(e, t) {
  if (e.length !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
}
function Xu(e, t, n, r, a, i) {
  if (!e.length)
    return t;
  const o = new Set(t._nodes);
  let s = t.historyValue;
  const l = uy(e, o, s);
  let u = t;
  a || ([u, s] = hw(u, r, n, l, o, s, i, n.actionExecutor)), u = Za(u, r, n, l.flatMap((f) => f.actions), i, void 0), u = fw(u, r, n, l, o, i, s, a);
  const d = [...o];
  u.status === "done" && (u = Za(u, r, n, d.sort((f, p) => p.order - f.order).flatMap((f) => f.exit), i, void 0));
  try {
    return s === t.historyValue && cw(t._nodes, o) ? u : Kr(u, {
      _nodes: d,
      historyValue: s
    });
  } catch (f) {
    throw f;
  }
}
function dw(e, t, n, r, a) {
  if (r.output === void 0)
    return;
  const i = Gu(a.id, a.output !== void 0 && a.parent ? Ku(a.output, e.context, t, n.self) : void 0);
  return Ku(r.output, e.context, i, n.self);
}
function fw(e, t, n, r, a, i, o, s) {
  let l = e;
  const u = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
  pw(r, o, d, u), s && d.add(e.machine.root);
  const f = /* @__PURE__ */ new Set();
  for (const p of [...u].sort((h, y) => h.order - y.order)) {
    a.add(p);
    const h = [];
    h.push(...p.entry);
    for (const y of p.invoke)
      h.push(q0(y.src, {
        ...y,
        syncSnapshot: !!y.onSnapshot
      }));
    if (d.has(p)) {
      const y = p.initial.actions;
      h.push(...y);
    }
    if (l = Za(l, t, n, h, i, p.invoke.map((y) => y.id)), p.type === "final") {
      const y = p.parent;
      let g = (y == null ? void 0 : y.type) === "parallel" ? y : y == null ? void 0 : y.parent, w = g || p;
      for ((y == null ? void 0 : y.type) === "compound" && i.push(Gu(y.id, p.output !== void 0 ? Ku(p.output, l.context, t, n.self) : void 0)); (g == null ? void 0 : g.type) === "parallel" && !f.has(g) && Vc(a, g); )
        f.add(g), i.push(Gu(g.id)), w = g, g = g.parent;
      if (g)
        continue;
      l = Kr(l, {
        status: "done",
        output: dw(l, t, n, l.machine.root, w)
      });
    }
  }
  return l;
}
function pw(e, t, n, r) {
  for (const a of e) {
    const i = cy(a, t);
    for (const s of a.target || [])
      !Dr(s) && // if the target is different than the source then it will *definitely* be entered
      (a.source !== s || // we know that the domain can't lie within the source
      // if it's different than the source then it's outside of it and it means that the target has to be entered as well
      a.source !== i || // reentering transitions always enter the target, even if it's the source itself
      a.reenter) && (r.add(s), n.add(s)), va(s, t, n, r);
    const o = jc(a, t);
    for (const s of o) {
      const l = Xo(s, i);
      (i == null ? void 0 : i.type) === "parallel" && l.push(i), dy(r, t, n, l, !a.source.parent && a.reenter ? void 0 : i);
    }
  }
}
function va(e, t, n, r) {
  var a;
  if (Dr(e))
    if (t[e.id]) {
      const i = t[e.id];
      for (const o of i)
        r.add(o), va(o, t, n, r);
      for (const o of i)
        bu(o, e.parent, r, t, n);
    } else {
      const i = sy(e);
      for (const o of i.target)
        r.add(o), i === ((a = e.parent) == null ? void 0 : a.initial) && n.add(e.parent), va(o, t, n, r);
      for (const o of i.target)
        bu(o, e.parent, r, t, n);
    }
  else if (e.type === "compound") {
    const [i] = e.initial.target;
    Dr(i) || (r.add(i), n.add(i)), va(i, t, n, r), bu(i, e, r, t, n);
  } else if (e.type === "parallel")
    for (const i of Ga(e).filter((o) => !Dr(o)))
      [...r].some((o) => mr(o, i)) || (Dr(i) || (r.add(i), n.add(i)), va(i, t, n, r));
}
function dy(e, t, n, r, a) {
  for (const i of r)
    if ((!a || mr(i, a)) && e.add(i), i.type === "parallel")
      for (const o of Ga(i).filter((s) => !Dr(s)))
        [...e].some((s) => mr(s, o)) || (e.add(o), va(o, t, n, e));
}
function bu(e, t, n, r, a) {
  dy(n, r, a, Xo(e, t));
}
function hw(e, t, n, r, a, i, o, s) {
  let l = e;
  const u = Yu(r, a, i);
  u.sort((f, p) => p.order - f.order);
  let d;
  for (const f of u)
    for (const p of sw(f)) {
      let h;
      p.history === "deep" ? h = (y) => zc(y) && mr(y, f) : h = (y) => y.parent === f, d ?? (d = {
        ...i
      }), d[p.id] = Array.from(a).filter(h);
    }
  for (const f of u)
    l = Za(l, t, n, [...f.exit, ...f.invoke.map((p) => ry(p.id))], o, void 0), a.delete(f);
  return [l, d || i];
}
function yw(e, t) {
  return e.implementations.actions[t];
}
function fy(e, t, n, r, a, i) {
  const {
    machine: o
  } = e;
  let s = e;
  for (const l of r) {
    const u = typeof l == "function", d = u ? l : (
      // the existing type of `.actions` assumes non-nullable `TExpressionAction`
      // it's fine to cast this here to get a common type and lack of errors in the rest of the code
      // our logic below makes sure that we call those 2 "variants" correctly
      yw(o, typeof l == "string" ? l : l.type)
    ), f = {
      context: s.context,
      event: t,
      self: n.self,
      system: n.system
    }, p = u || typeof l == "string" ? void 0 : "params" in l ? typeof l.params == "function" ? l.params({
      context: s.context,
      event: t
    }) : l.params : void 0;
    if (!d || !("resolve" in d)) {
      n.actionExecutor({
        type: typeof l == "string" ? l : typeof l == "object" ? l.type : l.name || "(anonymous)",
        info: f,
        params: p,
        exec: d
      });
      continue;
    }
    const h = d, [y, g, w] = h.resolve(
      n,
      s,
      f,
      p,
      d,
      // this holds all params
      a
    );
    s = y, "retryResolve" in h && (i == null || i.push([h, g])), "execute" in h && n.actionExecutor({
      type: h.type,
      info: f,
      params: g,
      exec: h.execute.bind(null, n, g)
    }), w && (s = fy(s, t, n, w, a, i));
  }
  return s;
}
function Za(e, t, n, r, a, i) {
  const o = i ? [] : void 0, s = fy(e, t, n, r, {
    internalQueue: a,
    deferredActorIds: i
  }, o);
  return o == null || o.forEach(([l, u]) => {
    l.retryResolve(n, s, u);
  }), s;
}
function _u(e, t, n, r) {
  let a = e;
  const i = [];
  function o(u, d, f) {
    n.system._sendInspectionEvent({
      type: "@xstate.microstep",
      actorRef: n.self,
      event: d,
      snapshot: u,
      _transitions: f
    }), i.push(u);
  }
  if (t.type === Ri)
    return a = Kr(yf(a, t, n), {
      status: "stopped"
    }), o(a, t, []), {
      snapshot: a,
      microstates: i
    };
  let s = t;
  if (s.type !== Xh) {
    const u = s, d = L0(u), f = gf(u, a);
    if (d && !f.length)
      return a = Kr(e, {
        status: "error",
        error: u.error
      }), o(a, u, []), {
        snapshot: a,
        microstates: i
      };
    a = Xu(
      f,
      e,
      n,
      s,
      !1,
      // isInitial
      r
    ), o(a, u, f);
  }
  let l = !0;
  for (; a.status === "active"; ) {
    let u = l ? gw(a, s) : [];
    const d = u.length ? a : void 0;
    if (!u.length) {
      if (!r.length)
        break;
      s = r.shift(), u = gf(s, a);
    }
    a = Xu(u, a, n, s, !1, r), l = a !== d, o(a, s, u);
  }
  return a.status !== "active" && yf(a, s, n), {
    snapshot: a,
    microstates: i
  };
}
function yf(e, t, n) {
  return Za(e, t, n, Object.values(e.children).map((r) => ry(r)), [], void 0);
}
function gf(e, t) {
  return t.machine.getTransitionData(t, e);
}
function gw(e, t) {
  const n = /* @__PURE__ */ new Set(), r = e._nodes.filter(zc);
  for (const a of r)
    e: for (const i of [a].concat(Xo(a, void 0)))
      if (i.always) {
        for (const o of i.always)
          if (o.guard === void 0 || si(o.guard, e.context, t, e)) {
            n.add(o);
            break e;
          }
      }
  return uy(Array.from(n), new Set(e._nodes), e.historyValue);
}
function vw(e, t) {
  const n = Ns(Vs(e, t));
  return oy(e, [...n]);
}
function mw(e) {
  return !!e && typeof e == "object" && "machine" in e && "value" in e;
}
const ww = function(t) {
  return $h(t, this.value);
}, bw = function(t) {
  return this.tags.has(t);
}, _w = function(t) {
  const n = this.machine.getTransitionData(this, t);
  return !!(n != null && n.length) && // Check that at least one transition is not forbidden
  n.some((r) => r.target !== void 0 || r.actions.length);
}, xw = function() {
  const {
    _nodes: t,
    tags: n,
    machine: r,
    getMeta: a,
    toJSON: i,
    can: o,
    hasTag: s,
    matches: l,
    ...u
  } = this;
  return {
    ...u,
    tags: Array.from(n)
  };
}, kw = function() {
  return this._nodes.reduce((t, n) => (n.meta !== void 0 && (t[n.id] = n.meta), t), {});
};
function Cs(e, t) {
  return {
    status: e.status,
    output: e.output,
    error: e.error,
    machine: t,
    context: e.context,
    _nodes: e._nodes,
    value: oy(t.root, e._nodes),
    tags: new Set(e._nodes.flatMap((n) => n.tags)),
    children: e.children,
    historyValue: e.historyValue || {},
    matches: ww,
    hasTag: bw,
    can: _w,
    getMeta: kw,
    toJSON: xw
  };
}
function Kr(e, t = {}) {
  return Cs({
    ...e,
    ...t
  }, e.machine);
}
function Sw(e, t) {
  const {
    _nodes: n,
    tags: r,
    machine: a,
    children: i,
    context: o,
    can: s,
    hasTag: l,
    matches: u,
    getMeta: d,
    toJSON: f,
    ...p
  } = e, h = {};
  for (const g in i) {
    const w = i[g];
    h[g] = {
      snapshot: w.getPersistedSnapshot(t),
      src: w.src,
      systemId: w._systemId,
      syncSnapshot: w._syncSnapshot
    };
  }
  return {
    ...p,
    context: py(o),
    children: h
  };
}
function py(e) {
  let t;
  for (const n in e) {
    const r = e[n];
    if (r && typeof r == "object")
      if ("sessionId" in r && "send" in r && "ref" in r)
        t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[n] = {
          xstate$$type: Nc,
          id: r.id
        };
      else {
        const a = py(r);
        a !== r && (t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[n] = a);
      }
  }
  return t ?? e;
}
function Cw(e, t, n, r, {
  event: a,
  id: i,
  delay: o
}, {
  internalQueue: s
}) {
  const l = t.machine.implementations.delays;
  if (typeof a == "string")
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Only event objects may be used with raise; use raise({ type: "${a}" }) instead`
    );
  const u = typeof a == "function" ? a(n, r) : a;
  let d;
  if (typeof o == "string") {
    const f = l && l[o];
    d = typeof f == "function" ? f(n, r) : f;
  } else
    d = typeof o == "function" ? o(n, r) : o;
  return typeof d != "number" && s.push(u), [t, {
    event: u,
    id: i,
    delay: d
  }, void 0];
}
function Ew(e, t) {
  const {
    event: n,
    delay: r,
    id: a
  } = t;
  if (typeof r == "number") {
    e.defer(() => {
      const i = e.self;
      e.system.scheduler.schedule(i, i, n, r, a);
    });
    return;
  }
}
function Tw(e, t) {
  function n(r, a) {
  }
  return n.type = "xstate.raise", n.event = e, n.id = t == null ? void 0 : t.id, n.delay = t == null ? void 0 : t.delay, n.resolve = Cw, n.execute = Ew, n;
}
const vf = /* @__PURE__ */ new WeakMap();
function Es(e) {
  return {
    config: e,
    start: (n, r) => {
      const {
        self: a,
        system: i,
        emit: o
      } = r, s = {
        receivers: void 0,
        dispose: void 0
      };
      vf.set(a, s), s.dispose = e({
        input: n.input,
        system: i,
        self: a,
        sendBack: (l) => {
          a.getSnapshot().status !== "stopped" && a._parent && i._relay(a, a._parent, l);
        },
        receive: (l) => {
          s.receivers ?? (s.receivers = /* @__PURE__ */ new Set()), s.receivers.add(l);
        },
        emit: o
      });
    },
    transition: (n, r, a) => {
      var o, s;
      const i = vf.get(a.self);
      return r.type === Ri ? (n = {
        ...n,
        status: "stopped",
        error: void 0
      }, (o = i.dispose) == null || o.call(i), n) : ((s = i.receivers) == null || s.forEach((l) => l(r)), n);
    },
    getInitialSnapshot: (n, r) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input: r
    }),
    getPersistedSnapshot: (n) => n,
    restoreSnapshot: (n) => n
  };
}
const mf = "xstate.promise.resolve", wf = "xstate.promise.reject", ds = /* @__PURE__ */ new WeakMap();
function Ot(e) {
  return {
    config: e,
    transition: (n, r, a) => {
      var i;
      if (n.status !== "active")
        return n;
      switch (r.type) {
        case mf: {
          const o = r.data;
          return {
            ...n,
            status: "done",
            output: o,
            input: void 0
          };
        }
        case wf:
          return {
            ...n,
            status: "error",
            error: r.data,
            input: void 0
          };
        case Ri:
          return (i = ds.get(a.self)) == null || i.abort(), {
            ...n,
            status: "stopped",
            input: void 0
          };
        default:
          return n;
      }
    },
    start: (n, {
      self: r,
      system: a,
      emit: i
    }) => {
      if (n.status !== "active")
        return;
      const o = new AbortController();
      ds.set(r, o), Promise.resolve(e({
        input: n.input,
        system: a,
        self: r,
        signal: o.signal,
        emit: i
      })).then((l) => {
        r.getSnapshot().status === "active" && (ds.delete(r), a._relay(r, r, {
          type: mf,
          data: l
        }));
      }, (l) => {
        r.getSnapshot().status === "active" && (ds.delete(r), a._relay(r, r, {
          type: wf,
          data: l
        }));
      });
    },
    getInitialSnapshot: (n, r) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input: r
    }),
    getPersistedSnapshot: (n) => n,
    restoreSnapshot: (n) => n
  };
}
function Aw(e, {
  machine: t,
  context: n
}, r, a) {
  const i = (o, s) => {
    if (typeof o == "string") {
      const l = Dc(t, o);
      if (!l)
        throw new Error(`Actor logic '${o}' not implemented in machine '${t.id}'`);
      const u = Li(l, {
        id: s == null ? void 0 : s.id,
        parent: e.self,
        syncSnapshot: s == null ? void 0 : s.syncSnapshot,
        input: typeof (s == null ? void 0 : s.input) == "function" ? s.input({
          context: n,
          event: r,
          self: e.self
        }) : s == null ? void 0 : s.input,
        src: o,
        systemId: s == null ? void 0 : s.systemId
      });
      return a[u.id] = u, u;
    } else
      return Li(o, {
        id: s == null ? void 0 : s.id,
        parent: e.self,
        syncSnapshot: s == null ? void 0 : s.syncSnapshot,
        input: s == null ? void 0 : s.input,
        src: o,
        systemId: s == null ? void 0 : s.systemId
      });
  };
  return (o, s) => {
    const l = i(o, s);
    return a[l.id] = l, e.defer(() => {
      l._processingStatus !== Kt.Stopped && l.start();
    }), l;
  };
}
function Pw(e, t, n, r, {
  assignment: a
}) {
  if (!t.context)
    throw new Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
  const i = {}, o = {
    context: t.context,
    event: n.event,
    spawn: Aw(e, t, n.event, i),
    self: e.self,
    system: e.system
  };
  let s = {};
  if (typeof a == "function")
    s = a(o, r);
  else
    for (const u of Object.keys(a)) {
      const d = a[u];
      s[u] = typeof d == "function" ? d(o, r) : d;
    }
  const l = Object.assign({}, t.context, s);
  return [Kr(t, {
    context: l,
    children: Object.keys(i).length ? {
      ...t.children,
      ...i
    } : t.children
  }), void 0, void 0];
}
function ie(e) {
  function t(n, r) {
  }
  return t.type = "xstate.assign", t.assignment = e, t.resolve = Pw, t;
}
let Ju = /* @__PURE__ */ function(e) {
  return e.Parent = "#_parent", e.Internal = "#_internal", e;
}({});
function Mw(e, t, n, r, {
  to: a,
  event: i,
  id: o,
  delay: s
}, l) {
  var y;
  const u = t.machine.implementations.delays;
  if (typeof i == "string")
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Only event objects may be used with sendTo; use sendTo({ type: "${i}" }) instead`
    );
  const d = typeof i == "function" ? i(n, r) : i;
  let f;
  if (typeof s == "string") {
    const g = u && u[s];
    f = typeof g == "function" ? g(n, r) : g;
  } else
    f = typeof s == "function" ? s(n, r) : s;
  const p = typeof a == "function" ? a(n, r) : a;
  let h;
  if (typeof p == "string") {
    if (p === Ju.Parent ? h = e.self._parent : p === Ju.Internal ? h = e.self : p.startsWith("#_") ? h = t.children[p.slice(2)] : h = (y = l.deferredActorIds) != null && y.includes(p) ? p : t.children[p], !h)
      throw new Error(`Unable to send event to actor '${p}' from machine '${t.machine.id}'.`);
  } else
    h = p || e.self;
  return [t, {
    to: h,
    targetId: typeof p == "string" ? p : void 0,
    event: d,
    id: o,
    delay: f
  }, void 0];
}
function Iw(e, t, n) {
  typeof n.to == "string" && (n.to = t.children[n.to]);
}
function Ow(e, t) {
  e.defer(() => {
    const {
      to: n,
      event: r,
      delay: a,
      id: i
    } = t;
    if (typeof a == "number") {
      e.system.scheduler.schedule(e.self, n, r, a, i);
      return;
    }
    e.system._relay(
      e.self,
      // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
      // if it initially started as a string
      n,
      r.type === M0 ? Jh(e.self.id, r.data) : r
    );
  });
}
function Fw(e, t, n) {
  function r(a, i) {
  }
  return r.type = "xstate.sendTo", r.to = e, r.event = t, r.id = n == null ? void 0 : n.id, r.delay = n == null ? void 0 : n.delay, r.resolve = Mw, r.retryResolve = Iw, r.execute = Ow, r;
}
function bf(e, t) {
  return Fw(Ju.Parent, e, t);
}
const _f = /* @__PURE__ */ new WeakMap();
function ca(e, t, n) {
  let r = _f.get(e);
  return r ? t in r || (r[t] = n()) : (r = {
    [t]: n()
  }, _f.set(e, r)), r[t];
}
const Rw = {}, bi = (e) => typeof e == "string" ? {
  type: e
} : typeof e == "function" ? "resolve" in e ? {
  type: e.type
} : {
  type: e.name
} : e;
class Wc {
  constructor(t, n) {
    if (this.config = t, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = n._parent, this.key = n._key, this.machine = n._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join(Zh), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? df(this.config.states, (r, a) => new Wc(r, {
      _parent: this,
      _key: a,
      _machine: this.machine
    })) : Rw, this.type === "compound" && !this.config.initial)
      throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
    this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = fr(this.config.entry).slice(), this.exit = fr(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = fr(t.tags).slice();
  }
  /** @internal */
  _initialize() {
    this.transitions = tw(this), this.config.always && (this.always = ga(this.config.always).map((t) => Or(this, Yh, t))), Object.keys(this.states).forEach((t) => {
      this.states[t]._initialize();
    });
  }
  /** The well-structured state node definition. */
  get definition() {
    return {
      id: this.id,
      key: this.key,
      version: this.machine.version,
      type: this.type,
      initial: this.initial ? {
        target: this.initial.target,
        source: this,
        actions: this.initial.actions.map(bi),
        eventType: null,
        reenter: !1,
        toJSON: () => ({
          target: this.initial.target.map((t) => `#${t.id}`),
          source: `#${this.id}`,
          actions: this.initial.actions.map(bi),
          eventType: null
        })
      } : void 0,
      history: this.history,
      states: df(this.states, (t) => t.definition),
      on: this.on,
      transitions: [...this.transitions.values()].flat().map((t) => ({
        ...t,
        actions: t.actions.map(bi)
      })),
      entry: this.entry.map(bi),
      exit: this.exit.map(bi),
      meta: this.meta,
      order: this.order || -1,
      output: this.output,
      invoke: this.invoke,
      description: this.description,
      tags: this.tags
    };
  }
  /** @internal */
  toJSON() {
    return this.definition;
  }
  /** The logic invoked as actors by this state node. */
  get invoke() {
    return ca(this, "invoke", () => fr(this.config.invoke).map((t, n) => {
      const {
        src: r,
        systemId: a
      } = t, i = t.id ?? ff(this.id, n), o = typeof r == "string" ? r : `xstate.invoke.${ff(this.id, n)}`;
      return {
        ...t,
        src: o,
        id: i,
        systemId: a,
        toJSON() {
          const {
            onDone: s,
            onError: l,
            ...u
          } = t;
          return {
            ...u,
            type: "xstate.invoke",
            src: o,
            id: i
          };
        }
      };
    }));
  }
  /** The mapping of events to transitions. */
  get on() {
    return ca(this, "on", () => [...this.transitions].flatMap(([n, r]) => r.map((a) => [n, a])).reduce((n, [r, a]) => (n[r] = n[r] || [], n[r].push(a), n), {}));
  }
  get after() {
    return ca(this, "delayedTransitions", () => ew(this));
  }
  get initial() {
    return ca(this, "initial", () => nw(this, this.config.initial));
  }
  /** @internal */
  next(t, n) {
    const r = n.type, a = [];
    let i;
    const o = ca(this, `candidates-${r}`, () => $0(this, r));
    for (const s of o) {
      const {
        guard: l
      } = s, u = t.context;
      let d = !1;
      try {
        d = !l || si(l, u, n, t);
      } catch (f) {
        const p = typeof l == "string" ? l : typeof l == "object" ? l.type : void 0;
        throw new Error(`Unable to evaluate guard ${p ? `'${p}' ` : ""}in transition for event '${r}' in state node '${this.id}':
${f.message}`);
      }
      if (d) {
        a.push(...s.actions), i = s;
        break;
      }
    }
    return i ? [i] : void 0;
  }
  /** All the event types accepted by this state node and its descendants. */
  get events() {
    return ca(this, "events", () => {
      const {
        states: t
      } = this, n = new Set(this.ownEvents);
      if (t)
        for (const r of Object.keys(t)) {
          const a = t[r];
          if (a.states)
            for (const i of a.events)
              n.add(`${i}`);
        }
      return Array.from(n);
    });
  }
  /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */
  get ownEvents() {
    const t = new Set([...this.transitions.keys()].filter((n) => this.transitions.get(n).some((r) => !(!r.target && !r.actions.length && !r.reenter))));
    return Array.from(t);
  }
}
const Lw = "#";
class Hc {
  constructor(t, n) {
    this.config = t, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = t.id || "(machine)", this.implementations = {
      actors: (n == null ? void 0 : n.actors) ?? {},
      actions: (n == null ? void 0 : n.actions) ?? {},
      delays: (n == null ? void 0 : n.delays) ?? {},
      guards: (n == null ? void 0 : n.guards) ?? {}
    }, this.version = this.config.version, this.schemas = this.config.schemas, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new Wc(t, {
      _key: this.id,
      _machine: this
    }), this.root._initialize(), this.states = this.root.states, this.events = this.root.events;
  }
  /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */
  provide(t) {
    const {
      actions: n,
      guards: r,
      actors: a,
      delays: i
    } = this.implementations;
    return new Hc(this.config, {
      actions: {
        ...n,
        ...t.actions
      },
      guards: {
        ...r,
        ...t.guards
      },
      actors: {
        ...a,
        ...t.actors
      },
      delays: {
        ...i,
        ...t.delays
      }
    });
  }
  resolveState(t) {
    const n = vw(this.root, t.value), r = Ns(Vs(this.root, n));
    return Cs({
      _nodes: [...r],
      context: t.context || {},
      children: {},
      status: Vc(r, this.root) ? "done" : t.status || "active",
      output: t.output,
      error: t.error,
      historyValue: t.historyValue
    }, this);
  }
  /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */
  transition(t, n, r) {
    return _u(t, n, r, []).snapshot;
  }
  /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */
  microstep(t, n, r) {
    return _u(t, n, r, []).microstates;
  }
  getTransitionData(t, n) {
    return Bc(this.root, t.value, t, n) || [];
  }
  /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */
  getPreInitialState(t, n, r) {
    const {
      context: a
    } = this.config, i = Cs({
      context: typeof a != "function" && a ? a : {},
      _nodes: [this.root],
      children: {},
      status: "active"
    }, this);
    return typeof a == "function" ? Za(i, n, t, [ie(({
      spawn: s,
      event: l,
      self: u
    }) => a({
      spawn: s,
      input: l.input,
      self: u
    }))], r, void 0) : i;
  }
  /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */
  getInitialSnapshot(t, n) {
    const r = Qh(n), a = [], i = this.getPreInitialState(t, r, a), o = Xu([{
      target: [...ly(this.root)],
      source: this.root,
      reenter: !0,
      actions: [],
      eventType: null,
      toJSON: null
      // TODO: fix
    }], i, t, r, !0, a), {
      snapshot: s
    } = _u(o, r, t, a);
    return s;
  }
  start(t) {
    Object.values(t.children).forEach((n) => {
      n.getSnapshot().status === "active" && n.start();
    });
  }
  getStateNodeById(t) {
    const n = Lc(t), r = n.slice(1), a = Ql(n[0]) ? n[0].slice(Lw.length) : n[0], i = this.idMap.get(a);
    if (!i)
      throw new Error(`Child state node '#${a}' does not exist on machine '${this.id}'`);
    return zs(i, r);
  }
  get definition() {
    return this.root.definition;
  }
  toJSON() {
    return this.definition;
  }
  getPersistedSnapshot(t, n) {
    return Sw(t, n);
  }
  restoreSnapshot(t, n) {
    const r = {}, a = t.children;
    Object.keys(a).forEach((l) => {
      const u = a[l], d = u.snapshot, f = u.src, p = typeof f == "string" ? Dc(this, f) : f;
      if (!p)
        return;
      const h = Li(p, {
        id: l,
        parent: n.self,
        syncSnapshot: u.syncSnapshot,
        snapshot: d,
        src: f,
        systemId: u.systemId
      });
      r[l] = h;
    });
    const i = Cs({
      ...t,
      children: r,
      _nodes: Array.from(Ns(Vs(this.root, t.value)))
    }, this), o = /* @__PURE__ */ new Set();
    function s(l, u) {
      if (!o.has(l)) {
        o.add(l);
        for (const d in l) {
          const f = l[d];
          if (f && typeof f == "object") {
            if ("xstate$$type" in f && f.xstate$$type === Nc) {
              l[d] = u[f.id];
              continue;
            }
            s(f, u);
          }
        }
      }
    }
    return s(i.context, r), i;
  }
}
function Uc(e, t) {
  return new Hc(e, t);
}
const wr = (e) => e;
var Dw = {};
let Jo = wr, Zr = wr;
Dw.NODE_ENV !== "production" && (Jo = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Zr = (e, t) => {
  if (!e)
    throw new Error(t);
});
function Nw(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function hy(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class yy {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Nw(this.subscriptions, t), () => hy(this.subscriptions, t);
  }
  notify(t, n, r) {
    const a = this.subscriptions.length;
    if (a)
      if (a === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < a; i++) {
          const o = this.subscriptions[i];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function gy(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const xf = /* @__PURE__ */ new Set();
function qc(e, t, n) {
  e || xf.has(t) || (console.warn(t), xf.add(t));
}
const zw = {
  skipAnimations: !1,
  useManualTiming: !1
};
function Vw(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, a = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(u) {
    i.has(u) && (l.schedule(u), e()), u(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, d = !1, f = !1) => {
      const h = f && r ? t : n;
      return d && i.add(u), h.has(u) || h.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.delete(u), i.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (o = u, r) {
        a = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(s), r = !1, a && (a = !1, l.process(u));
    }
  };
  return l;
}
const fs = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Bw = 40;
function jw(e, t) {
  let n = !1, r = !0;
  const a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, o = fs.reduce((m, v) => (m[v] = Vw(i), m), {}), { read: s, resolveKeyframes: l, update: u, preRender: d, render: f, postRender: p } = o, h = () => {
    const m = performance.now();
    n = !1, a.delta = r ? 1e3 / 60 : Math.max(Math.min(m - a.timestamp, Bw), 1), a.timestamp = m, a.isProcessing = !0, s.process(a), l.process(a), u.process(a), d.process(a), f.process(a), p.process(a), a.isProcessing = !1, n && t && (r = !1, e(h));
  }, y = () => {
    n = !0, r = !0, a.isProcessing || e(h);
  };
  return { schedule: fs.reduce((m, v) => {
    const C = o[v];
    return m[v] = (S, b = !1, x = !1) => (n || y(), C.schedule(S, b, x)), m;
  }, {}), cancel: (m) => {
    for (let v = 0; v < fs.length; v++)
      o[fs[v]].cancel(m);
  }, state: a, steps: o };
}
const { schedule: Xn, cancel: Qu, state: Bs, steps: _E } = jw(typeof requestAnimationFrame < "u" ? requestAnimationFrame : wr, !0);
let Ts;
function Ww() {
  Ts = void 0;
}
const gr = {
  now: () => (Ts === void 0 && gr.set(Bs.isProcessing || zw.useManualTiming ? Bs.timestamp : performance.now()), Ts),
  set: (e) => {
    Ts = e, queueMicrotask(Ww);
  }
};
var Hw = {};
const kf = 30, Uw = (e) => !isNaN(parseFloat(e));
class qw {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.13.5", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, a = !0) => {
      const i = gr.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), a && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = gr.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Uw(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return Hw.NODE_ENV !== "production" && qc(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new yy());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Xn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = gr.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > kf)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, kf);
    return gy(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Di(e, t) {
  return new qw(e, t);
}
function Gc(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Gw = Gc(() => window.ScrollTimeline !== void 0);
class vy {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((a) => Gw() && a.attachTimeline ? a.attachTimeline(t) : n(a));
    return () => {
      r.forEach((a, i) => {
        a && a(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const $l = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, my = (e, t, n = 10) => {
  let r = "";
  const a = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < a; i++)
    r += e($l(0, a - 1, i)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, An = (e) => e * 1e3, Yn = (e) => e / 1e3, Kw = 5;
function wy(e, t, n) {
  const r = Math.max(t - Kw, 0);
  return gy(n - e(r), t - r);
}
const Yr = (e, t, n) => n > t ? t : n < e ? e : n, wt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, xu = 1e-3;
function Zw({ duration: e = wt.duration, bounce: t = wt.bounce, velocity: n = wt.velocity, mass: r = wt.mass }) {
  let a, i;
  Jo(e <= An(wt.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - t;
  o = Yr(wt.minDamping, wt.maxDamping, o), e = Yr(wt.minDuration, wt.maxDuration, Yn(e)), o < 1 ? (a = (u) => {
    const d = u * o, f = d * e, p = d - n, h = $u(u, o), y = Math.exp(-f);
    return xu - p / h * y;
  }, i = (u) => {
    const f = u * o * e, p = f * n + n, h = Math.pow(o, 2) * Math.pow(u, 2) * e, y = Math.exp(-f), g = $u(Math.pow(u, 2), o);
    return (-a(u) + xu > 0 ? -1 : 1) * ((p - h) * y) / g;
  }) : (a = (u) => {
    const d = Math.exp(-u * e), f = (u - n) * e + 1;
    return -xu + d * f;
  }, i = (u) => {
    const d = Math.exp(-u * e), f = (n - u) * (e * e);
    return d * f;
  });
  const s = 5 / e, l = Xw(a, i, s);
  if (e = An(e), isNaN(l))
    return {
      stiffness: wt.stiffness,
      damping: wt.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const Yw = 12;
function Xw(e, t, n) {
  let r = n;
  for (let a = 1; a < Yw; a++)
    r = r - e(r) / t(r);
  return r;
}
function $u(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const js = 2e4;
function Kc(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < js; )
    t += n, r = e.next(t);
  return t >= js ? 1 / 0 : t;
}
const Jw = ["duration", "bounce"], Qw = ["stiffness", "damping", "mass"];
function Sf(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function $w(e) {
  let t = {
    velocity: wt.velocity,
    stiffness: wt.stiffness,
    damping: wt.damping,
    mass: wt.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Sf(e, Qw) && Sf(e, Jw))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), a = r * r, i = 2 * Yr(0.05, 1, 1 - e.bounce) * Math.sqrt(a);
      t = {
        ...t,
        mass: wt.mass,
        stiffness: a,
        damping: i
      };
    } else {
      const n = Zw(e);
      t = {
        ...t,
        ...n,
        mass: wt.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Zc(e = wt.visualDuration, t = wt.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: a } = n;
  const i = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: i }, { stiffness: l, damping: u, mass: d, duration: f, velocity: p, isResolvedFromDuration: h } = $w({
    ...n,
    velocity: -Yn(n.velocity || 0)
  }), y = p || 0, g = u / (2 * Math.sqrt(l * d)), w = o - i, m = Yn(Math.sqrt(l / d)), v = Math.abs(w) < 5;
  r || (r = v ? wt.restSpeed.granular : wt.restSpeed.default), a || (a = v ? wt.restDelta.granular : wt.restDelta.default);
  let C;
  if (g < 1) {
    const b = $u(m, g);
    C = (x) => {
      const E = Math.exp(-g * m * x);
      return o - E * ((y + g * m * w) / b * Math.sin(b * x) + w * Math.cos(b * x));
    };
  } else if (g === 1)
    C = (b) => o - Math.exp(-m * b) * (w + (y + m * w) * b);
  else {
    const b = m * Math.sqrt(g * g - 1);
    C = (x) => {
      const E = Math.exp(-g * m * x), k = Math.min(b * x, 300);
      return o - E * ((y + g * m * w) * Math.sinh(k) + b * w * Math.cosh(k)) / b;
    };
  }
  const S = {
    calculatedDuration: h && f || null,
    next: (b) => {
      const x = C(b);
      if (h)
        s.done = b >= f;
      else {
        let E = 0;
        g < 1 && (E = b === 0 ? An(y) : wy(C, b, x));
        const k = Math.abs(E) <= r, I = Math.abs(o - x) <= a;
        s.done = k && I;
      }
      return s.value = s.done ? o : x, s;
    },
    toString: () => {
      const b = Math.min(Kc(S), js), x = my((E) => S.next(b * E).value, b, 30);
      return b + "ms " + x;
    }
  };
  return S;
}
function eb(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), a = Math.min(Kc(r), js);
  return {
    type: "keyframes",
    ease: (i) => r.next(a * i).value / t,
    duration: Yn(a)
  };
}
const Qo = (e, t, n) => e + (t - e) * n;
function by(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const a = $l(0, t, r);
    e.push(Qo(n, 1, a));
  }
}
function _y(e) {
  const t = [0];
  return by(t, e.length - 1), t;
}
const jt = (e) => !!(e && e.getVelocity);
function tb(e, t, n) {
  var r;
  if (e instanceof Element)
    return [e];
  if (typeof e == "string") {
    let a = document;
    const i = (r = n == null ? void 0 : n[e]) !== null && r !== void 0 ? r : a.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
function Yc(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function xy(e, t, n, r) {
  return typeof e == "string" && Yc(t) ? tb(e, n, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e];
}
function eu(e) {
  return typeof e == "function";
}
function Cf(e, t, n, r) {
  var a;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (a = r.get(t)) !== null && a !== void 0 ? a : e;
}
const nb = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
}, ky = (e) => Array.isArray(e) && typeof e[0] != "number";
function rb(e, t) {
  return ky(e) ? e[nb(0, e.length, t)] : e;
}
function ab(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    a.at > t && a.at < n && (hy(e, a), r--);
  }
}
function ib(e, t, n, r, a, i) {
  ab(e, a, i);
  for (let o = 0; o < t.length; o++)
    e.push({
      value: t[o],
      at: Qo(a, i, r[o]),
      easing: rb(n, o)
    });
}
function ob(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const sb = "easeInOut";
function lb(e, { defaultTransition: t = {}, ...n } = {}, r, a) {
  const i = t.duration || 0.3, o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), l = {}, u = /* @__PURE__ */ new Map();
  let d = 0, f = 0, p = 0;
  for (let h = 0; h < e.length; h++) {
    const y = e[h];
    if (typeof y == "string") {
      u.set(y, f);
      continue;
    } else if (!Array.isArray(y)) {
      u.set(y.name, Cf(f, y.at, d, u));
      continue;
    }
    let [g, w, m = {}] = y;
    m.at !== void 0 && (f = Cf(f, m.at, d, u));
    let v = 0;
    const C = (S, b, x, E = 0, k = 0) => {
      const I = ub(S), { delay: D = 0, times: A = _y(I), type: M = "keyframes", ...N } = b;
      let { ease: P = t.ease || "easeOut", duration: Y } = b;
      const G = typeof D == "function" ? D(E, k) : D, q = I.length, J = eu(M) ? M : a == null ? void 0 : a[M];
      if (q <= 2 && J) {
        let B = 100;
        if (q === 2 && fb(I)) {
          const ne = I[1] - I[0];
          B = Math.abs(ne);
        }
        const K = { ...N };
        Y !== void 0 && (K.duration = An(Y));
        const U = eb(K, B, J);
        P = U.ease, Y = U.duration;
      }
      Y ?? (Y = i);
      const $ = f + G, W = $ + Y;
      A.length === 1 && A[0] === 0 && (A[1] = 1);
      const j = A.length - I.length;
      j > 0 && by(A, j), I.length === 1 && I.unshift(null), ib(x, I, P, A, $, W), v = Math.max(G + Y, v), p = Math.max(W, p);
    };
    if (jt(g)) {
      const S = Ef(g, s);
      C(w, m, Tf("default", S));
    } else {
      const S = xy(g, w, r, l), b = S.length;
      for (let x = 0; x < b; x++) {
        w = w, m = m;
        const E = S[x], k = Ef(E, s);
        for (const I in w)
          C(w[I], cb(m, I), Tf(I, k), x, b);
      }
    }
    d = f, f += v;
  }
  return s.forEach((h, y) => {
    for (const g in h) {
      const w = h[g];
      w.sort(ob);
      const m = [], v = [], C = [];
      for (let b = 0; b < w.length; b++) {
        const { at: x, value: E, easing: k } = w[b];
        m.push(E), v.push($l(0, p, x)), C.push(k || "easeOut");
      }
      v[0] !== 0 && (v.unshift(0), m.unshift(m[0]), C.unshift(sb)), v[v.length - 1] !== 1 && (v.push(1), m.push(null)), o.has(y) || o.set(y, {
        keyframes: {},
        transition: {}
      });
      const S = o.get(y);
      S.keyframes[g] = m, S.transition[g] = {
        ...t,
        duration: p,
        ease: C,
        times: v,
        ...n
      };
    }
  }), o;
}
function Ef(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function Tf(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function ub(e) {
  return Array.isArray(e) ? e : [e];
}
function cb(e, t) {
  return e && e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const db = (e) => typeof e == "number", fb = (e) => e.every(db), Ya = /* @__PURE__ */ new WeakMap(), $o = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], na = new Set($o), pb = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, hb = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), yb = {
  type: "keyframes",
  duration: 0.8
}, gb = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, vb = (e, { keyframes: t }) => t.length > 2 ? yb : na.has(e) ? e.startsWith("scale") ? hb(t[1]) : pb : gb;
function Sy(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const mb = (e) => e !== null;
function tu(e, { repeat: t, repeatType: n = "loop" }, r) {
  const a = e.filter(mb), i = t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !i || r === void 0 ? a[i] : r;
}
const Cy = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, wb = 1e-7, bb = 12;
function _b(e, t, n, r, a) {
  let i, o, s = 0;
  do
    o = t + (n - t) / 2, i = Cy(o, r, a) - e, i > 0 ? n = o : t = o;
  while (Math.abs(i) > wb && ++s < bb);
  return o;
}
function Xr(e, t, n, r) {
  if (e === t && n === r)
    return wr;
  const a = (i) => _b(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : Cy(a(i), t, r);
}
const Ey = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Ty = (e) => (t) => 1 - e(1 - t), Ay = /* @__PURE__ */ Xr(0.33, 1.53, 0.69, 0.99), Xc = /* @__PURE__ */ Ty(Ay), Py = /* @__PURE__ */ Ey(Xc), My = (e) => (e *= 2) < 1 ? 0.5 * Xc(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Jc = (e) => 1 - Math.sin(Math.acos(e)), xb = Ty(Jc), Iy = Ey(Jc), Oy = (e) => /^0[^.\s]+$/u.test(e);
function kb(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Oy(e) : !0;
}
const Fy = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Ry = (e) => (t) => typeof t == "string" && t.startsWith(e), Ly = /* @__PURE__ */ Ry("--"), Sb = /* @__PURE__ */ Ry("var(--"), Qc = (e) => Sb(e) ? Cb.test(e.split("/*")[0].trim()) : !1, Cb = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Eb = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Tb(e) {
  const t = Eb.exec(e);
  if (!t)
    return [,];
  const [, n, r, a] = t;
  return [`--${n ?? r}`, a];
}
const Ab = 4;
function Dy(e, t, n = 1) {
  Zr(n <= Ab, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, a] = Tb(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const o = i.trim();
    return Fy(o) ? parseFloat(o) : o;
  }
  return Qc(a) ? Dy(a, t, n + 1) : a;
}
const li = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Ni = {
  ...li,
  transform: (e) => Yr(0, 1, e)
}, ps = {
  ...li,
  default: 1
}, es = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ar = /* @__PURE__ */ es("deg"), ka = /* @__PURE__ */ es("%"), Ie = /* @__PURE__ */ es("px"), Pb = /* @__PURE__ */ es("vh"), Mb = /* @__PURE__ */ es("vw"), Af = {
  ...ka,
  parse: (e) => ka.parse(e) / 100,
  transform: (e) => ka.transform(e * 100)
}, Ib = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Pf = (e) => e === li || e === Ie, Mf = (e, t) => parseFloat(e.split(", ")[t]), If = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const a = r.match(/^matrix3d\((.+)\)$/u);
  if (a)
    return Mf(a[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/u);
    return i ? Mf(i[1], e) : 0;
  }
}, Ob = /* @__PURE__ */ new Set(["x", "y", "z"]), Fb = $o.filter((e) => !Ob.has(e));
function Rb(e) {
  const t = [];
  return Fb.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Xa = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: If(4, 13),
  y: If(5, 14)
};
Xa.translateX = Xa.x;
Xa.translateY = Xa.y;
const Ny = (e) => (t) => t.test(e), Lb = {
  test: (e) => e === "auto",
  parse: (e) => e
}, zy = [li, Ie, ka, ar, Mb, Pb, Lb], Of = (e) => zy.find(Ny(e)), Hr = /* @__PURE__ */ new Set();
let ec = !1, tc = !1;
function Vy() {
  if (tc) {
    const e = Array.from(Hr).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const a = Rb(r);
      a.length && (n.set(r, a), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const a = n.get(r);
      a && a.forEach(([i, o]) => {
        var s;
        (s = r.getValue(i)) === null || s === void 0 || s.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  tc = !1, ec = !1, Hr.forEach((e) => e.complete()), Hr.clear();
}
function By() {
  Hr.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (tc = !0);
  });
}
function Db() {
  By(), Vy();
}
class $c {
  constructor(t, n, r, a, i, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = a, this.element = i, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Hr.add(this), ec || (ec = !0, Xn.read(By), Xn.resolveKeyframes(Vy))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: a } = this;
    for (let i = 0; i < t.length; i++)
      if (t[i] === null)
        if (i === 0) {
          const o = a == null ? void 0 : a.get(), s = t[t.length - 1];
          if (o !== void 0)
            t[0] = o;
          else if (r && n) {
            const l = r.readValue(n, s);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = s), a && o === void 0 && a.set(t[0]);
        } else
          t[i] = t[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Hr.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Hr.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Ai = (e) => Math.round(e * 1e5) / 1e5, ed = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Nb(e) {
  return e == null;
}
const zb = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, td = (e, t) => (n) => !!(typeof n == "string" && zb.test(n) && n.startsWith(e) || t && !Nb(n) && Object.prototype.hasOwnProperty.call(n, t)), jy = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [a, i, o, s] = r.match(ed);
  return {
    [e]: parseFloat(a),
    [t]: parseFloat(i),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, Vb = (e) => Yr(0, 255, e), ku = {
  ...li,
  transform: (e) => Math.round(Vb(e))
}, Nr = {
  test: /* @__PURE__ */ td("rgb", "red"),
  parse: /* @__PURE__ */ jy("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + ku.transform(e) + ", " + ku.transform(t) + ", " + ku.transform(n) + ", " + Ai(Ni.transform(r)) + ")"
};
function Bb(e) {
  let t = "", n = "", r = "", a = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), a = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), a = e.substring(4, 5), t += t, n += n, r += r, a += a), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const nc = {
  test: /* @__PURE__ */ td("#"),
  parse: Bb,
  transform: Nr.transform
}, ma = {
  test: /* @__PURE__ */ td("hsl", "hue"),
  parse: /* @__PURE__ */ jy("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + ka.transform(Ai(t)) + ", " + ka.transform(Ai(n)) + ", " + Ai(Ni.transform(r)) + ")"
}, Ft = {
  test: (e) => Nr.test(e) || nc.test(e) || ma.test(e),
  parse: (e) => Nr.test(e) ? Nr.parse(e) : ma.test(e) ? ma.parse(e) : nc.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Nr.transform(e) : ma.transform(e)
}, jb = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Wb(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(ed)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(jb)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const Wy = "number", Hy = "color", Hb = "var", Ub = "var(", Ff = "${}", qb = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function zi(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, a = [];
  let i = 0;
  const s = t.replace(qb, (l) => (Ft.test(l) ? (r.color.push(i), a.push(Hy), n.push(Ft.parse(l))) : l.startsWith(Ub) ? (r.var.push(i), a.push(Hb), n.push(l)) : (r.number.push(i), a.push(Wy), n.push(parseFloat(l))), ++i, Ff)).split(Ff);
  return { values: n, split: s, indexes: r, types: a };
}
function Uy(e) {
  return zi(e).values;
}
function qy(e) {
  const { split: t, types: n } = zi(e), r = t.length;
  return (a) => {
    let i = "";
    for (let o = 0; o < r; o++)
      if (i += t[o], a[o] !== void 0) {
        const s = n[o];
        s === Wy ? i += Ai(a[o]) : s === Hy ? i += Ft.transform(a[o]) : i += a[o];
      }
    return i;
  };
}
const Gb = (e) => typeof e == "number" ? 0 : e;
function Kb(e) {
  const t = Uy(e);
  return qy(e)(t.map(Gb));
}
const ui = {
  test: Wb,
  parse: Uy,
  createTransformer: qy,
  getAnimatableNone: Kb
}, Zb = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Yb(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ed) || [];
  if (!r)
    return e;
  const a = n.replace(r, "");
  let i = Zb.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + a + ")";
}
const Xb = /\b([a-z-]*)\(.*?\)/gu, rc = {
  ...ui,
  getAnimatableNone: (e) => {
    const t = e.match(Xb);
    return t ? t.map(Yb).join(" ") : e;
  }
}, Jb = {
  // Border props
  borderWidth: Ie,
  borderTopWidth: Ie,
  borderRightWidth: Ie,
  borderBottomWidth: Ie,
  borderLeftWidth: Ie,
  borderRadius: Ie,
  radius: Ie,
  borderTopLeftRadius: Ie,
  borderTopRightRadius: Ie,
  borderBottomRightRadius: Ie,
  borderBottomLeftRadius: Ie,
  // Positioning props
  width: Ie,
  maxWidth: Ie,
  height: Ie,
  maxHeight: Ie,
  top: Ie,
  right: Ie,
  bottom: Ie,
  left: Ie,
  // Spacing props
  padding: Ie,
  paddingTop: Ie,
  paddingRight: Ie,
  paddingBottom: Ie,
  paddingLeft: Ie,
  margin: Ie,
  marginTop: Ie,
  marginRight: Ie,
  marginBottom: Ie,
  marginLeft: Ie,
  // Misc
  backgroundPositionX: Ie,
  backgroundPositionY: Ie
}, Qb = {
  rotate: ar,
  rotateX: ar,
  rotateY: ar,
  rotateZ: ar,
  scale: ps,
  scaleX: ps,
  scaleY: ps,
  scaleZ: ps,
  skew: ar,
  skewX: ar,
  skewY: ar,
  distance: Ie,
  translateX: Ie,
  translateY: Ie,
  translateZ: Ie,
  x: Ie,
  y: Ie,
  z: Ie,
  perspective: Ie,
  transformPerspective: Ie,
  opacity: Ni,
  originX: Af,
  originY: Af,
  originZ: Ie
}, Rf = {
  ...li,
  transform: Math.round
}, nd = {
  ...Jb,
  ...Qb,
  zIndex: Rf,
  size: Ie,
  // SVG
  fillOpacity: Ni,
  strokeOpacity: Ni,
  numOctaves: Rf
}, $b = {
  ...nd,
  // Color props
  color: Ft,
  backgroundColor: Ft,
  outlineColor: Ft,
  fill: Ft,
  stroke: Ft,
  // Border props
  borderColor: Ft,
  borderTopColor: Ft,
  borderRightColor: Ft,
  borderBottomColor: Ft,
  borderLeftColor: Ft,
  filter: rc,
  WebkitFilter: rc
}, rd = (e) => $b[e];
function Gy(e, t) {
  let n = rd(e);
  return n !== rc && (n = ui), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const e2 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function t2(e, t, n) {
  let r = 0, a;
  for (; r < e.length && !a; ) {
    const i = e[r];
    typeof i == "string" && !e2.has(i) && zi(i).values.length && (a = e[r]), r++;
  }
  if (a && n)
    for (const i of t)
      e[i] = Gy(n, a);
}
class Ky extends $c {
  constructor(t, n, r, a, i) {
    super(t, n, r, a, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let u = t[l];
      if (typeof u == "string" && (u = u.trim(), Qc(u))) {
        const d = Dy(u, n.current);
        d !== void 0 && (t[l] = d), l === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !Ib.has(r) || t.length !== 2)
      return;
    const [a, i] = t, o = Of(a), s = Of(i);
    if (o !== s)
      if (Pf(o) && Pf(s))
        for (let l = 0; l < t.length; l++) {
          const u = t[l];
          typeof u == "string" && (t[l] = parseFloat(u));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let a = 0; a < t.length; a++)
      kb(t[a]) && r.push(a);
    r.length && t2(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Xa[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const a = n[n.length - 1];
    a !== void 0 && t.getValue(r, a).jump(a, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: a } = this;
    if (!n || !n.current)
      return;
    const i = n.getValue(r);
    i && i.jump(this.measuredOrigin, !1);
    const o = a.length - 1, s = a[o];
    a[o] = Xa[r](n.measureViewportBox(), window.getComputedStyle(n.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, u]) => {
      n.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
const Lf = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(ui.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function n2(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function r2(e, t, n, r) {
  const a = e[0];
  if (a === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], o = Lf(a, t), s = Lf(i, t);
  return Jo(o === s, `You are trying to animate ${t} from "${a}" to "${i}". ${a} is not an animatable value - to enable this animation set ${a} to a value animatable to ${i} via the \`style\` property.`), !o || !s ? !1 : n2(e) || (n === "spring" || eu(n)) && r;
}
const a2 = 40;
class Zy {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: a = 0, repeatDelay: i = 0, repeatType: o = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = gr.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: a,
      repeatDelay: i,
      repeatType: o,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > a2 ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && Db(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = gr.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: a, velocity: i, delay: o, onComplete: s, onUpdate: l, isGenerator: u } = this.options;
    if (!u && !r2(t, r, a, i))
      if (o)
        this.options.duration = 0;
      else {
        l == null || l(tu(t, this.options, n)), s == null || s(), this.resolveFinishedPromise();
        return;
      }
    const d = this.initPlayback(t, n);
    d !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...d
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function Df({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: a = 10, bounceStiffness: i = 500, modifyTarget: o, min: s, max: l, restDelta: u = 0.5, restSpeed: d }) {
  const f = e[0], p = {
    done: !1,
    value: f
  }, h = (k) => s !== void 0 && k < s || l !== void 0 && k > l, y = (k) => s === void 0 ? l : l === void 0 || Math.abs(s - k) < Math.abs(l - k) ? s : l;
  let g = n * t;
  const w = f + g, m = o === void 0 ? w : o(w);
  m !== w && (g = m - f);
  const v = (k) => -g * Math.exp(-k / r), C = (k) => m + v(k), S = (k) => {
    const I = v(k), D = C(k);
    p.done = Math.abs(I) <= u, p.value = p.done ? m : D;
  };
  let b, x;
  const E = (k) => {
    h(p.value) && (b = k, x = Zc({
      keyframes: [p.value, y(p.value)],
      velocity: wy(C, k, p.value),
      // TODO: This should be passing * 1000
      damping: a,
      stiffness: i,
      restDelta: u,
      restSpeed: d
    }));
  };
  return E(0), {
    calculatedDuration: null,
    next: (k) => {
      let I = !1;
      return !x && b === void 0 && (I = !0, S(k), E(k)), b !== void 0 && k >= b ? x.next(k - b) : (!I && S(k), p);
    }
  };
}
const i2 = /* @__PURE__ */ Xr(0.42, 0, 1, 1), o2 = /* @__PURE__ */ Xr(0, 0, 0.58, 1), Yy = /* @__PURE__ */ Xr(0.42, 0, 0.58, 1), ad = (e) => Array.isArray(e) && typeof e[0] == "number", Nf = {
  linear: wr,
  easeIn: i2,
  easeInOut: Yy,
  easeOut: o2,
  circIn: Jc,
  circInOut: Iy,
  circOut: xb,
  backIn: Xc,
  backInOut: Py,
  backOut: Ay,
  anticipate: My
}, zf = (e) => {
  if (ad(e)) {
    Zr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, a] = e;
    return Xr(t, n, r, a);
  } else if (typeof e == "string")
    return Zr(Nf[e] !== void 0, `Invalid easing type '${e}'`), Nf[e];
  return e;
}, s2 = (e, t) => (n) => t(e(n)), id = (...e) => e.reduce(s2);
function Su(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function l2({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let a = 0, i = 0, o = 0;
  if (!t)
    a = i = o = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    a = Su(l, s, e + 1 / 3), i = Su(l, s, e), o = Su(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Ws(e, t) {
  return (n) => n > 0 ? t : e;
}
const Cu = (e, t, n) => {
  const r = e * e, a = n * (t * t - r) + r;
  return a < 0 ? 0 : Math.sqrt(a);
}, u2 = [nc, Nr, ma], c2 = (e) => u2.find((t) => t.test(e));
function Vf(e) {
  const t = c2(e);
  if (Jo(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === ma && (n = l2(n)), n;
}
const Bf = (e, t) => {
  const n = Vf(e), r = Vf(t);
  if (!n || !r)
    return Ws(e, t);
  const a = { ...n };
  return (i) => (a.red = Cu(n.red, r.red, i), a.green = Cu(n.green, r.green, i), a.blue = Cu(n.blue, r.blue, i), a.alpha = Qo(n.alpha, r.alpha, i), Nr.transform(a));
}, ac = /* @__PURE__ */ new Set(["none", "hidden"]);
function d2(e, t) {
  return ac.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function f2(e, t) {
  return (n) => Qo(e, t, n);
}
function od(e) {
  return typeof e == "number" ? f2 : typeof e == "string" ? Qc(e) ? Ws : Ft.test(e) ? Bf : y2 : Array.isArray(e) ? Xy : typeof e == "object" ? Ft.test(e) ? Bf : p2 : Ws;
}
function Xy(e, t) {
  const n = [...e], r = n.length, a = e.map((i, o) => od(i)(i, t[o]));
  return (i) => {
    for (let o = 0; o < r; o++)
      n[o] = a[o](i);
    return n;
  };
}
function p2(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const a in n)
    e[a] !== void 0 && t[a] !== void 0 && (r[a] = od(e[a])(e[a], t[a]));
  return (a) => {
    for (const i in r)
      n[i] = r[i](a);
    return n;
  };
}
function h2(e, t) {
  var n;
  const r = [], a = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], s = e.indexes[o][a[o]], l = (n = e.values[s]) !== null && n !== void 0 ? n : 0;
    r[i] = l, a[o]++;
  }
  return r;
}
const y2 = (e, t) => {
  const n = ui.createTransformer(t), r = zi(e), a = zi(t);
  return r.indexes.var.length === a.indexes.var.length && r.indexes.color.length === a.indexes.color.length && r.indexes.number.length >= a.indexes.number.length ? ac.has(e) && !a.values.length || ac.has(t) && !r.values.length ? d2(e, t) : id(Xy(h2(r, a), a.values), n) : (Jo(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Ws(e, t));
};
function Jy(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Qo(e, t, n) : od(e)(e, t);
}
function g2(e, t, n) {
  const r = [], a = n || Jy, i = e.length - 1;
  for (let o = 0; o < i; o++) {
    let s = a(e[o], e[o + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[o] || wr : t;
      s = id(l, s);
    }
    r.push(s);
  }
  return r;
}
function v2(e, t, { clamp: n = !0, ease: r, mixer: a } = {}) {
  const i = e.length;
  if (Zr(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  if (i === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const o = g2(t, r, a), s = o.length, l = (u) => {
    let d = 0;
    if (s > 1)
      for (; d < e.length - 2 && !(u < e[d + 1]); d++)
        ;
    const f = $l(e[d], e[d + 1], u);
    return o[d](f);
  };
  return n ? (u) => l(Yr(e[0], e[i - 1], u)) : l;
}
function m2(e, t) {
  return e.map((n) => n * t);
}
function w2(e, t) {
  return e.map(() => t || Yy).splice(0, e.length - 1);
}
function Hs({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const a = ky(r) ? r.map(zf) : zf(r), i = {
    done: !1,
    value: t[0]
  }, o = m2(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : _y(t),
    e
  ), s = v2(o, t, {
    ease: Array.isArray(a) ? a : w2(t, a)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = s(l), i.done = l >= e, i)
  };
}
const b2 = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Xn.update(t, !0),
    stop: () => Qu(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Bs.isProcessing ? Bs.timestamp : gr.now()
  };
};
var _2 = {};
const x2 = {
  decay: Df,
  inertia: Df,
  tween: Hs,
  keyframes: Hs,
  spring: Zc
}, k2 = (e) => e / 100;
class sd extends Zy {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: a, keyframes: i } = this.options, o = (a == null ? void 0 : a.KeyframeResolver) || $c, s = (l, u) => this.onKeyframesResolved(l, u);
    this.resolver = new o(i, s, n, r, a), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: a = 0, repeatType: i, velocity: o = 0 } = this.options, s = eu(n) ? n : x2[n] || Hs;
    let l, u;
    s !== Hs && typeof t[0] != "number" && (_2.NODE_ENV !== "production" && Zr(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = id(k2, Jy(t[0], t[1])), t = [0, 100]);
    const d = s({ ...this.options, keyframes: t });
    i === "mirror" && (u = s({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -o
    })), d.calculatedDuration === null && (d.calculatedDuration = Kc(d));
    const { calculatedDuration: f } = d, p = f + a, h = p * (r + 1) - a;
    return {
      generator: d,
      mirroredGenerator: u,
      mapPercentToKeyframes: l,
      calculatedDuration: f,
      resolvedDuration: p,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: k } = this.options;
      return { done: !0, value: k[k.length - 1] };
    }
    const { finalKeyframe: a, generator: i, mirroredGenerator: o, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: u, totalDuration: d, resolvedDuration: f } = r;
    if (this.startTime === null)
      return i.next(0);
    const { delay: p, repeat: h, repeatType: y, repeatDelay: g, onUpdate: w } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - d / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const m = this.currentTime - p * (this.speed >= 0 ? 1 : -1), v = this.speed >= 0 ? m < 0 : m > d;
    this.currentTime = Math.max(m, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = d);
    let C = this.currentTime, S = i;
    if (h) {
      const k = Math.min(this.currentTime, d) / f;
      let I = Math.floor(k), D = k % 1;
      !D && k >= 1 && (D = 1), D === 1 && I--, I = Math.min(I, h + 1), !!(I % 2) && (y === "reverse" ? (D = 1 - D, g && (D -= g / f)) : y === "mirror" && (S = o)), C = Yr(0, 1, D) * f;
    }
    const b = v ? { done: !1, value: l[0] } : S.next(C);
    s && (b.value = s(b.value));
    let { done: x } = b;
    !v && u !== null && (x = this.speed >= 0 ? this.currentTime >= d : this.currentTime <= 0);
    const E = this.holdTime === null && (this.state === "finished" || this.state === "running" && x);
    return E && a !== void 0 && (b.value = tu(l, this.options, a)), w && w(b.value), E && this.finish(), b;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? Yn(t.calculatedDuration) : 0;
  }
  get time() {
    return Yn(this.currentTime);
  }
  set time(t) {
    t = An(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = Yn(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = b2, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), n && n();
    const a = this.driver.now();
    this.holdTime !== null ? this.startTime = a - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = a) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const S2 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), C2 = {
  linearEasing: void 0
};
function E2(e, t) {
  const n = Gc(e);
  return () => {
    var r;
    return (r = C2[t]) !== null && r !== void 0 ? r : n();
  };
}
const Us = /* @__PURE__ */ E2(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function Qy(e) {
  return !!(typeof e == "function" && Us() || !e || typeof e == "string" && (e in ic || Us()) || ad(e) || Array.isArray(e) && e.every(Qy));
}
const Ci = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, ic = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Ci([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Ci([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Ci([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Ci([0.33, 1.53, 0.69, 0.99])
};
function $y(e, t) {
  if (e)
    return typeof e == "function" && Us() ? my(e, t) : ad(e) ? Ci(e) : Array.isArray(e) ? e.map((n) => $y(n, t) || ic.easeOut) : ic[e];
}
function T2(e, t, n, { delay: r = 0, duration: a = 300, repeat: i = 0, repeatType: o = "loop", ease: s = "easeInOut", times: l } = {}) {
  const u = { [t]: n };
  l && (u.offset = l);
  const d = $y(s, a);
  return Array.isArray(d) && (u.easing = d), e.animate(u, {
    delay: r,
    duration: a,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
function jf(e, t) {
  e.timeline = t, e.onfinish = null;
}
const A2 = /* @__PURE__ */ Gc(() => Object.hasOwnProperty.call(Element.prototype, "animate")), qs = 10, P2 = 2e4;
function M2(e) {
  return eu(e.type) || e.type === "spring" || !Qy(e.ease);
}
function I2(e, t) {
  const n = new sd({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const a = [];
  let i = 0;
  for (; !r.done && i < P2; )
    r = n.sample(i), a.push(r.value), i += qs;
  return {
    times: void 0,
    keyframes: a,
    duration: i - qs,
    ease: "linear"
  };
}
const eg = {
  anticipate: My,
  backInOut: Py,
  circInOut: Iy
};
function O2(e) {
  return e in eg;
}
class Wf extends Zy {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: a, keyframes: i } = this.options;
    this.resolver = new Ky(i, (o, s) => this.onKeyframesResolved(o, s), n, r, a), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: a = 300, times: i, ease: o, type: s, motionValue: l, name: u, startTime: d } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof o == "string" && Us() && O2(o) && (o = eg[o]), M2(this.options)) {
      const { onComplete: p, onUpdate: h, motionValue: y, element: g, ...w } = this.options, m = I2(t, w);
      t = m.keyframes, t.length === 1 && (t[1] = t[0]), a = m.duration, i = m.times, o = m.ease, s = "keyframes";
    }
    const f = T2(l.owner.current, u, t, { ...this.options, duration: a, times: i, ease: o });
    return f.startTime = d ?? this.calcStartTime(), this.pendingTimeline ? (jf(f, this.pendingTimeline), this.pendingTimeline = void 0) : f.onfinish = () => {
      const { onComplete: p } = this.options;
      l.set(tu(t, this.options, n)), p && p(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: f,
      duration: a,
      times: i,
      type: s,
      ease: o,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return Yn(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return Yn(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = An(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return wr;
      const { animation: r } = n;
      jf(r, t);
    }
    return wr;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: a, type: i, ease: o, times: s } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: u, onUpdate: d, onComplete: f, element: p, ...h } = this.options, y = new sd({
        ...h,
        keyframes: r,
        duration: a,
        type: i,
        ease: o,
        times: s,
        isGenerator: !0
      }), g = An(this.time);
      u.setWithVelocity(y.sample(g - qs).value, y.sample(g).value, qs);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: a, repeatType: i, damping: o, type: s } = t;
    return A2() && r && S2.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !a && i !== "mirror" && o !== 0 && s !== "inertia";
  }
}
function F2({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: a, repeat: i, repeatType: o, repeatDelay: s, from: l, elapsed: u, ...d }) {
  return !!Object.keys(d).length;
}
const tg = (e, t, n, r = {}, a, i) => (o) => {
  const s = Sy(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - An(l);
  let d = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (p) => {
      t.set(p), s.onUpdate && s.onUpdate(p);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : a
  };
  F2(s) || (d = {
    ...d,
    ...vb(e, d)
  }), d.duration && (d.duration = An(d.duration)), d.repeatDelay && (d.repeatDelay = An(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
  let f = !1;
  if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (d.duration = 0, d.delay === 0 && (f = !0)), f && !i && t.get() !== void 0) {
    const p = tu(d.keyframes, s);
    if (p !== void 0)
      return Xn.update(() => {
        d.onUpdate(p), d.onComplete();
      }), new vy([]);
  }
  return !i && Wf.supports(d) ? new Wf(d) : new sd(d);
}, R2 = (e) => Array.isArray(e), L2 = (e) => R2(e) ? e[e.length - 1] || 0 : e;
function Hf(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function ng(e, t, n, r) {
  if (typeof t == "function") {
    const [a, i] = Hf(r);
    t = t(n !== void 0 ? n : e.custom, a, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [a, i] = Hf(r);
    t = t(n !== void 0 ? n : e.custom, a, i);
  }
  return t;
}
function D2(e, t, n) {
  const r = e.getProps();
  return ng(r, t, r.custom, e);
}
function N2(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Di(n));
}
function z2(e, t) {
  const n = D2(e, t);
  let { transitionEnd: r = {}, transition: a = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const o in i) {
    const s = L2(i[o]);
    N2(e, o, s);
  }
}
const ld = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), V2 = "framerAppearId", B2 = "data-" + ld(V2);
function j2(e) {
  return e.props[B2];
}
function W2(e) {
  return !!(jt(e) && e.add);
}
function H2(e, t) {
  const n = e.getValue("willChange");
  if (W2(n))
    return n.add(t);
}
function U2({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function q2(e, t, { delay: n = 0, transitionOverride: r, type: a } = {}) {
  var i;
  let { transition: o = e.getDefaultTransition(), transitionEnd: s, ...l } = t;
  r && (o = r);
  const u = [], d = a && e.animationState && e.animationState.getState()[a];
  for (const f in l) {
    const p = e.getValue(f, (i = e.latestValues[f]) !== null && i !== void 0 ? i : null), h = l[f];
    if (h === void 0 || d && U2(d, f))
      continue;
    const y = {
      delay: n,
      ...Sy(o || {}, f)
    };
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const m = j2(e);
      if (m) {
        const v = window.MotionHandoffAnimation(m, f, Xn);
        v !== null && (y.startTime = v, g = !0);
      }
    }
    H2(e, f), p.start(tg(f, p, h, e.shouldReduceMotion && na.has(f) ? { type: !1 } : y, e, g));
    const w = p.animation;
    w && u.push(w);
  }
  return s && Promise.all(u).then(() => {
    Xn.update(() => {
      s && z2(e, s);
    });
  }), u;
}
function G2(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const K2 = {};
function Z2(e, { layout: t, layoutId: n }) {
  return na.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!K2[e] || e === "opacity");
}
function rg(e, t, n) {
  var r;
  const { style: a } = e, i = {};
  for (const o in a)
    (jt(a[o]) || t.style && jt(t.style[o]) || Z2(o, e) || ((r = n == null ? void 0 : n.getValue(o)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (i[o] = a[o]);
  return i;
}
function Y2(e, t, n) {
  const r = rg(e, t, n);
  for (const a in e)
    if (jt(e[a]) || jt(t[a])) {
      const i = $o.indexOf(a) !== -1 ? "attr" + a.charAt(0).toUpperCase() + a.substring(1) : a;
      r[i] = e[a];
    }
  return r;
}
const X2 = typeof window < "u", oc = { current: null }, ag = { current: !1 };
function J2() {
  if (ag.current = !0, !!X2)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => oc.current = e.matches;
      e.addListener(t), t();
    } else
      oc.current = !1;
}
function Q2(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function $2(e) {
  return typeof e == "string" || Array.isArray(e);
}
const e_ = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], t_ = ["initial", ...e_];
function ig(e) {
  return Q2(e.animate) || t_.some((t) => $2(e[t]));
}
function n_(e) {
  return !!(ig(e) || e.variants);
}
var r_ = {};
function a_(e, t, n) {
  for (const r in t) {
    const a = t[r], i = n[r];
    if (jt(a))
      e.addValue(r, a), r_.NODE_ENV === "development" && qc(a.version === "11.13.5", `Attempting to mix Motion versions ${a.version} with 11.13.5 may not work as expected.`);
    else if (jt(i))
      e.addValue(r, Di(a, { owner: e }));
    else if (i !== a)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(a) : o.hasAnimated || o.set(a);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, Di(o !== void 0 ? o : a, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Uf = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, sc = {};
for (const e in Uf)
  sc[e] = {
    isEnabled: (t) => Uf[e].some((n) => !!t[n])
  };
const i_ = [...zy, Ft, ui], o_ = (e) => i_.find(Ny(e)), qf = () => ({ min: 0, max: 0 }), ud = () => ({
  x: qf(),
  y: qf()
});
var s_ = {};
const Gf = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class og {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: a, blockInitialAnimation: i, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = $c, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = gr.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Xn.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = a, this.options = s, this.blockInitialAnimation = !!i, this.isControllingVariants = ig(n), this.isVariantNode = n_(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in f) {
      const h = f[p];
      l[p] !== void 0 && jt(h) && h.set(l[p], !1);
    }
  }
  mount(t) {
    this.current = t, Ya.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), ag.current || J2(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : oc.current, s_.NODE_ENV !== "production" && qc(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Ya.delete(this.current), this.projection && this.projection.unmount(), Qu(this.notifyUpdate), Qu(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = na.has(t), a = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Xn.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      a(), i(), o && o(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in sc) {
      const n = sc[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: a } = n;
      if (!this.features[t] && a && r(this.props) && (this.features[t] = new a(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ud();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Gf.length; r++) {
      const a = Gf[r];
      this.propEventSubscriptions[a] && (this.propEventSubscriptions[a](), delete this.propEventSubscriptions[a]);
      const i = "on" + a, o = t[i];
      o && (this.propEventSubscriptions[a] = this.on(a, o));
    }
    this.prevMotionValues = a_(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Di(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let a = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return a != null && (typeof a == "string" && (Fy(a) || Oy(a)) ? a = parseFloat(a) : !o_(a) && ui.test(n) && (a = Gy(t, n)), this.setBaseTarget(t, jt(a) ? a.get() : a)), jt(a) ? a.get() : a;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let a;
    if (typeof r == "string" || typeof r == "object") {
      const o = ng(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (a = o[t]);
    }
    if (r && a !== void 0)
      return a;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !jt(i) ? i : this.initialValues[t] !== void 0 && a === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new yy()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class sg extends og {
  constructor() {
    super(...arguments), this.KeyframeResolver = Ky;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    jt(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
const lg = (e, t) => t && typeof e == "number" ? t.transform(e) : e, l_ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, u_ = $o.length;
function c_(e, t, n) {
  let r = "", a = !0;
  for (let i = 0; i < u_; i++) {
    const o = $o[i], s = e[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const u = lg(s, nd[o]);
      if (!l) {
        a = !1;
        const d = l_[o] || o;
        r += `${d}(${u}) `;
      }
      n && (t[o] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, a ? "" : r) : a && (r = "none"), r;
}
function ug(e, t, n) {
  const { style: r, vars: a, transformOrigin: i } = e;
  let o = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (na.has(l)) {
      o = !0;
      continue;
    } else if (Ly(l)) {
      a[l] = u;
      continue;
    } else {
      const d = lg(u, nd[l]);
      l.startsWith("origin") ? (s = !0, i[l] = d) : r[l] = d;
    }
  }
  if (t.transform || (o || n ? r.transform = c_(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: d = 0 } = i;
    r.transformOrigin = `${l} ${u} ${d}`;
  }
}
function Kf(e, t, n) {
  return typeof e == "string" ? e : Ie.transform(t + n * e);
}
function d_(e, t, n) {
  const r = Kf(t, e.x, e.width), a = Kf(n, e.y, e.height);
  return `${r} ${a}`;
}
const f_ = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, p_ = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function h_(e, t, n = 1, r = 0, a = !0) {
  e.pathLength = 1;
  const i = a ? f_ : p_;
  e[i.offset] = Ie.transform(-r);
  const o = Ie.transform(t), s = Ie.transform(n);
  e[i.array] = `${o} ${s}`;
}
function y_(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: a,
  originY: i,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, d, f) {
  if (ug(e, u, f), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: h, dimensions: y } = e;
  p.transform && (y && (h.transform = p.transform), delete p.transform), y && (a !== void 0 || i !== void 0 || h.transform) && (h.transformOrigin = d_(y, a !== void 0 ? a : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), o !== void 0 && h_(p, o, s, l, !1);
}
const cg = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function dg(e, { style: t, vars: n }, r, a) {
  Object.assign(e.style, t, a && a.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
function g_(e, t, n, r) {
  dg(e, t, void 0, r);
  for (const a in t.attrs)
    e.setAttribute(cg.has(a) ? a : ld(a), t.attrs[a]);
}
const v_ = (e) => typeof e == "string" && e.toLowerCase() === "svg";
class m_ extends sg {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ud;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (na.has(n)) {
      const r = rd(n);
      return r && r.default || 0;
    }
    return n = cg.has(n) ? n : ld(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Y2(t, n, r);
  }
  build(t, n, r) {
    y_(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, a) {
    g_(t, n, r, a);
  }
  mount(t) {
    this.isSVGTag = v_(t.tagName), super.mount(t);
  }
}
function w_({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function b_(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function __(e, t) {
  return w_(b_(e.getBoundingClientRect(), t));
}
function x_(e) {
  return window.getComputedStyle(e);
}
class k_ extends sg {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = dg;
  }
  readValueFromInstance(t, n) {
    if (na.has(n)) {
      const r = rd(n);
      return r && r.default || 0;
    } else {
      const r = x_(t), a = (Ly(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return __(t, n);
  }
  build(t, n, r) {
    ug(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return rg(t, n, r);
  }
}
function S_(e, t) {
  return e in t;
}
class C_ extends og {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, n) {
    if (S_(n, t)) {
      const r = t[n];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, n) {
    delete n.output[t];
  }
  measureInstanceViewportBox() {
    return ud();
  }
  build(t, n) {
    Object.assign(t.output, n);
  }
  renderInstance(t, { output: n }) {
    Object.assign(t, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function E_(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = G2(e) ? new m_(t) : new k_(t);
  n.mount(e), Ya.set(e, n);
}
function T_(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new C_(t);
  n.mount(e), Ya.set(e, n);
}
function A_(e, t, n) {
  const r = jt(e) ? e : Di(e);
  return r.start(tg("", r, t, n)), r.animation;
}
function P_(e, t) {
  return jt(e) || typeof e == "number" || typeof e == "string" && !Yc(t);
}
function fg(e, t, n, r) {
  const a = [];
  if (P_(e, t))
    a.push(A_(e, Yc(t) && t.default || t, n && (n.default || n)));
  else {
    const i = xy(e, t, r), o = i.length;
    Zr(!!o, "No valid elements provided.");
    for (let s = 0; s < o; s++) {
      const l = i[s], u = l instanceof Element ? E_ : T_;
      Ya.has(l) || u(l);
      const d = Ya.get(l), f = { ...n };
      "delay" in f && typeof f.delay == "function" && (f.delay = f.delay(s, o)), a.push(...q2(d, { ...t, transition: f }, {}));
    }
  }
  return a;
}
function M_(e, t, n) {
  const r = [];
  return lb(e, t, n, { spring: Zc }).forEach(({ keyframes: i, transition: o }, s) => {
    r.push(...fg(s, i, o));
  }), r;
}
function I_(e) {
  return Array.isArray(e) && Array.isArray(e[0]);
}
function O_(e) {
  function t(n, r, a) {
    let i = [];
    return I_(n) ? i = M_(n, r, e) : i = fg(n, r, a, e), new vy(i);
  }
  return t;
}
const F_ = O_(), Eu = (e, t = {
  startPoint: {
    x: 0,
    y: 0
  },
  options: {
    speed: 400,
    randomness: 0.02
  }
}) => {
  let n;
  const r = async (a, i, o) => {
    if (!i)
      throw e.dispatchEvent(
        new CustomEvent("cursormove", { detail: { success: !1 } })
      ), new Error("targetPoint is required");
    const s = a.x, l = a.y, u = i.x, d = i.y, f = Math.hypot(u - s, d - l), p = 0.5, h = (o == null ? void 0 : o.randomness) ?? 0.02, y = Math.min(f * h, 12), g = () => (Math.random() - 0.5) * y, w = s + (u - s) * 0.33, m = l + (d - l) * 0.33, v = w + g(), C = m + g(), S = {
      transform: [
        `translate(${s}px, ${l}px)`,
        `translate(${v}px, ${C}px)`,
        `translate(${u}px, ${d}px)`
      ]
    }, b = {
      duration: p,
      easing: "cubic-bezier(0.4, 0.0, 0.2, 1)",
      // Standard easing curve
      ...o
    };
    n = F_(e, S, b), n.then(() => {
      e.dispatchEvent(
        new CustomEvent("cursormove", {
          detail: { success: !0, position: i }
        })
      );
    }).catch((x) => {
      e.dispatchEvent(
        new CustomEvent("cursormove", { detail: { success: !1 } })
      ), console.warn("[Layup] Animation failed:", x);
    });
  };
  return r(t.startPoint, t.targetPoint, t.options), {
    update(a) {
      r(a.startPoint, a.targetPoint, a.options);
    },
    destroy() {
      n == null || n.cancel();
    }
  };
};
var R_ = /* @__PURE__ */ O("<div></div>"), L_ = /* @__PURE__ */ O('<div class="layup-relative layup-h-8 layup-w-8"></div>');
function D_(e, t) {
  be(t, !1), gn();
  var n = L_();
  at(n, 4, () => [3, 2, 1], gt, (r, a) => {
    var i = R_();
    const o = /* @__PURE__ */ St(() => Ee("layup-absolute layup-h-8 layup-w-8 layup-animate-bounce-fade layup-rounded-full layup-bg-accent", a === 1 && "layup-delay-0", a === 2 && "layup-delay-300", a === 3 && "layup-delay-600"));
    ee(() => Ve(i, c(o))), _(r, i);
  }), _(e, n), _e();
}
var N_ = /* @__PURE__ */ O('<span class="animated-letter layup-text-base !layup-font-light !layup-text-primary dark:!layup-text-primary svelte-pd0xct"> </span>'), z_ = /* @__PURE__ */ O('<span class="word-space svelte-pd0xct">&nbsp;</span>'), V_ = /* @__PURE__ */ O('<span class="word-wrapper svelte-pd0xct"><!><!></span>'), B_ = /* @__PURE__ */ O("<div></div>");
function pg(e, t) {
  var i;
  be(t, !0);
  let n = [], r = L(t, "intensity", 3, "default");
  Rn(() => {
    const o = () => {
      const u = n.filter((p) => {
        var h;
        return p && ((h = p.textContent) == null ? void 0 : h.trim()) !== "";
      }), d = {
        default: {
          letterDelay: 50,
          letterDuration: 300,
          cycleDelay: 200,
          initialOpacity: "0.7",
          initialGlow: "0 0 5px rgba(255, 255, 255, 0.3)",
          peakOpacity: "1",
          peakGlow: "0 0 8px rgba(255, 255, 255, 0.8)"
        },
        subtle: {
          letterDelay: 80,
          letterDuration: 400,
          cycleDelay: 400,
          initialOpacity: "0.8",
          initialGlow: "0 0 2px rgba(255, 255, 255, 0.15)",
          peakOpacity: "1",
          peakGlow: "0 0 4px rgba(255, 255, 255, 0.3)"
        }
      }[r()], f = u.length * d.letterDelay + d.letterDuration;
      return u.forEach((p) => {
        p && (p.style.opacity = d.initialOpacity, p.style.textShadow = d.initialGlow);
      }), u.forEach((p, h) => {
        p && setTimeout(
          () => {
            p.style.opacity = d.peakOpacity, p.style.textShadow = d.peakGlow, setTimeout(
              () => {
                p && (p.style.opacity = d.initialOpacity, p.style.textShadow = d.initialGlow);
              },
              d.letterDuration
            );
          },
          h * d.letterDelay
        );
      }), f + d.cycleDelay;
    };
    let s = o();
    const l = setInterval(
      () => {
        s = o();
      },
      s
    );
    return () => clearInterval(l);
  }), (i = X == null ? void 0 : X.config) == null || i.styles;
  var a = B_();
  at(a, 21, () => {
    var o;
    return (o = t.text) == null ? void 0 : o.split(" ");
  }, gt, (o, s, l) => {
    var u = V_(), d = T(u);
    at(d, 17, () => c(s).split(""), gt, (h, y) => {
      var g = N_(), w = T(g);
      tn(g, (m) => n[n.length] = m, () => n == null ? void 0 : n[n.length]), ee(() => ke(w, c(y))), _(h, g);
    });
    var f = Q(d);
    {
      var p = (h) => {
        var y = z_();
        _(h, y);
      };
      H(f, (h) => {
        var y;
        l !== ((y = t.text) == null ? void 0 : y.split(" ").length) - 1 && h(p);
      });
    }
    _(o, u);
  }), ee(() => {
    Ve(a, `text-container layup-relative layup-z-50 !layup-max-w-sm !layup-rounded-sm !layup-text-base !layup-font-light
      !layup-text-primary dark:!layup-text-primary ${t.padding ?? ""} svelte-pd0xct`), he(a, "style", `text-align: ${t.textAlign ?? ""};`);
  }), _(e, a), _e();
}
var j_ = /* @__PURE__ */ vt('<svg><g filter="url(#filter0_d_1615_459)"><path d="M23.3401 4.77807L23.3402 4.7781C25.492 5.35532 26.2233 8.03394 24.6723 9.62217C24.2851 10.1366 23.6996 10.5794 23.0667 10.9741C22.4226 11.3759 21.6821 11.7559 20.9656 12.1237L20.9413 12.1361C20.2081 12.5125 19.501 12.8763 18.8978 13.2548C18.2956 13.6327 17.8447 13.9967 17.5828 14.3581C17.4318 14.605 17.1877 15.0598 16.8784 15.6382L16.8477 15.6955C16.5435 16.2646 16.1866 16.9319 15.8176 17.5876C15.4368 18.2642 15.0376 18.9382 14.6639 19.4863C14.4772 19.7602 14.2918 20.01 14.114 20.2158C13.9582 20.3961 13.7877 20.5669 13.6088 20.6862C12.0192 22.2179 9.354 21.487 8.77826 19.3408L8.77822 19.3407L4.58915 3.70906C4.08094 1.81504 5.81514 0.0809754 7.70914 0.589143L23.3401 4.77807Z" stroke="white"></path></g><defs><filter id="filter0_d_1615_459" x="-0.000976562" y="-0.000976562" width="30.0015" height="30.0017" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1615_459"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1615_459" result="shape"></feBlend></filter></defs></svg>');
function W_(e, t) {
  let n = L(t, "class", 3, ""), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = j_();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      width: "34",
      height: "28",
      viewBox: "-2 -2 34 32",
      class: n(),
      ...r,
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, a);
}
var H_ = /* @__PURE__ */ vt('<svg><path d="M21.2233 10.3375L19.6005 7.52495C19.2524 6.92223 18.6792 6.48242 18.0069 6.30222C17.3346 6.12202 16.6183 6.21619 16.0155 6.56402C15.6793 6.75826 15.3909 7.02545 15.1717 7.34589L13.5386 4.52495C13.3081 4.12629 12.9768 3.79527 12.5779 3.56514C12.179 3.33501 11.7266 3.21387 11.2661 3.21387C10.8056 3.21387 10.3532 3.33501 9.95429 3.56514C9.55541 3.79527 9.22408 4.12629 8.99358 4.52495C8.51421 4.1475 7.91833 3.94882 7.30836 3.96306C6.69839 3.97731 6.11243 4.20359 5.6512 4.60302C5.18998 5.00244 4.8823 5.55006 4.78105 6.15174C4.6798 6.75342 4.7913 7.37157 5.0964 7.89995L5.24546 8.1587C4.85756 8.18879 4.4814 8.30574 4.14483 8.50089C3.54202 8.84912 3.10222 9.42256 2.92219 10.095C2.74215 10.7675 2.83663 11.484 3.18483 12.0868L6.93483 18.5856C7.47435 19.5255 8.19482 20.3491 9.0546 21.0089C9.91437 21.6686 10.8964 22.1514 11.9439 22.4293C12.6448 22.6166 13.3672 22.7111 14.0926 22.7106C15.5396 22.7081 16.9605 22.3251 18.2127 21.6C19.4649 20.8749 20.5044 19.8332 21.2268 18.5795C21.9492 17.3257 22.3292 15.904 22.3286 14.4571C22.3279 13.0101 21.9468 11.5887 21.2233 10.3356V10.3375ZM20.5989 16.21C20.2531 17.4992 19.5329 18.657 18.5292 19.5369C17.5256 20.4169 16.2835 20.9795 14.9602 21.1537C13.6368 21.3279 12.2915 21.1058 11.0943 20.5155C9.8971 19.9253 8.90181 18.9933 8.23421 17.8375L4.48421 11.3387C4.34146 11.0808 4.30567 10.7771 4.38454 10.493C4.46341 10.2089 4.65063 9.96718 4.90594 9.81975C5.16124 9.67231 5.46422 9.63099 5.74968 9.70467C6.03514 9.77834 6.28027 9.96113 6.43233 10.2137L8.23515 13.3375C8.28294 13.4255 8.34788 13.503 8.42613 13.5655C8.50438 13.628 8.59435 13.6742 8.69075 13.7014C8.78715 13.7286 8.88801 13.7362 8.98739 13.7237C9.08677 13.7113 9.18265 13.6791 9.26937 13.629C9.3561 13.5789 9.43191 13.5119 9.49234 13.4321C9.55277 13.3522 9.59659 13.261 9.62122 13.164C9.64584 13.0669 9.65078 12.9659 9.63572 12.8668C9.62067 12.7678 9.58594 12.6728 9.53358 12.5875L6.39483 7.14995C6.31774 7.02191 6.26694 6.87978 6.24539 6.73188C6.22384 6.58397 6.23198 6.43326 6.26933 6.28854C6.30668 6.14382 6.3725 6.00799 6.46293 5.88899C6.55337 5.76999 6.66661 5.6702 6.79604 5.59546C6.92547 5.52072 7.0685 5.47251 7.21677 5.45367C7.36504 5.43482 7.51558 5.44571 7.6596 5.48569C7.80362 5.52568 7.93822 5.59396 8.05555 5.68655C8.17288 5.77914 8.27059 5.89418 8.34296 6.02495L11.2698 11.0875C11.3176 11.1755 11.3826 11.253 11.4608 11.3155C11.5391 11.378 11.629 11.4242 11.7254 11.4514C11.8218 11.4786 11.9227 11.4862 12.0221 11.4737C12.1215 11.4613 12.2173 11.4291 12.3041 11.379C12.3908 11.3289 12.4666 11.2619 12.527 11.1821C12.5875 11.1022 12.6313 11.011 12.6559 10.914C12.6805 10.8169 12.6855 10.7159 12.6704 10.6168C12.6554 10.5178 12.6206 10.4228 12.5683 10.3375L10.292 6.39995C10.2149 6.27191 10.1641 6.12978 10.1426 5.98188C10.121 5.83398 10.1292 5.68326 10.1665 5.53854C10.2039 5.39382 10.2697 5.25799 10.3601 5.13899C10.4506 5.01999 10.5638 4.9202 10.6932 4.84546C10.8227 4.77072 10.9657 4.72251 11.114 4.70367C11.2622 4.68482 11.4128 4.69571 11.5568 4.73569C11.7008 4.77568 11.8354 4.84396 11.9527 4.93655C12.0701 5.02914 12.1678 5.14418 12.2401 5.27495L15.3733 10.7031C14.6435 11.4441 14.1929 12.4151 14.0983 13.4509C14.0036 14.4866 14.2706 15.5232 14.8539 16.3843C14.9658 16.5489 15.1385 16.6623 15.334 16.6996C15.5295 16.7369 15.7318 16.695 15.8964 16.5831C16.061 16.4712 16.1744 16.2985 16.2117 16.103C16.249 15.9075 16.207 15.7052 16.0951 15.5406C15.6644 14.9027 15.4953 14.1236 15.6229 13.3646C15.7504 12.6055 16.1649 11.9245 16.7805 11.4625C16.9272 11.3525 17.0285 11.1925 17.0653 11.0128C17.1021 10.8332 17.0718 10.6463 16.9801 10.4875L16.3539 9.39995C16.2743 9.27189 16.2212 9.12912 16.1978 8.98013C16.1744 8.83114 16.1813 8.67897 16.2179 8.53267C16.2545 8.38637 16.3202 8.24893 16.411 8.12851C16.5018 8.0081 16.6158 7.90717 16.7464 7.83172C16.877 7.75628 17.0214 7.70786 17.1711 7.68934C17.3208 7.67082 17.4726 7.68259 17.6177 7.72394C17.7627 7.76529 17.8979 7.83537 18.0153 7.93003C18.1327 8.02469 18.2299 8.14199 18.3011 8.27495L19.9239 11.0875C20.3692 11.854 20.6581 12.7013 20.7739 13.5802C20.8898 14.4591 20.8303 15.3523 20.5989 16.2081V16.21ZM17.8558 3.93527C17.9062 3.74321 18.0308 3.579 18.2021 3.47865C18.3735 3.3783 18.5776 3.35 18.7698 3.39995C19.4861 3.58873 20.1578 3.91801 20.7457 4.36865C21.3336 4.81929 21.8261 5.3823 22.1945 6.02495L22.2255 6.07839C22.2778 6.16377 22.3125 6.25877 22.3276 6.35778C22.3427 6.4568 22.3377 6.55783 22.3131 6.65491C22.2885 6.75198 22.2446 6.84315 22.1842 6.92302C22.1238 7.00288 22.048 7.06984 21.9612 7.11994C21.8745 7.17003 21.7786 7.20225 21.6793 7.21469C21.5799 7.22712 21.479 7.21953 21.3826 7.19236C21.2862 7.16518 21.1963 7.11898 21.118 7.05647C21.0398 6.99396 20.9748 6.91641 20.927 6.82839L20.8961 6.77495C20.6257 6.30398 20.2643 5.89151 19.8329 5.56156C19.4016 5.23161 18.9089 4.99077 18.3836 4.85308C18.1921 4.80105 18.029 4.67524 17.9301 4.50321C17.8311 4.33118 17.8044 4.12695 17.8558 3.93527Z"></path><path d="M20.5989 16.21C20.2531 17.4992 19.5329 18.657 18.5292 19.5369C17.5256 20.4169 16.2835 20.9795 14.9602 21.1537C13.6368 21.3279 12.2915 21.1058 11.0943 20.5155C9.8971 19.9253 8.90181 18.9933 8.23421 17.8375L4.48421 11.3387C4.34146 11.0808 4.30567 10.7771 4.38454 10.493C4.46341 10.2089 4.65063 9.96718 4.90594 9.81975C5.16124 9.67231 5.46422 9.63099 5.74968 9.70467C6.03514 9.77834 6.28027 9.96113 6.43233 10.2137L8.23515 13.3375C8.28294 13.4255 8.34788 13.503 8.42613 13.5655C8.50438 13.628 8.59435 13.6742 8.69075 13.7014C8.78715 13.7286 8.88801 13.7362 8.98739 13.7237C9.08677 13.7113 9.18265 13.6791 9.26937 13.629C9.3561 13.5789 9.43191 13.5119 9.49234 13.4321C9.55277 13.3522 9.59659 13.261 9.62122 13.164C9.64584 13.0669 9.65078 12.9659 9.63572 12.8668C9.62067 12.7678 9.58594 12.6728 9.53358 12.5875L6.39483 7.14995C6.31774 7.02191 6.26694 6.87978 6.24539 6.73188C6.22384 6.58397 6.23198 6.43326 6.26933 6.28854C6.30668 6.14382 6.3725 6.00799 6.46293 5.88899C6.55337 5.76999 6.66661 5.6702 6.79604 5.59546C6.92547 5.52072 7.0685 5.47251 7.21677 5.45367C7.36504 5.43482 7.51558 5.44571 7.6596 5.48569C7.80362 5.52568 7.93822 5.59396 8.05555 5.68655C8.17288 5.77914 8.27059 5.89418 8.34296 6.02495L11.2698 11.0875C11.3176 11.1755 11.3826 11.253 11.4608 11.3155C11.5391 11.378 11.629 11.4242 11.7254 11.4514C11.8218 11.4786 11.9227 11.4862 12.0221 11.4737C12.1215 11.4613 12.2173 11.4291 12.3041 11.379C12.3908 11.3289 12.4666 11.2619 12.527 11.1821C12.5875 11.1022 12.6313 11.011 12.6559 10.914C12.6805 10.8169 12.6855 10.7159 12.6704 10.6168C12.6554 10.5178 12.6206 10.4228 12.5683 10.3375L10.292 6.39995C10.2149 6.27191 10.1641 6.12978 10.1426 5.98188C10.121 5.83398 10.1292 5.68326 10.1665 5.53854C10.2039 5.39382 10.2697 5.25799 10.3601 5.13899C10.4506 5.01999 10.5638 4.9202 10.6932 4.84546C10.8227 4.77072 10.9657 4.72251 11.114 4.70367C11.2622 4.68482 11.4128 4.69571 11.5568 4.73569C11.7008 4.77568 11.8354 4.84396 11.9527 4.93655C12.0701 5.02914 12.1678 5.14418 12.2401 5.27495L15.3733 10.7031C14.6435 11.4441 14.1929 12.4151 14.0983 13.4509C14.0036 14.4866 14.2706 15.5232 14.8539 16.3843C14.9658 16.5489 15.1385 16.6623 15.334 16.6996C15.5295 16.7369 15.7318 16.695 15.8964 16.5831C16.061 16.4712 16.1744 16.2985 16.2117 16.103C16.249 15.9075 16.207 15.7052 16.0951 15.5406C15.6644 14.9027 15.4953 14.1236 15.6229 13.3646C15.7504 12.6055 16.1649 11.9245 16.7805 11.4625C16.9272 11.3525 17.0285 11.1925 17.0653 11.0128C17.1021 10.8332 17.0718 10.6463 16.9801 10.4875L16.3539 9.39995C16.2743 9.27189 16.2212 9.12912 16.1978 8.98013C16.1744 8.83114 16.1813 8.67897 16.2179 8.53267C16.2545 8.38637 16.3202 8.24893 16.411 8.12851C16.5018 8.0081 16.6158 7.90717 16.7464 7.83172C16.877 7.75628 17.0214 7.70786 17.1711 7.68934C17.3208 7.67082 17.4726 7.68259 17.6177 7.72394C17.7627 7.76529 17.8979 7.83537 18.0153 7.93003C18.1327 8.02469 18.2299 8.14199 18.3011 8.27495L19.9239 11.0875C20.3692 11.854 20.6581 12.7013 20.7739 13.5802C20.8898 14.4591 20.8303 15.3523 20.5989 16.2081V16.21Z" fill="white"></path></svg>');
function U_(e, t) {
  let n = L(t, "class", 3, "layup-fill-primary"), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = H_();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      width: "40",
      height: "40",
      ...r,
      class: n(),
      viewBox: "0 0 25 25",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, a);
}
var Zf = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Gt = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, q_ = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function hg(e, t) {
  e.forEach(function(n) {
    Array.isArray(n) ? hg(n, t) : t.push(n);
  });
}
function yg(e) {
  let t = [];
  return hg(e, t), t;
}
var gg = (...e) => yg(e).filter(Boolean), vg = (e, t) => {
  let n = {}, r = Object.keys(e), a = Object.keys(t);
  for (let i of r) if (a.includes(i)) {
    let o = e[i], s = t[i];
    Array.isArray(o) || Array.isArray(s) ? n[i] = gg(s, o) : typeof o == "object" && typeof s == "object" ? n[i] = vg(o, s) : n[i] = s + " " + o;
  } else n[i] = e[i];
  for (let i of a) r.includes(i) || (n[i] = t[i]);
  return n;
}, Yf = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim(), G_ = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, mg = (e) => e || void 0, Vi = (...e) => mg(yg(e).filter(Boolean).join(" ")), Tu = null, Hn = {}, lc = !1, _i = (...e) => (t) => t.twMerge ? ((!Tu || lc) && (lc = !1, Tu = Gt(Hn) ? Uh : F1({ ...Hn, extend: { theme: Hn.theme, classGroups: Hn.classGroups, conflictingClassGroupModifiers: Hn.conflictingClassGroupModifiers, conflictingClassGroups: Hn.conflictingClassGroups, ...Hn.extend } })), mg(Tu(Vi(e)))) : Vi(e), Xf = (e, t) => {
  for (let n in t) e.hasOwnProperty(n) ? e[n] = Vi(e[n], t[n]) : e[n] = t[n];
  return e;
}, K_ = (e, t) => {
  let { extend: n = null, slots: r = {}, variants: a = {}, compoundVariants: i = [], compoundSlots: o = [], defaultVariants: s = {} } = e, l = { ...G_, ...t }, u = n != null && n.base ? Vi(n.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, d = n != null && n.variants && !Gt(n.variants) ? vg(a, n.variants) : a, f = n != null && n.defaultVariants && !Gt(n.defaultVariants) ? { ...n.defaultVariants, ...s } : s;
  !Gt(l.twMergeConfig) && !q_(l.twMergeConfig, Hn) && (lc = !0, Hn = l.twMergeConfig);
  let p = Gt(n == null ? void 0 : n.slots), h = Gt(r) ? {} : { base: Vi(e == null ? void 0 : e.base, p && (n == null ? void 0 : n.base)), ...r }, y = p ? h : Xf({ ...n == null ? void 0 : n.slots }, Gt(h) ? { base: e == null ? void 0 : e.base } : h), g = Gt(n == null ? void 0 : n.compoundVariants) ? i : gg(n == null ? void 0 : n.compoundVariants, i), w = (v) => {
    if (Gt(d) && Gt(r) && p) return _i(u, v == null ? void 0 : v.class, v == null ? void 0 : v.className)(l);
    if (g && !Array.isArray(g)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof g}`);
    if (o && !Array.isArray(o)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof o}`);
    let C = (M, N, P = [], Y) => {
      let G = P;
      if (typeof N == "string") G = G.concat(Yf(N).split(" ").map((q) => `${M}:${q}`));
      else if (Array.isArray(N)) G = G.concat(N.reduce((q, J) => q.concat(`${M}:${J}`), []));
      else if (typeof N == "object" && typeof Y == "string") {
        for (let q in N) if (N.hasOwnProperty(q) && q === Y) {
          let J = N[q];
          if (J && typeof J == "string") {
            let $ = Yf(J);
            G[Y] ? G[Y] = G[Y].concat($.split(" ").map((W) => `${M}:${W}`)) : G[Y] = $.split(" ").map((W) => `${M}:${W}`);
          } else Array.isArray(J) && J.length > 0 && (G[Y] = J.reduce(($, W) => $.concat(`${M}:${W}`), []));
        }
      }
      return G;
    }, S = (M, N = d, P = null, Y = null) => {
      var G;
      let q = N[M];
      if (!q || Gt(q)) return null;
      let J = (G = Y == null ? void 0 : Y[M]) != null ? G : v == null ? void 0 : v[M];
      if (J === null) return null;
      let $ = Zf(J), W = Array.isArray(l.responsiveVariants) && l.responsiveVariants.length > 0 || l.responsiveVariants === !0, j = f == null ? void 0 : f[M], B = [];
      if (typeof $ == "object" && W) for (let [ne, ue] of Object.entries($)) {
        let ae = q[ue];
        if (ne === "initial") {
          j = ue;
          continue;
        }
        Array.isArray(l.responsiveVariants) && !l.responsiveVariants.includes(ne) || (B = C(ne, ae, B, P));
      }
      let K = $ != null && typeof $ != "object" ? $ : Zf(j), U = q[K || "false"];
      return typeof B == "object" && typeof P == "string" && B[P] ? Xf(B, U) : B.length > 0 ? (B.push(U), P === "base" ? B.join(" ") : B) : U;
    }, b = () => d ? Object.keys(d).map((M) => S(M, d)) : null, x = (M, N) => {
      if (!d || typeof d != "object") return null;
      let P = new Array();
      for (let Y in d) {
        let G = S(Y, d, M, N), q = M === "base" && typeof G == "string" ? G : G && G[M];
        q && (P[P.length] = q);
      }
      return P;
    }, E = {};
    for (let M in v) v[M] !== void 0 && (E[M] = v[M]);
    let k = (M, N) => {
      var P;
      let Y = typeof (v == null ? void 0 : v[M]) == "object" ? { [M]: (P = v[M]) == null ? void 0 : P.initial } : {};
      return { ...f, ...E, ...Y, ...N };
    }, I = (M = [], N) => {
      let P = [];
      for (let { class: Y, className: G, ...q } of M) {
        let J = !0;
        for (let [$, W] of Object.entries(q)) {
          let j = k($, N)[$];
          if (Array.isArray(W)) {
            if (!W.includes(j)) {
              J = !1;
              break;
            }
          } else {
            let B = (K) => K == null || K === !1;
            if (B(W) && B(j)) continue;
            if (j !== W) {
              J = !1;
              break;
            }
          }
        }
        J && (Y && P.push(Y), G && P.push(G));
      }
      return P;
    }, D = (M) => {
      let N = I(g, M);
      if (!Array.isArray(N)) return N;
      let P = {};
      for (let Y of N) if (typeof Y == "string" && (P.base = _i(P.base, Y)(l)), typeof Y == "object") for (let [G, q] of Object.entries(Y)) P[G] = _i(P[G], q)(l);
      return P;
    }, A = (M) => {
      if (o.length < 1) return null;
      let N = {};
      for (let { slots: P = [], class: Y, className: G, ...q } of o) {
        if (!Gt(q)) {
          let J = !0;
          for (let $ of Object.keys(q)) {
            let W = k($, M)[$];
            if (W === void 0 || (Array.isArray(q[$]) ? !q[$].includes(W) : q[$] !== W)) {
              J = !1;
              break;
            }
          }
          if (!J) continue;
        }
        for (let J of P) N[J] = N[J] || [], N[J].push([Y, G]);
      }
      return N;
    };
    if (!Gt(r) || !p) {
      let M = {};
      if (typeof y == "object" && !Gt(y)) for (let N of Object.keys(y)) M[N] = (P) => {
        var Y, G;
        return _i(y[N], x(N, P), ((Y = D(P)) != null ? Y : [])[N], ((G = A(P)) != null ? G : [])[N], P == null ? void 0 : P.class, P == null ? void 0 : P.className)(l);
      };
      return M;
    }
    return _i(u, b(), I(g), v == null ? void 0 : v.class, v == null ? void 0 : v.className)(l);
  }, m = () => {
    if (!(!d || typeof d != "object")) return Object.keys(d);
  };
  return w.variantKeys = m(), w.extend = n, w.base = u, w.slots = y, w.variants = d, w.defaultVariants = f, w.compoundSlots = o, w.compoundVariants = g, w;
};
const Jf = K_({
  base: "focus-visible:!layup-ring-ring !layup-inline-flex layup-items-center layup-justify-center !layup-gap-2 !layup-whitespace-nowrap !layup-text-sm layup-font-medium transition-colors focus-visible:layup-outline-none focus-visible:ring-0 disabled:layup-pointer-events-none disabled:layup-opacity-50 [&_svg]:layup-pointer-events-none [&_svg]:layup-size-4 [&_svg]:layup-shrink-0",
  variants: {
    variant: {
      default: "layup-bg-accent layup-text-accent-foreground hover:!layup-bg-accent-bg layup-shadow",
      destructive: "layup-bg-destructive layup-text-destructive-foreground hover:!layup-bg-destructive/90 layup-shadow-sm",
      outline: "layup-border-input layup-bg-background hover:layup-bg-accent hover:layup-text-accent-foreground layup-border layup-shadow-sm",
      secondary: "layup-bg-secondary layup-text-secondary-foreground hover:!layup-bg-secondary/80 layup-shadow-sm",
      ghost: "hover:!layup-bg-accent hover:!layup-text-accent-foreground",
      link: "layup-text-accent layup-underline-offset-4 hover:!layup-underline"
    },
    size: {
      default: "layup-h-9 layup-px-4 layup-py-2",
      sm: "layup-h-8 layup-rounded-md layup-px-3 !layup-text-xs",
      lg: "layup-h-10 layup-rounded-md layup-px-8",
      icon: "layup-size-8"
    }
  },
  defaultVariants: { variant: "default", size: "default" }
});
var Z_ = /* @__PURE__ */ O("<a><!></a>"), Y_ = /* @__PURE__ */ O("<button><!></button>");
function Re(e, t) {
  be(t, !0);
  let n = L(t, "variant", 3, "default"), r = L(t, "size", 3, "default"), a = L(t, "ref", 15, null), i = L(t, "href", 3, void 0), o = L(t, "type", 3, "button"), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "class",
    "variant",
    "size",
    "ref",
    "href",
    "type",
    "children"
  ]);
  var l = Z(), u = V(l);
  {
    var d = (p) => {
      var h = Z_();
      let y;
      var g = T(h);
      lt(g, () => t.children ?? De), tn(h, (w) => a(w), () => a()), ee(() => y = Je(h, y, {
        class: Ee(Jf({
          variant: n(),
          size: r(),
          className: t.class
        })),
        href: i(),
        ...s
      })), _(p, h);
    }, f = (p) => {
      var h = Y_(), y = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, g = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, w = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, m = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, v = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, C = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, S = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, b = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, x = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, E = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      }, k = (A) => {
        A.preventDefault(), A.stopPropagation(), A.stopImmediatePropagation();
      };
      let I;
      var D = T(h);
      lt(D, () => t.children ?? De), tn(h, (A) => a(A), () => a()), ee(() => I = Je(h, I, {
        tabindex: "-99",
        onfocus: y,
        onpointerover: g,
        onpointerenter: w,
        onmouseover: m,
        onmouseenter: v,
        onpointermove: C,
        onpointerdown: S,
        onmousedown: b,
        onpointerup: x,
        onmouseup: E,
        onblur: k,
        class: Ee(Jf({
          variant: n(),
          size: r(),
          className: t.class
        })),
        type: o(),
        ...s
      })), _(p, h);
    };
    H(u, (p) => {
      i() ? p(d) : p(f, !1);
    });
  }
  _(e, l), _e();
}
function X_(e) {
  return typeof e == "function";
}
function J_(e) {
  return e !== null && typeof e == "object";
}
const Bi = Symbol("box"), cd = Symbol("is-writable");
function Q_(e) {
  return J_(e) && Bi in e;
}
function $_(e) {
  return ce.isBox(e) && cd in e;
}
function ce(e) {
  let t = de(oe(e));
  return {
    [Bi]: !0,
    [cd]: !0,
    get current() {
      return c(t);
    },
    set current(n) {
      z(t, oe(n));
    }
  };
}
function ex(e, t) {
  const n = /* @__PURE__ */ R(e);
  return t ? {
    [Bi]: !0,
    [cd]: !0,
    get current() {
      return c(n);
    },
    set current(r) {
      t(r);
    }
  } : {
    [Bi]: !0,
    get current() {
      return e();
    }
  };
}
function tx(e) {
  return ce.isBox(e) ? e : X_(e) ? ce.with(e) : ce(e);
}
function nx(e) {
  return Object.entries(e).reduce(
    (t, [n, r]) => ce.isBox(r) ? (ce.isWritableBox(r) ? Object.defineProperty(t, n, {
      get() {
        return r.current;
      },
      set(a) {
        r.current = a;
      }
    }) : Object.defineProperty(t, n, {
      get() {
        return r.current;
      }
    }), t) : Object.assign(t, { [n]: r }),
    {}
  );
}
function rx(e) {
  return ce.isWritableBox(e) ? {
    [Bi]: !0,
    get current() {
      return e.current;
    }
  } : e;
}
ce.from = tx;
ce.with = ex;
ce.flatten = nx;
ce.readonly = rx;
ce.isBox = Q_;
ce.isWritableBox = $_;
function wg(...e) {
  return function(t) {
    var n;
    for (const r of e)
      if (r) {
        if (t.defaultPrevented)
          return;
        typeof r == "function" ? r.call(this, t) : (n = r.current) == null || n.call(this, t);
      }
  };
}
var Qf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ax(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bg = {}, $f = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, ix = /\n/g, ox = /^\s*/, sx = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, lx = /^:\s*/, ux = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, cx = /^[;\s]*/, dx = /^\s+|\s+$/g, fx = `
`, ep = "/", tp = "*", Fr = "", px = "comment", hx = "declaration", yx = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function a(y) {
    var g = y.match(ix);
    g && (n += g.length);
    var w = y.lastIndexOf(fx);
    r = ~w ? y.length - w : r + y.length;
  }
  function i() {
    var y = { line: n, column: r };
    return function(g) {
      return g.position = new o(y), u(), g;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(y) {
    var g = new Error(
      t.source + ":" + n + ":" + r + ": " + y
    );
    if (g.reason = y, g.filename = t.source, g.line = n, g.column = r, g.source = e, !t.silent) throw g;
  }
  function l(y) {
    var g = y.exec(e);
    if (g) {
      var w = g[0];
      return a(w), e = e.slice(w.length), g;
    }
  }
  function u() {
    l(ox);
  }
  function d(y) {
    var g;
    for (y = y || []; g = f(); )
      g !== !1 && y.push(g);
    return y;
  }
  function f() {
    var y = i();
    if (!(ep != e.charAt(0) || tp != e.charAt(1))) {
      for (var g = 2; Fr != e.charAt(g) && (tp != e.charAt(g) || ep != e.charAt(g + 1)); )
        ++g;
      if (g += 2, Fr === e.charAt(g - 1))
        return s("End of comment missing");
      var w = e.slice(2, g - 2);
      return r += 2, a(w), e = e.slice(g), r += 2, y({
        type: px,
        comment: w
      });
    }
  }
  function p() {
    var y = i(), g = l(sx);
    if (g) {
      if (f(), !l(lx)) return s("property missing ':'");
      var w = l(ux), m = y({
        type: hx,
        property: np(g[0].replace($f, Fr)),
        value: w ? np(w[0].replace($f, Fr)) : Fr
      });
      return l(cx), m;
    }
  }
  function h() {
    var y = [];
    d(y);
    for (var g; g = p(); )
      g !== !1 && (y.push(g), d(y));
    return y;
  }
  return u(), h();
};
function np(e) {
  return e ? e.replace(dx, Fr) : Fr;
}
var gx = Qf && Qf.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(bg, "__esModule", { value: !0 });
var rp = bg.default = mx, vx = gx(yx);
function mx(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, vx.default)(e), a = typeof t == "function";
  return r.forEach(function(i) {
    if (i.type === "declaration") {
      var o = i.property, s = i.value;
      a ? t(o, s, i) : s && (n = n || {}, n[o] = s);
    }
  }), n;
}
const wx = rp.default || rp, bx = /\d/, _x = ["-", "_", "/", "."];
function xx(e = "") {
  if (!bx.test(e))
    return e !== e.toLowerCase();
}
function kx(e) {
  const t = [];
  let n = "", r, a;
  for (const i of e) {
    const o = _x.includes(i);
    if (o === !0) {
      t.push(n), n = "", r = void 0;
      continue;
    }
    const s = xx(i);
    if (a === !1) {
      if (r === !1 && s === !0) {
        t.push(n), n = i, r = s;
        continue;
      }
      if (r === !0 && s === !1 && n.length > 1) {
        const l = n.at(-1);
        t.push(n.slice(0, Math.max(0, n.length - 1))), n = l + i, r = s;
        continue;
      }
    }
    n += i, r = s, a = o;
  }
  return t.push(n), t;
}
function _g(e) {
  return e ? kx(e).map((t) => Cx(t)).join("") : "";
}
function Sx(e) {
  return Ex(_g(e || ""));
}
function Cx(e) {
  return e ? e[0].toUpperCase() + e.slice(1) : "";
}
function Ex(e) {
  return e ? e[0].toLowerCase() + e.slice(1) : "";
}
function Ei(e) {
  if (!e)
    return {};
  const t = {};
  function n(r, a) {
    if (r.startsWith("-moz-") || r.startsWith("-webkit-") || r.startsWith("-ms-") || r.startsWith("-o-")) {
      t[_g(r)] = a;
      return;
    }
    if (r.startsWith("--")) {
      t[r] = a;
      return;
    }
    t[Sx(r)] = a;
  }
  return wx(e, n), t;
}
function Sa(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
function Tx(e, t) {
  const n = RegExp(e, "g");
  return (r) => {
    if (typeof r != "string")
      throw new TypeError(`expected an argument of type string, but got ${typeof r}`);
    return r.match(n) ? r.replace(n, t) : r;
  };
}
const Ax = Tx(/[A-Z]/, (e) => `-${e.toLowerCase()}`);
function Px(e) {
  if (!e || typeof e != "object" || Array.isArray(e))
    throw new TypeError(`expected an argument of type object, but got ${typeof e}`);
  return Object.keys(e).map((t) => `${Ax(t)}: ${e[t]};`).join(`
`);
}
function dd(e = {}) {
  return Px(e).replace(`
`, " ");
}
const Mx = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0",
  transform: "translateX(-100%)"
};
dd(Mx);
function Ix(e) {
  var t;
  return e.length > 2 && e.startsWith("on") && e[2] === ((t = e[2]) == null ? void 0 : t.toLowerCase());
}
function $t(...e) {
  const t = { ...e[0] };
  for (let n = 1; n < e.length; n++) {
    const r = e[n];
    for (const a in r) {
      const i = t[a], o = r[a], s = typeof i == "function", l = typeof o == "function";
      if (s && Ix(a)) {
        const u = i, d = o;
        t[a] = wg(u, d);
      } else if (s && l)
        t[a] = Sa(i, o);
      else if (a === "class" && typeof i == "string" && typeof o == "string")
        t[a] = zh(i, o);
      else if (a === "style") {
        const u = typeof i == "object", d = typeof o == "object", f = typeof i == "string", p = typeof o == "string";
        if (u && d)
          t[a] = { ...i, ...o };
        else if (u && p) {
          const h = Ei(o);
          t[a] = { ...i, ...h };
        } else if (f && d) {
          const h = Ei(i);
          t[a] = { ...h, ...o };
        } else if (f && p) {
          const h = Ei(i), y = Ei(o);
          t[a] = { ...h, ...y };
        } else u ? t[a] = i : d && (t[a] = o);
      } else
        t[a] = o !== void 0 ? o : i;
    }
  }
  return typeof t.style == "object" && (t.style = dd(t.style).replaceAll(`
`, " ")), t.hidden !== !0 && (t.hidden = void 0), t.disabled !== !0 && (t.disabled = void 0), t;
}
function In({
  id: e,
  ref: t,
  deps: n = () => !0,
  onRefChange: r = () => {
  },
  getRootNode: a = () => typeof document < "u" ? document : void 0
}) {
  const i = /* @__PURE__ */ R(() => n()), o = /* @__PURE__ */ R(() => a());
  Se(() => (e.current, c(i), c(o), _t(() => {
    var l;
    const s = (l = c(o)) == null ? void 0 : l.getElementById(e.current);
    s ? t.current = s : t.current = null, r(t.current);
  }))), Se(() => () => {
    t.current = null, r(null);
  });
}
function Ox(e) {
  Se(() => () => {
    e();
  });
}
function xg(e, t) {
  setTimeout(t, e);
}
function nu(e) {
  Ac().then(e);
}
function kg(e) {
  return e ? "open" : "closed";
}
function Fx(e) {
  return e ? "true" : void 0;
}
const Rx = "Enter", Lx = "Escape", Dx = " ", Nx = "Tab", fd = typeof document < "u", ap = zx();
function zx() {
  var e, t;
  return fd && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && // eslint-disable-next-line regexp/no-unused-capturing-group
  (/iP(ad|hone|od)/.test(window.navigator.userAgent) || // The new iPad Pro Gen3 does not identify itself as iPad, but as Macintosh.
  ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Gs(e) {
  return e instanceof HTMLElement;
}
function Vx(e) {
  return e instanceof Element;
}
function Bx(e) {
  return e !== null;
}
function jx(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wx(e, t) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ip(e, t) {
  return Ih(e, t);
}
function Hx(e, t) {
  const n = e, r = typeof e == "symbol" ? e.description : e;
  if (!bm(n)) {
    if (t === void 0)
      throw new Error(`Missing context dependency: ${r} and no fallback was provided.`);
    return t;
  }
  return Xl(e);
}
function Ux(e, t) {
  return typeof e == "string" && t === void 0 ? `${e}Context` : Array.isArray(e) && t === void 0 ? `${e[0]}Context` : `${e}Context`;
}
function ru(e, t, n = !0) {
  const r = Ux(e, t), a = Symbol.for(`bits-ui.${r}`), i = r;
  function o(l) {
    const u = Hx(n ? a : i, l);
    if (u === void 0)
      throw new Error(`Context \`${r}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
    return u;
  }
  function s(l) {
    return ip(n ? a : i, l);
  }
  return [s, o];
}
let op = 0;
function $n(e = "bits") {
  return op++, `${e}-${op}`;
}
function Ct() {
}
var Ea, Gi, sr, zr, Sr, uc, cc;
class qx {
  constructor(t, n) {
    te(this, Sr);
    te(this, Ea, de());
    te(this, Gi);
    te(this, sr, 0);
    te(this, zr, null);
    F(this, Ea).v = oe(t), Te(this, Gi, n);
  }
  get current() {
    return sm() ? Se(() => (hu(this, sr)._++, F(this, sr) === 1 && qt(this, Sr, uc).call(this, !0), () => {
      Ac().then(() => {
        hu(this, sr)._--, F(this, sr) === 0 && qt(this, Sr, cc).call(this);
      });
    })) : F(this, sr) === 0 && (qt(this, Sr, uc).call(this, !1), qt(this, Sr, cc).call(this)), c(F(this, Ea));
  }
}
Ea = new WeakMap(), Gi = new WeakMap(), sr = new WeakMap(), zr = new WeakMap(), Sr = new WeakSet(), uc = function(t) {
  Te(this, zr, F(this, Gi).call(this, (n) => {
    z(F(this, Ea), oe(n));
  }, t) ?? null);
}, cc = function() {
  F(this, zr) !== null && (F(this, zr).call(this), Te(this, zr, null));
};
new qx(null, (e, t) => {
  function n() {
    e(document.activeElement);
  }
  if (n(), !!t)
    return document.addEventListener("focusin", n), document.addEventListener("focusout", n), () => {
      document.removeEventListener("focusin", n), document.removeEventListener("focusout", n);
    };
});
function Gx(e) {
  return typeof e == "function";
}
function Kx(e) {
  return Gx(e) ? e() : e;
}
var lr;
class Zx {
  constructor(t, n = { box: "border-box" }) {
    te(this, lr, de(oe({ width: 0, height: 0 })));
    var r, a;
    F(this, lr).v = oe({
      width: ((r = n.initialSize) == null ? void 0 : r.width) ?? 0,
      height: ((a = n.initialSize) == null ? void 0 : a.height) ?? 0
    }), Se(() => {
      const i = Kx(t);
      if (!i) return;
      const o = new ResizeObserver((s) => {
        for (const l of s) {
          const u = n.box === "content-box" ? l.contentBoxSize : l.borderBoxSize, d = Array.isArray(u) ? u : [u];
          c(F(this, lr)).width = d.reduce((f, p) => Math.max(f, p.inlineSize), 0), c(F(this, lr)).height = d.reduce((f, p) => Math.max(f, p.blockSize), 0);
        }
      });
      return o.observe(i), () => {
        o.disconnect();
      };
    });
  }
  get width() {
    return c(F(this, lr)).width;
  }
  get height() {
    return c(F(this, lr)).height;
  }
}
lr = new WeakMap();
var Ki, Zi;
class Sg {
  constructor(t) {
    te(this, Ki, de());
    te(this, Zi);
    Se(() => {
      z(F(this, Ki), oe(F(this, Zi))), Te(this, Zi, t());
    });
  }
  get current() {
    return c(F(this, Ki));
  }
}
Ki = new WeakMap(), Zi = new WeakMap();
function Yx(e, t) {
  const n = ce(e);
  function r(i) {
    return t[n.current][i] ?? n.current;
  }
  return { state: n, dispatch: (i) => {
    n.current = r(i);
  } };
}
function Xx(e, t) {
  let n = de(oe({})), r = de("none");
  const a = e.current ? "mounted" : "unmounted";
  let i = de(null);
  const o = new Sg(() => e.current);
  Se(() => {
    t.current && e.current && nu(() => {
      z(i, oe(document.getElementById(t.current)));
    });
  });
  const { state: s, dispatch: l } = Yx(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" },
    unmounted: { MOUNT: "mounted" }
  });
  Se(() => {
    const p = e.current;
    _t(() => {
      if (c(i) || z(i, oe(document.getElementById(t.current))), !c(i) || !(p !== o.current)) return;
      const y = c(r), g = hs(c(i));
      p ? l("MOUNT") : g === "none" || c(n).display === "none" ? l("UNMOUNT") : l(o && y !== g ? "ANIMATION_OUT" : "UNMOUNT");
    });
  });
  function u(p) {
    if (c(i) || z(i, oe(document.getElementById(t.current))), !c(i)) return;
    const h = hs(c(i)), y = h.includes(p.animationName) || h === "none";
    p.target === c(i) && y && l("ANIMATION_END");
  }
  function d(p) {
    c(i) || z(i, oe(document.getElementById(t.current))), c(i) && p.target === c(i) && z(r, oe(hs(c(i))));
  }
  Se(() => {
    s.current, _t(() => {
      if (c(i) || z(i, oe(document.getElementById(t.current))), !c(i)) return;
      const p = hs(c(i));
      z(r, oe(s.current === "mounted" ? p : "none"));
    });
  }), Se(() => {
    if (c(i))
      return z(n, oe(getComputedStyle(c(i)))), c(i).addEventListener("animationstart", d), c(i).addEventListener("animationcancel", u), c(i).addEventListener("animationend", u), () => {
        var p, h, y;
        (p = c(i)) == null || p.removeEventListener("animationstart", d), (h = c(i)) == null || h.removeEventListener("animationcancel", u), (y = c(i)) == null || y.removeEventListener("animationend", u);
      };
  });
  const f = /* @__PURE__ */ R(() => ["mounted", "unmountSuspended"].includes(s.current));
  return {
    get current() {
      return c(f);
    }
  };
}
function hs(e) {
  return e && getComputedStyle(e).animationName || "none";
}
function pd(e, t) {
  be(t, !0);
  const n = Xx(ce.with(() => t.present), ce.with(() => t.id));
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = Z(), l = V(s);
      lt(l, () => t.presence ?? De, () => ({ present: n })), _(o, s);
    };
    H(a, (o) => {
      (t.forceMount || t.present || n.current) && o(i);
    });
  }
  _(e, r), _e();
}
function Jx(e) {
  return {
    content: `data-${e}-content`,
    trigger: `data-${e}-trigger`,
    overlay: `data-${e}-overlay`,
    title: `data-${e}-title`,
    description: `data-${e}-description`,
    close: `data-${e}-close`,
    cancel: `data-${e}-cancel`,
    action: `data-${e}-action`
  };
}
var Yi, Xi, Ji, Qi, $i, eo, to, no, ro, tl, nl;
class Qx {
  constructor(t) {
    Le(this, "open");
    Le(this, "variant");
    te(this, Yi, de(null));
    te(this, Xi, de(null));
    te(this, Ji, de(null));
    te(this, Qi, de(null));
    te(this, $i, de(void 0));
    te(this, eo, de(void 0));
    te(this, to, de(void 0));
    te(this, no, de(void 0));
    te(this, ro, de(null));
    te(this, tl, /* @__PURE__ */ R(() => Jx(this.variant.current)));
    Le(this, "handleOpen", () => {
      this.open.current || (this.open.current = !0);
    });
    Le(this, "handleClose", () => {
      this.open.current && (this.open.current = !1);
    });
    te(this, nl, /* @__PURE__ */ R(() => ({
      "data-state": kg(this.open.current)
    })));
    this.open = t.open, this.variant = t.variant;
  }
  get triggerNode() {
    return c(F(this, Yi));
  }
  set triggerNode(t) {
    z(F(this, Yi), oe(t));
  }
  get titleNode() {
    return c(F(this, Xi));
  }
  set titleNode(t) {
    z(F(this, Xi), oe(t));
  }
  get contentNode() {
    return c(F(this, Ji));
  }
  set contentNode(t) {
    z(F(this, Ji), oe(t));
  }
  get descriptionNode() {
    return c(F(this, Qi));
  }
  set descriptionNode(t) {
    z(F(this, Qi), oe(t));
  }
  get contentId() {
    return c(F(this, $i));
  }
  set contentId(t) {
    z(F(this, $i), oe(t));
  }
  get titleId() {
    return c(F(this, eo));
  }
  set titleId(t) {
    z(F(this, eo), oe(t));
  }
  get triggerId() {
    return c(F(this, to));
  }
  set triggerId(t) {
    z(F(this, to), oe(t));
  }
  get descriptionId() {
    return c(F(this, no));
  }
  set descriptionId(t) {
    z(F(this, no), oe(t));
  }
  get cancelNode() {
    return c(F(this, ro));
  }
  set cancelNode(t) {
    z(F(this, ro), oe(t));
  }
  get attrs() {
    return c(F(this, tl));
  }
  get sharedProps() {
    return c(F(this, nl));
  }
}
Yi = new WeakMap(), Xi = new WeakMap(), Ji = new WeakMap(), Qi = new WeakMap(), $i = new WeakMap(), eo = new WeakMap(), to = new WeakMap(), no = new WeakMap(), ro = new WeakMap(), tl = new WeakMap(), nl = new WeakMap();
var Ta, ao, _n, io, Vr, rl, al, il, ol, sl;
class $x {
  constructor(t, n) {
    te(this, Ta);
    te(this, ao);
    te(this, _n);
    te(this, io);
    te(this, Vr);
    te(this, rl, /* @__PURE__ */ R(() => F(this, _n).attrs[F(this, io).current]));
    te(this, al, (t) => {
      if (!F(this, Vr).current) {
        if (t.pointerType === "touch") return t.preventDefault();
        t.button > 0 || F(this, _n).handleClose();
      }
    });
    te(this, il, (t) => {
      F(this, Vr).current || t.pointerType === "touch" && (t.preventDefault(), F(this, _n).handleClose());
    });
    te(this, ol, (t) => {
      F(this, Vr).current || (t.key === Dx || t.key === Rx) && (t.preventDefault(), F(this, _n).handleClose());
    });
    te(this, sl, /* @__PURE__ */ R(() => ({
      id: F(this, Ta).current,
      [c(F(this, rl))]: "",
      onpointerdown: F(this, al),
      onpointerup: F(this, il),
      onkeydown: F(this, ol),
      ...F(this, _n).sharedProps
    })));
    Te(this, _n, n), Te(this, ao, t.ref), Te(this, Ta, t.id), Te(this, io, t.variant), Te(this, Vr, t.disabled), In({
      id: F(this, Ta),
      ref: F(this, ao),
      deps: () => F(this, _n).open.current
    });
  }
  get props() {
    return c(F(this, sl));
  }
}
Ta = new WeakMap(), ao = new WeakMap(), _n = new WeakMap(), io = new WeakMap(), Vr = new WeakMap(), rl = new WeakMap(), al = new WeakMap(), il = new WeakMap(), ol = new WeakMap(), sl = new WeakMap();
var Aa, oo, ll, ul;
class e3 {
  constructor(t, n) {
    te(this, Aa);
    te(this, oo);
    Le(this, "root");
    te(this, ll, /* @__PURE__ */ R(() => ({ open: this.root.open.current })));
    te(this, ul, /* @__PURE__ */ R(() => ({
      id: F(this, Aa).current,
      role: this.root.variant.current === "alert-dialog" ? "alertdialog" : "dialog",
      "aria-describedby": this.root.descriptionId,
      "aria-labelledby": this.root.titleId,
      [this.root.attrs.content]: "",
      style: { pointerEvents: "auto" },
      ...this.root.sharedProps
    })));
    Te(this, Aa, t.id), this.root = n, Te(this, oo, t.ref), In({
      id: F(this, Aa),
      ref: F(this, oo),
      deps: () => this.root.open.current,
      onRefChange: (r) => {
        this.root.contentNode = r, this.root.contentId = r == null ? void 0 : r.id;
      }
    });
  }
  get snippetProps() {
    return c(F(this, ll));
  }
  get props() {
    return c(F(this, ul));
  }
}
Aa = new WeakMap(), oo = new WeakMap(), ll = new WeakMap(), ul = new WeakMap();
var Pa, so, cl, dl;
class t3 {
  constructor(t, n) {
    te(this, Pa);
    te(this, so);
    Le(this, "root");
    te(this, cl, /* @__PURE__ */ R(() => ({ open: this.root.open.current })));
    te(this, dl, /* @__PURE__ */ R(() => ({
      id: F(this, Pa).current,
      [this.root.attrs.overlay]: "",
      style: { pointerEvents: "auto" },
      ...this.root.sharedProps
    })));
    Te(this, Pa, t.id), Te(this, so, t.ref), this.root = n, In({
      id: F(this, Pa),
      ref: F(this, so),
      deps: () => this.root.open.current
    });
  }
  get snippetProps() {
    return c(F(this, cl));
  }
  get props() {
    return c(F(this, dl));
  }
}
Pa = new WeakMap(), so = new WeakMap(), cl = new WeakMap(), dl = new WeakMap();
const [n3, hd] = ru("Dialog.Root");
function r3(e) {
  return n3(new Qx(e));
}
function a3(e) {
  return new e3(e, hd());
}
function i3(e) {
  return new t3(e, hd());
}
function o3(e) {
  return new $x(e, hd());
}
function s3(e, t) {
  be(t, !0);
  var n = Z(), r = V(n);
  Gr(r, () => t.children, (a) => {
    var i = Z(), o = V(i);
    lt(o, () => t.children ?? De), _(a, i);
  }), _(e, n), _e();
}
function Cg(e, t) {
  be(t, !0);
  let n = L(t, "to", 3, "body");
  const r = _m();
  let a = /* @__PURE__ */ R(i);
  function i() {
    if (!fd || t.disabled) return null;
    let d = null;
    return typeof n() == "string" ? d = document.querySelector(n()) : (n() instanceof HTMLElement || n() instanceof DocumentFragment) && (d = n()), d;
  }
  let o;
  Se(() => {
    if (!c(a) || t.disabled) {
      o && (ju(o), o = null);
      return;
    }
    return _t(() => o = Mc(s3, {
      target: c(a),
      props: { children: t.children },
      context: r
    })), () => {
      o && (ju(o), o = null);
    };
  });
  var s = Z(), l = V(s);
  {
    var u = (d) => {
      var f = Z(), p = V(f);
      lt(p, () => t.children ?? De), _(d, f);
    };
    H(l, (d) => {
      t.disabled && d(u);
    });
  }
  _(e, s), _e();
}
function Sn(e, t, n, r) {
  const a = Array.isArray(t) ? t : [t];
  return a.forEach((i) => e.addEventListener(i, n, r)), () => {
    a.forEach((i) => e.removeEventListener(i, n, r));
  };
}
function sp(e, t = 500) {
  let n = null;
  const r = (...a) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...a);
    }, t);
  };
  return r.destroy = () => {
    n !== null && (clearTimeout(n), n = null);
  }, r;
}
function yd(e, t) {
  return e === t || e.contains(t);
}
function Eg(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
globalThis.bitsDismissableLayers ?? (globalThis.bitsDismissableLayers = /* @__PURE__ */ new Map());
var Ma, Br, ur, Ia, cr, Oa, Fa, lo, uo, co, qn, fl, Qa, Tg, pl, Ra, hl, yl, gl, vl, fo, Ag, ml, wl;
class l3 {
  constructor(t) {
    te(this, Qa);
    te(this, Ma);
    te(this, Br);
    te(this, ur, { pointerdown: !1 });
    te(this, Ia, !1);
    Le(this, "node", ce(null));
    te(this, cr);
    te(this, Oa);
    te(this, Fa, de(!1));
    te(this, lo);
    te(this, uo, de(null));
    te(this, co);
    te(this, qn, Ct);
    te(this, fl, (t) => {
      t.defaultPrevented || this.currNode && nu(() => {
        var n, r;
        !this.currNode || F(this, vl).call(this, t.target) || t.target && !c(F(this, Fa)) && ((r = (n = F(this, lo)).current) == null || r.call(n, t));
      });
    });
    te(this, pl, (t) => {
      let n = t;
      n.defaultPrevented && (n = lp(t)), F(this, Ma).current(t);
    });
    te(this, Ra, sp(
      (t) => {
        if (!this.currNode) {
          F(this, qn).call(this);
          return;
        }
        const n = F(this, co).current(t, this.currNode) || f3(t, this.currNode);
        if (!F(this, Ia) || qt(this, Qa, Ag).call(this) || !n) {
          F(this, qn).call(this);
          return;
        }
        let r = t;
        if (r.defaultPrevented && (r = lp(r)), F(this, Br).current !== "close" && F(this, Br).current !== "defer-otherwise-close") {
          F(this, qn).call(this);
          return;
        }
        t.pointerType === "touch" ? (F(this, qn).call(this), Te(this, qn, Sn(F(this, cr), "click", F(this, pl), { once: !0 }))) : F(this, Ma).current(r);
      },
      10
    ));
    te(this, hl, (t) => {
      F(this, ur)[t.type] = !0;
    });
    te(this, yl, (t) => {
      F(this, ur)[t.type] = !1;
    });
    te(this, gl, () => {
      this.node.current && Te(this, Ia, d3(this.node.current));
    });
    te(this, vl, (t) => this.node.current ? yd(this.node.current, t) : !1);
    te(this, fo, sp(
      () => {
        for (const t in F(this, ur))
          F(this, ur)[t] = !1;
        Te(this, Ia, !1);
      },
      20
    ));
    te(this, ml, () => {
      z(F(this, Fa), !0);
    });
    te(this, wl, () => {
      z(F(this, Fa), !1);
    });
    Le(this, "props", {
      onfocuscapture: F(this, ml),
      onblurcapture: F(this, wl)
    });
    Te(this, Oa, t.enabled), Te(this, co, t.isValidEvent), In({
      id: t.id,
      ref: this.node,
      deps: () => F(this, Oa).current,
      onRefChange: (a) => {
        this.currNode = a;
      }
    }), Te(this, Br, t.interactOutsideBehavior), Te(this, Ma, t.onInteractOutside), Te(this, lo, t.onFocusOutside), Se(() => {
      Te(this, cr, Eg(this.currNode));
    });
    let n = Ct;
    const r = () => {
      F(this, fo).call(this), globalThis.bitsDismissableLayers.delete(this), F(this, Ra).destroy(), n();
    };
    Se(() => (F(this, Oa).current && this.currNode && xg(1, () => {
      this.currNode && (globalThis.bitsDismissableLayers.set(this, _t(() => F(this, Br))), n(), n = qt(this, Qa, Tg).call(this));
    }), () => {
      r();
    })), Ox(() => {
      F(this, fo).destroy(), globalThis.bitsDismissableLayers.delete(this), F(this, Ra).destroy(), F(this, qn).call(this), n();
    });
  }
  get currNode() {
    return c(F(this, uo));
  }
  set currNode(t) {
    z(F(this, uo), oe(t));
  }
}
Ma = new WeakMap(), Br = new WeakMap(), ur = new WeakMap(), Ia = new WeakMap(), cr = new WeakMap(), Oa = new WeakMap(), Fa = new WeakMap(), lo = new WeakMap(), uo = new WeakMap(), co = new WeakMap(), qn = new WeakMap(), fl = new WeakMap(), Qa = new WeakSet(), Tg = function() {
  return Sa(
    /**
    * CAPTURE INTERACTION START
    * mark interaction-start event as intercepted.
    * mark responsible layer during interaction start
    * to avoid checking if is responsible layer during interaction end
    * when a new floating element may have been opened.
    */
    Sn(F(this, cr), "pointerdown", Sa(F(this, hl), F(this, gl)), !0),
    /**
    * BUBBLE INTERACTION START
    * Mark interaction-start event as non-intercepted. Debounce `onInteractOutsideStart`
    * to avoid prematurely checking if other events were intercepted.
    */
    Sn(F(this, cr), "pointerdown", Sa(F(this, yl), F(this, Ra))),
    /**
    * HANDLE FOCUS OUTSIDE
    */
    Sn(F(this, cr), "focusin", F(this, fl))
  );
}, pl = new WeakMap(), Ra = new WeakMap(), hl = new WeakMap(), yl = new WeakMap(), gl = new WeakMap(), vl = new WeakMap(), fo = new WeakMap(), Ag = function() {
  return Object.values(F(this, ur)).some(Boolean);
}, ml = new WeakMap(), wl = new WeakMap();
function u3(e) {
  return new l3(e);
}
function c3(e) {
  return e.findLast(([t, { current: n }]) => n === "close" || n === "ignore");
}
function d3(e) {
  const t = [...globalThis.bitsDismissableLayers], n = c3(t);
  if (n) return n[0].node.current === e;
  const [r] = t[0];
  return r.node.current === e;
}
function f3(e, t) {
  if ("button" in e && e.button > 0) return !1;
  const n = e.target;
  return Vx(n) ? Eg(n).documentElement.contains(n) && !yd(t, n) : !1;
}
function lp(e) {
  const t = e.currentTarget, n = e.target;
  let r;
  e instanceof PointerEvent ? r = new PointerEvent(e.type, e) : r = new PointerEvent("pointerdown", e);
  let a = !1;
  return new Proxy(r, {
    get: (o, s) => s === "currentTarget" ? t : s === "target" ? n : s === "preventDefault" ? () => {
      a = !0, typeof o.preventDefault == "function" && o.preventDefault();
    } : s === "defaultPrevented" ? a : s in o ? o[s] : e[s]
  });
}
function Pg(e, t) {
  be(t, !0);
  let n = L(t, "interactOutsideBehavior", 3, "close"), r = L(t, "onInteractOutside", 3, Ct), a = L(t, "onFocusOutside", 3, Ct), i = L(t, "isValidEvent", 3, () => !1);
  const o = u3({
    id: ce.with(() => t.id),
    interactOutsideBehavior: ce.with(() => n()),
    onInteractOutside: ce.with(() => r()),
    enabled: ce.with(() => t.enabled),
    onFocusOutside: ce.with(() => a()),
    isValidEvent: ce.with(() => i())
  });
  var s = Z(), l = V(s);
  lt(l, () => t.children ?? De, () => ({ props: o.props })), _(e, s), _e();
}
globalThis.bitsEscapeLayers ?? (globalThis.bitsEscapeLayers = /* @__PURE__ */ new Map());
var po, La, ho, bl, _l;
class p3 {
  constructor(t) {
    te(this, po);
    te(this, La);
    te(this, ho);
    te(this, bl, () => Sn(document, "keydown", F(this, _l), { passive: !1 }));
    te(this, _l, (t) => {
      if (t.key !== Lx || !y3(this)) return;
      const n = new KeyboardEvent(t.type, t);
      t.preventDefault();
      const r = F(this, La).current;
      r !== "close" && r !== "defer-otherwise-close" || F(this, po).current(n);
    });
    Te(this, La, t.escapeKeydownBehavior), Te(this, po, t.onEscapeKeydown), Te(this, ho, t.enabled);
    let n = Ct;
    Se(() => (F(this, ho).current && (globalThis.bitsEscapeLayers.set(this, _t(() => F(this, La))), n = F(this, bl).call(this)), () => {
      n(), globalThis.bitsEscapeLayers.delete(this);
    }));
  }
}
po = new WeakMap(), La = new WeakMap(), ho = new WeakMap(), bl = new WeakMap(), _l = new WeakMap();
function h3(e) {
  return new p3(e);
}
function y3(e) {
  const t = [...globalThis.bitsEscapeLayers], n = t.findLast(([a, { current: i }]) => i === "close" || i === "ignore");
  if (n) return n[0] === e;
  const [r] = t[0];
  return r === e;
}
function Mg(e, t) {
  be(t, !0);
  let n = L(t, "escapeKeydownBehavior", 3, "close"), r = L(t, "onEscapeKeydown", 3, Ct);
  h3({
    escapeKeydownBehavior: ce.with(() => n()),
    onEscapeKeydown: ce.with(() => r()),
    enabled: ce.with(() => t.enabled)
  });
  var a = Z(), i = V(a);
  lt(i, () => t.children ?? De), _(e, a), _e();
}
const g3 = ce([]);
function v3() {
  const e = g3;
  return {
    add(t) {
      const n = e.current[0];
      t.id !== (n == null ? void 0 : n.id) && (n == null || n.pause()), e.current = up(e.current, t), e.current.unshift(t);
    },
    remove(t) {
      var n;
      e.current = up(e.current, t), (n = e.current[0]) == null || n.resume();
    }
  };
}
function m3() {
  let e = de(!1);
  return {
    id: $n(),
    get paused() {
      return c(e);
    },
    pause() {
      z(e, !0);
    },
    resume() {
      z(e, !1);
    }
  };
}
function up(e, t) {
  return [...e].filter((n) => n.id !== t.id);
}
function w3(e) {
  return e.filter((t) => t.tagName !== "A");
}
function ir(e, { select: t = !1 } = {}) {
  if (!(e && e.focus))
    return;
  const n = document.activeElement;
  e.focus({ preventScroll: !0 }), e !== n && jx(e) && t && e.select();
}
function b3(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ir(r, { select: t }), document.activeElement !== n)
      return !0;
}
function cp(e, t) {
  for (const n of e)
    if (!Wx(n, t))
      return n;
}
function Ig(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    // eslint-disable-next-line ts/no-explicit-any
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function _3(e) {
  const t = Ig(e), n = cp(t, e), r = cp(t.reverse(), e);
  return [n, r];
}
const x3 = "focusScope.autoFocusOnMount", k3 = "focusScope.autoFocusOnDestroy", dp = { bubbles: !1, cancelable: !0 };
function S3({
  id: e,
  loop: t,
  enabled: n,
  onOpenAutoFocus: r,
  onCloseAutoFocus: a,
  forceMount: i
}) {
  const o = v3(), s = m3(), l = ce(null);
  In({ id: e, ref: l, deps: () => n.current });
  let u = de(null);
  Se(() => {
    const y = l.current;
    if (!y || !n.current) return;
    function g(S) {
      if (s.paused || !y) return;
      const b = S.target;
      Gs(b) && (y.contains(b) ? z(u, oe(b)) : ir(c(u), { select: !0 }));
    }
    function w(S) {
      if (s.paused || !y) return;
      const b = S.relatedTarget;
      Gs(b) && b !== null && (y.contains(b) || ir(c(u), { select: !0 }));
    }
    function m(S) {
      (y == null ? void 0 : y.contains(c(u))) || ir(y);
    }
    const v = Sa(Sn(document, "focusin", g), Sn(document, "focusout", w)), C = new MutationObserver(m);
    return y && C.observe(y, { childList: !0, subtree: !0 }), () => {
      v(), C.disconnect();
    };
  }), Se(() => {
    if (i.current) return;
    let y = l.current;
    const g = document.activeElement;
    return _t(() => {
      d(y, g);
    }), () => {
      y && f(g);
    };
  }), Se(() => {
    if (!i.current) return;
    let y = l.current;
    n.current;
    const g = document.activeElement;
    return _t(() => {
      d(y, g);
    }), () => {
      y && f(g);
    };
  });
  function d(y, g) {
    if (y || (y = document.getElementById(e.current)), !y) return;
    if (o.add(s), !y.contains(g)) {
      const m = new CustomEvent(x3, dp);
      r.current(m), m.defaultPrevented || nu(() => {
        y && (b3(w3(Ig(y)), { select: !0 }), document.activeElement === g && ir(y));
      });
    }
  }
  function f(y) {
    const g = new CustomEvent(k3, dp);
    a.current(g), setTimeout(
      () => {
        !g.defaultPrevented && y && ir(y ?? document.body, { select: !0 }), o.remove(s);
      },
      0
    );
  }
  function p(y) {
    if (!n.current || !t.current && !n.current || s.paused) return;
    const g = y.key === Nx && !y.ctrlKey && !y.altKey && !y.metaKey, w = document.activeElement;
    if (!(g && w)) return;
    const m = l.current;
    if (!m) return;
    const [v, C] = _3(m);
    v && C ? !y.shiftKey && w === C ? (y.preventDefault(), t.current && ir(v, { select: !0 })) : y.shiftKey && w === v && (y.preventDefault(), t.current && ir(C, { select: !0 })) : w === m && y.preventDefault();
  }
  const h = /* @__PURE__ */ R(() => ({
    id: e.current,
    tabindex: -1,
    onkeydown: p
  }));
  return {
    get props() {
      return c(h);
    }
  };
}
function Og(e, t) {
  be(t, !0);
  let n = L(t, "trapFocus", 3, !1), r = L(t, "loop", 3, !1), a = L(t, "onCloseAutoFocus", 3, Ct), i = L(t, "onOpenAutoFocus", 3, Ct), o = L(t, "forceMount", 3, !1);
  const s = S3({
    enabled: ce.with(() => n()),
    loop: ce.with(() => r()),
    onCloseAutoFocus: ce.with(() => a()),
    onOpenAutoFocus: ce.with(() => i()),
    id: ce.with(() => t.id),
    forceMount: ce.with(() => o())
  });
  var l = Z(), u = V(l);
  lt(u, () => t.focusScope ?? De, () => ({ props: s.props })), _(e, l), _e();
}
globalThis.bitsTextSelectionLayers ?? (globalThis.bitsTextSelectionLayers = /* @__PURE__ */ new Map());
var yo, go, vo, dr, Da, mo, xl, Fg, kl, wo;
class C3 {
  constructor(t) {
    te(this, xl);
    te(this, yo);
    te(this, go);
    te(this, vo);
    te(this, dr);
    te(this, Da, Ct);
    te(this, mo, ce(null));
    te(this, kl, (t) => {
      const n = F(this, mo).current, r = t.target;
      !Gs(n) || !Gs(r) || !F(this, dr).current || !A3(this) || !yd(n, r) || (F(this, go).current(t), !t.defaultPrevented && Te(this, Da, T3(n)));
    });
    te(this, wo, () => {
      F(this, Da).call(this), Te(this, Da, Ct);
    });
    Te(this, yo, t.id), Te(this, dr, t.preventOverflowTextSelection), Te(this, go, t.onPointerDown), Te(this, vo, t.onPointerUp), In({
      id: F(this, yo),
      ref: F(this, mo),
      deps: () => F(this, dr).current
    });
    let n = Ct;
    Se(() => (F(this, dr).current && (globalThis.bitsTextSelectionLayers.set(this, _t(() => F(this, dr))), n = qt(this, xl, Fg).call(this)), () => {
      n(), F(this, wo).call(this), globalThis.bitsTextSelectionLayers.delete(this);
    }));
  }
}
yo = new WeakMap(), go = new WeakMap(), vo = new WeakMap(), dr = new WeakMap(), Da = new WeakMap(), mo = new WeakMap(), xl = new WeakSet(), Fg = function() {
  return Sa(Sn(document, "pointerdown", F(this, kl)), Sn(document, "pointerup", wg(F(this, wo), F(this, vo))));
}, kl = new WeakMap(), wo = new WeakMap();
function E3(e) {
  return new C3(e);
}
const fp = (e) => e.style.userSelect || e.style.webkitUserSelect;
function T3(e) {
  const t = document.body, n = fp(t), r = fp(e);
  return ys(t, "none"), ys(e, "text"), () => {
    ys(t, n), ys(e, r);
  };
}
function ys(e, t) {
  e.style.userSelect = t, e.style.webkitUserSelect = t;
}
function A3(e) {
  const t = [...globalThis.bitsTextSelectionLayers];
  if (!t.length) return !1;
  const n = t.at(-1);
  return n ? n[0] === e : !1;
}
function Rg(e, t) {
  be(t, !0);
  let n = L(t, "preventOverflowTextSelection", 3, !0), r = L(t, "onPointerDown", 3, Ct), a = L(t, "onPointerUp", 3, Ct);
  E3({
    id: ce.with(() => t.id),
    preventOverflowTextSelection: ce.with(() => n()),
    onPointerDown: ce.with(() => r()),
    onPointerUp: ce.with(() => a()),
    enabled: ce.with(() => t.enabled)
  });
  var i = Z(), o = V(i);
  lt(o, () => t.children ?? De), _(e, i), _e();
}
var xn, kn, Gn, Na, As;
const Od = class Od extends Map {
  /**
   * @param {Iterable<readonly [K, V]> | null | undefined} [value]
   */
  constructor(n) {
    super();
    te(this, Na);
    /** @type {Map<K, Source<number>>} */
    te(this, xn, /* @__PURE__ */ new Map());
    te(this, kn, Et(0));
    te(this, Gn, Et(0));
    if (n) {
      for (var [r, a] of n)
        super.set(r, a);
      F(this, Gn).v = super.size;
    }
  }
  /** @param {K} key */
  has(n) {
    var r = F(this, xn), a = r.get(n);
    if (a === void 0) {
      var i = super.get(n);
      if (i !== void 0)
        a = Et(0), r.set(n, a);
      else
        return c(F(this, kn)), !1;
    }
    return c(a), !0;
  }
  /**
   * @param {(value: V, key: K, map: Map<K, V>) => void} callbackfn
   * @param {any} [this_arg]
   */
  forEach(n, r) {
    qt(this, Na, As).call(this), super.forEach(n, r);
  }
  /** @param {K} key */
  get(n) {
    var r = F(this, xn), a = r.get(n);
    if (a === void 0) {
      var i = super.get(n);
      if (i !== void 0)
        a = Et(0), r.set(n, a);
      else {
        c(F(this, kn));
        return;
      }
    }
    return c(a), super.get(n);
  }
  /**
   * @param {K} key
   * @param {V} value
   * */
  set(n, r) {
    var f;
    var a = F(this, xn), i = a.get(n), o = super.get(n), s = super.set(n, r), l = F(this, kn);
    if (i === void 0)
      a.set(n, Et(0)), z(F(this, Gn), super.size), wi(l);
    else if (o !== r) {
      wi(i);
      var u = l.reactions === null ? null : new Set(l.reactions), d = u === null || !((f = i.reactions) != null && f.every(
        (p) => (
          /** @type {NonNullable<typeof v_reactions>} */
          u.has(p)
        )
      ));
      d && wi(l);
    }
    return s;
  }
  /** @param {K} key */
  delete(n) {
    var r = F(this, xn), a = r.get(n), i = super.delete(n);
    return a !== void 0 && (r.delete(n), z(F(this, Gn), super.size), z(a, -1), wi(F(this, kn))), i;
  }
  clear() {
    if (super.size !== 0) {
      super.clear();
      var n = F(this, xn);
      z(F(this, Gn), 0);
      for (var r of n.values())
        z(r, -1);
      wi(F(this, kn)), n.clear();
    }
  }
  keys() {
    return c(F(this, kn)), super.keys();
  }
  values() {
    return qt(this, Na, As).call(this), super.values();
  }
  entries() {
    return qt(this, Na, As).call(this), super.entries();
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  get size() {
    return c(F(this, Gn)), super.size;
  }
};
xn = new WeakMap(), kn = new WeakMap(), Gn = new WeakMap(), Na = new WeakSet(), As = function() {
  c(F(this, kn));
  var n = F(this, xn);
  if (F(this, Gn).v !== n.size)
    for (var r of Dd(Od.prototype, this, "keys").call(this))
      n.has(r) || n.set(r, Et(0));
  for (var [, a] of F(this, xn))
    c(a);
};
let dc = Od;
function P3(e) {
  let t = 0, n = de(void 0), r;
  function a() {
    t -= 1, r && t <= 0 && (r(), z(n, void 0), r = void 0);
  }
  return (...i) => (t += 1, c(n) === void 0 && (r = yh(() => {
    z(n, oe(e(...i)));
  })), Se(() => () => {
    a();
  }), c(n));
}
const M3 = P3(() => {
  const e = new dc(), t = /* @__PURE__ */ R(() => {
    for (const i of e.values())
      if (i)
        return !0;
    return !1;
  });
  new Sg(() => c(t));
  let n = oe({}), r = null;
  function a() {
    fd && (document.body.style.paddingRight = n.paddingRight ?? "", document.body.style.marginRight = n.marginRight ?? "", document.body.style.pointerEvents = n.pointerEvents ?? "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = n.overflow ?? "", ap && (r == null || r()));
  }
  return Se(() => {
    const i = c(t);
    return _t(() => {
      if (!i)
        return;
      const o = getComputedStyle(document.body);
      n.overflow = o.overflow, n.paddingRight = o.paddingRight, n.marginRight = o.marginRight, n.pointerEvents = o.pointerEvents;
      const s = window.innerWidth - document.documentElement.clientWidth, u = {
        padding: Number.parseInt(n.paddingRight ?? "0", 10) + s,
        margin: Number.parseInt(n.marginRight ?? "0", 10)
      };
      s > 0 && (document.body.style.paddingRight = `${u.padding}px`, document.body.style.marginRight = `${u.margin}px`, document.body.style.setProperty("--scrollbar-width", `${s}px`), document.body.style.overflow = "hidden"), ap && (r = Sn(
        document,
        "touchmove",
        (d) => {
          d.target === document.documentElement && (d.touches.length > 1 || d.preventDefault());
        },
        { passive: !1 }
      )), nu(() => {
        document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
      });
    });
  }), Se(() => () => {
    r == null || r();
  }), {
    get map() {
      return e;
    },
    resetBodyStyle: a
  };
});
function I3(e, t = () => null) {
  const n = $n(), r = M3(), a = /* @__PURE__ */ R(t);
  r.map.set(n, e ?? !1);
  const i = ce.with(() => r.map.get(n) ?? !1, (o) => r.map.set(n, o));
  return Se(() => () => {
    r.map.delete(n), Array.from(r.map.values()).length === 0 && (c(a) === null ? r.resetBodyStyle() : xg(c(a), () => r.resetBodyStyle()));
  }), i;
}
function Ks(e, t) {
  be(t, !0);
  let n = L(t, "preventScroll", 3, !0), r = L(t, "restoreScrollDelay", 3, null);
  I3(n(), () => r()), _e();
}
function O3({ forceMount: e, present: t, trapFocus: n, open: r }) {
  return e ? r && n : t && n;
}
var F3 = /* @__PURE__ */ O("<div><!></div>");
function R3(e, t) {
  be(t, !0);
  let n = L(t, "id", 19, $n), r = L(t, "forceMount", 3, !1), a = L(t, "ref", 15, null), i = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "forceMount",
    "child",
    "children",
    "ref"
  ]);
  const o = i3({
    id: ce.with(() => n()),
    ref: ce.with(() => a(), (u) => a(u))
  }), s = /* @__PURE__ */ R(() => $t(i, o.props));
  var l = /* @__PURE__ */ R(() => o.root.open.current || r());
  pd(e, {
    get id() {
      return n();
    },
    get present() {
      return c(l);
    },
    presence: (d) => {
      var f = Z(), p = V(f);
      {
        var h = (g) => {
          var w = Z(), m = V(w), v = /* @__PURE__ */ St(() => ({
            props: $t(c(s)),
            ...o.snippetProps
          }));
          lt(m, () => t.child, () => c(v)), _(g, w);
        }, y = (g) => {
          var w = F3();
          const m = /* @__PURE__ */ R(() => $t(c(s)));
          let v;
          var C = T(w);
          lt(C, () => t.children ?? De, () => o.snippetProps), ee(() => v = Je(w, v, { ...c(m) })), _(g, w);
        };
        H(p, (g) => {
          t.child ? g(h) : g(y, !1);
        });
      }
      _(d, f);
    },
    $$slots: { presence: !0 }
  }), _e();
}
const L3 = ["top", "right", "bottom", "left"], br = Math.min, Jt = Math.max, Zs = Math.round, gs = Math.floor, Pn = (e) => ({
  x: e,
  y: e
}), D3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, N3 = {
  start: "end",
  end: "start"
};
function fc(e, t, n) {
  return Jt(e, br(t, n));
}
function Jn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Qn(e) {
  return e.split("-")[0];
}
function ci(e) {
  return e.split("-")[1];
}
function gd(e) {
  return e === "x" ? "y" : "x";
}
function vd(e) {
  return e === "y" ? "height" : "width";
}
function _r(e) {
  return ["top", "bottom"].includes(Qn(e)) ? "y" : "x";
}
function md(e) {
  return gd(_r(e));
}
function z3(e, t, n) {
  n === void 0 && (n = !1);
  const r = ci(e), a = md(e), i = vd(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = Ys(o)), [o, Ys(o)];
}
function V3(e) {
  const t = Ys(e);
  return [pc(e), t, pc(t)];
}
function pc(e) {
  return e.replace(/start|end/g, (t) => N3[t]);
}
function B3(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function j3(e, t, n, r) {
  const a = ci(e);
  let i = B3(Qn(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(pc)))), i;
}
function Ys(e) {
  return e.replace(/left|right|bottom|top/g, (t) => D3[t]);
}
function W3(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Lg(e) {
  return typeof e != "number" ? W3(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xs(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function pp(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = _r(t), o = md(t), s = vd(o), l = Qn(t), u = i === "y", d = r.x + r.width / 2 - a.width / 2, f = r.y + r.height / 2 - a.height / 2, p = r[s] / 2 - a[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: r.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - a.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (ci(t)) {
    case "start":
      h[o] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      h[o] += p * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const H3 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: d,
    y: f
  } = pp(u, r, l), p = r, h = {}, y = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: w,
      fn: m
    } = s[g], {
      x: v,
      y: C,
      data: S,
      reset: b
    } = await m({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = v ?? d, f = C ?? f, h = {
      ...h,
      [w]: {
        ...h[w],
        ...S
      }
    }, b && y <= 50 && (y++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (u = b.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : b.rects), {
      x: d,
      y: f
    } = pp(u, p, l)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: a,
    middlewareData: h
  };
};
async function ji(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = Jn(t, e), y = Lg(h), w = s[p ? f === "floating" ? "reference" : "floating" : f], m = Xs(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), v = f === "floating" ? {
    x: r,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), S = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Xs(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: v,
    offsetParent: C,
    strategy: l
  }) : v);
  return {
    top: (m.top - b.top + y.top) / S.y,
    bottom: (b.bottom - m.bottom + y.bottom) / S.y,
    left: (m.left - b.left + y.left) / S.x,
    right: (b.right - m.right + y.right) / S.x
  };
}
const U3 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Jn(e, t) || {};
    if (u == null)
      return {};
    const f = Lg(d), p = {
      x: n,
      y: r
    }, h = md(a), y = vd(h), g = await o.getDimensions(u), w = h === "y", m = w ? "top" : "left", v = w ? "bottom" : "right", C = w ? "clientHeight" : "clientWidth", S = i.reference[y] + i.reference[h] - p[h] - i.floating[y], b = p[h] - i.reference[h], x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let E = x ? x[C] : 0;
    (!E || !await (o.isElement == null ? void 0 : o.isElement(x))) && (E = s.floating[C] || i.floating[y]);
    const k = S / 2 - b / 2, I = E / 2 - g[y] / 2 - 1, D = br(f[m], I), A = br(f[v], I), M = D, N = E - g[y] - A, P = E / 2 - g[y] / 2 + k, Y = fc(M, P, N), G = !l.arrow && ci(a) != null && P !== Y && i.reference[y] / 2 - (P < M ? D : A) - g[y] / 2 < 0, q = G ? P < M ? P - M : P - N : 0;
    return {
      [h]: p[h] + q,
      data: {
        [h]: Y,
        centerOffset: P - Y - q,
        ...G && {
          alignmentOffset: q
        }
      },
      reset: G
    };
  }
}), q3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...w
      } = Jn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const m = Qn(a), v = _r(s), C = Qn(s) === s, S = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), b = p || (C || !g ? [Ys(s)] : V3(s)), x = y !== "none";
      !p && x && b.push(...j3(s, g, y, S));
      const E = [s, ...b], k = await ji(t, w), I = [];
      let D = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && I.push(k[m]), f) {
        const P = z3(a, o, S);
        I.push(k[P[0]], k[P[1]]);
      }
      if (D = [...D, {
        placement: a,
        overflows: I
      }], !I.every((P) => P <= 0)) {
        var A, M;
        const P = (((A = i.flip) == null ? void 0 : A.index) || 0) + 1, Y = E[P];
        if (Y)
          return {
            data: {
              index: P,
              overflows: D
            },
            reset: {
              placement: Y
            }
          };
        let G = (M = D.filter((q) => q.overflows[0] <= 0).sort((q, J) => q.overflows[1] - J.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!G)
          switch (h) {
            case "bestFit": {
              var N;
              const q = (N = D.filter((J) => {
                if (x) {
                  const $ = _r(J.placement);
                  return $ === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((J) => [J.placement, J.overflows.filter(($) => $ > 0).reduce(($, W) => $ + W, 0)]).sort((J, $) => J[1] - $[1])[0]) == null ? void 0 : N[0];
              q && (G = q);
              break;
            }
            case "initialPlacement":
              G = s;
              break;
          }
        if (a !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
};
function hp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function yp(e) {
  return L3.some((t) => e[t] >= 0);
}
const G3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Jn(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ji(t, {
            ...a,
            elementContext: "reference"
          }), o = hp(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: yp(o)
            }
          };
        }
        case "escaped": {
          const i = await ji(t, {
            ...a,
            altBoundary: !0
          }), o = hp(i, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: yp(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function K3(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = Qn(n), s = ci(n), l = _r(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = i && l ? -1 : 1, f = Jn(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: y
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof y == "number" && (h = s === "end" ? y * -1 : y), l ? {
    x: h * d,
    y: p * u
  } : {
    x: p * u,
    y: h * d
  };
}
const Z3 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: s
      } = t, l = await K3(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, Y3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: m,
              y: v
            } = w;
            return {
              x: m,
              y: v
            };
          }
        },
        ...l
      } = Jn(e, t), u = {
        x: n,
        y: r
      }, d = await ji(t, l), f = _r(Qn(a)), p = gd(f);
      let h = u[p], y = u[f];
      if (i) {
        const w = p === "y" ? "top" : "left", m = p === "y" ? "bottom" : "right", v = h + d[w], C = h - d[m];
        h = fc(v, h, C);
      }
      if (o) {
        const w = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", v = y + d[w], C = y - d[m];
        y = fc(v, y, C);
      }
      const g = s.fn({
        ...t,
        [p]: h,
        [f]: y
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [p]: i,
            [f]: o
          }
        }
      };
    }
  };
}, X3 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Jn(e, t), d = {
        x: n,
        y: r
      }, f = _r(a), p = gd(f);
      let h = d[p], y = d[f];
      const g = Jn(s, t), w = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const C = p === "y" ? "height" : "width", S = i.reference[p] - i.floating[C] + w.mainAxis, b = i.reference[p] + i.reference[C] - w.mainAxis;
        h < S ? h = S : h > b && (h = b);
      }
      if (u) {
        var m, v;
        const C = p === "y" ? "width" : "height", S = ["top", "left"].includes(Qn(a)), b = i.reference[f] - i.floating[C] + (S && ((m = o.offset) == null ? void 0 : m[f]) || 0) + (S ? 0 : w.crossAxis), x = i.reference[f] + i.reference[C] + (S ? 0 : ((v = o.offset) == null ? void 0 : v[f]) || 0) - (S ? w.crossAxis : 0);
        y < b ? y = b : y > x && (y = x);
      }
      return {
        [p]: h,
        [f]: y
      };
    }
  };
}, J3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        rects: i,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Jn(e, t), d = await ji(t, u), f = Qn(a), p = ci(a), h = _r(a) === "y", {
        width: y,
        height: g
      } = i.floating;
      let w, m;
      f === "top" || f === "bottom" ? (w = f, m = p === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (m = f, w = p === "end" ? "top" : "bottom");
      const v = g - d.top - d.bottom, C = y - d.left - d.right, S = br(g - d[w], v), b = br(y - d[m], C), x = !t.middlewareData.shift;
      let E = S, k = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = C), (r = t.middlewareData.shift) != null && r.enabled.y && (E = v), x && !p) {
        const D = Jt(d.left, 0), A = Jt(d.right, 0), M = Jt(d.top, 0), N = Jt(d.bottom, 0);
        h ? k = y - 2 * (D !== 0 || A !== 0 ? D + A : Jt(d.left, d.right)) : E = g - 2 * (M !== 0 || N !== 0 ? M + N : Jt(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: k,
        availableHeight: E
      });
      const I = await o.getDimensions(s.floating);
      return y !== I.width || g !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function au() {
  return typeof window < "u";
}
function di(e) {
  return Dg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function en(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ln(e) {
  var t;
  return (t = (Dg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Dg(e) {
  return au() ? e instanceof Node || e instanceof en(e).Node : !1;
}
function fn(e) {
  return au() ? e instanceof Element || e instanceof en(e).Element : !1;
}
function On(e) {
  return au() ? e instanceof HTMLElement || e instanceof en(e).HTMLElement : !1;
}
function gp(e) {
  return !au() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof en(e).ShadowRoot;
}
function ts(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = pn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function Q3(e) {
  return ["table", "td", "th"].includes(di(e));
}
function iu(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function wd(e) {
  const t = bd(), n = fn(e) ? pn(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function $3(e) {
  let t = xr(e);
  for (; On(t) && !Ja(t); ) {
    if (wd(t))
      return t;
    if (iu(t))
      return null;
    t = xr(t);
  }
  return null;
}
function bd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ja(e) {
  return ["html", "body", "#document"].includes(di(e));
}
function pn(e) {
  return en(e).getComputedStyle(e);
}
function ou(e) {
  return fn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function xr(e) {
  if (di(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    gp(e) && e.host || // Fallback.
    Ln(e)
  );
  return gp(t) ? t.host : t;
}
function Ng(e) {
  const t = xr(e);
  return Ja(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : On(t) && ts(t) ? t : Ng(t);
}
function Wi(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = Ng(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = en(a);
  if (i) {
    const s = hc(o);
    return t.concat(o, o.visualViewport || [], ts(a) ? a : [], s && n ? Wi(s) : []);
  }
  return t.concat(a, Wi(a, [], n));
}
function hc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function zg(e) {
  const t = pn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = On(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, s = Zs(n) !== i || Zs(r) !== o;
  return s && (n = i, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function _d(e) {
  return fn(e) ? e : e.contextElement;
}
function Ca(e) {
  const t = _d(e);
  if (!On(t))
    return Pn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = zg(t);
  let o = (i ? Zs(n.width) : n.width) / r, s = (i ? Zs(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const e5 = /* @__PURE__ */ Pn(0);
function Vg(e) {
  const t = en(e);
  return !bd() || !t.visualViewport ? e5 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function t5(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== en(e) ? !1 : t;
}
function Jr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = _d(e);
  let o = Pn(1);
  t && (r ? fn(r) && (o = Ca(r)) : o = Ca(e));
  const s = t5(i, n, r) ? Vg(i) : Pn(0);
  let l = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, d = a.width / o.x, f = a.height / o.y;
  if (i) {
    const p = en(i), h = r && fn(r) ? en(r) : r;
    let y = p, g = hc(y);
    for (; g && r && h !== y; ) {
      const w = Ca(g), m = g.getBoundingClientRect(), v = pn(g), C = m.left + (g.clientLeft + parseFloat(v.paddingLeft)) * w.x, S = m.top + (g.clientTop + parseFloat(v.paddingTop)) * w.y;
      l *= w.x, u *= w.y, d *= w.x, f *= w.y, l += C, u += S, y = en(g), g = hc(y);
    }
  }
  return Xs({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function xd(e, t) {
  const n = ou(e).scrollLeft;
  return t ? t.left + n : Jr(Ln(e)).left + n;
}
function Bg(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    xd(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: a,
    y: i
  };
}
function n5(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", o = Ln(r), s = t ? iu(t.floating) : !1;
  if (r === o || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Pn(1);
  const d = Pn(0), f = On(r);
  if ((f || !f && !i) && ((di(r) !== "body" || ts(o)) && (l = ou(r)), On(r))) {
    const h = Jr(r);
    u = Ca(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const p = o && !f && !i ? Bg(o, l, !0) : Pn(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + p.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + p.y
  };
}
function r5(e) {
  return Array.from(e.getClientRects());
}
function a5(e) {
  const t = Ln(e), n = ou(e), r = e.ownerDocument.body, a = Jt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Jt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + xd(e);
  const s = -n.scrollTop;
  return pn(r).direction === "rtl" && (o += Jt(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function i5(e, t) {
  const n = en(e), r = Ln(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = bd();
    (!u || u && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function o5(e, t) {
  const n = Jr(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = On(e) ? Ca(e) : Pn(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, l = a * i.x, u = r * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function vp(e, t, n) {
  let r;
  if (t === "viewport")
    r = i5(e, n);
  else if (t === "document")
    r = a5(Ln(e));
  else if (fn(t))
    r = o5(t, n);
  else {
    const a = Vg(e);
    r = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Xs(r);
}
function jg(e, t) {
  const n = xr(e);
  return n === t || !fn(n) || Ja(n) ? !1 : pn(n).position === "fixed" || jg(n, t);
}
function s5(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Wi(e, [], !1).filter((s) => fn(s) && di(s) !== "body"), a = null;
  const i = pn(e).position === "fixed";
  let o = i ? xr(e) : e;
  for (; fn(o) && !Ja(o); ) {
    const s = pn(o), l = wd(o);
    !l && s.position === "fixed" && (a = null), (i ? !l && !a : !l && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || ts(o) && !l && jg(e, o)) ? r = r.filter((d) => d !== o) : a = s, o = xr(o);
  }
  return t.set(e, r), r;
}
function l5(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? iu(t) ? [] : s5(t, this._c) : [].concat(n), r], s = o[0], l = o.reduce((u, d) => {
    const f = vp(t, d, a);
    return u.top = Jt(f.top, u.top), u.right = br(f.right, u.right), u.bottom = br(f.bottom, u.bottom), u.left = Jt(f.left, u.left), u;
  }, vp(t, s, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function u5(e) {
  const {
    width: t,
    height: n
  } = zg(e);
  return {
    width: t,
    height: n
  };
}
function c5(e, t, n) {
  const r = On(t), a = Ln(t), i = n === "fixed", o = Jr(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Pn(0);
  if (r || !r && !i)
    if ((di(t) !== "body" || ts(a)) && (s = ou(t)), r) {
      const p = Jr(t, !0, i, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else a && (l.x = xd(a));
  const u = a && !r && !i ? Bg(a, s) : Pn(0), d = o.left + s.scrollLeft - l.x - u.x, f = o.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
function Au(e) {
  return pn(e).position === "static";
}
function mp(e, t) {
  if (!On(e) || pn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ln(e) === n && (n = n.ownerDocument.body), n;
}
function Wg(e, t) {
  const n = en(e);
  if (iu(e))
    return n;
  if (!On(e)) {
    let a = xr(e);
    for (; a && !Ja(a); ) {
      if (fn(a) && !Au(a))
        return a;
      a = xr(a);
    }
    return n;
  }
  let r = mp(e, t);
  for (; r && Q3(r) && Au(r); )
    r = mp(r, t);
  return r && Ja(r) && Au(r) && !wd(r) ? n : r || $3(e) || n;
}
const d5 = async function(e) {
  const t = this.getOffsetParent || Wg, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: c5(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function f5(e) {
  return pn(e).direction === "rtl";
}
const p5 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: n5,
  getDocumentElement: Ln,
  getClippingRect: l5,
  getOffsetParent: Wg,
  getElementRects: d5,
  getClientRects: r5,
  getDimensions: u5,
  getScale: Ca,
  isElement: fn,
  isRTL: f5
};
function h5(e, t) {
  let n = null, r;
  const a = Ln(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: u,
      top: d,
      width: f,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !f || !p)
      return;
    const h = gs(d), y = gs(a.clientWidth - (u + f)), g = gs(a.clientHeight - (d + p)), w = gs(u), v = {
      rootMargin: -h + "px " + -y + "px " + -g + "px " + -w + "px",
      threshold: Jt(0, br(1, l)) || 1
    };
    let C = !0;
    function S(b) {
      const x = b[0].intersectionRatio;
      if (x !== l) {
        if (!C)
          return o();
        x ? o(!1, x) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...v,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, v);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function y5(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = _d(e), d = a || i ? [...u ? Wi(u) : [], ...Wi(t)] : [];
  d.forEach((m) => {
    a && m.addEventListener("scroll", n, {
      passive: !0
    }), i && m.addEventListener("resize", n);
  });
  const f = u && s ? h5(u, n) : null;
  let p = -1, h = null;
  o && (h = new ResizeObserver((m) => {
    let [v] = m;
    v && v.target === u && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(t);
    })), n();
  }), u && !l && h.observe(u), h.observe(t));
  let y, g = l ? Jr(e) : null;
  l && w();
  function w() {
    const m = Jr(e);
    g && (m.x !== g.x || m.y !== g.y || m.width !== g.width || m.height !== g.height) && n(), g = m, y = requestAnimationFrame(w);
  }
  return n(), () => {
    var m;
    d.forEach((v) => {
      a && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), f == null || f(), (m = h) == null || m.disconnect(), h = null, l && cancelAnimationFrame(y);
  };
}
const g5 = Z3, v5 = Y3, m5 = q3, w5 = J3, b5 = G3, _5 = U3, x5 = X3, k5 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: p5,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return H3(e, t, {
    ...a,
    platform: i
  });
};
function xi(e) {
  return typeof e == "function" ? e() : e;
}
function Hg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wp(e, t) {
  const n = Hg(e);
  return Math.round(t * n) / n;
}
function bp(e) {
  return {
    [`--bits-${e}-content-transform-origin`]: "var(--bits-floating-transform-origin)",
    [`--bits-${e}-content-available-width`]: "var(--bits-floating-available-width)",
    [`--bits-${e}-content-available-height`]: "var(--bits-floating-available-height)",
    [`--bits-${e}-anchor-width`]: "var(--bits-floating-anchor-width)",
    [`--bits-${e}-anchor-height`]: "var(--bits-floating-anchor-height)"
  };
}
function S5(e) {
  const t = e.whileElementsMounted, n = /* @__PURE__ */ R(() => xi(e.open) ?? !0), r = /* @__PURE__ */ R(() => xi(e.middleware)), a = /* @__PURE__ */ R(() => xi(e.transform) ?? !0), i = /* @__PURE__ */ R(() => xi(e.placement) ?? "bottom"), o = /* @__PURE__ */ R(() => xi(e.strategy) ?? "absolute"), s = e.reference;
  let l = de(0), u = de(0);
  const d = ce(null);
  let f = de(oe(c(o))), p = de(oe(c(i))), h = de(oe({})), y = de(!1);
  const g = /* @__PURE__ */ R(() => {
    const b = {
      position: c(f),
      left: "0",
      top: "0"
    };
    if (!d.current)
      return b;
    const x = wp(d.current, c(l)), E = wp(d.current, c(u));
    return c(a) ? {
      ...b,
      transform: `translate(${x}px, ${E}px)`,
      ...Hg(d.current) >= 1.5 && { willChange: "transform" }
    } : {
      position: c(f),
      left: `${x}px`,
      top: `${E}px`
    };
  });
  let w;
  function m() {
    s.current === null || d.current === null || k5(s.current, d.current, {
      middleware: c(r),
      placement: c(i),
      strategy: c(o)
    }).then((b) => {
      z(l, oe(b.x)), z(u, oe(b.y)), z(f, oe(b.strategy)), z(p, oe(b.placement)), z(h, oe(b.middlewareData)), z(y, !0);
    });
  }
  function v() {
    typeof w == "function" && (w(), w = void 0);
  }
  function C() {
    if (v(), t === void 0) {
      m();
      return;
    }
    s.current === null || d.current === null || (w = t(s.current, d.current, m));
  }
  function S() {
    c(n) || z(y, !1);
  }
  return Se(m), Se(C), Se(S), Se(() => v), {
    floating: d,
    reference: s,
    get strategy() {
      return c(f);
    },
    get placement() {
      return c(p);
    },
    get middlewareData() {
      return c(h);
    },
    get isPositioned() {
      return c(y);
    },
    get floatingStyles() {
      return c(g);
    },
    get update() {
      return m;
    }
  };
}
const C5 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
class E5 {
  constructor() {
    Le(this, "anchorNode", ce(null));
    Le(this, "customAnchorNode", ce(null));
    Le(this, "triggerNode", ce(null));
    Se(() => {
      this.customAnchorNode.current ? typeof this.customAnchorNode.current == "string" ? this.anchorNode.current = document.querySelector(this.customAnchorNode.current) : this.anchorNode.current = this.customAnchorNode.current : this.anchorNode.current = this.triggerNode.current;
    });
  }
}
var bo, _o, xo, ko, za, So, Co, Va, jr, Eo, To, Ao, Po, Mo, Io, Sl, Oo, Cl, Fo, El, Tl, Ro, Lo, Do, No, Al, Pl, Ml, Il, Ol, Fl, zo, Rl, Ll, Dl, Nl;
class T5 {
  constructor(t, n) {
    // state
    Le(this, "root");
    // nodes
    Le(this, "contentRef", ce(null));
    Le(this, "wrapperRef", ce(null));
    Le(this, "arrowRef", ce(null));
    // ids
    Le(this, "arrowId", ce($n()));
    Le(this, "id");
    Le(this, "wrapperId");
    Le(this, "style");
    te(this, bo, /* @__PURE__ */ R(() => {
      if (typeof this.style == "string") return Ei(this.style);
      if (!this.style) return {};
    }));
    te(this, _o);
    te(this, xo);
    te(this, ko);
    te(this, za);
    te(this, So);
    te(this, Co);
    te(this, Va);
    te(this, jr);
    te(this, Eo);
    te(this, To);
    te(this, Ao);
    te(this, Po);
    te(this, Mo);
    Le(this, "onPlaced");
    Le(this, "enabled");
    te(this, Io, new Zx(() => this.arrowRef.current ?? void 0));
    te(this, Sl, /* @__PURE__ */ R(() => {
      var t;
      return ((t = F(this, Io)) == null ? void 0 : t.width) ?? 0;
    }));
    te(this, Oo, /* @__PURE__ */ R(() => {
      var t;
      return ((t = F(this, Io)) == null ? void 0 : t.height) ?? 0;
    }));
    te(this, Cl, /* @__PURE__ */ R(() => {
      var t;
      return ((t = F(this, xo)) == null ? void 0 : t.current) + (F(this, za).current !== "center" ? `-${F(this, za).current}` : "");
    }));
    te(this, Fo, /* @__PURE__ */ R(() => Array.isArray(F(this, jr).current) ? F(this, jr).current : [F(this, jr).current]));
    te(this, El, /* @__PURE__ */ R(() => c(F(this, Fo)).length > 0));
    te(this, Tl, /* @__PURE__ */ R(() => ({
      padding: F(this, Eo).current,
      boundary: c(F(this, Fo)).filter(Bx),
      altBoundary: this.hasExplicitBoundaries
    })));
    te(this, Ro, de(void 0));
    te(this, Lo, de(void 0));
    te(this, Do, de(void 0));
    te(this, No, de(void 0));
    te(this, Al, /* @__PURE__ */ R(() => [
      g5({
        mainAxis: F(this, ko).current + c(F(this, Oo)),
        alignmentAxis: F(this, So).current
      }),
      F(this, Va) && v5({
        mainAxis: !0,
        crossAxis: !1,
        limiter: F(this, To).current === "partial" ? x5() : void 0,
        ...this.detectOverflowOptions
      }),
      F(this, Va) && m5({ ...this.detectOverflowOptions }),
      w5({
        ...this.detectOverflowOptions,
        apply: ({ rects: t, availableWidth: n, availableHeight: r }) => {
          const { width: a, height: i } = t.reference;
          z(F(this, Ro), oe(n)), z(F(this, Lo), oe(r)), z(F(this, Do), oe(a)), z(F(this, No), oe(i));
        }
      }),
      this.arrowRef.current && _5({
        element: this.arrowRef.current,
        padding: F(this, Co).current
      }),
      F5({
        arrowWidth: c(F(this, Sl)),
        arrowHeight: c(F(this, Oo))
      }),
      F(this, Ao).current && b5({
        strategy: "referenceHidden",
        ...this.detectOverflowOptions
      })
    ].filter(Boolean)));
    Le(this, "floating");
    te(this, Pl, /* @__PURE__ */ R(() => R5(this.floating.placement)));
    te(this, Ml, /* @__PURE__ */ R(() => L5(this.floating.placement)));
    te(this, Il, /* @__PURE__ */ R(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.x) ?? 0;
    }));
    te(this, Ol, /* @__PURE__ */ R(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.y) ?? 0;
    }));
    te(this, Fl, /* @__PURE__ */ R(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.centerOffset) !== 0;
    }));
    te(this, zo, de());
    te(this, Rl, /* @__PURE__ */ R(() => C5[this.placedSide]));
    te(this, Ll, /* @__PURE__ */ R(() => {
      var t, n, r;
      return {
        id: this.wrapperId.current,
        "data-bits-floating-content-wrapper": "",
        style: {
          ...this.floating.floatingStyles,
          // keep off page when measuring
          transform: this.floating.isPositioned ? this.floating.floatingStyles.transform : "translate(0, -200%)",
          minWidth: "max-content",
          zIndex: this.contentZIndex,
          "--bits-floating-transform-origin": `${(t = this.floating.middlewareData.transformOrigin) == null ? void 0 : t.x} ${(n = this.floating.middlewareData.transformOrigin) == null ? void 0 : n.y}`,
          "--bits-floating-available-width": `${c(F(this, Ro))}px`,
          "--bits-floating-available-height": `${c(F(this, Lo))}px`,
          "--bits-floating-anchor-width": `${c(F(this, Do))}px`,
          "--bits-floating-anchor-height": `${c(F(this, No))}px`,
          // hide the content if using the hide middleware and should be hidden
          ...((r = this.floating.middlewareData.hide) == null ? void 0 : r.referenceHidden) && {
            visibility: "hidden",
            "pointer-events": "none"
          },
          ...c(F(this, bo))
        },
        // Floating UI calculates logical alignment based the `dir` attribute
        dir: F(this, _o).current
      };
    }));
    te(this, Dl, /* @__PURE__ */ R(() => ({
      "data-side": this.placedSide,
      "data-align": this.placedAlign,
      style: dd({
        ...c(F(this, bo))
        // if the FloatingContent hasn't been placed yet (not all measurements done)
      })
    })));
    te(this, Nl, /* @__PURE__ */ R(() => ({
      position: "absolute",
      left: this.arrowX ? `${this.arrowX}px` : void 0,
      top: this.arrowY ? `${this.arrowY}px` : void 0,
      [this.arrowBaseSide]: 0,
      "transform-origin": {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[this.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[this.placedSide],
      visibility: this.cannotCenterArrow ? "hidden" : void 0
    })));
    this.id = t.id, Te(this, xo, t.side), Te(this, ko, t.sideOffset), Te(this, za, t.align), Te(this, So, t.alignOffset), Te(this, Co, t.arrowPadding), Te(this, Va, t.avoidCollisions), Te(this, jr, t.collisionBoundary), Te(this, Eo, t.collisionPadding), Te(this, To, t.sticky), Te(this, Ao, t.hideWhenDetached), Te(this, Mo, t.updatePositionStrategy), this.onPlaced = t.onPlaced, Te(this, Po, t.strategy), Te(this, _o, t.dir), this.style = t.style, this.root = n, this.enabled = t.enabled, this.wrapperId = t.wrapperId, t.customAnchor && (this.root.customAnchorNode.current = t.customAnchor.current), Se(() => {
      t.customAnchor.current, _t(() => {
        this.root.customAnchorNode.current = t.customAnchor.current;
      });
    }), In({
      id: this.wrapperId,
      ref: this.wrapperRef,
      deps: () => this.enabled.current
    }), In({
      id: this.id,
      ref: this.contentRef,
      deps: () => this.enabled.current
    }), this.floating = S5({
      strategy: () => F(this, Po).current,
      placement: () => c(F(this, Cl)),
      middleware: () => this.middleware,
      reference: this.root.anchorNode,
      whileElementsMounted: (...r) => {
        var i;
        return y5(...r, {
          animationFrame: ((i = F(this, Mo)) == null ? void 0 : i.current) === "always"
        });
      },
      open: () => this.enabled.current
    }), Se(() => {
      var r;
      this.floating.isPositioned && ((r = this.onPlaced) == null || r.current());
    }), Se(() => {
      const r = this.contentRef.current;
      r && _t(() => {
        this.contentZIndex = window.getComputedStyle(r).zIndex;
      });
    }), Se(() => {
      this.floating.floating.current = this.wrapperRef.current;
    });
  }
  get hasExplicitBoundaries() {
    return c(F(this, El));
  }
  get detectOverflowOptions() {
    return c(F(this, Tl));
  }
  get middleware() {
    return c(F(this, Al));
  }
  get placedSide() {
    return c(F(this, Pl));
  }
  get placedAlign() {
    return c(F(this, Ml));
  }
  get arrowX() {
    return c(F(this, Il));
  }
  get arrowY() {
    return c(F(this, Ol));
  }
  get cannotCenterArrow() {
    return c(F(this, Fl));
  }
  get contentZIndex() {
    return c(F(this, zo));
  }
  set contentZIndex(t) {
    z(F(this, zo), oe(t));
  }
  get arrowBaseSide() {
    return c(F(this, Rl));
  }
  get wrapperProps() {
    return c(F(this, Ll));
  }
  get props() {
    return c(F(this, Dl));
  }
  get arrowStyle() {
    return c(F(this, Nl));
  }
}
bo = new WeakMap(), _o = new WeakMap(), xo = new WeakMap(), ko = new WeakMap(), za = new WeakMap(), So = new WeakMap(), Co = new WeakMap(), Va = new WeakMap(), jr = new WeakMap(), Eo = new WeakMap(), To = new WeakMap(), Ao = new WeakMap(), Po = new WeakMap(), Mo = new WeakMap(), Io = new WeakMap(), Sl = new WeakMap(), Oo = new WeakMap(), Cl = new WeakMap(), Fo = new WeakMap(), El = new WeakMap(), Tl = new WeakMap(), Ro = new WeakMap(), Lo = new WeakMap(), Do = new WeakMap(), No = new WeakMap(), Al = new WeakMap(), Pl = new WeakMap(), Ml = new WeakMap(), Il = new WeakMap(), Ol = new WeakMap(), Fl = new WeakMap(), zo = new WeakMap(), Rl = new WeakMap(), Ll = new WeakMap(), Dl = new WeakMap(), Nl = new WeakMap();
const [
  A5,
  P5
] = ru("Floating.Root"), [
  M5,
  xE
] = ru("Floating.Content");
function I5() {
  return A5(new E5());
}
function O5(e) {
  return M5(new T5(e, P5()));
}
function F5(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(t) {
      var w, m, v;
      const { placement: n, rects: r, middlewareData: a } = t, o = ((w = a.arrow) == null ? void 0 : w.centerOffset) !== 0, s = o ? 0 : e.arrowWidth, l = o ? 0 : e.arrowHeight, [u, d] = kd(n), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((m = a.arrow) == null ? void 0 : m.x) ?? 0) + s / 2, h = (((v = a.arrow) == null ? void 0 : v.y) ?? 0) + l / 2;
      let y = "", g = "";
      return u === "bottom" ? (y = o ? f : `${p}px`, g = `${-l}px`) : u === "top" ? (y = o ? f : `${p}px`, g = `${r.floating.height + l}px`) : u === "right" ? (y = `${-l}px`, g = o ? f : `${h}px`) : u === "left" && (y = `${r.floating.width + l}px`, g = o ? f : `${h}px`), { data: { x: y, y: g } };
    }
  };
}
function kd(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
function R5(e) {
  return kd(e)[0];
}
function L5(e) {
  return kd(e)[1];
}
function D5(e, t) {
  be(t, !0), I5();
  var n = Z(), r = V(n);
  lt(r, () => t.children ?? De), _(e, n), _e();
}
var N5 = /* @__PURE__ */ O("<div><!></div>");
function z5(e, t) {
  be(t, !0);
  let n = L(t, "side", 3, "bottom"), r = L(t, "sideOffset", 3, 0), a = L(t, "align", 3, "center"), i = L(t, "alignOffset", 3, 0), o = L(t, "arrowPadding", 3, 0), s = L(t, "avoidCollisions", 3, !0), l = L(t, "collisionBoundary", 19, () => []), u = L(t, "collisionPadding", 3, 0), d = L(t, "hideWhenDetached", 3, !1), f = L(t, "onPlaced", 3, () => {
  }), p = L(t, "sticky", 3, "partial"), h = L(t, "updatePositionStrategy", 3, "optimized"), y = L(t, "strategy", 3, "fixed"), g = L(t, "dir", 3, "ltr"), w = L(t, "style", 19, () => ({})), m = L(t, "wrapperId", 19, $n), v = L(t, "customAnchor", 3, null);
  const C = O5({
    side: ce.with(() => n()),
    sideOffset: ce.with(() => r()),
    align: ce.with(() => a()),
    alignOffset: ce.with(() => i()),
    id: ce.with(() => t.id),
    arrowPadding: ce.with(() => o()),
    avoidCollisions: ce.with(() => s()),
    collisionBoundary: ce.with(() => l()),
    collisionPadding: ce.with(() => u()),
    hideWhenDetached: ce.with(() => d()),
    onPlaced: ce.with(() => f()),
    sticky: ce.with(() => p()),
    updatePositionStrategy: ce.with(() => h()),
    strategy: ce.with(() => y()),
    dir: ce.with(() => g()),
    style: ce.with(() => w()),
    enabled: ce.with(() => !1),
    wrapperId: ce.with(() => m()),
    customAnchor: ce.with(() => v())
  }), S = /* @__PURE__ */ R(() => $t(C.wrapperProps, { style: { pointerEvents: "auto" } }));
  var b = N5();
  let x;
  var E = T(b);
  lt(E, () => t.content ?? De, () => ({ props: C.props })), ee(() => x = Je(b, x, { ...c(S) })), _(e, b), _e();
}
function V5(e, t) {
  be(t, !0), Rn(() => {
    var a;
    (a = t.onPlaced) == null || a.call(t);
  });
  var n = Z(), r = V(n);
  lt(r, () => t.content ?? De, () => ({ props: {} })), _(e, n), _e();
}
const B5 = "data-separator-root";
var Ba, Vo, ja, Wa, zl;
class j5 {
  constructor(t) {
    te(this, Ba);
    te(this, Vo);
    te(this, ja);
    te(this, Wa);
    te(this, zl, /* @__PURE__ */ R(() => ({
      id: F(this, Ba).current,
      role: F(this, Wa).current ? "none" : "separator",
      "aria-orientation": F(this, ja).current,
      "aria-hidden": Fx(F(this, Wa).current),
      "data-orientation": F(this, ja).current,
      [B5]: ""
    })));
    Te(this, ja, t.orientation), Te(this, Wa, t.decorative), Te(this, Ba, t.id), Te(this, Vo, t.ref), In({ id: F(this, Ba), ref: F(this, Vo) });
  }
  get props() {
    return c(F(this, zl));
  }
}
Ba = new WeakMap(), Vo = new WeakMap(), ja = new WeakMap(), Wa = new WeakMap(), zl = new WeakMap();
function W5(e) {
  return new j5(e);
}
var H5 = /* @__PURE__ */ O("<div><!></div>");
function U5(e, t) {
  be(t, !0);
  let n = L(t, "id", 19, $n), r = L(t, "ref", 15, null), a = L(t, "decorative", 3, !1), i = L(t, "orientation", 3, "horizontal"), o = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "ref",
    "child",
    "children",
    "decorative",
    "orientation"
  ]);
  const s = W5({
    ref: ce.with(() => r(), (h) => r(h)),
    id: ce.with(() => n()),
    decorative: ce.with(() => a()),
    orientation: ce.with(() => i())
  }), l = /* @__PURE__ */ R(() => $t(o, s.props));
  var u = Z(), d = V(u);
  {
    var f = (h) => {
      var y = Z(), g = V(y);
      lt(g, () => t.child, () => ({ props: c(l) })), _(h, y);
    }, p = (h) => {
      var y = H5();
      let g;
      var w = T(y);
      lt(w, () => t.children ?? De), ee(() => g = Je(y, g, { ...c(l) })), _(h, y);
    };
    H(d, (h) => {
      t.child ? h(f) : h(p, !1);
    });
  }
  _(e, u), _e();
}
function q5(e, t) {
  let n = L(t, "isStatic", 3, !1), r = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "content",
    "isStatic",
    "onPlaced"
  ]);
  var a = Z(), i = V(a);
  {
    var o = (l) => {
      V5(l, {
        get content() {
          return t.content;
        },
        get onPlaced() {
          return t.onPlaced;
        }
      });
    }, s = (l) => {
      z5(l, ot(
        {
          get content() {
            return t.content;
          },
          get onPlaced() {
            return t.onPlaced;
          }
        },
        () => r
      ));
    };
    H(i, (l) => {
      n() ? l(o) : l(s, !1);
    });
  }
  _(e, a);
}
var G5 = /* @__PURE__ */ O("<!> <!>", 1);
function Ug(e, t) {
  be(t, !0);
  let n = L(t, "interactOutsideBehavior", 3, "close"), r = L(t, "trapFocus", 3, !0), a = L(t, "isValidEvent", 3, () => !1), i = L(t, "customAnchor", 3, null), o = L(t, "isStatic", 3, !1), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled"
  ]);
  q5(e, {
    get isStatic() {
      return o();
    },
    get id() {
      return t.id;
    },
    get side() {
      return t.side;
    },
    get sideOffset() {
      return t.sideOffset;
    },
    get align() {
      return t.align;
    },
    get alignOffset() {
      return t.alignOffset;
    },
    get arrowPadding() {
      return t.arrowPadding;
    },
    get avoidCollisions() {
      return t.avoidCollisions;
    },
    get collisionBoundary() {
      return t.collisionBoundary;
    },
    get collisionPadding() {
      return t.collisionPadding;
    },
    get sticky() {
      return t.sticky;
    },
    get hideWhenDetached() {
      return t.hideWhenDetached;
    },
    get updatePositionStrategy() {
      return t.updatePositionStrategy;
    },
    get strategy() {
      return t.strategy;
    },
    get dir() {
      return t.dir;
    },
    get wrapperId() {
      return t.wrapperId;
    },
    get style() {
      return t.style;
    },
    get onPlaced() {
      return t.onPlaced;
    },
    get customAnchor() {
      return i();
    },
    content: (u, d) => {
      let f = () => d == null ? void 0 : d().props;
      var p = G5(), h = V(p);
      {
        var y = (v) => {
          Ks(v, {
            get preventScroll() {
              return t.preventScroll;
            }
          });
        }, g = (v) => {
          var C = Z(), S = V(C);
          {
            var b = (x) => {
              Ks(x, {
                get preventScroll() {
                  return t.preventScroll;
                }
              });
            };
            H(
              S,
              (x) => {
                t.forceMount || x(b);
              },
              !0
            );
          }
          _(v, C);
        };
        H(h, (v) => {
          t.forceMount && t.enabled ? v(y) : v(g, !1);
        });
      }
      var w = Q(h, 2), m = /* @__PURE__ */ R(() => t.enabled && r());
      Og(w, {
        get id() {
          return t.id;
        },
        get onOpenAutoFocus() {
          return t.onOpenAutoFocus;
        },
        get onCloseAutoFocus() {
          return t.onCloseAutoFocus;
        },
        get loop() {
          return t.loop;
        },
        get trapFocus() {
          return c(m);
        },
        get forceMount() {
          return t.forceMount;
        },
        focusScope: (C, S) => {
          let b = () => S == null ? void 0 : S().props;
          Mg(C, {
            get onEscapeKeydown() {
              return t.onEscapeKeydown;
            },
            get escapeKeydownBehavior() {
              return t.escapeKeydownBehavior;
            },
            get enabled() {
              return t.enabled;
            },
            children: (x, E) => {
              Pg(x, {
                get id() {
                  return t.id;
                },
                get onInteractOutside() {
                  return t.onInteractOutside;
                },
                get onFocusOutside() {
                  return t.onFocusOutside;
                },
                get interactOutsideBehavior() {
                  return n();
                },
                get isValidEvent() {
                  return a();
                },
                get enabled() {
                  return t.enabled;
                },
                children: (I, D) => {
                  let A = () => D == null ? void 0 : D().props;
                  Rg(I, {
                    get id() {
                      return t.id;
                    },
                    get preventOverflowTextSelection() {
                      return t.preventOverflowTextSelection;
                    },
                    get onPointerDown() {
                      return t.onPointerDown;
                    },
                    get onPointerUp() {
                      return t.onPointerUp;
                    },
                    get enabled() {
                      return t.enabled;
                    },
                    children: (M, N) => {
                      var P = Z(), Y = V(P), G = /* @__PURE__ */ St(() => ({
                        props: $t(s, f(), A(), b(), { style: { pointerEvents: "auto" } })
                      }));
                      lt(Y, () => t.popper ?? De, () => c(G)), _(M, P);
                    },
                    $$slots: { default: !0 }
                  });
                },
                $$slots: { default: !0 }
              });
            },
            $$slots: { default: !0 }
          });
        },
        $$slots: { focusScope: !0 }
      }), _(u, p);
    },
    $$slots: { content: !0 }
  }), _e();
}
function K5(e, t) {
  let n = L(t, "interactOutsideBehavior", 3, "close"), r = L(t, "trapFocus", 3, !0), a = L(t, "isValidEvent", 3, () => !1), i = L(t, "customAnchor", 3, null), o = L(t, "isStatic", 3, !1), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "present",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic"
  ]);
  pd(e, ot(
    {
      get id() {
        return t.id;
      },
      get present() {
        return t.present;
      }
    },
    () => s,
    { presence: (u, d) => {
      let f = () => d == null ? void 0 : d().present;
      Ug(u, ot(
        {
          get popper() {
            return t.popper;
          },
          get onEscapeKeydown() {
            return t.onEscapeKeydown;
          },
          get escapeKeydownBehavior() {
            return t.escapeKeydownBehavior;
          },
          get preventOverflowTextSelection() {
            return t.preventOverflowTextSelection;
          },
          get id() {
            return t.id;
          },
          get onPointerDown() {
            return t.onPointerDown;
          },
          get onPointerUp() {
            return t.onPointerUp;
          },
          get side() {
            return t.side;
          },
          get sideOffset() {
            return t.sideOffset;
          },
          get align() {
            return t.align;
          },
          get alignOffset() {
            return t.alignOffset;
          },
          get arrowPadding() {
            return t.arrowPadding;
          },
          get avoidCollisions() {
            return t.avoidCollisions;
          },
          get collisionBoundary() {
            return t.collisionBoundary;
          },
          get collisionPadding() {
            return t.collisionPadding;
          },
          get sticky() {
            return t.sticky;
          },
          get hideWhenDetached() {
            return t.hideWhenDetached;
          },
          get updatePositionStrategy() {
            return t.updatePositionStrategy;
          },
          get strategy() {
            return t.strategy;
          },
          get dir() {
            return t.dir;
          },
          get preventScroll() {
            return t.preventScroll;
          },
          get wrapperId() {
            return t.wrapperId;
          },
          get style() {
            return t.style;
          },
          get onPlaced() {
            return t.onPlaced;
          },
          get customAnchor() {
            return i();
          },
          get isStatic() {
            return o();
          },
          get enabled() {
            return f().current;
          },
          get onInteractOutside() {
            return t.onInteractOutside;
          },
          get onCloseAutoFocus() {
            return t.onCloseAutoFocus;
          },
          get onOpenAutoFocus() {
            return t.onOpenAutoFocus;
          },
          get interactOutsideBehavior() {
            return n();
          },
          get loop() {
            return t.loop;
          },
          get trapFocus() {
            return r();
          },
          get isValidEvent() {
            return a();
          },
          get onFocusOutside() {
            return t.onFocusOutside;
          },
          forceMount: !1
        },
        () => s
      ));
    }, $$slots: { presence: !0 } }
  ));
}
function Z5(e, t) {
  let n = L(t, "interactOutsideBehavior", 3, "close"), r = L(t, "trapFocus", 3, !0), a = L(t, "isValidEvent", 3, () => !1), i = L(t, "customAnchor", 3, null), o = L(t, "isStatic", 3, !1), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled"
  ]);
  Ug(e, ot(
    {
      get popper() {
        return t.popper;
      },
      get onEscapeKeydown() {
        return t.onEscapeKeydown;
      },
      get escapeKeydownBehavior() {
        return t.escapeKeydownBehavior;
      },
      get preventOverflowTextSelection() {
        return t.preventOverflowTextSelection;
      },
      get id() {
        return t.id;
      },
      get onPointerDown() {
        return t.onPointerDown;
      },
      get onPointerUp() {
        return t.onPointerUp;
      },
      get side() {
        return t.side;
      },
      get sideOffset() {
        return t.sideOffset;
      },
      get align() {
        return t.align;
      },
      get alignOffset() {
        return t.alignOffset;
      },
      get arrowPadding() {
        return t.arrowPadding;
      },
      get avoidCollisions() {
        return t.avoidCollisions;
      },
      get collisionBoundary() {
        return t.collisionBoundary;
      },
      get collisionPadding() {
        return t.collisionPadding;
      },
      get sticky() {
        return t.sticky;
      },
      get hideWhenDetached() {
        return t.hideWhenDetached;
      },
      get updatePositionStrategy() {
        return t.updatePositionStrategy;
      },
      get strategy() {
        return t.strategy;
      },
      get dir() {
        return t.dir;
      },
      get preventScroll() {
        return t.preventScroll;
      },
      get wrapperId() {
        return t.wrapperId;
      },
      get style() {
        return t.style;
      },
      get onPlaced() {
        return t.onPlaced;
      },
      get customAnchor() {
        return i();
      },
      get isStatic() {
        return o();
      },
      get enabled() {
        return t.enabled;
      },
      get onInteractOutside() {
        return t.onInteractOutside;
      },
      get onCloseAutoFocus() {
        return t.onCloseAutoFocus;
      },
      get onOpenAutoFocus() {
        return t.onOpenAutoFocus;
      },
      get interactOutsideBehavior() {
        return n();
      },
      get loop() {
        return t.loop;
      },
      get trapFocus() {
        return r();
      },
      get isValidEvent() {
        return a();
      },
      get onFocusOutside() {
        return t.onFocusOutside;
      }
    },
    () => s,
    { forceMount: !0 }
  ));
}
var Bo, jo, Wo;
class Y5 {
  constructor(t) {
    Le(this, "open");
    te(this, Bo, de(null));
    te(this, jo, de(void 0));
    te(this, Wo, de(null));
    Le(this, "toggleOpen", () => {
      this.open.current = !this.open.current;
    });
    Le(this, "close", () => {
      this.open.current && (this.open.current = !1);
    });
    this.open = t.open;
  }
  get contentNode() {
    return c(F(this, Bo));
  }
  set contentNode(t) {
    z(F(this, Bo), oe(t));
  }
  get contentId() {
    return c(F(this, jo));
  }
  set contentId(t) {
    z(F(this, jo), oe(t));
  }
  get triggerNode() {
    return c(F(this, Wo));
  }
  set triggerNode(t) {
    z(F(this, Wo), oe(t));
  }
}
Bo = new WeakMap(), jo = new WeakMap(), Wo = new WeakMap();
var Ha, Ho, Vl, Bl;
class X5 {
  constructor(t, n) {
    te(this, Ha);
    te(this, Ho);
    Le(this, "root");
    te(this, Vl, /* @__PURE__ */ R(() => ({ open: this.root.open.current })));
    te(this, Bl, /* @__PURE__ */ R(() => ({
      id: F(this, Ha).current,
      tabindex: -1,
      "data-state": kg(this.root.open.current),
      "data-popover-content": "",
      style: { pointerEvents: "auto" }
    })));
    Te(this, Ha, t.id), this.root = n, Te(this, Ho, t.ref), In({
      id: F(this, Ha),
      ref: F(this, Ho),
      deps: () => this.root.open.current,
      onRefChange: (r) => {
        this.root.contentNode = r, this.root.contentId = r == null ? void 0 : r.id;
      }
    });
  }
  get snippetProps() {
    return c(F(this, Vl));
  }
  get props() {
    return c(F(this, Bl));
  }
}
Ha = new WeakMap(), Ho = new WeakMap(), Vl = new WeakMap(), Bl = new WeakMap();
const [J5, Q5] = ru("Popover.Root");
function $5(e) {
  return J5(new Y5(e));
}
function e4(e) {
  return new X5(e, Q5());
}
var t4 = /* @__PURE__ */ O("<div><!></div>"), n4 = /* @__PURE__ */ O("<div><!></div>");
function _p(e, t) {
  be(t, !0);
  let n = L(t, "ref", 15, null), r = L(t, "id", 19, $n), a = L(t, "forceMount", 3, !1), i = L(t, "onCloseAutoFocus", 3, Ct), o = L(t, "onEscapeKeydown", 3, Ct), s = L(t, "onInteractOutside", 3, Ct), l = L(t, "trapFocus", 3, !0), u = L(t, "preventScroll", 3, !1), d = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "child",
    "children",
    "ref",
    "id",
    "forceMount",
    "onCloseAutoFocus",
    "onEscapeKeydown",
    "onInteractOutside",
    "trapFocus",
    "preventScroll"
  ]);
  const f = e4({
    id: ce.with(() => r()),
    ref: ce.with(() => n(), (S) => n(S))
  }), p = /* @__PURE__ */ R(() => $t(d, f.props));
  function h(S) {
    s()(S), !S.defaultPrevented && f.root.close();
  }
  function y(S) {
    o()(S), !S.defaultPrevented && f.root.close();
  }
  function g(S) {
    var b;
    i()(S), !S.defaultPrevented && (S.preventDefault(), (b = f.root.triggerNode) == null || b.focus());
  }
  var w = Z(), m = V(w);
  {
    var v = (S) => {
      Z5(S, ot(() => c(p), {
        get enabled() {
          return f.root.open.current;
        },
        get id() {
          return r();
        },
        onInteractOutside: h,
        onEscapeKeydown: y,
        onCloseAutoFocus: g,
        get trapFocus() {
          return l();
        },
        get preventScroll() {
          return u();
        },
        loop: !0,
        forceMount: !0,
        popper: (x, E) => {
          let k = () => E == null ? void 0 : E().props;
          var I = Z();
          const D = /* @__PURE__ */ R(() => $t(k(), {
            style: bp("popover")
          }));
          var A = V(I);
          {
            var M = (P) => {
              var Y = Z(), G = V(Y);
              lt(G, () => t.child, () => ({
                props: c(D),
                ...f.snippetProps
              })), _(P, Y);
            }, N = (P) => {
              var Y = t4();
              let G;
              var q = T(Y);
              lt(q, () => t.children ?? De), ee(() => G = Je(Y, G, { ...c(D) })), _(P, Y);
            };
            H(A, (P) => {
              t.child ? P(M) : P(N, !1);
            });
          }
          _(x, I);
        },
        $$slots: { popper: !0 }
      }));
    }, C = (S) => {
      var b = Z(), x = V(b);
      {
        var E = (k) => {
          K5(k, ot(() => c(p), {
            get present() {
              return f.root.open.current;
            },
            get id() {
              return r();
            },
            onInteractOutside: h,
            onEscapeKeydown: y,
            onCloseAutoFocus: g,
            get trapFocus() {
              return l();
            },
            get preventScroll() {
              return u();
            },
            loop: !0,
            forceMount: !1,
            popper: (D, A) => {
              let M = () => A == null ? void 0 : A().props;
              var N = Z();
              const P = /* @__PURE__ */ R(() => $t(M(), {
                style: bp("popover")
              }));
              var Y = V(N);
              {
                var G = (J) => {
                  var $ = Z(), W = V($);
                  lt(W, () => t.child, () => ({
                    props: c(P),
                    ...f.snippetProps
                  })), _(J, $);
                }, q = (J) => {
                  var $ = n4();
                  let W;
                  var j = T($);
                  lt(j, () => t.children ?? De), ee(() => W = Je($, W, { ...c(P) })), _(J, $);
                };
                H(Y, (J) => {
                  t.child ? J(G) : J(q, !1);
                });
              }
              _(D, N);
            },
            $$slots: { popper: !0 }
          }));
        };
        H(
          x,
          (k) => {
            a() || k(E);
          },
          !0
        );
      }
      _(S, b);
    };
    H(m, (S) => {
      a() ? S(v) : S(C, !1);
    });
  }
  _(e, w), _e();
}
function r4(e, t) {
  be(t, !0);
  let n = L(t, "open", 15, !1), r = L(t, "onOpenChange", 3, Ct), a = L(t, "controlledOpen", 3, !1);
  r3({
    variant: ce.with(() => "dialog"),
    open: ce.with(() => n(), (s) => {
      a() || n(s), r()(s);
    })
  });
  var i = Z(), o = V(i);
  lt(o, () => t.children ?? De), _(e, i), _e();
}
var a4 = /* @__PURE__ */ O("<button><!></button>");
function i4(e, t) {
  be(t, !0);
  let n = L(t, "id", 19, $n), r = L(t, "ref", 15, null), a = L(t, "disabled", 3, !1), i = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "children",
    "child",
    "id",
    "ref",
    "disabled"
  ]);
  const o = o3({
    variant: ce.with(() => "close"),
    id: ce.with(() => n()),
    ref: ce.with(() => r(), (p) => r(p)),
    disabled: ce.with(() => !!a())
  }), s = /* @__PURE__ */ R(() => $t(i, o.props));
  var l = Z(), u = V(l);
  {
    var d = (p) => {
      var h = Z(), y = V(h);
      lt(y, () => t.child, () => ({ props: c(s) })), _(p, h);
    }, f = (p) => {
      var h = a4();
      let y;
      var g = T(h);
      lt(g, () => t.children ?? De), ee(() => y = Je(h, y, { ...c(s) })), _(p, h);
    };
    H(u, (p) => {
      t.child ? p(d) : p(f, !1);
    });
  }
  _(e, l), _e();
}
var o4 = /* @__PURE__ */ O("<!> <!>", 1), s4 = /* @__PURE__ */ O("<!> <div><!></div>", 1);
function l4(e, t) {
  be(t, !0);
  let n = L(t, "id", 19, $n), r = L(t, "ref", 15, null), a = L(t, "forceMount", 3, !1), i = L(t, "onCloseAutoFocus", 3, Ct), o = L(t, "onEscapeKeydown", 3, Ct), s = L(t, "onInteractOutside", 3, Ct), l = L(t, "trapFocus", 3, !0), u = L(t, "preventScroll", 3, !0), d = L(t, "restoreScrollDelay", 3, null), f = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "children",
    "child",
    "ref",
    "forceMount",
    "onCloseAutoFocus",
    "onEscapeKeydown",
    "onInteractOutside",
    "trapFocus",
    "preventScroll",
    "restoreScrollDelay"
  ]);
  const p = a3({
    id: ce.with(() => n()),
    ref: ce.with(() => r(), (g) => r(g))
  }), h = /* @__PURE__ */ R(() => $t(f, p.props));
  var y = /* @__PURE__ */ R(() => p.root.open.current || a());
  pd(e, ot(() => c(h), {
    get forceMount() {
      return a();
    },
    get present() {
      return c(y);
    },
    presence: (w, m) => {
      let v = () => m == null ? void 0 : m().present;
      var C = /* @__PURE__ */ R(() => O3({
        forceMount: a(),
        present: v().current,
        trapFocus: l(),
        open: p.root.open.current
      }));
      Og(w, ot(
        {
          loop: !0,
          get trapFocus() {
            return c(C);
          }
        },
        () => c(h),
        {
          onCloseAutoFocus: (b) => {
            var x;
            i()(b), !b.defaultPrevented && ((x = p.root.triggerNode) == null || x.focus());
          },
          focusScope: (b, x) => {
            let E = () => x == null ? void 0 : x().props;
            Mg(b, ot(() => c(h), {
              get enabled() {
                return v().current;
              },
              onEscapeKeydown: (k) => {
                o()(k), !k.defaultPrevented && p.root.handleClose();
              },
              children: (k, I) => {
                Pg(k, ot(() => c(h), {
                  get enabled() {
                    return v().current;
                  },
                  onInteractOutside: (D) => {
                    s()(D), !D.defaultPrevented && p.root.handleClose();
                  },
                  children: (D, A) => {
                    Rg(D, ot(() => c(h), {
                      get enabled() {
                        return v().current;
                      },
                      children: (M, N) => {
                        var P = Z(), Y = V(P);
                        {
                          var G = (J) => {
                            var $ = o4(), W = V($);
                            {
                              var j = (U) => {
                                Ks(U, {
                                  get preventScroll() {
                                    return u();
                                  },
                                  get restoreScrollDelay() {
                                    return d();
                                  }
                                });
                              };
                              H(W, (U) => {
                                p.root.open.current && U(j);
                              });
                            }
                            var B = Q(W, 2), K = /* @__PURE__ */ St(() => ({
                              props: $t(c(h), E()),
                              ...p.snippetProps
                            }));
                            lt(B, () => t.child, () => c(K)), _(J, $);
                          }, q = (J) => {
                            var $ = s4(), W = V($);
                            Ks(W, {
                              get preventScroll() {
                                return u();
                              }
                            });
                            var j = Q(W, 2);
                            const B = /* @__PURE__ */ R(() => $t(c(h), E()));
                            let K;
                            var U = T(j);
                            lt(U, () => t.children ?? De), ee(() => K = Je(j, K, { ...c(B) })), _(J, $);
                          };
                          H(Y, (J) => {
                            t.child ? J(G) : J(q, !1);
                          });
                        }
                        _(M, P);
                      },
                      $$slots: { default: !0 }
                    }));
                  },
                  $$slots: { default: !0 }
                }));
              },
              $$slots: { default: !0 }
            }));
          },
          $$slots: { focusScope: !0 }
        }
      ));
    },
    $$slots: { presence: !0 }
  })), _e();
}
function u4(e, t) {
  be(t, !0);
  let n = L(t, "open", 15, !1), r = L(t, "onOpenChange", 3, Ct), a = L(t, "controlledOpen", 3, !1);
  $5({
    open: ce.with(() => n(), (i) => {
      a() || n(i), r()(i);
    })
  }), D5(e, {
    children: (i, o) => {
      var s = Z(), l = V(s);
      lt(l, () => t.children ?? De), _(i, s);
    },
    $$slots: { default: !0 }
  }), _e();
}
function c4(e, t) {
  be(t, !0);
  let n = L(t, "ref", 15, null), r = L(t, "align", 3, "center"), a = L(t, "sideOffset", 3, 4), i = L(t, "portal", 3, !0), o = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class",
    "align",
    "sideOffset",
    "portal",
    "style"
  ]);
  var s = Z(), l = V(s);
  {
    var u = (f) => {
      var p = Z(), h = V(p);
      rt(h, () => Cg, (y, g) => {
        g(y, {
          children: (w, m) => {
            var v = Z(), C = V(v), S = /* @__PURE__ */ R(() => Ee("layup-z-50 layup-w-72 layup-rounded-md layup-border layup-bg-popover layup-p-4 layup-text-popover-foreground layup-shadow-md layup-outline-none data-[state=open]:layup-animate-in data-[state=closed]:layup-animate-out data-[state=closed]:layup-fade-out-0 data-[state=open]:layup-fade-in-0 data-[state=closed]:layup-zoom-out-95 data-[state=open]:layup-zoom-in-95 data-[side=bottom]:layup-slide-in-from-top-2 data-[side=left]:layup-slide-in-from-right-2 data-[side=right]:layup-slide-in-from-left-2 data-[side=top]:layup-slide-in-from-bottom-2", t.class));
            rt(C, () => _p, (b, x) => {
              x(b, ot(
                {
                  get align() {
                    return r();
                  },
                  get style() {
                    return t.style;
                  },
                  get sideOffset() {
                    return a();
                  },
                  get class() {
                    return c(S);
                  }
                },
                () => o,
                {
                  get ref() {
                    return n();
                  },
                  set ref(E) {
                    n(E);
                  }
                }
              ));
            }), _(w, v);
          },
          $$slots: { default: !0 }
        });
      }), _(f, p);
    }, d = (f) => {
      var p = Z(), h = V(p), y = /* @__PURE__ */ R(() => Ee("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 layup-z-50 layup-w-72 layup-rounded-md layup-border layup-bg-popover layup-p-4 layup-text-popover-foreground layup-shadow-md layup-outline-none", t.class));
      rt(h, () => _p, (g, w) => {
        w(g, ot(
          {
            get align() {
              return r();
            },
            get style() {
              return t.style;
            },
            get sideOffset() {
              return a();
            },
            get class() {
              return c(y);
            }
          },
          () => o,
          {
            get ref() {
              return n();
            },
            set ref(m) {
              n(m);
            }
          }
        ));
      }), _(f, p);
    };
    H(l, (f) => {
      i() ? f(u) : f(d, !1);
    });
  }
  _(e, s), _e();
}
const d4 = u4, f4 = (e) => e;
function Sd(e) {
  const t = e - 1;
  return t * t * t + 1;
}
function xp(e) {
  const t = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return t ? [parseFloat(t[1]), t[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function qg(e, { delay: t = 0, duration: n = 400, easing: r = f4 } = {}) {
  const a = +getComputedStyle(e).opacity;
  return {
    delay: t,
    duration: n,
    easing: r,
    css: (i) => `opacity: ${i * a}`
  };
}
function ns(e, { delay: t = 0, duration: n = 400, easing: r = Sd, x: a = 0, y: i = 0, opacity: o = 0 } = {}) {
  const s = getComputedStyle(e), l = +s.opacity, u = s.transform === "none" ? "" : s.transform, d = l * (1 - o), [f, p] = xp(a), [h, y] = xp(i);
  return {
    delay: t,
    duration: n,
    easing: r,
    css: (g, w) => `
			transform: ${u} translate(${(1 - g) * f}${p}, ${(1 - g) * h}${y});
			opacity: ${l - d * w}`
  };
}
function yc(e, { delay: t = 0, duration: n = 400, easing: r = Sd, axis: a = "y" } = {}) {
  const i = getComputedStyle(e), o = +i.opacity, s = a === "y" ? "height" : "width", l = parseFloat(i[s]), u = a === "y" ? ["top", "bottom"] : ["left", "right"], d = u.map(
    (m) => (
      /** @type {'Left' | 'Right' | 'Top' | 'Bottom'} */
      `${m[0].toUpperCase()}${m.slice(1)}`
    )
  ), f = parseFloat(i[`padding${d[0]}`]), p = parseFloat(i[`padding${d[1]}`]), h = parseFloat(i[`margin${d[0]}`]), y = parseFloat(i[`margin${d[1]}`]), g = parseFloat(
    i[`border${d[0]}Width`]
  ), w = parseFloat(
    i[`border${d[1]}Width`]
  );
  return {
    delay: t,
    duration: n,
    easing: r,
    css: (m) => `overflow: hidden;opacity: ${Math.min(m * 20, 1) * o};${s}: ${m * l}px;padding-${u[0]}: ${m * f}px;padding-${u[1]}: ${m * p}px;margin-${u[0]}: ${m * h}px;margin-${u[1]}: ${m * y}px;border-${u[0]}-width: ${m * g}px;border-${u[1]}-width: ${m * w}px;`
  };
}
function Qt(e, { delay: t = 0, duration: n = 400, easing: r = Sd, start: a = 0, opacity: i = 0 } = {}) {
  const o = getComputedStyle(e), s = +o.opacity, l = o.transform === "none" ? "" : o.transform, u = 1 - a, d = s * (1 - i);
  return {
    delay: t,
    duration: n,
    easing: r,
    css: (f, p) => `
			transform: ${l} scale(${1 - u * p});
			opacity: ${s - d * p}
		`
  };
}
var p4 = /* @__PURE__ */ O("<div> </div>"), h4 = /* @__PURE__ */ O("<!> <!>", 1), y4 = /* @__PURE__ */ O('<div class="layup-relative layup-z-[99999999] layup-flex layup-w-fit layup-items-center layup-justify-center svelte-qzlv45"><!> <div> </div></div>'), g4 = /* @__PURE__ */ O("<div><!></div>"), v4 = /* @__PURE__ */ O('<div class="layup-fixed -layup-top-2 layup-z-[99999999] layup-flex layup-items-center svelte-qzlv45"><div class="layup-flex layup-items-center svelte-qzlv45"><!> <div> </div></div></div>'), m4 = /* @__PURE__ */ O('<span class="!layup-text-base svelte-qzlv45">Hide</span>'), w4 = /* @__PURE__ */ O('<div class="!layup-text-sm svelte-qzlv45">Next step</div>'), b4 = /* @__PURE__ */ O('<span class="!layup-text-base svelte-qzlv45">Finish</span>'), _4 = /* @__PURE__ */ O(`<div class="layup-cursor-popover !layup-pointer-events-none !layup-z-[9999999] !layup-flex !layup-min-w-[200px]
              !layup-max-w-[260px] !layup-origin-top-left !layup-transform-gpu !layup-items-center !layup-gap-1.5 !layup-rounded-lg !layup-border-none !layup-outline-none !layup-ring-0 focus-visible:!layup-ring-0 svelte-qzlv45"><div><div><div class="!layup-pointer-events-none !layup-flex !layup-w-full !layup-items-start !layup-justify-between !layup-gap-2 svelte-qzlv45"><div class="!layup-flex !layup-flex-1 !layup-items-start svelte-qzlv45"><!></div></div> <div class="!layup-flex !layup-w-full !layup-justify-end !layup-gap-2 svelte-qzlv45"><!> <!> <!></div></div></div></div>`), x4 = /* @__PURE__ */ O("<layup-cursor><!> <!> <!></layup-cursor>", 2);
function k4(e, t) {
  var b;
  be(t, !0);
  let n = de({ x: 0, y: 0 }), r = de(void 0), a = de(!1), i = de(!1);
  X.config.styles;
  let o = de(null);
  (b = t.actorRef) == null || b.subscribe((x) => {
    z(o, x);
  });
  let s = /* @__PURE__ */ R(() => {
    var x;
    return (x = c(o)) == null ? void 0 : x.context.position;
  }), l = /* @__PURE__ */ R(() => {
    var x;
    return (x = c(o)) == null ? void 0 : x.context.visible;
  }), u = /* @__PURE__ */ R(() => {
    var x;
    return (x = c(o)) == null ? void 0 : x.context.showText;
  }), d = /* @__PURE__ */ R(() => {
    var x;
    return (x = c(o)) == null ? void 0 : x.context.text;
  }), f = /* @__PURE__ */ R(() => {
    var x;
    return (x = c(o)) == null ? void 0 : x.context.popoverSide;
  }), p = de(!0);
  const h = (x) => {
    var E;
    x.detail.success && (z(n, x.detail.position), (E = t.actorRef) == null || E.send({ type: "cursorMoved" }));
  };
  Se(() => {
    var x;
    t.initialPosition && ((x = c(o)) == null ? void 0 : x.value) === "initCursor" && z(n, t.initialPosition);
  }), Se(() => {
    var I, D;
    if (!c(s)) return;
    const x = 0, E = c(s).y < x, k = c(s).y > window.innerHeight - x;
    E !== c(a) && (z(a, E), (I = t.actorRef) == null || I.send({
      type: "SCROLL_UP",
      scrollUp: c(a)
    })), k !== c(i) && (z(i, k), (D = t.actorRef) == null || D.send({
      type: "SCROLL_DOWN",
      scrollDown: c(i)
    }));
  });
  let y = de(!1), g;
  Se(() => {
    var x;
    ((x = c(o)) == null ? void 0 : x.value) === "findSelector" ? (g && clearTimeout(g), g = setTimeout(
      () => {
        z(y, !0);
      },
      500
    )) : (g && clearTimeout(g), z(y, !1));
  }), Oc(() => {
    g && clearTimeout(g);
  });
  var w = x4();
  Ud(w, "class", "layup-cursor layup-pointer-events-none layup-fixed layup-z-[99999999] layup-size-8 !layup-opacity-100 layup-will-change-transform svelte-qzlv45"), Ud(w, "style", "top: 0; left: 0; transform-origin: center center;");
  var m = T(w);
  Gr(m, () => c(l), (x) => {
    var E = Z(), k = V(E);
    {
      var I = (D) => {
        var A = g4();
        const M = /* @__PURE__ */ R(() => `${Ee("layup-z-[9999999] layup-flex layup-w-fit layup-items-center layup-justify-center layup-overflow-auto", c(f) === "left" ? "layup-scale-x-[-1]" : "") ?? ""} svelte-qzlv45`);
        var N = T(A);
        {
          var P = (G) => {
            var q = h4(), J = V(q);
            W_(J, { class: "layup-overflow-auto layup-fill-accent" });
            var $ = Q(J, 2);
            {
              var W = (j) => {
                var B = p4();
                const K = /* @__PURE__ */ R(() => `${Ee(
                  "!layup-absolute !layup-rounded-[4px] !layup-border-[1px] !layup-border-border !layup-border-white !layup-bg-accent !layup-pb-[2px] !layup-pl-[6px] !layup-pr-[6px] !layup-pt-[2px] !layup-text-sm !layup-text-white !layup-transition-opacity !layup-duration-300",
                  // Position based on popoverSide
                  c(f) === "left" && "!layup-right-10 !layup-top-0",
                  c(f) === "right" && "!layup-left-10 !layup-top-0",
                  c(f) === "top" && "!layup-bottom-8 !layup-left-0",
                  c(f) === "bottom" && "!layup-left-0 !layup-top-8"
                ) ?? ""} svelte-qzlv45`);
                var U = T(B);
                ee(() => {
                  Ve(B, c(K)), ke(U, X.config.name);
                }), _(j, B);
              };
              H($, (j) => {
                c(u) || j(W);
              });
            }
            _(G, q);
          }, Y = (G) => {
            var q = Z(), J = V(q);
            {
              var $ = (W) => {
                var j = y4(), B = T(j);
                D_(B, {});
                var K = Q(B, 2);
                const U = /* @__PURE__ */ R(() => `${Ee(
                  "!layup-border-border/70 !layup-fixed !layup-rounded-[4px] !layup-border-[1px] !layup-border-white !layup-bg-accent !layup-pb-[2px] !layup-pl-[6px] !layup-pr-[6px] !layup-pt-[2px] !layup-text-sm !layup-text-white !layup-transition-opacity !layup-duration-300",
                  // Position based on popoverSide
                  c(f) === "left" && "!layup-right-10 !layup-top-0",
                  c(f) === "right" && "!layup-left-10 !layup-top-0",
                  c(f) === "top" && "!layup-bottom-8 !layup-left-0",
                  c(f) === "bottom" && "!layup-left-0 !layup-top-8"
                ) ?? ""} svelte-qzlv45`);
                var ne = T(K);
                ee(() => {
                  Ve(K, c(U)), ke(ne, X.config.name);
                }), _(W, j);
              };
              H(
                J,
                (W) => {
                  c(y) && W($);
                },
                !0
              );
            }
            _(G, q);
          };
          H(N, (G) => {
            c(y) ? G(Y, !1) : G(P);
          });
        }
        ee(() => Ve(A, c(M))), bt(5, A, () => Qt, () => ({ duration: 400 })), _(D, A);
      };
      H(k, (D) => {
        var A;
        c(l) && ((A = c(o)) == null ? void 0 : A.value) !== "completed" && D(I);
      });
    }
    _(x, E);
  });
  var v = Q(m, 2);
  {
    var C = (x) => {
      var E = v4(), k = T(E), I = T(k), D = /* @__PURE__ */ R(() => Ee("transform-origin: bottom left;"));
      U_(I, {
        class: "animate-wave layup-fill-accent",
        get style() {
          return c(D);
        }
      });
      var A = Q(I, 2);
      const M = /* @__PURE__ */ R(() => `${Ee(
        "!layup-absolute !layup-w-fit !layup-rounded-[4px] !layup-border-[1px] !layup-border-border !layup-border-white !layup-bg-accent !layup-pb-[2px] !layup-pl-[6px] !layup-pr-[6px] !layup-pt-[2px] !layup-text-sm !layup-text-white !layup-transition-opacity !layup-duration-300",
        // Position based on popoverSide with increased spacing
        c(f) === "left" && "!layup-right-14 !layup-top-0",
        c(f) === "right" && "!layup-left-14 !layup-top-0",
        c(f) === "top" && "!layup-bottom-10 !layup-left-0",
        c(f) === "bottom" && "!layup-left-0 !layup-top-10"
      ) ?? ""} svelte-qzlv45`);
      var N = T(A);
      ee(() => {
        Ve(A, c(M)), ke(N, X.config.name);
      }), ct("introend", E, () => {
        setTimeout(
          () => {
            z(p, !1);
          },
          1500
        );
      }), bt(5, E, () => Qt, () => ({ duration: 500, start: 1.2 })), bt(6, E, () => Qt, () => ({ duration: 500 })), _(x, E);
    };
    H(v, (x) => {
      var E;
      ((E = c(o)) == null ? void 0 : E.value) === "completed" && c(p) && x(C);
    });
  }
  var S = Q(v, 2);
  Gr(S, () => c(d), (x) => {
    var E = Z(), k = V(E);
    {
      var I = (D) => {
        var A = Z(), M = V(A);
        rt(M, () => d4, (N, P) => {
          P(N, {
            open: !0,
            controlledOpen: !0,
            children: (Y, G) => {
              var q = Z(), J = V(q), $ = /* @__PURE__ */ R(() => c(f) === "top" || c(f) === "bottom" ? 20 : -10), W = /* @__PURE__ */ R(() => c(f) === "top" || c(f) === "bottom" ? "center" : "start"), j = /* @__PURE__ */ R(() => c(f) === "left" || c(f) === "right" ? 20 : 0);
              rt(J, () => c4, (B, K) => {
                K(B, {
                  trapFocus: !1,
                  get customAnchor() {
                    return c(r);
                  },
                  get sideOffset() {
                    return c($);
                  },
                  get side() {
                    return c(f);
                  },
                  get align() {
                    return c(W);
                  },
                  get alignOffset() {
                    return c(j);
                  },
                  onclick: (U) => {
                    U.preventDefault(), U.stopPropagation();
                  },
                  onOpenAutoFocus: (U) => {
                    U.preventDefault(), U.stopPropagation();
                  },
                  onCloseAutoFocus: (U) => {
                    U.preventDefault(), U.stopPropagation();
                  },
                  portal: !0,
                  class: "layup-cursor-popover !layup-pointer-events-none !layup-z-[9999999] !layup-w-fit !layup-transform-gpu  !layup-rounded-lg  !layup-border-none !layup-p-0 !layup-text-base !layup-text-white focus-visible:!layup-ring-0",
                  children: (U, ne) => {
                    var ue = Z(), ae = V(ue);
                    {
                      var se = (ge) => {
                        var pe = _4(), ve = T(pe);
                        const me = /* @__PURE__ */ R(() => `${Ee(
                          "layup-relative layup-w-full !layup-rounded-sm layup-p-[1px]",
                          // Change gradient direction based on popover side
                          c(f) === "right" && "layup-bg-gradient-to-br !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          c(f) === "left" && "layup-bg-gradient-to-bl !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          c(f) === "top" && "layup-bg-gradient-to-t !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          c(f) === "bottom" && "layup-bg-gradient-to-b !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%"
                        ) ?? ""} svelte-qzlv45`);
                        var we = T(ve);
                        const fe = /* @__PURE__ */ R(() => `${Ee("!layup-shadow-primary/20 !layup-relative layup-z-10 !layup-flex !layup-w-full !layup-flex-col !layup-items-start !layup-justify-center !layup-gap-2 !layup-rounded-sm  !layup-bg-background !layup-p-2  !layup-text-base !layup-shadow-md dark:!layup-text-white") ?? ""} svelte-qzlv45`);
                        var Oe = T(we), Ue = T(Oe), Fe = T(Ue);
                        pg(Fe, {
                          get text() {
                            return c(d);
                          },
                          textAlign: "left",
                          backgroundColor: "transparent",
                          textColor: "text-textPrimary",
                          padding: "!layup-p-0"
                        });
                        var qe = Q(Oe, 2), tt = T(qe);
                        Re(tt, {
                          variant: "ghost",
                          size: "sm",
                          class: "!layup-bg-background-secondary/50 !layup-pointer-events-auto !layup-h-7 !layup-rounded-sm !layup-p-2 !layup-text-primary !layup-transition-transform !layup-duration-200 hover:!layup-bg-background-secondary hover:!layup-text-primary",
                          onmousedowncapture: (Ke) => {
                            Ke.stopPropagation();
                          },
                          onclick: (Ke) => {
                            var Ae;
                            Ke.preventDefault(), Ke.stopPropagation(), (Ae = t.actorRef) == null || Ae.send({ type: "HIDE_TEXT" });
                          },
                          children: (Ke, Ae) => {
                            var re = m4();
                            _(Ke, re);
                          },
                          $$slots: { default: !0 }
                        });
                        var pt = Q(tt, 2);
                        {
                          var je = (Ke) => {
                            var Ae = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 !layup-rounded-sm !layup-bg-accent !layup-p-2 !layup-text-white !layup-transition-transform !layup-duration-300 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-accent-secondary hover:!layup-text-white hover:!layup-no-underline dark:!layup-border-[0px] dark:hover:!layup-bg-accent-secondary"));
                            Re(Ke, {
                              onmousedowncapture: (re) => {
                                re.stopPropagation();
                              },
                              onclick: (re) => {
                                var le;
                                re.preventDefault(), re.stopPropagation(), (le = t.actorRef) == null || le.send({ type: "interacted" });
                              },
                              variant: "ghost",
                              get class() {
                                return c(Ae);
                              },
                              children: (re, le) => {
                                var Pe = w4();
                                _(re, Pe);
                              },
                              $$slots: { default: !0 }
                            });
                          };
                          H(pt, (Ke) => {
                            var Ae, re;
                            (Ae = c(o)) != null && Ae.can({ type: "NEXT_STEP" }) && !((re = c(o)) != null && re.can({ type: "LAST_STEP" })) && Ke(je);
                          });
                        }
                        var Ge = Q(pt, 2);
                        {
                          var mt = (Ke) => {
                            var Ae = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 !layup-rounded-sm !layup-border !layup-border-none !layup-bg-success/90  !layup-p-2 !layup-text-white !layup-shadow-lg !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:layup-scale-105 hover:!layup-bg-success hover:!layup-text-white hover:!layup-no-underline dark:!layup-border-border dark:!layup-text-white  dark:hover:!layup-bg-success"));
                            Re(Ke, {
                              onmousedowncapture: (re) => {
                                re.stopPropagation();
                              },
                              onclick: (re) => {
                                var le;
                                re.preventDefault(), re.stopPropagation(), (le = t.actorRef) == null || le.send({ type: "LAST_STEP" });
                              },
                              variant: "ghost",
                              get class() {
                                return c(Ae);
                              },
                              children: (re, le) => {
                                var Pe = b4();
                                _(re, Pe);
                              },
                              $$slots: { default: !0 }
                            });
                          };
                          H(Ge, (Ke) => {
                            var Ae;
                            (Ae = c(o)) != null && Ae.can({ type: "LAST_STEP" }) && Ke(mt);
                          });
                        }
                        ee(() => {
                          Ve(ve, c(me)), Ve(we, c(fe));
                        }), bt(5, pe, () => Qt, () => ({ duration: 400 })), _(ge, pe);
                      };
                      H(ae, (ge) => {
                        c(l) && c(u) && ge(se);
                      });
                    }
                    _(U, ue);
                  },
                  $$slots: { default: !0 }
                });
              }), _(Y, q);
            },
            $$slots: { default: !0 }
          });
        }), _(D, A);
      };
      H(k, (D) => {
        var A, M, N;
        c(d) && ((A = c(o)) == null ? void 0 : A.value) !== "completed" && ((M = c(o)) == null ? void 0 : M.value) !== "findSelector" && ((N = c(o)) == null ? void 0 : N.value) !== "error" && D(I);
      });
    }
    _(x, E);
  }), tn(w, (x) => z(r, x), () => c(r)), _a(w, (x, E) => Eu == null ? void 0 : Eu(x, E), () => ({
    startPoint: c(n),
    targetPoint: c(s)
  })), ct("cursormove", w, h), _(e, w), _e();
}
const S4 = Uc(
  {
    initial: "idle",
    states: {
      idle: {
        on: {
          QUERY: "querying"
        }
      },
      querying: {
        invoke: {
          input: ({ event: e }) => e.query,
          id: "knowledgeQuery",
          src: "knowledgeQuery",
          onDone: {
            target: "idle",
            actions: [
              bf(({ event: e }) => ({
                type: "KNOWLEDGE_QUERY_RESPONSE",
                data: e.output
              }))
            ]
          },
          onError: {
            target: "idle",
            actions: [
              bf(({ event: e }) => ({
                type: "KNOWLEDGE_QUERY_ERROR",
                data: e.error
              }))
            ]
          }
        }
      }
    }
  },
  {
    actors: {
      knowledgeQuery: Ot(async ({ input: e }) => {
        const t = await H1(e);
        if (!t)
          throw new Error("No response from knowledge query");
        return t;
      })
    }
  }
);
function C4(e, t) {
  var n;
  if (!e || e.type !== "css") return null;
  try {
    const r = document.querySelectorAll(e.value);
    if (r.length === 1) return r[0];
    if (r.length > 1 && t && t.type === "js")
      for (const a of r) {
        const i = t.conditions;
        if (!i) continue;
        let o = !1;
        switch (i.condition) {
          case "text-contains":
            o = (n = a.textContent) == null ? void 0 : n.includes(i.value);
            break;
          case "matches":
            o = a.matches(i.value);
            break;
          case "key-exists":
            o = a.hasAttribute(i.key) && a.getAttribute(i.key) === i.value;
            break;
          default:
            o = !1;
        }
        if (o) return a;
      }
    return r[0] || null;
  } catch (r) {
    return console.error("Error processing selector:", r), null;
  }
}
const E4 = async (e, t = 5e3) => {
  const n = Date.now(), r = (a) => {
    const i = a.find(
      (l) => l.type.toLowerCase() === "css"
    );
    if (i)
      try {
        const l = document.querySelectorAll(i.value);
        if (l.length >= 1) return l[0];
      } catch (l) {
        console.error("Invalid CSS selector:", l);
      }
    const o = a.find(
      (l) => l.type.toLowerCase() === "xpath"
    );
    if (o)
      try {
        const l = document.evaluate(
          o.value,
          document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
        if (l) return l;
      } catch (l) {
        console.error("Invalid XPath selector:", l);
      }
    const s = a.find(
      (l) => l.type.toLowerCase() === "js"
    );
    if (s && i)
      try {
        const l = document.querySelectorAll(i.value);
        C4(l, s);
      } catch (l) {
        console.error("Invalid JS selector:", l);
      }
    return null;
  };
  return new Promise((a, i) => {
    const o = () => {
      const s = r(e);
      if (s)
        return a(s);
      if (Date.now() - n > t)
        return i(
          new Error(
            `Timeout waiting for element with selectors: ${JSON.stringify(e)}`
          )
        );
      const l = new MutationObserver(() => {
        const u = r(e);
        u && (l.disconnect(), a(u));
      });
      l.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0
      }), setTimeout(o, 100);
    };
    o();
  });
}, kp = async (e, t = 5e3) => Promise.all(
  e.map((n) => E4(n, t))
), Sp = async (e, t) => {
  if (e)
    return new Promise((n, r) => {
      if (!document.body.contains(e)) {
        r(new Error("Element is no longer in DOM"));
        return;
      }
      const a = new IntersectionObserver(
        (o) => {
          const [s] = o;
          if (!document.body.contains(e)) {
            a.disconnect(), r(new Error("Element was removed during scroll"));
            return;
          }
          s.isIntersecting && (a.disconnect(), n());
        },
        {
          root: null,
          // viewport
          threshold: 0.1
          // partially visible is enough
        }
      ), i = new MutationObserver(() => {
        document.body.contains(e) || (a.disconnect(), i.disconnect(), r(new Error("Element was removed during scroll")));
      });
      i.observe(document.body, {
        childList: !0,
        subtree: !0
      }), setTimeout(() => {
        a.disconnect(), i.disconnect(), n();
      }, 1200), a.observe(e), e.scrollIntoView({ behavior: "instant", block: "center" });
    });
}, gc = (e) => {
  if (e.children.length === 0)
    return 1;
  let t = 0;
  for (const n of e.children)
    t = Math.max(t, gc(n));
  return t + 1;
}, T4 = (e) => e.map((n) => {
  let r = 0;
  for (const a of n.actions)
    r = Math.max(r, gc(a));
  return gc(n.actions[0]);
});
class Pu extends Error {
  constructor(n, r, a) {
    super(r);
    Le(this, "type");
    Le(this, "subMessage");
    this.name = "CustomError", this.type = n, this.subMessage = a, Object.setPrototypeOf(this, new.target.prototype);
  }
}
const A4 = (e) => {
  if (!e) return null;
  try {
    const t = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      steps: []
    }, n = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      actions: []
    }, r = (i) => {
      const o = JSON.parse(i.metadata);
      return {
        id: i.id,
        guideText: o.message,
        waitForInput: o.wait_for_input,
        tips: o.tips,
        highlight: !0,
        type: i == null ? void 0 : i.type,
        url: o.url,
        attachEvent: o.attach_event ? [o.attach_event] : null,
        validation: o == null ? void 0 : o.validation,
        selector: [JSON.parse(i.selection_criteria)],
        criteria: {},
        dependencies: [],
        children: []
      };
    };
    let a = null;
    return e == null || e.steps.forEach((i, o) => {
      const s = r(i);
      a ? a.children.push(s) : n.actions.push(s), a = s;
    }), t.steps.push(n), t;
  } catch {
  }
}, da = (e) => {
  var t, n, r, a, i;
  if (!e) return null;
  try {
    const o = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      steps: []
    }, s = {
      name: ((t = e.flow) == null ? void 0 : t.name) || ((n = e.flow) == null ? void 0 : n.title),
      description: (r = e.flow) == null ? void 0 : r.description,
      id: (a = e.flow) == null ? void 0 : a.id,
      actions: []
    }, l = (d) => {
      const f = JSON.parse(d.metadata);
      return {
        id: d.id,
        guideText: f.message,
        waitForInput: f.wait_for_input,
        attachEvent: f.attach_event ? [f.attach_event] : null,
        tips: f.tips,
        highlight: !0,
        url: f.url,
        type: d == null ? void 0 : d.type,
        validation: f == null ? void 0 : f.validation,
        selector: [JSON.parse(d.selection_criteria)],
        criteria: {},
        dependencies: [],
        children: []
      };
    };
    let u = null;
    return (i = e == null ? void 0 : e.flow) == null || i.steps.forEach((d, f) => {
      const p = l(d);
      u ? u.children.push(p) : s.actions.push(p), u = p;
    }), o.steps.push(s), o;
  } catch {
  }
}, P4 = (e) => {
  if (!e) return !1;
  const t = [
    "is-open",
    "opened",
    "expanded",
    "-open",
    "--selected"
  ], n = [
    "data-state",
    "data-active",
    "aria-current",
    "aria-selected"
  ], r = (i) => {
    if (!i) return !1;
    if (Array.from(i.classList || []).some(
      (l) => t.some((u) => {
        var d;
        return (d = l == null ? void 0 : l.includes) == null ? void 0 : d.call(l, u);
      })
    ))
      return !0;
    for (const l of n) {
      const u = i.getAttribute(l);
      if (u && ["true", "open", "page"].includes(u))
        return !0;
    }
    return Array.from(i.children || []).some((l) => r(l));
  };
  return r(e);
};
function Cp(e) {
  const t = new URL(e), n = new URL(window.location.href);
  return t.pathname + t.search === n.pathname + n.search;
}
function Ep(e, t) {
  localStorage.setItem("new_page_flow", JSON.stringify(t));
  const n = new URL(e), r = new URL(window.location.origin);
  r.pathname = n.pathname, r.search = n.search, window.location.href = r.toString();
}
function M4(e) {
  var i, o, s, l, u, d, f, p, h, y, g, w;
  const t = {
    ...e,
    colors: JSON.parse(e.colors),
    font_family: JSON.parse(e.font_family),
    font_sizes: JSON.parse(e.font_sizes),
    icons: JSON.parse(e.icons),
    widget_variant: ((i = e.widget_variant) == null ? void 0 : i.toLowerCase()) || "compact"
  }, n = {
    ...t,
    ...(o = X.config) == null ? void 0 : o.theme,
    colors: {
      ...t.colors,
      dark_mode: {
        ...(s = t.colors) == null ? void 0 : s.dark_mode,
        ...(d = (u = (l = X.config) == null ? void 0 : l.theme) == null ? void 0 : u.colors) == null ? void 0 : d.dark_mode
      },
      light_mode: {
        ...(f = t.colors) == null ? void 0 : f.light_mode,
        ...(y = (h = (p = X.config) == null ? void 0 : p.theme) == null ? void 0 : h.colors) == null ? void 0 : y.light_mode
      }
    }
  }, r = window.matchMedia("(prefers-color-scheme: dark)"), a = ((g = X.config.theme) == null ? void 0 : g.mode) === "system" ? n.colors[`${r.matches ? "dark" : "light"}_mode`] : n.colors[`${(w = X.config.theme) == null ? void 0 : w.mode}_mode`];
  return X.config.styles = ks(
    n,
    a
  ), Ss(n, a), r.addEventListener("change", (m) => {
    if (localStorage.getItem("layup-widget-theme") === "system") {
      const v = document.getElementById("layup-app");
      if (m.matches) {
        v == null || v.setAttribute("data-layup-mode", "dark");
        const C = n.colors.dark_mode;
        X.config.styles = ks(
          n,
          C
        ), Ss(n, C);
      } else {
        v == null || v.setAttribute("data-layup-mode", "light");
        const C = n.colors.light_mode;
        X.config.styles = ks(
          n,
          C
        ), Ss(n, C);
      }
    }
  }), X.config.variant = n.widget_variant, X.config.theme = n, n;
}
const Wn = Uc(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5RQK4EsJgLIEMDGAFmgHZgCCeALgPYBOAxAMoDCASgPIAynA+gCrseAUU5CsQgHJ8A2gAYAuolAAHarDSU01YkpAAPRACYAjIYDsAOgAcAZgCcZ2WeM2AbIbt2ANCACeR2QAWCztZdzMzQLsAVmNZOOiAX0SfVAxsfCJSChoGRgAJdgB1fgBJAAVGOUUkEFV1TW1dAwQTY2iLaKdXHq6raKsrH38EU2TU9ExcQhJyKjp6fNKAESEyyurdeo0tHVqWkxNOrtd7ZytXWSG-I0N4i2NjM3NowLigs1dxkDSpzNmcgsCsV+EIABoyBRbNQ7Jr7AIxCyBQbGQJhGxvQyuaLDRBxKxI6I2FxWSJmaJdInfX4ZGbZeYMJarUEQza1baNPagA6PYwhZ6vKyGcyBCm41oeSzRRxvN7S6J2KzUya0rJzXL0PhCVhYUoSMhatkqGGc5qIOyGcWBVyWYmGSmBZyXezK9LTNWAvJsLi8ACq5SNdRNuzNrWMPQsNjOhlFsjspzM4pjoSRn1cdnD0Sxnldfzp6qB3u4PGWxQkgY5IfhYazD2RdruhhssjFN1a9mCsibFI8LdRdlzqoBDPo5TIvsYQgrwbh3PNlrbNkc1gVbhtMZbUa+KR+Kvdw9yFjAtFoC3KE-y04aVbnCDcgWC7UuQVC8Qc4tRRKRzeFjuMVkCYlB33elD2PU8GAAITIZgAGkr1hLl9EQKMLgsVxw08IJmy3HE23DexrFsGxzGbOwbCseNgP+UC6CPE8FlYIRGD4MhWEhGpjWvWdkLva07E6CjQgxQCoh6cUYkMSNyVkNwhSiMxBmo-NPXoiD6HBUoOOhbikJaCjm0jYSAM8U54g-BVZCIqNiUuKxM2Uj0GQsPBqAAW2UAAbMBKEgegmJYtjtPZGc9LxNECUGEVZKbU503FVxBgsGMTE8IVHG3CY3RogtaBc9yvJ8vzNOCrjENDf8AOsUwfwxRLTgSpKUuMNLzDCRyDzo1yPO83yIFHdhGC00oADUpyhELdIq9wOk8QC4scRtjHFAZXAsT5olOKw43I0lDA62i8u6wq+voCQhAAcQNUbxs4oMpurcMm3W0kSIfQJYvMK0UztKJyNiWxsSSHcaRA3KXJQWhYDoUoIG8+gIG0MALBIAA3agAGtkZIDRylChDTUewZgnspsuzqi4bA-S4pJtUUoniQCEgO8GYEoHJdgRpGUeIdGsYsNmOe0Amb140wPBCFxyJbAZhUTNtFOCdMiQo6VrTiTLd2ylTnMFqhOcR0geb55G9c5aRjDuyseJababEjBUPFFSiNY-a0CU+Pt+KjQxbBZ1SzYN7m0cx02fKF4hpEMK3Qoq4UBIzexmwpIUvvwgYBJasx417exZHif3dfD-XtC5o2Q-5wPhZsGOHtvcWE6l5PZbTkYXAVCwnHsmbSSuUVC8PKviHocC6K8nBKAAMzoNyBeL82JrKwn6-jyWk5l1P5bb0wrOlezBgpbPIgHuiccoZhIehhgz4vqGYeIWBKBwYg8DAEWbYRSxSY8Nw7EdPuLKoheqYeM9gMybUCCfPKN9L4LDwLA2gWBqCo0gO-MK7YsTJTMG9WyzsIjU0Ik2B8lUm5ZigXPSgmhiBQEYE-Wgp09CPwnsjHAk9fK0AABTvFkAASnoKDHKAcfJUJoXQvqaDQzJntmiEwrhkTkkUstdORw97tAikSZE+0QZ7kEUXShJBRE4HoX5RhT9fIWFYewrhXReH8J0TrQewiDG0KMeIxe91yrVixKKfkcV86onsNcNucjLCKneqhcMLZNYCIcXRSeJAICMDAN5Echtsa81DhYeJxBEnJLAAyCRXi5GzU+G4fxgFFQfibAJIU9lyTSntD-ch2TckpI1Gk42mSWlJLaXQC2tdPG3hsmtb+m1FLYgfB+RS9tAYPnzhcFsThmkJJ6fkjUo88rjynjPLJKy8kFPcdbdBwzqrCjGRcV4gQLIWkjMRIkvsuyKTMOQ2AeBTyeU8nwagQhvJuTAMQSgZd0kmwsK895nzvm-P+ZQQpQzbBWTzhRP6ZklFtwiHyFqxJXpXAcBRF5bzqAfK+T8sAfyAVAs6fzMFhKIUkrJTCy2OlBm8QMgi4yyLmyorxDaSwkR84ZlCJtPo+LwXEqheSjZFgtnT1oLPalRLIWkuhbCllH1M5bTcHEYkFEpluEjPeHoUS-7kLcsgsAt8r70HgXfRBZqIAqpaBFXlCkIjplMIBKmbY7jPHQnIlwPR3AKXIdQAARrAY8KC6XQvoCgZQEBmF410g68Klh4iYQ+i2ACcQFxtz-lJQC5I7agPtEqbR2snKHlDeG2gkbxWAryfSzgagYWHNjtWZEVlrRXCFFmGyFopn2RCABN4jwbS2F9sGsNEawBRvJSQdh+A3EDOXrxDtSI7I9qbFGft6cbTJSXLJZsnwIg2GBllPMFa6JVunbOwF50IQ8BYkIAMra66ru2uu7tjS+05rxOOpEw7favEeM4LR56hyHQsNemtM662jiYiNUo7AJyPq1C+5dotHUfq7VFXt27f2jAtASci5J1yDGeO0Sd1ba1KvJZwMgLFUPPuTQgNdOHN0-pWg+ToT5myihIgBUtO5iDUEwPAWoMTL20CZSux1VyvW2AdrtNWjNnllovZ1PKGyZOYZQnI4IkQWoDEZpRK4FlXjWTcHVBU9kbDkOOr1SAOmP6jAVB0RK0pyIWnlBcRqBITCkk+ABdMS41PgbBqpMAegNDOfQR9a0IQnZvENRhPCIxnCdsSsevaPbjD2YQbDbysWKoDE7P0bOyIYiyTCNTe47RHjYXcE4B85Ch7FerP0BOXYXgaLqlvPEYzkr+vePGbELhyEwJte128dx3Cd0cGEQLp72gEfDOGfdD5lvWkcGFrWGnINsxES44xEBpu8RjP0QkvZnDbtXNTBLYSPpPDjFEJ4yycmrIZGd-S8QCSolkvVT8gwpkWZ6M2fOXZUSfDy+piD4N5W0rrd9vTURrDjKFYnRKnq0WJWsKA7V7RBOlvC7ow8pqUEWroMj1jMY1oWj-sly4qWPzbUfNaX6GIlw9CozepHk1mUtB3SMO4gE8dOBagE0kcjkjJCAA */
    id: "guideMachineActor",
    context: ({ input: e, self: t, spawn: n }) => ({
      id: (e == null ? void 0 : e.id) || (e == null ? void 0 : e.guidanceFlow.id),
      steps: e == null ? void 0 : e.guidanceFlow.steps,
      knowledgeFetching: !1,
      guidanceFlow: e == null ? void 0 : e.guidanceFlow,
      progressSteps: T4(e == null ? void 0 : e.guidanceFlow.steps),
      query: e == null ? void 0 : e.query,
      currentStepIndex: (e == null ? void 0 : e.currentStepIndex) || 0,
      currentSelection: (e == null ? void 0 : e.currentSelection) || null,
      currentActionsMap: (e == null ? void 0 : e.currentActionsMap) || [],
      feedback: !1,
      firstCursorMoved: !1,
      flowStatus: e == null ? void 0 : e.flowStatus,
      feedbackStatus: "null",
      error: null,
      knowledgeMessage: [],
      knowledgeMachine: n(S4, { id: "knowledgeMachine" }),
      showKnowledge: !1,
      showText: !0,
      theme: e == null ? void 0 : e.theme,
      status: null,
      tips: !1,
      notify: "",
      currentElements: [],
      attachEvent: null,
      scrollUp: !1,
      scrollDown: !1,
      query_id: e == null ? void 0 : e.query_id,
      flow_id: e == null ? void 0 : e.flow_id,
      cursorInstance: null,
      position: {
        x: 0,
        y: 0
      },
      popoverSide: "right",
      isMoving: !1,
      text: "",
      initCursorCheck: !1,
      action: null,
      visible: !1,
      currentElement: null,
      highlightedElement: null
    }),
    initial: "getAction",
    states: {
      error: {
        entry: ["setError", "setStatus"],
        invoke: {
          id: "updatePosition",
          src: Es(({ sendBack: e }) => {
            setTimeout(() => {
              e({ type: "updatePosition" });
            }, 400);
          })
        },
        on: {
          updatePosition: {
            actions: "updatePositionToBack"
          },
          RELOAD: {
            guard: "canReload",
            actions: ["reloadToFirstStep"]
          },
          BACK: {
            target: "findSelector",
            guard: "canPreviousAction",
            actions: ["backStep"]
          },
          RESTART: {
            target: "getAction",
            actions: ["restartContext"]
          },
          EXIT: {
            target: "exit"
          }
        }
      },
      completed: {
        entry: [
          "clearLocalStorage",
          ie({
            showKnowledge: !1,
            showText: !0,
            tips: !1,
            scrollUp: !1,
            scrollDown: !1,
            notify: "",
            knowledgeMessage: []
          })
        ],
        on: {
          RESTART: {
            target: "getAction",
            actions: ["restartContext"]
          },
          EXIT: {
            actions: ["removeCursor"],
            target: "exit"
          },
          POSITIVE: {
            actions: ["positiveFeedback"]
          },
          NEGATIVE: {
            actions: ["negativeFeedback"]
          }
        }
      },
      waitBeforeObserve: {
        after: {
          400: {
            target: "findSelector"
          }
        }
      },
      exit: {
        always: {
          actions: ["updateQueryStatus"]
        },
        type: "final"
      },
      cursorIdle: {
        invoke: {
          id: "initPosition",
          src: "getInitPosition",
          onDone: {
            actions: ie({
              position: ({ event: e }) => e.output
            }),
            target: "initCursor"
          }
        }
      },
      getAction: {
        entry: ["setLocalStorage"],
        invoke: {
          id: "getAction",
          src: "getAction",
          input: ({ context: e }) => e,
          onError: {
            target: "error"
          },
          onDone: [
            {
              guard: "statusCompleted",
              target: "completed",
              actions: ["setStatusCompleted", "clearContext"]
            },
            {
              guard: "checkCompletedStep",
              actions: ["nextStep"],
              target: "getAction",
              // Reattempt getting the next action
              reenter: !0
            },
            {
              actions: ["setActions"],
              guard: Mr(["actionAvailable", "isInitCursor"]),
              target: "cursorIdle"
            },
            {
              actions: ["setActions"],
              guard: "actionAvailable",
              target: "waitBeforeObserve"
            }
          ]
        }
      },
      initCursor: {
        invoke: {
          id: "initCursor",
          src: "initCursor",
          input: ({ self: e, context: t }) => ({
            self: e,
            context: t
          })
        },
        on: {
          initCursorInstance: {
            actions: ie({
              cursorInstance: ({ event: e }) => e.data
            })
          },
          cursorMoved: {
            target: "gettingStarted"
          }
        }
      },
      gettingStarted: {
        after: {
          100: {
            actions: [
              "makeVisible",
              ie({
                initCursorCheck: !0
              })
            ]
          },
          500: {
            target: "findSelector"
          }
        }
      },
      findSelector: {
        invoke: {
          id: "findSelector",
          src: "findSelector",
          input: ({ context: e }) => ({
            currentAction: e.currentActionsMap[e.currentActionsMap.length - 1],
            currentActionsMap: e.currentActionsMap
          }),
          onDone: [
            {
              guard: "checkElementOpen",
              target: "getAction"
            },
            {
              actions: ie({
                currentElement: ({ event: e }) => e.output.elements[0]
              }),
              target: "scrollToElement"
            }
          ],
          onError: {
            target: "error"
          }
        }
      },
      scrollToElement: {
        invoke: {
          id: "scrollToElement",
          src: Ot(async ({ input: e }) => {
            var o, s, l, u, d, f;
            await Sp(e.event.output.elements[0]);
            const n = ((s = (o = e == null ? void 0 : e.event) == null ? void 0 : o.output) != null && s.attachEvent ? (u = (l = e == null ? void 0 : e.event) == null ? void 0 : l.output) == null ? void 0 : u.attachEvent : (f = (d = e == null ? void 0 : e.event) == null ? void 0 : d.output) == null ? void 0 : f.elements[0]).getBoundingClientRect(), r = 16, a = n.right - r, i = n.bottom - r;
            return {
              element: e.event.output.elements[0],
              position: {
                x: a,
                y: i
              },
              action: e.context.currentActionsMap[e.context.currentActionsMap.length - 1],
              attachEvent: e.event.output.attachEvent
            };
          }),
          input: ({ context: e, event: t }) => ({
            context: e,
            event: t
          }),
          onDone: [
            {
              actions: ["setElement", "updatePopoverSide"],
              target: "observeElement"
            }
          ],
          onError: {
            target: "findSelector"
          }
        }
      },
      observeElement: {
        invoke: {
          id: "observeElement",
          src: "observeElement",
          input: ({ context: e }) => e
        },
        on: {
          cursorMoved: {
            guard: ({ context: e }) => !(e != null && e.firstCursorMoved),
            actions: [
              ie({
                text: ({ context: e }) => {
                  var t;
                  return (t = e == null ? void 0 : e.action) == null ? void 0 : t.guideText;
                },
                firstCursorMoved: !0
              }),
              "log"
            ]
          },
          updatePosition: {
            guard: ({ event: e, context: t }) => {
              var a, i, o, s, l;
              const n = !t.position || Math.abs(((a = e.data) == null ? void 0 : a.x) - ((i = t.position) == null ? void 0 : i.x)) > 1 || Math.abs(((o = e.data) == null ? void 0 : o.y) - ((s = t.position) == null ? void 0 : s.y)) > 1, r = ((l = e.data) == null ? void 0 : l.popoverSide) !== t.popoverSide;
              return n || r;
            },
            actions: ["updatePositionAndPopover"]
          },
          elementLost: {
            target: "findSelector"
          },
          interacted: {
            actions: [
              "clearText",
              ie({
                firstCursorMoved: !1
              })
            ],
            target: "getAction"
          },
          NEXT_STEP: {
            actions: ie({
              currentStepIndex: ({ context: e }) => e.currentActionsMap[e.currentActionsMap.length - 1].children.length === 0 ? e.currentStepIndex + 1 : e.currentStepIndex,
              currentActionsMap: ({ context: e }) => e.currentActionsMap[e.currentActionsMap.length - 1].children.length === 0 ? [
                e.steps[e.currentStepIndex + 1].actions[0]
              ] : [
                ...e.currentActionsMap,
                e.currentActionsMap[e.currentActionsMap.length - 1].children[0]
              ]
            }),
            guard: "canNextAction",
            target: "#guideMachineActor.findSelector"
          },
          PREVIOUS_STEP: {
            actions: ie({
              currentActionsMap: ({ context: e }) => e.currentActionsMap.slice(0, -1)
            }),
            guard: "canPreviousAction",
            target: "#guideMachineActor.findSelector"
          },
          LAST_STEP: {
            guard: "isLastStep",
            actions: ["setStatusCompleted"],
            target: "#guideMachineActor.completed"
          }
        }
      }
    },
    on: {
      HIDE_KNOWLEDGE: {
        actions: [
          ie({
            showKnowledge: !1
          })
        ]
      },
      SHOW_KNOWLEDGE: {
        actions: [
          ie({
            showKnowledge: !0
          })
        ]
      },
      sendTipsMessage: {
        actions: [
          ie({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "user",
                content: t.data.title
              },
              {
                role: "assistant",
                content: t.data.description
              }
            ]
          })
        ]
      },
      sendKnowledgeMessage: {
        guard: ({ context: e }) => e.showKnowledge,
        actions: [
          ie({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "user",
                content: t.data
              }
            ],
            knowledgeFetching: !0
          }),
          "sendKnowledgeMessage"
        ]
      },
      KNOWLEDGE_QUERY_RESPONSE: {
        actions: [
          ie({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "assistant",
                content: t.data.answer,
                show_animation: !0,
                source: t.data.source
              }
            ],
            knowledgeFetching: !1
          })
        ]
      },
      KNOWLEDGE_QUERY_ERROR: {
        actions: [
          ie({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "assistant",
                content: "No knowledge found",
                source: null
              }
            ],
            knowledgeFetching: !1
          })
        ]
      },
      SCROLL_TO_ELEMENT: {
        actions: ["scrollToElement"]
      },
      SHOW_TIPS: {
        guard: "tipsPresent",
        actions: [
          ie({
            tips: !0
          })
        ]
      },
      HIDE_TIPS: {
        guard: "tipsPresent",
        actions: ie({
          tips: !1
        })
      },
      SHOW_TEXT: {
        guard: "textNotDisplayed",
        actions: ["setShowTextTrue"]
      },
      HIDE_TEXT: {
        guard: "textDisplayed",
        actions: ["setShowTextFalse"]
      },
      TERMINATE: {
        target: ".completed",
        actions: ["setStatus", "clearContext"]
      },
      SCROLL_UP: {
        actions: ie({
          scrollUp: ({ event: e }) => e.scrollUp
        })
      },
      SCROLL_DOWN: {
        actions: ie({
          scrollDown: ({ event: e }) => e.scrollDown
        })
      },
      PAUSE: {
        actions: ["setStatus"],
        target: ".exit"
      }
    },
    output: ({ context: e }) => ({
      id: e.id,
      status: e.status,
      query: e.query,
      feedbackStatus: e.feedbackStatus,
      error: e.error,
      steps: e.steps,
      flowStatus: e.flowStatus,
      query_id: e.query_id,
      flow_id: e.flow_id,
      progressSteps: e.progressSteps,
      guidanceFlow: e.guidanceFlow,
      currentStepIndex: e.currentStepIndex,
      currentSelection: e.currentSelection,
      currentActionsMap: e.status === "PAUSE" ? e.currentActionsMap.slice(0, -1) : e.currentActionsMap
    })
  },
  {
    actors: {
      observeElement: Es(({ input: e, sendBack: t }) => {
        const n = e == null ? void 0 : e.currentElement;
        if (!n) return;
        const r = e == null ? void 0 : e.currentActionsMap[(e == null ? void 0 : e.currentActionsMap.length) - 1], a = e == null ? void 0 : e.attachEvent, i = n, o = /* @__PURE__ */ new Set();
        let s = !1, l = null, u = null, d = null;
        const f = () => {
          d || (d = document.createElement("layup-overlay"), d.classList.add("layup-virtual-pointer"), document.body.appendChild(d)), p();
        }, p = () => {
          if (!d || !i) return;
          const b = i.getBoundingClientRect(), x = 4;
          d.style.top = `${b.top - x}px`, d.style.left = `${b.left - x}px`, d.style.width = `${b.width + x * 2}px`, d.style.height = `${b.height + x * 2}px`;
        }, h = {
          click: () => {
            (!r.waitForInput || a) && t({ type: "interacted" });
          },
          scroll: () => {
            l || (l = setTimeout(() => {
              y(), p(), l = null;
            }, 16));
          },
          resize: () => {
            u || (u = setTimeout(() => {
              y(), p(), u = null;
            }, 100));
          }
        }, y = () => {
          if (!i || !document.body.contains(i)) {
            s || (s = !0, t({ type: "elementLost" }));
            return;
          }
          const x = (a || i).getBoundingClientRect(), E = 24, k = 24, I = 30, D = window.innerWidth, A = x.right / D;
          let M;
          const N = A > 0.7 ? "left" : "right";
          N === "left" ? M = Math.min(x.right - E, x.left + E) : M = Math.max(x.left + E, x.right - E);
          let P = x.bottom - k;
          x.top < window.innerHeight && x.bottom > 0 && x.left < window.innerWidth && x.right > 0 && x.bottom > window.innerHeight && (P = Math.min(
            window.innerHeight - I,
            x.bottom - k
          ), P = Math.max(x.top + k, P)), s = !1, t({
            type: "updatePosition",
            data: {
              x: M,
              y: P,
              popoverSide: N
            }
          });
        };
        r != null && r.waitForInput && f();
        const g = a || i;
        let w;
        const m = (b) => {
          if (r.waitForInput && !a) return;
          const x = b.target.value;
          if (r.validation && new RegExp(r.validation.regex).test(x)) {
            clearTimeout(w), t({
              type: "interacted",
              data: x
            });
            return;
          }
          clearTimeout(w), w = setTimeout(() => {
            t({
              type: "interacted",
              data: x
            });
          }, 2e3);
        };
        (r == null ? void 0 : r.type) === "Type" ? g.addEventListener("input", m, { passive: !0 }) : (r == null ? void 0 : r.type) === "Click" && g.addEventListener("click", h.click);
        const C = (() => {
          const b = new IntersectionObserver(
            (E) => {
              E[0].isIntersecting || y();
            },
            {
              root: null,
              // viewport
              threshold: 0.1
              // trigger when at least 10% is visible
            }
          );
          b.observe(i), a && b.observe(a);
          const x = (E) => {
            if (!E) return;
            const k = (D) => {
              const A = window.getComputedStyle(D), M = A.getPropertyValue("overflow-y"), N = A.getPropertyValue("overflow-x");
              return M === "auto" || M === "scroll" || N === "auto" || N === "scroll";
            };
            let I = E.parentElement;
            for (; I; ) {
              if (k(I) && !o.has(I)) {
                o.add(I), I.addEventListener("scroll", h.scroll, {
                  passive: !0
                });
                break;
              }
              I = I.parentElement;
            }
          };
          return x(i), a && x(a), () => {
            b.disconnect(), o.forEach((E) => {
              E.removeEventListener("scroll", h.scroll);
            });
          };
        })(), S = new MutationObserver((b) => {
          for (const x of b) {
            if (x.type === "childList" && Array.from(x.removedNodes).some(
              (k) => k === i || k instanceof Element && k.contains(i)
            )) {
              t({ type: "elementLost" });
              return;
            }
            p();
            break;
          }
        });
        return window.addEventListener("resize", h.resize, { passive: !0 }), window.addEventListener("scroll", h.scroll, { passive: !0 }), S.observe(document.body, {
          childList: !0,
          subtree: !0,
          attributes: !1
          // Only watch for DOM changes, not attribute changes
        }), y(), () => {
          (r == null ? void 0 : r.type) === "Type" ? (g.removeEventListener("input", m), clearTimeout(w)) : (r == null ? void 0 : r.type) === "Click" && g.removeEventListener("click", h.click), d && (d.remove(), d = null), S.disconnect(), window.removeEventListener("resize", h.resize), window.removeEventListener("scroll", h.scroll), clearTimeout(l), clearTimeout(u), C();
        };
      }),
      getInitPosition: Ot(async () => {
        await new Promise((n) => setTimeout(n, 100));
        const e = document.getElementById("layup-widget");
        if (!e)
          return { x: 0, y: 0 };
        const t = e.getBoundingClientRect();
        return {
          x: t.left + t.width / 2,
          y: t.top + t.height / 2
        };
      }),
      initCursor: Es(({ input: e, sendBack: t }) => {
        var r;
        const n = Mc(k4, {
          target: document.body,
          props: {
            actorRef: e == null ? void 0 : e.self,
            initialPosition: (r = e == null ? void 0 : e.context) == null ? void 0 : r.position
          }
        });
        t({ type: "initCursorInstance", data: n });
      }),
      findSelector: Ot(async ({ input: e }) => {
        const { currentAction: t, currentActionsMap: n } = e;
        try {
          const r = await kp(t.selector);
          let a = null;
          if (t.attachEvent)
            try {
              a = await kp(t.attachEvent);
            } catch (i) {
              console.warn("Failed to find attach event elements:", i), a = null;
            }
          return {
            elements: r,
            selector: t.selector[0][0],
            attachEvent: a ? a[0] : null
          };
        } catch {
          throw n.length === 1 ? new Pu(
            "FirstElementNotFound",
            "It looks like you off the path",
            "Do you want to restart?"
          ) : new Pu(
            "ElementNotFound",
            "Hmm... Something went wrong.",
            `Try going back and letting ${X.config.name} retry.`
          );
        }
      }),
      getAction: Ot(async ({ input: e }) => {
        try {
          const {
            currentStepIndex: t,
            steps: n,
            currentSelection: r,
            currentActionsMap: a
          } = e;
          if (n.length === t)
            return { status: "completed" };
          if (a.length === 0)
            return { action: n[t].actions[0] };
          const i = a[a.length - 1];
          return i.children.length === 0 ? { status: "completedStep" } : i.children.length === 1 ? { action: i.children[0] } : { action: i.children.find(
            (s) => s.id === i.criteria[r]
          ) || null };
        } catch {
          throw new Pu(
            "InternalError",
            "We might have encountered Machine Error",
            "Please try again"
          );
        }
      })
    },
    actions: {
      updateQueryStatus: async ({ context: e }) => {
        if (console.log("updateQueryStatus", e, e == null ? void 0 : e.feedbackStatus), !e || e != null && e.error) {
          await ef(e.query_id, "Failed");
          return;
        }
        (e == null ? void 0 : e.feedbackStatus) !== "negative" && !(e != null && e.error) && await ef(e.query_id, "Engaged"), e != null && e.query_id && (e != null && e.flow_id) && await j1({
          flow: e.flow_id,
          query: e.query_id,
          had_full_run: e.status === "completed",
          from_cache: !1,
          is_helpful: e.feedbackStatus === "positive"
        });
      },
      updatePositionToBack: ie({
        position: () => {
          const e = document.getElementById("error-button");
          if (e) {
            const t = e.getBoundingClientRect();
            return {
              x: t.left + t.width / 2,
              y: t.top + t.height / 2
            };
          }
          return { x: 0, y: 0 };
        }
      }),
      reloadToFirstStep: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        t != null && t.url && (window.location.href = t.url);
      },
      sendKnowledgeMessage: ({ context: e, event: t }) => {
        e.knowledgeMachine.send({
          type: "QUERY",
          query: t.data
        });
      },
      setLocalStorage: ({ context: e }) => {
        var n;
        const t = {
          id: e.id,
          query: e.query,
          flow_id: e.flow_id,
          query_id: e.query_id,
          currentStepIndex: e.currentStepIndex,
          currentSelection: e.currentSelection,
          currentActionsMap: (n = e.currentActionsMap) == null ? void 0 : n.map((r) => {
            var a;
            return {
              ...r,
              tips: (a = r.tips) == null ? void 0 : a.map((i) => ({
                title: i.title,
                content: i.content
              }))
            };
          }),
          guidanceFlow: e.guidanceFlow
        };
        localStorage.setItem(
          "incomplete_flow",
          JSON.stringify(t)
        );
      },
      clearLocalStorage: () => {
        localStorage.removeItem("incomplete_flow");
      },
      removeCursor: ({ context: e }) => {
        const t = e.cursorInstance;
        ju(t);
      },
      clearText: ie({
        text: ""
      }),
      updatePosition: ie({
        position: ({ event: e }) => e.data.position,
        popoverSide: ({ event: e }) => e.data.popoverSide
      }),
      makeVisible: ie({
        visible: !0
      }),
      makeInvisible: ie({
        visible: !1
      }),
      setText: ie({
        text: ({ event: e }) => e.data
      }),
      setHighlightedElement: ie({
        highlightedElement: ({ event: e }) => e.data
      }),
      scrollToElement: async ({ context: e }) => {
        const t = e.currentElement;
        t && await Sp(t);
      },
      setShowTextTrue: ie({
        showText: !0
      }),
      setShowTextFalse: ie({
        showText: !1
      }),
      setStatusCompleted: ie({
        status: "completed"
      }),
      backStep: ie({
        currentActionsMap: ({ context: e }) => e.currentActionsMap.slice(0, -1)
      }),
      setStatus: ie({
        status: ({ event: e }) => e.type
      }),
      setError: ie({
        error: ({ event: e }) => {
          var t, n;
          return {
            message: e.error.message,
            subMessage: (t = e.error) == null ? void 0 : t.subMessage,
            type: (n = e.error) == null ? void 0 : n.type
          };
        }
      }),
      clearError: ie({
        error: null
      }),
      positiveFeedback: ie({
        feedback: !0,
        feedbackStatus: "positive"
      }),
      negativeFeedback: ie({
        feedback: !0,
        feedbackStatus: "negative"
      }),
      restartContext: ie({
        currentStepIndex: 0,
        currentActionsMap: []
      }),
      nextStep: ie({
        currentStepIndex: ({ context: e }) => e.currentStepIndex + 1,
        currentActionsMap: []
      }),
      setActions: ie({
        currentActionsMap: ({ event: e, context: t }) => [
          ...t.currentActionsMap,
          e.output.action
        ]
      }),
      log: ({ context: e, event: t }) => console.log("log guide-machine", e, t),
      clearContext: ie({
        currentStepIndex: 0,
        currentActionsMap: []
      }),
      updateClampedPosition: ie({
        position: ({ context: e, event: t }) => {
          const a = t.data || e.position, i = 400 / 2;
          let o = "right", s = a.x;
          return a.x > window.innerWidth - i ? (o = "left", s = a.x - 30) : a.x < i && (o = "right", s = a.x + 30), e.popoverSide = o, {
            x: s,
            y: a.y
          };
        },
        popoverSide: ({ context: e }) => e.popoverSide
      }),
      setElement: ie({
        currentElement: ({ event: e }) => e.output.element,
        attachEvent: ({ event: e }) => e.output.attachEvent,
        action: ({ event: e }) => e.output.action
      }),
      setElementPosition: ie({
        position: ({ event: e }) => e.output.position
      }),
      updatePositionAndPopover: ie({
        position: ({ event: e }) => ({
          x: e.data.x,
          y: e.data.y
        }),
        popoverSide: ({ event: e }) => e.data.popoverSide
      }),
      updatePopoverSide: ie({
        popoverSide: ({ event: e, context: t }) => {
          const n = t.element;
          return n && n.getBoundingClientRect().right / window.innerWidth > 0.7 ? "left" : "right";
        },
        position: ({ event: e, context: t }) => {
          var y;
          const n = (y = e.output) == null ? void 0 : y.position;
          if (!n) return t.position;
          const r = t.element;
          if (!r) return n;
          const a = r.getBoundingClientRect(), i = window.innerHeight, o = 24, s = 24, l = 30, u = a.width, d = window.innerWidth, f = a.right / d;
          let p;
          if (f > 0.7) {
            const g = (f - 0.7) / 0.3;
            p = a.left + u * (1 - g) - o;
          } else
            p = a.right - o;
          const h = Math.max(
            a.top + s,
            Math.min(
              a.bottom - s,
              Math.min(i - l, n.y)
            )
          );
          return {
            x: p,
            y: h
          };
        }
      })
    },
    guards: {
      canReload: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t == null ? void 0 : t.url;
      },
      isInitCursor: ({ context: e }) => !e.initCursorCheck,
      checkElementOpen: ({ event: e }) => P4(e.output.elements[0]),
      tipsPresent: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t && Array.isArray(t.tips) && t.tips.length > 0;
      },
      textNotDisplayed: ({ context: e }) => !e.showText,
      textDisplayed: ({ context: e }) => e.showText,
      checkCompletedStep: ({ event: e }) => e.output.status === "completedStep",
      actionAvailable: ({ event: e }) => !!e.output.action,
      statusCompleted: ({ event: e }) => e.output.status === "completed",
      completedSteps: ({ context: e }) => e.currentStepIndex >= e.steps.length,
      canNextAction: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t ? t.waitForInput ? !0 : t.type === "Click" ? !1 : t.children.length === 1 || t.children.length === 0 && e.currentStepIndex < e.steps.length - 1 : !1;
      },
      isLastStep: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return e.currentStepIndex === e.steps.length - 1 && t.children.length === 0;
      },
      canPreviousAction: ({ context: e }) => e.currentActionsMap.length > 1,
      firstError: ({ context: e }) => {
        var t;
        return ((t = e.error) == null ? void 0 : t.type) === "FirstElementNotFound";
      },
      canNextStep: ({ context: e }) => e.currentStepIndex < e.steps.length,
      shouldUpdatePopoverSide: ({ event: e }) => {
        const t = e.output.position, r = 400 / 2;
        return t.x > window.innerWidth - r || t.x < r;
      }
    }
  }
), I4 = Uc(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QFcCWBaAtgQwMYAtUA7MAYn2yIgBswBlMMAQWuoFUAHCbAFzgG0ADAF1EoDgHtYqHqglExIAJ6J0ARgDsAVgA0IAB6IAzABY1agHQAmABxqAnPYBsJrVe2CNAXy960WPEISckoaMAAxMF5kACcBEUVJaVl5RUMEEys9FQQ7Cy1BQsFnNUEtGyMNIx8-DBwCYjIKKloAeSIAIwlsGIhiKCFRJBAkmTkFYfTM7MQrcxMLGy17VyXXdxsakH96oKbQ2gBFZDAYpUHEqTHUycRp5TvzQXzBCvMKotctncDG0j4YphiLwwBdhqMUhNQFMsg8EGonBoFlZBEYEfYbBoNEtvL5tnVfiQLMQxthqKgAF79YlEGSkCDyMA0gBuEgA1kySbIyZTQQlwVdIWljOVrPYNII1DZ7FoTOLUTMEFYCvYLM4bJjlpUqjLvgSGkSuageVSiFAaXSGYaiKyORbueSKaC1ENxILxsKEEYnDYxRKpTK5RKjIrtE41RonD7JUZbJG9QEDZzaQ7KdSufTGSz2cnSY7QVZXSN3TdQDkseGtNirO4oxpbCGDI8tItbGplQndo17cbHemU6RTjEJDELBxqLwAGYjzA9k18osQj23L0+v2S6Wy+WNnI2OVqqwY0o+2UaRydwm51NOgASqFgPBHSkHsFwYLdyWX0NmZlVmRrNgbii2iKrGSIWEYWgOO4Rj2MUZRaBeSZzvmd4Pk+9qZtatpXr2vJoY+ZzvsWn6lk2SomMUFj-rYQGeLocKVFoRgQbYJg2C4TimNiSF7Ch+H3oRSiYUOI5jhOPDToC-G3oJT7EUuZHpFYv7UTWtFSsBDE5EYlTPEYghyvYaJIipSy8d2RrzgRGEQGAtB8FhyY4RYdkOWANlEfyH7XFC5FSvu9hzNKh5OGokFlKBuksbGSzmO47zVHiPzIVZqFyWcrn2WAjmiaO45TjOWXuZ55zeSRvmegFqpBQGoXhQU2nGCp+naFYulWE4zFLEltSJnxhDoWc9LZXwCkln5ymUX+6mAZp9GgRKVitnuVZuMxLhWBZRKDUJpBxOgMTIEQ42kZNiBOLCOl7uGbaRiYJhOEF8bJfqA0Zc+cBvuVinnUqVTLYiNbevdryRYxqILEF7Vxmo5T2Go21MrtT6kLAUQxAQp2VSuMGA-W7WIi4YNNRksbIuYBnGRiJj1kjFgo8NYD6DI2NCrjpkWEDhOg4BpNogZizaLBD2OO1Jj0+jPQEKVTnZnaUuY-gpVs1+5HuJkXMEyDxN84qmRotY5SxpdjiCJd9PIFwIKwBY8hdD0fRmnLxAuWlvLtA7vT9KrZE5GYkZazdhkOJoTh6OkWiimolGXYhr39d2VvcHwtv2903vO3l4mFdJ7tOp7GdOwMP0TYo-th0Hj0hwjkYR4gUe+jH5sdgnXZEsnNsWJOUQ8LEcAuzaOYyREvf97Avt+f7kFN9i1e-mH9cIG4lhtq3fXt0ynep93Y9xLAg4xMO+USVJs756P0T75P5d3DPFiaMHC91+RK-WHY6-4onhphMSYSkFANAdkb64w4s8Q8EonCeARNAxU7VDZaDjkYTE4pES4g3peP+tAsFkHTo7EB34lRgPXFAjQMCyGKjhpKCCBklhVkjNGdBX9N44JwaQHuV8FyXDOp6WwUCSHQNIWofWLgIxdR6sZCKW026YIAI4nGGgVMqi4y4rjlM8TIUoQJwglL6VB0ZwpxicPTeRpxnz72QJgLhAoeFqLgmpLRpMozPH0XNWKL0MHIVMcNI6J1S62MIeohxmpFRhWWq4mMRiTEKPMcdOgyAoAwAfJAcI1AJAAHcJ7+JxoE+xmiQlwkQVDBhbiokyK8TE-ax0AAqEgODxMSXAPgEBUkZKySogJ5Egn5O0TkKC4YImGMxMY8pfFvHPkVljbJ7NckaOCr0u4a5BnuJGZ4sZlTJn4H4C6bhOTyLSg0Isds-NXiWEehqUyYEY7RLMftMApiHwEPVpzbmOtKJ60YisBYBk3BQKglWKUqzmFyMqV9J5yliEQPNoI2BcJgYtigSsKokoTC6S+KM7s4zyAfXBYgGOjghZBmVJUfRcCJQaKeoIOYWIHBnglhiok4yLAwB4K09JAAhJQAA5bAVjB4uRZWyzlPKrG4oyJrHppNMguJKZE4Z9MOF933mwsF0y1bpACpQ0wXNEGfxSnxRV482GGriAwMAfiOl7I1XuUJy145rO7CauAbD0bmrFZquEtKH66vtcC5CTrbaoH-r491Nq4XLB1XHBVe9nVBtoKQHAMQ2RmotbsmZ-kw05GVKqLqUaGVMgDRYV1RAAD6AaXzfUtem5SiCLDBmOaBREdbTBMWjZw22xay0xoPmCnZNirWzFrfW5U+tBbi1bfm3e7ai2MFLeWgEQIiAgjFcqcMw6pVjpbdoNtSrnWdvnacRdy6+0+WrYOtdqIG1wjlMtKoqLt2TsLfu7tVTU39rPUqIdl6R3XqCs2+9vr9XdjwZnKAFaV2QvlEIoRipjLLRjrpSUcGkSZHpiB4ur6IP8KhdB2FOQHArAfsUB6lFIw1nNmhzoRd+gJp6GyJgsAADCEhMDjhypAMVukuLvwIy4NwHgNCKnUO2fIlGvYYcTfR2AXKJA8DoDwHozTOPehYm2RwfH3AFEE3C+DPr6Y8CCGyakgq0npPCCOQujsaNWmcsPEzGTzMxEs6B91cwWzBQ4pUcwGJM14vaho82EVHrmC6vpwzxmcpssc85jD2cCqSSKvZszFmqNWbNE8rNtMWzqkAoZZxmQGIav89YLRVMHqAXcGF4gRmzTMsi6ZzlABJCA-K7P1YyU1iAGXZhBRYjly5CUTBL3ir6JEjhAJfIq0woDRIDPVYi6y0zrW7RJdc8qErGouJkIcBqIbnq3AsRsP5+BZDliAbet2ObRAavmiS4fY+OcEvSVW2qpSfm4Ybc89tnze2dKIOeHFZwywwzLCq9dhbxxbk2flkyFlkOvJVvVX5yCn2tved22SglYszCaGgSsMHN26s8Hh8+aHrs2vE5idsxHb34TtXc1KL76PfPwgBaxUKzhlRYkQQTiHoKj5iXi2fInJO1sM8215nbLPbB-pWIgg57Yxb00AUGsAABZEFZjwjDkwAABWwMgdGy3YdAPV5ebr8IwnUUC3QxwlFwrDYqAMuYRNsR8bKMr03GuKla51-rw3ZAydDxW1783J6Krpvw1b2OyCo525jI770B4ESRjd64D3k6Vd2W9+s33LH-dG7i6fRLoekwW4RCJmPtuVgJ4zUn2qruOLp-O9-E3quc-dlgAkpJzS2UHyDwK0vexQ2xgfmZSUafGpatsNb4mcEDIGXpQ6okWezfIS7405JLTTP96zOTkP7ew807+lKUf7Z2IT6b1Pz1sVZ-TVRA-pffq+Kr470SDfPeUk7-u4L4vz2h+NAj7wbj6Pzu6kxDJ37wQL6GSe6H7+oNZKDNbG7MoAEkChrrZjZzST7gz4a36xz37QFP4zZt7Z6YKTgIFIED52aoHOjH5VRHYtiYGX5gHT6+j4FQGP6wGkHwEdaIEtZF65yziv7m6vYn4MF1pyhYFX44F4p4HmwEGcGZ40F2ypagadbIHCFl6iFVQIzPC5qeAohQKXT3D4buD6TtTzBIiohVhcFr58Tob9DqFUEH7cHD7h6-S3zwjQRqjyEcGL7DYyh9YnhQTYEt4sKaH2GqHFzqECFPZCE0HupBR6H-b1jQrGFXQXQfZFAhyK7ihVC2Fv5MgOHOzOEkF2GAHaErihzJGkKGEtwmF4r26tihRhRLDuA1gFGYLFFgalEoFwFuF0FVHiFMGgHN6sGQHz6KHL5lGFEqHiY0axHC4REVGDGEIOCCz6GpFGEqQZHwgfA+FcTuBiyIjIKdH+ovq9HLFoGVFrFJGRoGFpE7GULqStgGRzCoiHhHa9TP7dhXEFoXF77B4zFH5ppqz4bmxnItxLCFBzTuABGPTs5CJVCRibBKH9GOovqLEl7onXGrH+S6H3FbH1G7GxgsTZEojmASjsTfHEF9GuGYqVKXEJE3H4koiEl1HpFwIByLBahYiEymBEEXYr7KFYpMk4m0Ggl+x4pQQLAx4GTaDogO4ZoagOLaAFZIhLRnG55MwC4nyCF0nlG4mSkn4EmbEclPHhqVDWBdTaBfEHb2BakMlmK64Tik6AmD7inoGMGSHMFjE34z7sGTGL6OmMoxIunYBunYTUGenuGqJrHDE+mjHX64EBm+FBkwFon0mhnOmuk-56lxEGmFFekSEYi+nJmyGplz4P7BlbBEASB2TwDDDEHGmejoDOBCadTLRGRy5PSPSrD0x5QtlqK7EIzLSeBHYYhcTsTGH0z5z9BDmEIqShLSgWDjlzDBYIi0zSLTEyT9gyALnkT1ihiBxVhHa1hAwVCzkph4SyRDQ5CnpI7whyiWCYhErMRngMKgRwzLSahxhVieCwRAq0kXylT2gHnKSGTLRti6qODtjShRSvArRmAohQRSjMRXl5gCR3nFTsbgXSmwSErijEoflRigTKg-lQTQy6RwRzA0lCnIwfR4VKiXS3oFCUSmBA4GyLTmwPxzxQLPw2GTqbKlRMWHhWmRjLAVAIxQJ2BSoqQtj26oqXR7iQWWzWypyiW-bGCBhBzyW0SILOBqUpyxphBMVHnXqQW8VPyhzaDTb0UWDbzOrdFmW7EBzhiIjWW1xAX2WOW2wBouWjrRx8U1xhyzmmXvqPnZqqgoU44Yj1gfL4ZmDZbATyHARRjbk-E-zYJxpgCiUuCHIxXo7xUyGs6ohqTmwrxwzIUZW0njJMXoDsRRQsS0xRiIieD1j252Wt4WBMo5VMWCCgQQm8UWGZDnKmA3KZRJbCq8q5URW04DWMQOAIr1hoijU+jjWPrdr1WNVwjoAqRqiOA9krB8aAR0XdWFp9VzV-QLX+xdTWCdTlBoK2DlCok7lPqzpdrtr9WKjLCqj1jiJPVLAahibUZmhMVojuDUTIIqQaYCaUKNQ6rizODFAto1X2VXY3ZMVdR6GQTLAhydnmVZrkwPyZASjGRaLmSToY3pjhUPm05tEPyQSpEwxRjmBwJ1hcyk1xhzRUq861ZJbRZRHzlXWehPS+hcRx742XSE0-jmCc0PUFDhSooUZU3hb83tYcp8FY0Yhcy41wTIXS27HPU5pc2Yg81o3dXU3q2LYZJmUEqXogyGRLDGTaZZr-Uk3PVLQyUOmq3zbW0k5mXYgvCHiGQrB7gAxwIbQe1tRzClCGRnXhE0FMUxwIiLDGRmBZbzykzYiqhMTMQIiIg0wJ2YJ-E4LJ2IKHL8UFZHZ2DkyULhSqiah8ZogFCvCvWZXAk+5nDa754G7ozJ19lp2mAxxqn8XgGk1CxFL52t3A2ZmGlMgf5NJf5tID2iLSjD2Z1j2UKIoQRhiuAt0wnt20ml3kG8HNar0LDr0Z2j2GTgFngA573T2H0hlFFC1midYX1D3X2yhb2eowm72II+hIjLDmBhEl3KHOUi1VGD1X0j0-2331061MRhTIIYgUmCndUn1bVQNrFZZcx7jygp3QyKjDKT2yhbnegogW2J3ik9UxLl2Q2IIbQEy6oNHwixiN3aB42PT1hxUv10M5kRmf2wOb0IOepEUAPN1UJt0+A+BAA */
    id: "ui-machine",
    initial: "initializing",
    context: {
      plans: null,
      features: null,
      messages: [],
      theme: null,
      metadata: null,
      history: [],
      searchedHistory: [],
      suggestedFlowsByName: [],
      topSuggestedFlows: [],
      isInitialized: !1,
      query: null,
      query_id: null,
      showWidget: !1,
      firstTime: !1,
      showDialog: !1,
      flowFound: null,
      isHistory: !1
    },
    states: {
      error: {},
      newUserOnboarding: {
        entry: [ie({ showWidget: !0 }), ie({ showDialog: !0 })],
        on: {
          terminate: {
            actions: [
              ie({ showWidget: !1 }),
              ie({ showDialog: !1 })
            ],
            target: "#ui-machine.idle"
          },
          run: {
            target: "guideMachine.onboarding",
            reenter: !0
          },
          markAsCompleted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsCompletedOnboarding",
              "apiMarkAsCompletedOnboarding"
            ]
          },
          markAsNotStarted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsNotStartedOnboarding",
              "apiMarkAsNotStartedOnboarding"
            ]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      newUserFeatures: {
        entry: [ie({ showWidget: !0 }), ie({ showDialog: !0 })],
        on: {
          terminate: {
            actions: [
              ie({ showWidget: !1 }),
              ie({ showDialog: !1 })
            ],
            target: "#ui-machine.idle"
          },
          featureSeen: {
            target: "idle",
            actions: ["markFeatureSeenLocally", "markSeen"]
          },
          run: {
            target: "#ui-machine.guideMachine.features",
            reenter: !0
          },
          markSeen: {
            target: "idle",
            actions: ["markSeen"]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      initializing: {
        initial: "init",
        states: {
          init: {
            invoke: {
              id: "initialize",
              src: "initialize",
              onDone: [
                {
                  guard: "hasOnboardingFlowId",
                  actions: ["setContext", "clearLocalStorage"],
                  target: "#ui-machine.thinking.getFlowForOnboarding"
                },
                {
                  guard: "hasFlowId",
                  actions: ["setContext", "clearLocalStorage"],
                  target: "#ui-machine.thinking.getFlowById"
                },
                {
                  guard: "hasIncompleteFlow",
                  actions: ["setContext"],
                  target: "#ui-machine.thinking.incompleteFlow"
                },
                {
                  guard: "hasNewPageFlow",
                  actions: ["setContext"],
                  target: "#ui-machine.thinking.newPageFlow"
                },
                {
                  // If both are present, mark onboarding complete and show features
                  guard: "hasBothFeaturesAndOnboarding",
                  target: "#ui-machine.newUserOnboarding",
                  actions: ["markShowFeaturesNext", "setContext"]
                  // Mark onboarding as complete
                },
                {
                  guard: Mr(["isNewUser", "hasOnboardingNewUser"]),
                  actions: ["setContext"],
                  target: "#ui-machine.newUserOnboarding"
                },
                {
                  guard: Q0([
                    Mr(["isNewUser", "hasFeaturesNewUser"]),
                    Mr(["showFeaturesNext", "hasFeaturesNewUser"])
                  ]),
                  actions: ["setContext", "markShowFeaturesComplete"],
                  target: "#ui-machine.newUserFeatures"
                },
                {
                  target: "#ui-machine.idle",
                  actions: ["setContext"]
                }
              ],
              onError: {
                actions: ["setError"],
                target: "#ui-machine.error"
              }
            }
          }
        }
      },
      initializeHistory: {
        initial: "init",
        states: {
          init: {
            invoke: {
              id: "initializeHistory",
              src: "initializeHistory",
              onDone: {
                target: "#ui-machine.history",
                actions: ["setHistory"]
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.query"
              }
            }
          },
          delete: {
            invoke: {
              id: "deleteHistory",
              src: "deleteHistory",
              input: ({ event: e }) => e,
              onDone: {
                target: "init"
              },
              onError: {
                actions: ["setError"],
                target: "init"
              }
            }
          }
        },
        on: {
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.query"
          }
        }
      },
      history: {
        on: {
          delete: {
            target: "initializeHistory.delete"
          },
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.query"
          },
          search: {
            target: "searchHistory"
          },
          openHistory: {
            target: "#ui-machine.query",
            actions: ["setLayupMessagesHistory"]
          },
          exit: {
            target: "query",
            actions: ["clearMessages"]
          }
        }
      },
      searchHistory: {
        invoke: {
          id: "searchHistory",
          src: "searchHistory",
          onDone: {
            target: "history",
            actions: ["setSearchedHistory"]
          }
        }
      },
      updates: {
        initial: "idle",
        states: {
          idle: {},
          onboarding: {
            invoke: {
              id: "initializeOnboarding",
              input: ({ event: e }) => e,
              src: "initializeOnboarding",
              onDone: [
                {
                  target: "#ui-machine.onboarding",
                  actions: ie({
                    plans: ({ event: e }) => e.output
                  })
                }
              ],
              onError: {
                actions: [
                  ({ event: e }) => {
                    console.error("Onboarding error:", e.error), ua.error("Failed to initialize onboarding");
                  }
                ],
                target: "#ui-machine.error"
              }
            }
          },
          features: {
            invoke: {
              id: "initializeFeatures",
              src: "initializeFeatures",
              input: ({ event: e }) => e,
              onDone: {
                target: "#ui-machine.idle",
                actions: ["setFeatures"]
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.idle"
              }
            }
          }
        }
      },
      idle: {
        initial: "idle",
        states: {
          idle: {
            on: {
              guide: {
                target: "#ui-machine.query"
              },
              onboard: {
                guard: "hasOnboarding",
                target: "#ui-machine.onboarding"
              },
              feature: {
                guard: "hasFeatures",
                target: "#ui-machine.features"
              },
              getAndRunFlow: {
                guard: "isInitialized",
                target: "#ui-machine.thinking.getAndRunFlow"
              },
              locationChange: {
                guard: "isInitialized",
                actions: async ({ self: e, event: t }) => {
                  const n = await mu();
                  e.send({ type: "updateTopQueries", data: n });
                }
              },
              updateTopQueries: {
                actions: ie({
                  topSuggestedFlows: ({ event: e }) => e.data
                })
              }
            }
          }
        }
      },
      query: {
        initial: "idle",
        states: {
          idle: {},
          getFlowByName: {
            invoke: {
              id: "getFlowByName",
              src: "getFlowByName",
              input: ({ event: e }) => e,
              onDone: {
                target: "idle",
                actions: ["setSuggestedFlowsByName"]
              }
            }
          }
        },
        on: {
          locationChange: {
            guard: "isInitialized",
            actions: async ({ self: e, event: t }) => {
              const n = await mu();
              e.send({ type: "updateTopQueries", data: n });
            }
          },
          updateTopQueries: {
            actions: ie({
              topSuggestedFlows: ({ event: e }) => e.data
            })
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          },
          playNewPage: {
            actions: ["playNewPage"]
          },
          play: {
            target: "guideMachine.queryPlay"
          },
          resume: {
            target: "guideMachine.queryFromPause"
          },
          run: {
            target: "guideMachine.query",
            reenter: !0
          },
          runSuggestedFlows: {
            actions: ["setTopSuggestedFlows"],
            target: "thinking.getQuery"
          },
          runTopSuggestedFlows: {
            actions: ["setTopSuggestedFlows"],
            target: "thinking.getQuery"
          },
          search: [
            {
              guard: "hasQuerySearch",
              actions: ["setQueryBySearch"],
              target: ".getFlowByName"
            },
            {
              actions: ["clearQuerySearch"],
              target: ".idle"
            }
          ],
          request: {
            actions: ["setUserQuery"],
            target: "thinking.getQuery"
          },
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.idle"
          },
          goToHistory: {
            actions: ["clearMessages", ie({ isHistory: !1 })],
            target: "#ui-machine.history"
          },
          history: {
            target: "initializeHistory.init"
          }
        }
      },
      features: {
        initial: "idle",
        states: {
          idle: {
            on: {
              esc: {
                target: "#ui-machine.idle"
              },
              featureSeen: {
                target: "idle",
                actions: ["markFeatureSeenLocally", "markSeen"]
              },
              seen: {
                guard: "hasSeenFeatures",
                target: "seen_features"
              },
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              },
              markSeen: {
                target: "idle",
                actions: ["markSeen"]
              },
              getAndRunFlow: {
                guard: "isInitialized",
                target: "#ui-machine.thinking.getAndRunFlow"
              },
              openFeature: {
                target: "open_new_feature"
              }
            }
          },
          seen_features: {
            on: {
              esc: [
                {
                  guard: "hasFeatures",
                  target: "idle"
                },
                {
                  target: "#ui-machine.idle"
                }
              ],
              terminate: [
                {
                  guard: "hasFeatures",
                  target: "idle"
                },
                {
                  target: "#ui-machine.idle"
                }
              ],
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              },
              getAndRunFlow: {
                guard: "isInitialized",
                target: "#ui-machine.thinking.getAndRunFlow"
              },
              openFeature: {
                target: "open_seen_feature"
              }
            }
          },
          open_new_feature: {
            entry: ["markFeatureSeenLocally", "markSeen"],
            on: {
              esc: {
                target: "idle"
              },
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              }
            }
          },
          open_seen_feature: {
            entry: ["markFeatureSeenLocally", "markSeen"],
            on: {
              esc: {
                target: "seen_features"
              },
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              }
            }
          }
        }
      },
      onboarding: {
        on: {
          esc: {
            target: "#ui-machine.idle"
          },
          run: {
            target: "guideMachine.onboarding",
            reenter: !0
          },
          markAsCompleted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsCompletedOnboarding",
              "apiMarkAsCompletedOnboarding"
            ]
          },
          markAsNotStarted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsNotStartedOnboarding",
              "apiMarkAsNotStartedOnboarding"
            ]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      thinking: {
        id: "thinking",
        initial: "idle",
        states: {
          idle: {},
          getAndRunFlow: {
            invoke: {
              id: "getAndRunFlow",
              src: "getAndRunFlow",
              input: ({ event: e }) => e,
              onDone: {
                target: "#ui-machine.guideMachine.flowById"
              },
              onError: {
                target: "#ui-machine.idle"
              }
            }
          },
          newPageFlow: {
            invoke: {
              id: "getNewPageFlow",
              src: "getNewPageFlow",
              onDone: [
                {
                  guard: "hasFlowObject",
                  actions: [
                    ie({ showWidget: !0 }),
                    ie({ showDialog: !0 })
                  ],
                  target: "#ui-machine.guideMachine.newPageFlow"
                }
              ]
            }
          },
          incompleteFlow: {
            invoke: {
              id: "getIncompleteFlow",
              src: "getIncompleteFlow",
              onDone: [
                {
                  guard: "hasFlowObject",
                  actions: [
                    ie({ showWidget: !0 }),
                    ie({ showDialog: !0 })
                  ],
                  target: "#ui-machine.guideMachine.incompleteFlow"
                },
                {
                  actions: ["clearIncompleteFlow"],
                  target: "#ui-machine.idle"
                }
              ],
              onError: {
                target: "#ui-machine.idle"
              }
            }
          },
          getFlowForOnboarding: {
            invoke: {
              id: "getFlowForOnboarding",
              src: "getFlowForOnboarding",
              onDone: {
                actions: [
                  ie({ showWidget: !0 }),
                  ie({ showDialog: !0 })
                ],
                target: "#ui-machine.guideMachine.onboardingById"
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.idle"
              }
            }
          },
          getFlowById: {
            invoke: {
              id: "getFlowById",
              src: "getFlowById",
              input: ({ event: e }) => e,
              onDone: {
                guard: "hasFlowObject",
                actions: [
                  ie({ showWidget: !0 }),
                  ie({ showDialog: !0 })
                ],
                target: "#ui-machine.guideMachine.flowById"
              }
            }
          },
          getQuery: {
            id: "getQuery",
            invoke: {
              src: Es(({ input: e, sendBack: t }) => {
                try {
                  x0(
                    `${X.config.api_host}/automation/platforms/guidance/stream`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "x-api-token": X.internal_config.api_key
                      },
                      body: JSON.stringify({
                        query: e.query,
                        messages: e.messages,
                        id: e.query_id,
                        user_id: X.config.platform_user_data.user_id,
                        group_id: X.config.group_id,
                        current_user_location: window.location.href
                      }),
                      onmessage(n) {
                        if (n.data)
                          try {
                            if (console.log("event.data", n.data), n.event === "in-progress") {
                              const a = n.data.replace(/'/g, '"').replace(/None/g, "null");
                              n.data = a;
                            }
                            const r = JSON.parse(n.data);
                            switch (n.event) {
                              case "stream":
                                t({
                                  type: "STREAMING_MESSAGE",
                                  data: r
                                });
                                break;
                              case "in-progress":
                                t({
                                  type: "STREAMING_STATUS",
                                  data: r.message
                                });
                                break;
                              case "guide_json":
                                t({ type: "GUIDE_JSON", data: r });
                                break;
                              case "general_json":
                                t({ type: "GENERAL_JSON", data: r });
                                break;
                            }
                          } catch (r) {
                            console.error(
                              "Error parsing event data:",
                              r,
                              n.data
                            );
                          }
                      },
                      onclose() {
                        t({ type: "STREAMING_COMPLETE" });
                      },
                      onerror(n) {
                        throw console.error("EventSource error:", n), t({ type: "STREAMING_COMPLETE" }), new Error("EventSource closed");
                      }
                    }
                  );
                } catch (n) {
                  console.error("Error fetching EventSource:", n);
                }
              }),
              input: ({ context: e }) => ({
                query: e.query,
                messages: e.messages,
                query_id: e.query_id
              })
            },
            on: {
              STREAMING_MESSAGE: {
                actions: ie({
                  messages: ({ context: e, event: t }) => {
                    const n = [...e.messages], r = n[n.length - 1];
                    if ((r == null ? void 0 : r.role) === "assistant") {
                      const a = r.content || "";
                      r.content = a + t.data.replace(/"/g, "").replace(/\\/g, "_");
                    }
                    return n;
                  }
                })
              },
              STREAMING_STATUS: {
                actions: [
                  ie({
                    messages: ({ context: e, event: t }) => {
                      console.log("event.data", t.data);
                      const n = [...e.messages], r = n[n.length - 1];
                      return (r == null ? void 0 : r.role) === "assistant" && (r.status = t.data), n;
                    }
                  })
                ]
              },
              GUIDE_JSON: {
                target: "#ui-machine.query",
                actions: ie({
                  messages: ({ context: e, event: t }) => {
                    var a, i, o, s, l, u, d, f, p, h, y, g, w, m, v;
                    const n = [...e.messages], r = n[n.length - 1];
                    return (r == null ? void 0 : r.role) === "assistant" && (r.flow = (l = (s = (a = t.data) == null ? void 0 : a.conversation) == null ? void 0 : s[((o = (i = t.data) == null ? void 0 : i.conversation) == null ? void 0 : o.length) - 1]) == null ? void 0 : l.flow, r.content = (h = (p = (u = t.data) == null ? void 0 : u.conversation) == null ? void 0 : p[((f = (d = t.data) == null ? void 0 : d.conversation) == null ? void 0 : f.length) - 1]) == null ? void 0 : h.content, r.suggested_queries = (v = (m = (y = t.data) == null ? void 0 : y.conversation) == null ? void 0 : m[((w = (g = t.data) == null ? void 0 : g.conversation) == null ? void 0 : w.length) - 1]) == null ? void 0 : v.suggested_queries), n;
                  },
                  query_id: ({ event: e }) => {
                    var t;
                    return (t = e.data) == null ? void 0 : t.query_id;
                  }
                })
              },
              GENERAL_JSON: {
                target: "#ui-machine.query",
                actions: ie({
                  messages: ({ context: e, event: t }) => {
                    var a, i, o, s, l;
                    const n = [...e.messages], r = n[n.length - 1];
                    return (r == null ? void 0 : r.role) === "assistant" && (r.sources = (l = (s = (a = t.data) == null ? void 0 : a.conversation) == null ? void 0 : s[((o = (i = t.data) == null ? void 0 : i.conversation) == null ? void 0 : o.length) - 1]) == null ? void 0 : l.sources), n;
                  },
                  query_id: ({ event: e }) => {
                    var t;
                    return (t = e.data) == null ? void 0 : t.query_id;
                  }
                })
              },
              STREAMING_COMPLETE: {
                target: "#ui-machine.query"
              },
              playNewPage: {
                actions: ["playNewPage"]
              },
              play: {
                target: "#ui-machine.guideMachine.queryPlay"
              }
            }
          }
        }
      },
      guideMachine: {
        id: "guideMachine",
        initial: "idle",
        states: {
          idle: {},
          newPageFlow: {
            entry: ["clearNewPageFlow"],
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s;
                return {
                  id: (n = e == null ? void 0 : e.output) == null ? void 0 : n.query_id,
                  query: (r = e == null ? void 0 : e.output) == null ? void 0 : r.query,
                  flow_id: (i = (a = e == null ? void 0 : e.output) == null ? void 0 : a.flow) == null ? void 0 : i.id,
                  query_id: (o = e == null ? void 0 : e.output) == null ? void 0 : o.query_id,
                  guidanceFlow: da({
                    flow: e == null ? void 0 : e.output.flow,
                    id: (s = e == null ? void 0 : e.output) == null ? void 0 : s.query_id
                  }),
                  theme: t.theme
                };
              },
              onDone: {
                actions: ["clearLocalStorage"],
                target: "#ui-machine.idle"
              }
            }
          },
          incompleteFlow: {
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s, l, u;
                return {
                  id: (n = e == null ? void 0 : e.output) == null ? void 0 : n.id,
                  query: (r = e == null ? void 0 : e.output) == null ? void 0 : r.query,
                  query_id: (a = e == null ? void 0 : e.output) == null ? void 0 : a.query_id,
                  flow_id: (i = e == null ? void 0 : e.output) == null ? void 0 : i.flow_id,
                  currentStepIndex: (o = e == null ? void 0 : e.output) == null ? void 0 : o.currentStepIndex,
                  currentSelection: (s = e == null ? void 0 : e.output) == null ? void 0 : s.currentSelection,
                  currentActionsMap: (l = e == null ? void 0 : e.output) == null ? void 0 : l.currentActionsMap,
                  guidanceFlow: (u = e == null ? void 0 : e.output) == null ? void 0 : u.guidanceFlow,
                  theme: t.theme
                };
              },
              onDone: {
                actions: ["clearIncompleteFlow"],
                target: "#ui-machine.idle"
              }
            }
          },
          queryFromPause: {
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s, l, u;
                return {
                  id: (n = e == null ? void 0 : e.item) == null ? void 0 : n.id,
                  query: (r = e == null ? void 0 : e.item) == null ? void 0 : r.query,
                  flow_id: (i = (a = e == null ? void 0 : e.item) == null ? void 0 : a.flow) == null ? void 0 : i.id,
                  currentStepIndex: (o = e == null ? void 0 : e.item) == null ? void 0 : o.currentStepIndex,
                  currentSelection: (s = e == null ? void 0 : e.item) == null ? void 0 : s.currentSelection,
                  currentActionsMap: (l = e == null ? void 0 : e.item) == null ? void 0 : l.currentActionsMap,
                  guidanceFlow: (u = e == null ? void 0 : e.item) == null ? void 0 : u.guidanceFlow,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["removePausedMessage", "clearMessages"],
                  target: "#ui-machine.query",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.idle",
                actions: ["setError"]
              }
            }
          },
          flowById: {
            entry: [ie({ showWidget: !0 }), ie({ showDialog: !0 })],
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s;
                return {
                  guidanceFlow: A4(e.output),
                  theme: t.theme,
                  id: (r = (n = e == null ? void 0 : e.output) == null ? void 0 : n.flow) == null ? void 0 : r.id,
                  query: (i = (a = e == null ? void 0 : e.output) == null ? void 0 : a.flow) == null ? void 0 : i.name,
                  flow_id: (s = (o = e == null ? void 0 : e.output) == null ? void 0 : o.flow) == null ? void 0 : s.id
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: [
                    "appendPausedMessage",
                    "clearLocalStorage",
                    ie({ showWidget: !1 }),
                    ie({ showDialog: !1 })
                  ],
                  target: "#ui-machine.idle"
                },
                {
                  target: "#ui-machine.idle"
                }
              ],
              onError: {
                target: "#ui-machine.idle",
                actions: ["setError"]
              }
            }
          },
          onboardingById: {
            entry: ["markInProgressOnboarding"],
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s;
                return {
                  id: (n = e == null ? void 0 : e.output) == null ? void 0 : n.id,
                  guidanceFlow: da(
                    (r = e == null ? void 0 : e.output) == null ? void 0 : r.template_onboarding_flow
                  ),
                  flowStatus: (i = (a = e == null ? void 0 : e.output) == null ? void 0 : a.state) == null ? void 0 : i.status,
                  theme: t == null ? void 0 : t.theme,
                  query: (s = (o = e == null ? void 0 : e.output) == null ? void 0 : o.template_onboarding_flow) == null ? void 0 : s.title
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  target: "#ui-machine.updates.onboarding"
                }
              ],
              onError: {
                target: "#ui-machine.onboarding",
                actions: ["setError"]
              }
            }
          },
          onboarding: {
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s;
                return {
                  id: (n = e == null ? void 0 : e.item) == null ? void 0 : n.id,
                  query: (a = (r = e == null ? void 0 : e.item) == null ? void 0 : r.template_onboarding_flow) == null ? void 0 : a.title,
                  guidanceFlow: da(
                    (i = e == null ? void 0 : e.item) == null ? void 0 : i.template_onboarding_flow
                  ),
                  flowStatus: (s = (o = e == null ? void 0 : e.item) == null ? void 0 : o.state) == null ? void 0 : s.status,
                  theme: t == null ? void 0 : t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  target: "#ui-machine.updates.onboarding"
                }
              ],
              onError: {
                target: "#ui-machine.onboarding",
                actions: ["setError"]
              }
            }
          },
          features: {
            entry: ["markInProgressFeatures"],
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i;
                return {
                  id: (n = e == null ? void 0 : e.item) == null ? void 0 : n.id,
                  guidanceFlow: da((r = e == null ? void 0 : e.item) == null ? void 0 : r.template_announcement),
                  theme: t == null ? void 0 : t.theme,
                  query: (i = (a = e == null ? void 0 : e.item) == null ? void 0 : a.template_announcement) == null ? void 0 : i.title
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  target: "#ui-machine.updates.features",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.features",
                actions: ["setError"]
              }
            }
          },
          query: {
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o, s;
                return {
                  guidanceFlow: da({
                    flow: (n = e == null ? void 0 : e.output) == null ? void 0 : n.flow,
                    id: (a = (r = e == null ? void 0 : e.output) == null ? void 0 : r.query) == null ? void 0 : a.id
                  }),
                  query: (o = (i = e == null ? void 0 : e.output) == null ? void 0 : i.query) == null ? void 0 : o.query,
                  flow_id: (s = e == null ? void 0 : e.output.flow) == null ? void 0 : s.id,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["clearMessages"],
                  target: "#ui-machine.query",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.query",
                actions: ["setError"]
              }
            }
          },
          queryPlay: {
            invoke: {
              id: "guideMachine",
              src: Wn,
              input: ({ event: e, context: t }) => {
                var n, r, a, i, o;
                return {
                  guidanceFlow: da({
                    flow: e == null ? void 0 : e.item.flow,
                    id: (r = (n = e == null ? void 0 : e.item) == null ? void 0 : n.flow) == null ? void 0 : r.id
                  }),
                  query: (a = e == null ? void 0 : e.item) == null ? void 0 : a.content,
                  data: (i = e == null ? void 0 : e.item) == null ? void 0 : i.flow,
                  flow_id: (o = e.item.flow) == null ? void 0 : o.id,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["clearMessages"],
                  target: "#ui-machine.query"
                }
              ],
              onError: {
                target: "#ui-machine.query",
                actions: ["setError"]
              }
            }
          }
        }
      }
    },
    on: {
      exit_everything: {
        target: ".idle",
        actions: [
          "clearContext",
          "clearMessages",
          ie({ showWidget: !1 }),
          ie({ showDialog: !1 })
        ]
      },
      showWidgetOn: {
        actions: ie({
          showWidget: ({ event: e }) => e.showWidget
        })
      },
      dialogOn: {
        actions: ie({
          showDialog: !0
        })
      },
      dialogOff: {
        actions: ie({
          showDialog: !1
        })
      },
      handleSeeAllUpdates: {
        guard: Y0("hasFeatures"),
        target: ".features.seen_features"
      },
      handleFeatures: {
        guard: Mr(["hasFeatures", "isInitialized"]),
        target: ".features"
      },
      handleOnboarding: {
        guard: Mr(["hasOnboarding", "isInitialized"]),
        target: ".onboarding"
      },
      handleQuery: {
        guard: Mr(["hasQuery", "isInitialized"]),
        target: ".query"
      },
      terminate: {
        target: ".idle",
        actions: ["clearContext", "clearMessages"]
      }
    }
  },
  {
    actors: {
      getAndRunFlow: Ot(async ({ input: e }) => await tf(e == null ? void 0 : e.flow_id)),
      getIncompleteFlow: Ot(async () => {
        const e = localStorage.getItem("incomplete_flow");
        if (e)
          return JSON.parse(e);
      }),
      getNewPageFlow: Ot(async () => {
        const e = localStorage.getItem("new_page_flow");
        if (e)
          return JSON.parse(e);
      }),
      getFlowByName: Ot(
        async ({ input: e }) => !e || !e.query ? void 0 : await W1(e.query)
      ),
      getFlowById: Ot(async () => {
        const t = new URLSearchParams(window.location.search).get("flow_id");
        if (!t)
          throw new Error("No flow ID provided");
        const n = await tf(t);
        if (n.starting_url)
          if (!Cp(n.starting_url))
            Ep(n.starting_url, { flow: n });
          else
            return n;
      }),
      getFlowForOnboarding: Ot(async () => {
        const t = new URLSearchParams(window.location.search).get("onboarding_flow");
        if (!t)
          throw new Error("No flow ID provided");
        const n = await V1(t);
        if (!n) throw new Error("No flow found");
        return n;
      }),
      initializeOnboarding: Ot(async ({ input: e }) => {
        var n, r;
        return !e || e.output.error && e.output.flowStatus !== "Completed" ? await mi((n = e == null ? void 0 : e.output) == null ? void 0 : n.id, "NotStarted") : await mi((r = e == null ? void 0 : e.output) == null ? void 0 : r.id, "Completed"), await $d();
      }),
      initializeFeatures: Ot(async ({ input: e }) => {
        var n, r;
        return e ? (e.output.error || e.output.feedbackStatus === "negative" ? await us((n = e == null ? void 0 : e.output) == null ? void 0 : n.id, "NotStarted") : await us((r = e == null ? void 0 : e.output) == null ? void 0 : r.id, "Completed"), await Qd()) : void 0;
      }),
      deleteHistory: Ot(async ({ input: e }) => e ? await B1(e == null ? void 0 : e.id) : void 0),
      initializeHistory: Ot(async () => {
        try {
          return await z1();
        } catch {
          throw new Error("Something went wrong");
        }
      }),
      searchHistory: Ot(async () => " "),
      initialize: Ot(async () => {
        var e, t, n;
        try {
          const r = await N1();
          if (!r)
            throw new Error("Failed to initialize widget");
          const a = JSON.parse(r.platform.metadata);
          X.config.name = ((e = r.platform) == null ? void 0 : e.display_name) || ((t = r.platform) == null ? void 0 : t.name.charAt(0).toUpperCase()) + ((n = r.platform) == null ? void 0 : n.name.slice(1)), X.internal_config.platform_id = r.platform.id;
          const i = M4(r.theme), o = await $d(), s = await Qd(), l = await mu();
          return {
            plans: o,
            features: s,
            metadata: {
              is_guidance_active: a.is_guidance_active,
              is_onboarding_active: a.is_onboarding_active,
              is_announcement_active: a.is_announcement_active
            },
            theme: i,
            topSuggestedFlows: l,
            firstTime: r.is_new_user,
            platform: r.platform
          };
        } catch {
          throw new Error("Something went wrong");
        }
      })
    },
    actions: {
      setLayupMessagesHistory: ie({
        messages: ({ context: e, event: t }) => JSON.parse(t.item.conversation),
        isHistory: !0
      }),
      playNewPage: ({ context: e, event: t }) => {
        var n, r, a, i, o, s, l;
        (r = (n = t.item) == null ? void 0 : n.flow) != null && r.starting_url && !Cp((i = (a = t.item) == null ? void 0 : a.flow) == null ? void 0 : i.starting_url) && Ep((s = (o = t.item) == null ? void 0 : o.flow) == null ? void 0 : s.starting_url, {
          flow: (l = t.item) == null ? void 0 : l.flow,
          query: e.query,
          query_id: e.query_id,
          messages: e.messages
        });
      },
      clearLocalStorage: () => {
        localStorage.removeItem("incomplete_flow"), localStorage.removeItem("new_page_flow");
      },
      appendLayupErrorMessages: ie({
        messages: ({ context: e }) => [
          ...e.messages,
          {
            role: "assistant",
            content: "There was an error fetching your query",
            error: !0
          }
        ]
      }),
      markShowFeaturesComplete: () => {
        localStorage.setItem("showFeaturesNext", "false");
      },
      markShowFeaturesNext: () => {
        localStorage.setItem("showFeaturesNext", "true");
      },
      handleProgress: ie({
        agentMessage: ({ event: e }) => e.data
      }),
      handleDone: ie({
        agentMessage: null,
        sessionId: ({ event: e }) => {
          var t, n;
          return (n = (t = e.data) == null ? void 0 : t.query) == null ? void 0 : n.id;
        },
        messages: ({ context: e, event: t }) => {
          var n, r, a;
          return [
            ...e.messages,
            t.data.messages[((n = t.data.messages) == null ? void 0 : n.length) - 1].content[((a = t.data.messages[((r = t.data.messages) == null ? void 0 : r.length) - 1].content) == null ? void 0 : a.length) - 1]
          ];
        }
      }),
      appendKnowledgeQuery: ie({
        messages: ({ context: e, event: t }) => [
          ...e.messages,
          {
            role: "assistant",
            content: t.output.answer
          }
        ]
      }),
      markAsNotStartedOnboarding: ie({
        plans: ({ event: e, context: t }) => {
          const n = t.plans, r = n.onboarding_flows.map((a) => (a.id === e.item.id && (a.state.status = "NotStarted"), a));
          return { ...n, onboarding_flows: r };
        }
      }),
      apiMarkAsNotStartedOnboarding: ({ event: e }) => {
        mi(e.item.id, "NotStarted");
      },
      markAsCompletedOnboarding: ie({
        plans: ({ event: e, context: t }) => {
          const n = t.plans, r = n.onboarding_flows.map((a) => (a.id === e.item.id && (a.state.status = "Completed"), a));
          return { ...n, onboarding_flows: r };
        }
      }),
      apiMarkAsCompletedOnboarding: ({ event: e }) => {
        mi(e.item.id, "Completed");
      },
      removePausedMessage: ie({
        messages: ({ context: e, event: t }) => e.messages.filter(
          (n) => {
            var r;
            return n.role !== "guidance-machine" && n.id !== ((r = t == null ? void 0 : t.output) == null ? void 0 : r.id);
          }
        )
      }),
      appendPausedMessage: ie({
        messages: ({ context: e, event: t }) => {
          var a, i, o, s, l, u, d, f, p, h;
          const n = {
            role: "guidance-machine",
            content: (a = t == null ? void 0 : t.output) == null ? void 0 : a.query,
            query: (i = t == null ? void 0 : t.output) == null ? void 0 : i.query,
            id: (o = t == null ? void 0 : t.output) == null ? void 0 : o.id,
            flow_id: (l = (s = t == null ? void 0 : t.output) == null ? void 0 : s.flow) == null ? void 0 : l.id,
            currentStepIndex: (u = t == null ? void 0 : t.output) == null ? void 0 : u.currentStepIndex,
            currentSelection: (d = t == null ? void 0 : t.output) == null ? void 0 : d.currentSelection,
            currentActionsMap: (f = t == null ? void 0 : t.output) == null ? void 0 : f.currentActionsMap,
            progressSteps: (p = t == null ? void 0 : t.output) == null ? void 0 : p.progressSteps,
            guidanceFlow: (h = t == null ? void 0 : t.output) == null ? void 0 : h.guidanceFlow
          }, r = e.messages.findIndex(
            (y) => {
              var g;
              return y.role === "guidance-machine" && y.id === ((g = t == null ? void 0 : t.output) == null ? void 0 : g.id);
            }
          );
          if (r >= 0) {
            const y = [...e.messages];
            return y[r] = n, y;
          }
          return [...e.messages, n];
        }
      }),
      addFlowFound: ie({
        flowFound: ({ event: e }) => e.output
      }),
      clearQuerySearch: ie({
        query: null,
        suggestedFlowsByName: []
      }),
      setQueryBySearch: ie({
        query: ({ event: e }) => e.query
      }),
      setSuggestedFlowsByName: ie({
        suggestedFlowsByName: ({ event: e }) => e.output
      }),
      setQuery: ie({
        query: ({ event: e }) => e.output.query.query
      }),
      markSeen: async ({ event: e }) => {
        var t;
        await us((t = e == null ? void 0 : e.item) == null ? void 0 : t.id, "Seen");
      },
      markFeatureSeenLocally: ie({
        features: ({ context: e, event: t }) => {
          const n = e.features, r = n == null ? void 0 : n.find(
            (a) => {
              var i;
              return (a == null ? void 0 : a.id) === ((i = t == null ? void 0 : t.item) == null ? void 0 : i.id);
            }
          );
          return r && (r.state.status = "Seen"), n;
        }
      }),
      markInProgressFeatures: async ({ event: e }) => {
        var n, r;
        const t = ((n = e == null ? void 0 : e.item) == null ? void 0 : n.id) || ((r = e == null ? void 0 : e.output) == null ? void 0 : r.id);
        t && await us(t, "InProgress");
      },
      markInProgressOnboarding: async ({ event: e }) => {
        var n, r;
        const t = ((n = e == null ? void 0 : e.item) == null ? void 0 : n.id) || ((r = e == null ? void 0 : e.output) == null ? void 0 : r.id);
        t && await mi(t, "InProgress");
      },
      setOnboarding: ie({
        plans: ({ event: e }) => e.output
      }),
      setFeatures: ie({
        features: ({ event: e }) => e.output
      }),
      clearMessages: ie({
        messages: [],
        query_id: null
      }),
      setError: ({ event: e }) => {
        switch (e.actorId) {
          case "getFlowForOnboarding":
            ua.error("There was an error fetching your onboarding flow!");
            break;
          case "getQuery":
            ua.error("There was an error fetching your query!");
            break;
          case "getFlow":
            ua.error("We were not able to fetch the flow!");
            break;
          case "initializeHistory":
            ua.error("There is an issue with the history API!");
            break;
          case "guideMachine":
            ua.error("There is an issue with the guide flow!");
            break;
        }
      },
      setHistory: ie({
        history: ({ event: e }) => e.output
      }),
      log: ({ context: e, event: t }) => console.log("log", e, t),
      setTopSuggestedFlows: ie({
        messages: ({ event: e, context: t }) => [
          ...t.messages,
          { role: "user", content: e.name },
          { role: "assistant", content: "" }
        ],
        query: ({ event: e }) => e.name
      }),
      setUserQuery: ie({
        messages: ({ event: e, context: t }) => [
          ...t.messages,
          { role: "user", content: e.userMessages },
          { role: "assistant", content: "" }
        ],
        query: ({ event: e }) => e.userMessages
      }),
      appendLayupMessages: ie({
        query_id: ({ event: e }) => {
          var t;
          return (t = e == null ? void 0 : e.output) == null ? void 0 : t.query_id;
        },
        messages: ({ event: e, context: t }) => {
          var r;
          let n;
          return (r = e.output) != null && r.conversation && (n = e.output.conversation), [...t.messages, n == null ? void 0 : n[(n == null ? void 0 : n.length) - 1]];
        }
      }),
      setContext: ie({
        isInitialized: !0,
        firstTime: ({ event: e }) => e.output.firstTime,
        plans: ({ event: e }) => e.output.plans,
        features: ({ event: e }) => e.output.features,
        metadata: ({ event: e }) => e.output.metadata,
        theme: ({ event: e }) => e.output.theme,
        topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
      }),
      clearContext: ie({
        messages: [],
        query_id: null
      }),
      clearIncompleteFlow: () => {
        localStorage.removeItem("incomplete_flow");
      },
      clearNewPageFlow: () => {
        localStorage.removeItem("new_page_flow");
      }
    },
    guards: {
      showFeaturesNext: () => localStorage.getItem("showFeaturesNext") === "true",
      hasBothFeaturesAndOnboarding: ({ event: e }) => {
        var t, n, r, a, i, o, s, l, u;
        return ((t = e == null ? void 0 : e.output) == null ? void 0 : t.firstTime) && ((r = (n = e == null ? void 0 : e.output) == null ? void 0 : n.features) == null ? void 0 : r.length) > 0 && ((o = (i = (a = e == null ? void 0 : e.output) == null ? void 0 : a.plans) == null ? void 0 : i.onboarding_flows) == null ? void 0 : o.length) > 0 && ((u = (l = (s = e == null ? void 0 : e.output) == null ? void 0 : s.plans) == null ? void 0 : l.onboarding_flows) == null ? void 0 : u.some(
          (d) => {
            var f;
            return ((f = d == null ? void 0 : d.state) == null ? void 0 : f.status) !== "Completed";
          }
        ));
      },
      isNewUser: ({ event: e }) => {
        var t;
        return (t = e == null ? void 0 : e.output) == null ? void 0 : t.firstTime;
      },
      isInitialized: ({ context: e }) => e == null ? void 0 : e.isInitialized,
      hasSeenFeatures: ({ context: e }) => {
        var t, n, r;
        return ((t = e == null ? void 0 : e.features) == null ? void 0 : t.length) > 0 && ((n = e == null ? void 0 : e.metadata) == null ? void 0 : n.is_announcement_active) && ((r = e == null ? void 0 : e.features) == null ? void 0 : r.some(
          (a) => {
            var i;
            return ((i = a == null ? void 0 : a.state) == null ? void 0 : i.status) !== "NotStarted";
          }
        ));
      },
      isKnowledgeQuery: ({ event: e }) => {
        var t;
        return (t = e == null ? void 0 : e.output) == null ? void 0 : t.answer;
      },
      isPaused: ({ event: e }) => {
        var t;
        return ((t = e == null ? void 0 : e.output) == null ? void 0 : t.status) === "PAUSE";
      },
      hasQuerySearch: ({ event: e }) => e == null ? void 0 : e.query,
      hasFeatures: ({ context: e }) => {
        var t, n, r;
        return ((t = e == null ? void 0 : e.features) == null ? void 0 : t.length) > 0 && ((n = e == null ? void 0 : e.metadata) == null ? void 0 : n.is_announcement_active) && ((r = e == null ? void 0 : e.features) == null ? void 0 : r.some(
          (a) => {
            var i;
            return ((i = a == null ? void 0 : a.state) == null ? void 0 : i.status) === "NotStarted";
          }
        ));
      },
      hasFeaturesNewUser: ({ event: e }) => {
        var t, n, r, a, i, o;
        return ((n = (t = e == null ? void 0 : e.output) == null ? void 0 : t.features) == null ? void 0 : n.length) > 0 && ((a = (r = e == null ? void 0 : e.output) == null ? void 0 : r.metadata) == null ? void 0 : a.is_announcement_active) && ((o = (i = e == null ? void 0 : e.output) == null ? void 0 : i.features) == null ? void 0 : o.some(
          (s) => {
            var l;
            return ((l = s == null ? void 0 : s.state) == null ? void 0 : l.status) === "NotStarted";
          }
        ));
      },
      hasOnboardingNewUser: ({ event: e }) => {
        var t, n, r, a, i, o, s, l;
        return ((t = e == null ? void 0 : e.output) == null ? void 0 : t.firstTime) && ((n = e == null ? void 0 : e.output) == null ? void 0 : n.plans) && ((i = (a = (r = e == null ? void 0 : e.output) == null ? void 0 : r.plans) == null ? void 0 : a.onboarding_flows) == null ? void 0 : i.length) > 0 && ((l = (s = (o = e == null ? void 0 : e.output) == null ? void 0 : o.plans) == null ? void 0 : s.onboarding_flows) == null ? void 0 : l.some(
          (u) => {
            var d;
            return ((d = u == null ? void 0 : u.state) == null ? void 0 : d.status) !== "Completed";
          }
        ));
      },
      hasOnboarding: ({ context: e }) => {
        var t, n, r, a, i;
        return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.is_onboarding_active) && (e == null ? void 0 : e.plans) && ((r = (n = e == null ? void 0 : e.plans) == null ? void 0 : n.onboarding_flows) == null ? void 0 : r.length) > 0 && ((i = (a = e == null ? void 0 : e.plans) == null ? void 0 : a.onboarding_flows) == null ? void 0 : i.some(
          (o) => {
            var s;
            return ((s = o == null ? void 0 : o.state) == null ? void 0 : s.status) !== "Completed";
          }
        ));
      },
      hasQuery: ({ context: e }) => {
        var t;
        return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.is_guidance_active;
      },
      hasOnboardingId: ({ event: e }) => (e == null ? void 0 : e.id) !== null,
      hasFlowObject: ({ event: e }) => (e == null ? void 0 : e.output) !== null,
      noSteps: ({ event: e }) => !e.output.flow,
      hasIncompleteFlow: () => localStorage.getItem("incomplete_flow") !== null,
      hasNewPageFlow: () => localStorage.getItem("new_page_flow") !== null,
      hasOnboardingFlowId: () => new URLSearchParams(window.location.search).get("onboarding_flow") !== null,
      hasFlowId: () => new URLSearchParams(window.location.search).get("flow_id") !== null
    }
  }
);
function O4(e, ...[t]) {
  const n = Li(e, t).start();
  return Oc(() => n.stop()), n;
}
function F4(e, ...[t]) {
  const n = O4(e, t);
  let r = n.getSnapshot();
  return {
    snapshot: Q1(r, (i) => n.subscribe((o) => {
      r !== o && (r = o, i(r));
    }).unsubscribe),
    send: n.send,
    actorRef: n
  };
}
function R4(e, ...[t]) {
  return F4(e, t);
}
var Gg = { exports: {} };
(function(e) {
  (function(t, n, r) {
    if (!t)
      return;
    for (var a = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    }, i = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    }, o = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      $: "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      _: "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    }, s = {
      option: "alt",
      command: "meta",
      return: "enter",
      escape: "esc",
      plus: "+",
      mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    }, l, u = 1; u < 20; ++u)
      a[111 + u] = "f" + u;
    for (u = 0; u <= 9; ++u)
      a[u + 96] = u.toString();
    function d(E, k, I) {
      if (E.addEventListener) {
        E.addEventListener(k, I, !1);
        return;
      }
      E.attachEvent("on" + k, I);
    }
    function f(E) {
      if (E.type == "keypress") {
        var k = String.fromCharCode(E.which);
        return E.shiftKey || (k = k.toLowerCase()), k;
      }
      return a[E.which] ? a[E.which] : i[E.which] ? i[E.which] : String.fromCharCode(E.which).toLowerCase();
    }
    function p(E, k) {
      return E.sort().join(",") === k.sort().join(",");
    }
    function h(E) {
      var k = [];
      return E.shiftKey && k.push("shift"), E.altKey && k.push("alt"), E.ctrlKey && k.push("ctrl"), E.metaKey && k.push("meta"), k;
    }
    function y(E) {
      if (E.preventDefault) {
        E.preventDefault();
        return;
      }
      E.returnValue = !1;
    }
    function g(E) {
      if (E.stopPropagation) {
        E.stopPropagation();
        return;
      }
      E.cancelBubble = !0;
    }
    function w(E) {
      return E == "shift" || E == "ctrl" || E == "alt" || E == "meta";
    }
    function m() {
      if (!l) {
        l = {};
        for (var E in a)
          E > 95 && E < 112 || a.hasOwnProperty(E) && (l[a[E]] = E);
      }
      return l;
    }
    function v(E, k, I) {
      return I || (I = m()[E] ? "keydown" : "keypress"), I == "keypress" && k.length && (I = "keydown"), I;
    }
    function C(E) {
      return E === "+" ? ["+"] : (E = E.replace(/\+{2}/g, "+plus"), E.split("+"));
    }
    function S(E, k) {
      var I, D, A, M = [];
      for (I = C(E), A = 0; A < I.length; ++A)
        D = I[A], s[D] && (D = s[D]), k && k != "keypress" && o[D] && (D = o[D], M.push("shift")), w(D) && M.push(D);
      return k = v(D, M, k), {
        key: D,
        modifiers: M,
        action: k
      };
    }
    function b(E, k) {
      return E === null || E === n ? !1 : E === k ? !0 : b(E.parentNode, k);
    }
    function x(E) {
      var k = this;
      if (E = E || n, !(k instanceof x))
        return new x(E);
      k.target = E, k._callbacks = {}, k._directMap = {};
      var I = {}, D, A = !1, M = !1, N = !1;
      function P(j) {
        j = j || {};
        var B = !1, K;
        for (K in I) {
          if (j[K]) {
            B = !0;
            continue;
          }
          I[K] = 0;
        }
        B || (N = !1);
      }
      function Y(j, B, K, U, ne, ue) {
        var ae, se, ge = [], pe = K.type;
        if (!k._callbacks[j])
          return [];
        for (pe == "keyup" && w(j) && (B = [j]), ae = 0; ae < k._callbacks[j].length; ++ae)
          if (se = k._callbacks[j][ae], !(!U && se.seq && I[se.seq] != se.level) && pe == se.action && (pe == "keypress" && !K.metaKey && !K.ctrlKey || p(B, se.modifiers))) {
            var ve = !U && se.combo == ne, me = U && se.seq == U && se.level == ue;
            (ve || me) && k._callbacks[j].splice(ae, 1), ge.push(se);
          }
        return ge;
      }
      function G(j, B, K, U) {
        k.stopCallback(B, B.target || B.srcElement, K, U) || j(B, K) === !1 && (y(B), g(B));
      }
      k._handleKey = function(j, B, K) {
        var U = Y(j, B, K), ne, ue = {}, ae = 0, se = !1;
        for (ne = 0; ne < U.length; ++ne)
          U[ne].seq && (ae = Math.max(ae, U[ne].level));
        for (ne = 0; ne < U.length; ++ne) {
          if (U[ne].seq) {
            if (U[ne].level != ae)
              continue;
            se = !0, ue[U[ne].seq] = 1, G(U[ne].callback, K, U[ne].combo, U[ne].seq);
            continue;
          }
          se || G(U[ne].callback, K, U[ne].combo);
        }
        var ge = K.type == "keypress" && M;
        K.type == N && !w(j) && !ge && P(ue), M = se && K.type == "keydown";
      };
      function q(j) {
        typeof j.which != "number" && (j.which = j.keyCode);
        var B = f(j);
        if (B) {
          if (j.type == "keyup" && A === B) {
            A = !1;
            return;
          }
          k.handleKey(B, h(j), j);
        }
      }
      function J() {
        clearTimeout(D), D = setTimeout(P, 1e3);
      }
      function $(j, B, K, U) {
        I[j] = 0;
        function ne(pe) {
          return function() {
            N = pe, ++I[j], J();
          };
        }
        function ue(pe) {
          G(K, pe, j), U !== "keyup" && (A = f(pe)), setTimeout(P, 10);
        }
        for (var ae = 0; ae < B.length; ++ae) {
          var se = ae + 1 === B.length, ge = se ? ue : ne(U || S(B[ae + 1]).action);
          W(B[ae], ge, U, j, ae);
        }
      }
      function W(j, B, K, U, ne) {
        k._directMap[j + ":" + K] = B, j = j.replace(/\s+/g, " ");
        var ue = j.split(" "), ae;
        if (ue.length > 1) {
          $(j, ue, B, K);
          return;
        }
        ae = S(j, K), k._callbacks[ae.key] = k._callbacks[ae.key] || [], Y(ae.key, ae.modifiers, { type: ae.action }, U, j, ne), k._callbacks[ae.key][U ? "unshift" : "push"]({
          callback: B,
          modifiers: ae.modifiers,
          action: ae.action,
          seq: U,
          level: ne,
          combo: j
        });
      }
      k._bindMultiple = function(j, B, K) {
        for (var U = 0; U < j.length; ++U)
          W(j[U], B, K);
      }, d(E, "keypress", q), d(E, "keydown", q), d(E, "keyup", q);
    }
    x.prototype.bind = function(E, k, I) {
      var D = this;
      return E = E instanceof Array ? E : [E], D._bindMultiple.call(D, E, k, I), D;
    }, x.prototype.unbind = function(E, k) {
      var I = this;
      return I.bind.call(I, E, function() {
      }, k);
    }, x.prototype.trigger = function(E, k) {
      var I = this;
      return I._directMap[E + ":" + k] && I._directMap[E + ":" + k]({}, E), I;
    }, x.prototype.reset = function() {
      var E = this;
      return E._callbacks = {}, E._directMap = {}, E;
    }, x.prototype.stopCallback = function(E, k) {
      var I = this;
      if ((" " + k.className + " ").indexOf(" mousetrap ") > -1 || b(k, I.target))
        return !1;
      if ("composedPath" in E && typeof E.composedPath == "function") {
        var D = E.composedPath()[0];
        D !== E.target && (k = D);
      }
      return k.tagName == "INPUT" || k.tagName == "SELECT" || k.tagName == "TEXTAREA" || k.isContentEditable;
    }, x.prototype.handleKey = function() {
      var E = this;
      return E._handleKey.apply(E, arguments);
    }, x.addKeycodes = function(E) {
      for (var k in E)
        E.hasOwnProperty(k) && (a[k] = E[k]);
      l = null;
    }, x.init = function() {
      var E = x(n);
      for (var k in E)
        k.charAt(0) !== "_" && (x[k] = /* @__PURE__ */ function(I) {
          return function() {
            return E[I].apply(E, arguments);
          };
        }(k));
    }, x.init(), t.Mousetrap = x, e.exports && (e.exports = x);
  })(typeof window < "u" ? window : null, typeof window < "u" ? document : null);
})(Gg);
var L4 = Gg.exports;
const Kg = /* @__PURE__ */ ax(L4);
var D4 = /* @__PURE__ */ vt(`<svg><path d="M12,24H6v-7c-3.3,0-6-2.7-6-6s2.7-6,6-6h5c3.6,0,7.3-3.4,7.3-3.4L20,0v7c2.2,0,4,1.8,4,4s-1.8,4-4,4v6.8l-1.7-1.5
			c0,0-3.1-2.8-6.3-3.3V24z M8,22h2v-5H8V22z M12,15.1c2.4,0.3,4.6,1.5,6,2.5V4.4c-1.4,1-3.6,2.3-6,2.6V15.1z M6,15h4V7H6
			c-2.2,0-4,1.8-4,4S3.8,15,6,15z M20,11v2c1.1,0,2-0.9,2-2s-0.9-2-2-2V11z"></path></svg>`);
function N4(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = D4();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      class: t.class,
      ...n,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      "stroke-width": "0"
    },
    void 0,
    !0
  )), _(e, r);
}
var z4 = /* @__PURE__ */ vt('<svg><path fill-rule="evenodd" clip-rule="evenodd" d="M1.54621 1.54621C1.97598 1.11644 2.55888 0.875 3.16667 0.875H14.8333C15.4411 0.875 16.024 1.11644 16.4538 1.54621C16.8836 1.97598 17.125 2.55888 17.125 3.16667V8.16667C17.125 8.51184 16.8452 8.79167 16.5 8.79167C16.1548 8.79167 15.875 8.51184 15.875 8.16667V3.16667C15.875 2.8904 15.7653 2.62545 15.5699 2.4301C15.3746 2.23475 15.1096 2.125 14.8333 2.125H3.16667C2.8904 2.125 2.62545 2.23475 2.4301 2.4301C2.23475 2.62545 2.125 2.8904 2.125 3.16667V14.8333C2.125 15.1096 2.23475 15.3746 2.4301 15.5699C2.62545 15.7653 2.8904 15.875 3.16667 15.875H8.16667C8.51184 15.875 8.79167 16.1548 8.79167 16.5C8.79167 16.8452 8.51184 17.125 8.16667 17.125H3.16667C2.55888 17.125 1.97598 16.8836 1.54621 16.4538C1.11644 16.024 0.875 15.4411 0.875 14.8333V3.16667C0.875 2.55888 1.11644 1.97598 1.54621 1.54621ZM9.78257 9.78257L12.3108 16.2838L13.0229 13.9862C13.0229 13.9861 13.0228 13.9864 13.0229 13.9862C13.093 13.7598 13.2173 13.5534 13.385 13.3858C13.5525 13.2182 13.7585 13.094 13.9849 13.0239M13.9849 13.0239L16.284 12.3109L9.78257 9.78257M9.79596 8.44658C9.60789 8.37228 9.40222 8.35441 9.20411 8.3952C9.00497 8.4362 8.82221 8.53468 8.67845 8.67845C8.53468 8.82221 8.4362 9.00497 8.3952 9.20411C8.35441 9.40222 8.37228 9.60789 8.44658 9.79596C8.44697 9.79695 8.44736 9.79793 8.44776 9.79892L11.3629 17.295C11.4414 17.496 11.5805 17.6676 11.7608 17.7862C11.9411 17.9048 12.1538 17.9644 12.3695 17.9569C12.5852 17.9493 12.7932 17.875 12.9648 17.7441C13.1364 17.6132 13.2631 17.4322 13.3274 17.2262L13.3278 17.225L14.217 14.3558C14.227 14.3235 14.2449 14.2936 14.2688 14.2697C14.2928 14.2457 14.3222 14.228 14.3546 14.2179L17.2251 13.3278L17.2262 13.3274C17.4322 13.2631 17.6132 13.1364 17.7441 12.9648C17.875 12.7932 17.9493 12.5852 17.9569 12.3695C17.9644 12.1538 17.9048 11.9411 17.7862 11.7608C17.6676 11.5805 17.496 11.4414 17.295 11.3629L9.79892 8.44776C9.79793 8.44736 9.79695 8.44697 9.79596 8.44658Z"></path></svg>');
function Tp(e, t) {
  let n = L(t, "class", 3, "layup-fill-white"), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = z4();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      class: n(),
      ...r,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, a);
}
var V4 = /* @__PURE__ */ vt('<svg><path d="M790 790H208V208h291v-83H208q-35 0-59 24.5T125 208v582q0 35 24 59t59 24h582q35 0 59-24t24-59V499h-83v291zM582 125v83h150L323 617l58 58 409-408v149h83V125H582z"></path></svg>');
function B4(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = V4();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      class: t.class,
      ...n,
      viewBox: "0 0 1000 1000",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var j4 = /* @__PURE__ */ vt('<svg><path d="M10.75 4.50003V8.57534L14.1363 10.6069C14.3068 10.7093 14.4297 10.8753 14.4779 11.0684C14.5261 11.2614 14.4956 11.4657 14.3931 11.6363C14.2907 11.8068 14.1247 11.9297 13.9316 11.9779C13.7386 12.0261 13.5343 11.9956 13.3638 11.8932L9.61375 9.64315C9.50276 9.57647 9.41093 9.48219 9.34719 9.36949C9.28344 9.25679 9.24996 9.12951 9.25 9.00003V4.50003C9.25 4.30112 9.32902 4.11035 9.46967 3.9697C9.61032 3.82905 9.80109 3.75003 10 3.75003C10.1989 3.75003 10.3897 3.82905 10.5303 3.9697C10.671 4.11035 10.75 4.30112 10.75 4.50003ZM10 2.77605e-05C8.81687 -0.00291932 7.64491 0.22881 6.55193 0.681803C5.45895 1.1348 4.46667 1.80006 3.6325 2.63909C2.95094 3.32909 2.34531 3.99284 1.75 4.68753V3.00003C1.75 2.80112 1.67098 2.61035 1.53033 2.4697C1.38968 2.32905 1.19891 2.25003 1 2.25003C0.801088 2.25003 0.610322 2.32905 0.46967 2.4697C0.329018 2.61035 0.25 2.80112 0.25 3.00003V6.75003C0.25 6.94894 0.329018 7.13971 0.46967 7.28036C0.610322 7.42101 0.801088 7.50003 1 7.50003H4.75C4.94891 7.50003 5.13968 7.42101 5.28033 7.28036C5.42098 7.13971 5.5 6.94894 5.5 6.75003C5.5 6.55112 5.42098 6.36035 5.28033 6.2197C5.13968 6.07905 4.94891 6.00003 4.75 6.00003H2.59375C3.26406 5.21065 3.93156 4.46722 4.69281 3.69659C5.73518 2.65423 7.0616 1.94216 8.50635 1.64935C9.95109 1.35654 11.4501 1.49598 12.816 2.05023C14.182 2.60449 15.3543 3.54899 16.1866 4.76572C17.0188 5.98245 17.474 7.41745 17.4953 8.89142C17.5166 10.3654 17.1031 11.813 16.3064 13.0532C15.5098 14.2935 14.3652 15.2716 13.0159 15.8651C11.6665 16.4586 10.1722 16.6414 8.71959 16.3905C7.26698 16.1396 5.92052 15.4662 4.84844 14.4544C4.77679 14.3867 4.6925 14.3338 4.60039 14.2986C4.50828 14.2635 4.41015 14.2468 4.3116 14.2496C4.21305 14.2524 4.11602 14.2746 4.02604 14.3149C3.93606 14.3551 3.8549 14.4128 3.78719 14.4844C3.71947 14.5561 3.66654 14.6403 3.6314 14.7325C3.59626 14.8246 3.57961 14.9227 3.5824 15.0212C3.58518 15.1198 3.60735 15.2168 3.64764 15.3068C3.68792 15.3968 3.74554 15.4779 3.81719 15.5457C4.88542 16.5537 6.18414 17.285 7.6 17.6757C9.01587 18.0665 10.5058 18.1047 11.9399 17.7872C13.3739 17.4696 14.7085 16.806 15.827 15.854C16.9456 14.9021 17.8142 13.6909 18.357 12.3261C18.8998 10.9613 19.1003 9.48439 18.9411 8.02426C18.7818 6.56414 18.2677 5.16517 17.4434 3.94947C16.6192 2.73376 15.5099 1.73825 14.2125 1.04982C12.915 0.361401 11.4688 0.000983756 10 2.77605e-05Z"></path></svg>');
function Zg(e, t) {
  let n = L(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = j4();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      viewBox: "0 0 19 18",
      class: n(),
      ...r
    },
    void 0,
    !0
  )), _(e, a);
}
var W4 = /* @__PURE__ */ O('<div class="layup-block dark:layup-hidden"><svg><path d="M17.8497 54.1549L0 44.2793V68.5144C0 72.0945 2.90566 75.0004 6.48577 75.0004H30.7194L20.8402 57.1497C20.1445 55.89 19.1053 54.8547 17.8454 54.1549H17.8497Z" fill="#2E2E2C"></path><path d="M68.5099 0H6.48577C2.90566 0 0 2.90583 0 6.48615V28.5322L52.2469 14.5334C57.2393 13.1971 61.8037 17.7616 60.4676 22.7545L46.4692 75H68.5144C72.0945 75 75 72.0983 75 68.514V6.48615C74.9959 2.90583 72.0945 0 68.5099 0Z" fill="#2E2E2C"></path></svg></div> <div class="layup-hidden dark:layup-block"><svg><path d="M4.28392 12.9971L0 10.627V16.4434C0 17.3026 0.697359 18 1.55659 18H7.37267L5.00164 13.7158C4.83468 13.4135 4.58527 13.165 4.2829 12.9971H4.28392Z" fill="white"></path><path d="M16.4424 0H1.55659C0.697359 0 0 0.697398 0 1.55668V6.84774L12.5393 3.48801C13.7374 3.16731 14.8329 4.26278 14.5122 5.46108L11.1526 18H16.4435C17.3027 18 18 17.3036 18 16.4434V1.55668C17.999 0.697398 17.3027 0 16.4424 0Z" fill="white"></path></svg></div>', 1);
function su(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy"]);
  var r = W4(), a = V(r), i = T(a);
  let o;
  var s = Q(a, 2), l = T(s);
  let u;
  ee(() => {
    o = Je(
      i,
      o,
      {
        xmlns: "http://www.w3.org/2000/svg",
        ...n,
        viewBox: "0 0 75 75",
        fill: "none"
      },
      void 0,
      !0
    ), u = Je(
      l,
      u,
      {
        ...n,
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg"
      },
      void 0,
      !0
    );
  }), _(e, r);
}
var H4 = /* @__PURE__ */ vt('<svg><path d="M8.86076 9.29209C8.83672 9.2318 8.83089 9.16578 8.84398 9.10221C8.85707 9.03864 8.8885 8.98029 8.9344 8.9344C8.98029 8.8885 9.03864 8.85707 9.10221 8.84398C9.16578 8.83089 9.2318 8.83672 9.29209 8.86076L15.2921 11.1941C15.3564 11.2192 15.4113 11.2637 15.4493 11.3214C15.4872 11.3791 15.5063 11.4472 15.5039 11.5162C15.5015 11.5852 15.4777 11.6518 15.4358 11.7067C15.3939 11.7616 15.336 11.8022 15.2701 11.8228L12.9741 12.5348C12.8705 12.5668 12.7763 12.6236 12.6996 12.7003C12.6229 12.7769 12.5661 12.8712 12.5341 12.9748L11.8228 15.2701C11.8022 15.336 11.7616 15.3939 11.7067 15.4358C11.6518 15.4777 11.5852 15.5015 11.5162 15.5039C11.4472 15.5063 11.3791 15.4872 11.3214 15.4493C11.2637 15.4113 11.2192 15.3564 11.1941 15.2921L8.86076 9.29209Z" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.8381 8.17147V4.17147C14.8381 3.81785 14.6977 3.47871 14.4476 3.22866C14.1976 2.97861 13.8584 2.83813 13.5048 2.83813H4.17147C3.81785 2.83813 3.47871 2.97861 3.22866 3.22866C2.97861 3.47871 2.83813 3.81785 2.83813 4.17147V13.5048C2.83813 13.8584 2.97861 14.1976 3.22866 14.4476C3.47871 14.6977 3.81785 14.8381 4.17147 14.8381H8.17147" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
function U4(e, t) {
  let n = L(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = H4();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      class: n(),
      ...r,
      viewBox: "2 2 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, a);
}
var q4 = /* @__PURE__ */ O('<div class="layup-flex layup-h-[20px] layup-w-[30px] layup-items-center layup-justify-center layup-rounded-xl layup-bg-accent-bg layup-text-accent"><span class="layup-text-sm !layup-text-accent"> </span></div>');
function G4(e, t) {
  var n = q4(), r = T(n), a = T(r);
  ee(() => ke(a, t.count)), _(e, n);
}
function K4(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, ["class", "orientation", "decorative"]);
  be(t, !1);
  let a = L(t, "class", 8, void 0), i = L(t, "orientation", 8, "horizontal"), o = L(t, "decorative", 8, void 0);
  gn();
  var s = /* @__PURE__ */ St(() => Ee("layup-shrink-0 layup-bg-border", i() === "horizontal" ? "layup-h-[1px] layup-w-full" : "layup-min-h-full layup-w-[1px]", a()));
  U5(e, ot(
    {
      get class() {
        return c(s);
      },
      get orientation() {
        return i();
      },
      get decorative() {
        return o();
      }
    },
    () => r
  )), _e();
}
/**
 * @license lucide-svelte v0.460.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
var Y4 = /* @__PURE__ */ vt("<svg><!><!></svg>");
function Cd(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, [
    "name",
    "color",
    "size",
    "strokeWidth",
    "absoluteStrokeWidth",
    "iconNode"
  ]);
  be(t, !1);
  let a = L(t, "name", 8, void 0), i = L(t, "color", 8, "currentColor"), o = L(t, "size", 8, 24), s = L(t, "strokeWidth", 8, 2), l = L(t, "absoluteStrokeWidth", 8, !1), u = L(t, "iconNode", 24, () => []);
  const d = (...g) => g.filter((w, m, v) => !!w && v.indexOf(w) === m).join(" ");
  gn();
  var f = Y4();
  let p;
  var h = T(f);
  at(h, 1, u, gt, (g, w) => {
    let m = () => c(w)[0], v = () => c(w)[1];
    var C = Z(), S = V(C);
    zm(S, m, !0, (b, x) => {
      let E;
      ee(() => E = Je(b, E, { ...v() }, void 0, b.namespaceURI === Jp, b.nodeName.includes("-")));
    }), _(g, C);
  });
  var y = Q(h);
  He(y, t, "default", {}, null), ee(() => p = Je(
    f,
    p,
    {
      ...Z4,
      ...r,
      width: o(),
      height: o(),
      stroke: i(),
      "stroke-width": l() ? Number(s()) * 24 / Number(o()) : s(),
      class: d("lucide-icon", "lucide", a() ? `lucide-${a()}` : "", n.class)
    },
    void 0,
    !0
  )), _(e, f), _e();
}
function vs(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Cd(e, ot({ name: "check" }, () => n, {
    iconNode: [["path", { d: "M20 6 9 17l-5-5" }]],
    children: (a, i) => {
      var o = Z(), s = V(o);
      He(s, t, "default", {}, null), _(a, o);
    },
    $$slots: { default: !0 }
  }));
}
function Ap(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Cd(e, ot({ name: "mouse-pointer-2" }, () => n, {
    iconNode: [
      [
        "path",
        {
          d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z"
        }
      ]
    ],
    children: (a, i) => {
      var o = Z(), s = V(o);
      He(s, t, "default", {}, null), _(a, o);
    },
    $$slots: { default: !0 }
  }));
}
function X4(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Cd(e, ot({ name: "trash-2" }, () => n, {
    iconNode: [
      ["path", { d: "M3 6h18" }],
      [
        "path",
        { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }
      ],
      [
        "path",
        { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }
      ],
      [
        "line",
        {
          x1: "10",
          x2: "10",
          y1: "11",
          y2: "17"
        }
      ],
      [
        "line",
        {
          x1: "14",
          x2: "14",
          y1: "11",
          y2: "17"
        }
      ]
    ],
    children: (a, i) => {
      var o = Z(), s = V(o);
      He(s, t, "default", {}, null), _(a, o);
    },
    $$slots: { default: !0 }
  }));
}
var J4 = /* @__PURE__ */ vt("<title> </title>"), Q4 = /* @__PURE__ */ vt("<desc> </desc>"), $4 = /* @__PURE__ */ vt('<svg><!><!><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"></path></svg>');
function kr(e, t) {
  var w, m;
  be(t, !0);
  const n = Xl("iconCtx") ?? {};
  let r = L(t, "size", 19, () => n.size || "24"), a = L(t, "role", 19, () => n.role || "img"), i = L(t, "color", 19, () => n.color || "currentColor"), o = L(t, "ariaLabel", 3, "cross 2"), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "size",
    "role",
    "color",
    "title",
    "desc",
    "ariaLabel"
  ]), l = `${((w = t.title) == null ? void 0 : w.id) || ""} ${((m = t.desc) == null ? void 0 : m.id) || ""}`;
  const u = /* @__PURE__ */ R(() => {
    var v, C;
    return !!((v = t.title) != null && v.id || (C = t.desc) != null && C.id);
  });
  var d = $4();
  let f;
  var p = T(d);
  {
    var h = (v) => {
      var C = J4(), S = T(C);
      ee(() => {
        he(C, "id", t.title.id), ke(S, t.title.title);
      }), _(v, C);
    };
    H(p, (v) => {
      var C;
      (C = t.title) != null && C.id && t.title.title && v(h);
    });
  }
  var y = Q(p);
  {
    var g = (v) => {
      var C = Q4(), S = T(C);
      ee(() => {
        he(C, "id", t.desc.id), ke(S, t.desc.desc);
      }), _(v, C);
    };
    H(y, (v) => {
      var C;
      (C = t.desc) != null && C.id && t.desc.desc && v(g);
    });
  }
  ee(() => f = Je(
    d,
    f,
    {
      xmlns: "http://www.w3.org/2000/svg",
      ...s,
      role: a(),
      width: r(),
      height: r(),
      fill: i(),
      "aria-label": o(),
      "aria-describedby": c(u) ? l : void 0,
      viewBox: "0 0 15 15"
    },
    void 0,
    !0
  )), _(e, d), _e();
}
function e9() {
  const e = console.warn;
  console.warn = (t) => {
    t.includes("unknown prop") || t.includes("unexpected slot") || e(t);
  }, Rn(() => {
    console.warn = e;
  });
}
var t9 = /* @__PURE__ */ O("<!> <!>", 1);
function Ir(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, [
    "type",
    "tokens",
    "header",
    "rows",
    "ordered",
    "renderers"
  ]);
  be(t, !1);
  let a = L(t, "type", 8, void 0), i = L(t, "tokens", 8, void 0), o = L(t, "header", 8, void 0), s = L(t, "rows", 8, void 0), l = L(t, "ordered", 8, !1), u = L(t, "renderers", 8);
  e9(), gn();
  var d = Z(), f = V(d);
  {
    var p = (y) => {
      var g = Z(), w = V(g);
      at(w, 1, i, gt, (m, v) => {
        var C = Z(), S = V(C);
        Ir(S, ot(() => c(v), {
          get renderers() {
            return u();
          }
        })), _(m, C);
      }), _(y, g);
    }, h = (y) => {
      var g = Z(), w = V(g);
      {
        var m = (v) => {
          var C = Z(), S = V(C);
          {
            var b = (E) => {
              var k = Z(), I = V(k);
              rt(I, () => u().table, (D, A) => {
                A(D, {
                  children: (M, N) => {
                    var P = t9(), Y = V(P);
                    rt(Y, () => u().tablehead, (q, J) => {
                      J(q, {
                        children: ($, W) => {
                          var j = Z(), B = V(j);
                          rt(B, () => u().tablerow, (K, U) => {
                            U(K, {
                              children: (ne, ue) => {
                                var ae = Z(), se = V(ae);
                                at(se, 1, o, gt, (ge, pe, ve) => {
                                  var me = Z(), we = V(me), fe = /* @__PURE__ */ St(() => r.align[ve] || "center");
                                  rt(we, () => u().tablecell, (Oe, Ue) => {
                                    Ue(Oe, {
                                      header: !0,
                                      get align() {
                                        return c(fe);
                                      },
                                      children: (Fe, qe) => {
                                        var tt = Z(), pt = V(tt);
                                        Ir(pt, {
                                          get tokens() {
                                            return c(pe).tokens;
                                          },
                                          get renderers() {
                                            return u();
                                          }
                                        }), _(Fe, tt);
                                      },
                                      $$slots: { default: !0 }
                                    });
                                  }), _(ge, me);
                                }), _(ne, ae);
                              },
                              $$slots: { default: !0 }
                            });
                          }), _($, j);
                        },
                        $$slots: { default: !0 }
                      });
                    });
                    var G = Q(Y, 2);
                    rt(G, () => u().tablebody, (q, J) => {
                      J(q, {
                        children: ($, W) => {
                          var j = Z(), B = V(j);
                          at(B, 1, s, gt, (K, U) => {
                            var ne = Z(), ue = V(ne);
                            rt(ue, () => u().tablerow, (ae, se) => {
                              se(ae, {
                                children: (ge, pe) => {
                                  var ve = Z(), me = V(ve);
                                  at(me, 1, () => c(U), gt, (we, fe, Oe) => {
                                    var Ue = Z(), Fe = V(Ue), qe = /* @__PURE__ */ St(() => r.align[Oe] || "center");
                                    rt(Fe, () => u().tablecell, (tt, pt) => {
                                      pt(tt, {
                                        header: !1,
                                        get align() {
                                          return c(qe);
                                        },
                                        children: (je, Ge) => {
                                          var mt = Z(), Ke = V(mt);
                                          Ir(Ke, {
                                            get tokens() {
                                              return c(fe).tokens;
                                            },
                                            get renderers() {
                                              return u();
                                            }
                                          }), _(je, mt);
                                        },
                                        $$slots: { default: !0 }
                                      });
                                    }), _(we, Ue);
                                  }), _(ge, ve);
                                },
                                $$slots: { default: !0 }
                              });
                            }), _(K, ne);
                          }), _($, j);
                        },
                        $$slots: { default: !0 }
                      });
                    }), _(M, P);
                  },
                  $$slots: { default: !0 }
                });
              }), _(E, k);
            }, x = (E) => {
              var k = Z(), I = V(k);
              {
                var D = (M) => {
                  var N = Z(), P = V(N);
                  {
                    var Y = (q) => {
                      var J = Z(), $ = V(J);
                      rt($, () => u().list, (W, j) => {
                        j(W, ot(
                          {
                            get ordered() {
                              return l();
                            }
                          },
                          () => r,
                          {
                            children: (B, K) => {
                              var U = Z(), ne = V(U);
                              at(ne, 1, () => r.items, gt, (ue, ae) => {
                                var se = Z(), ge = V(se);
                                rt(ge, () => u().orderedlistitem || u().listitem, (pe, ve) => {
                                  ve(pe, ot(() => c(ae), {
                                    children: (me, we) => {
                                      var fe = Z(), Oe = V(fe);
                                      Ir(Oe, {
                                        get tokens() {
                                          return c(ae).tokens;
                                        },
                                        get renderers() {
                                          return u();
                                        }
                                      }), _(me, fe);
                                    },
                                    $$slots: { default: !0 }
                                  }));
                                }), _(ue, se);
                              }), _(B, U);
                            },
                            $$slots: { default: !0 }
                          }
                        ));
                      }), _(q, J);
                    }, G = (q) => {
                      var J = Z(), $ = V(J);
                      rt($, () => u().list, (W, j) => {
                        j(W, ot(
                          {
                            get ordered() {
                              return l();
                            }
                          },
                          () => r,
                          {
                            children: (B, K) => {
                              var U = Z(), ne = V(U);
                              at(ne, 1, () => r.items, gt, (ue, ae) => {
                                var se = Z(), ge = V(se);
                                rt(ge, () => u().unorderedlistitem || u().listitem, (pe, ve) => {
                                  ve(pe, ot(() => c(ae), {
                                    children: (me, we) => {
                                      var fe = Z(), Oe = V(fe);
                                      Ir(Oe, {
                                        get tokens() {
                                          return c(ae).tokens;
                                        },
                                        get renderers() {
                                          return u();
                                        }
                                      }), _(me, fe);
                                    },
                                    $$slots: { default: !0 }
                                  }));
                                }), _(ue, se);
                              }), _(B, U);
                            },
                            $$slots: { default: !0 }
                          }
                        ));
                      }), _(q, J);
                    };
                    H(P, (q) => {
                      l() ? q(Y) : q(G, !1);
                    });
                  }
                  _(M, N);
                }, A = (M) => {
                  var N = Z(), P = V(N);
                  rt(P, () => u()[a()], (Y, G) => {
                    G(Y, ot(() => r, {
                      children: (q, J) => {
                        var $ = Z(), W = V($);
                        {
                          var j = (K) => {
                            var U = Z(), ne = V(U);
                            Ir(ne, {
                              get tokens() {
                                return i();
                              },
                              get renderers() {
                                return u();
                              }
                            }), _(K, U);
                          }, B = (K) => {
                            var U = qa();
                            ee(() => ke(U, r.raw)), _(K, U);
                          };
                          H(W, (K) => {
                            i() ? K(j) : K(B, !1);
                          });
                        }
                        _(q, $);
                      },
                      $$slots: { default: !0 }
                    }));
                  }), _(M, N);
                };
                H(
                  I,
                  (M) => {
                    a() === "list" ? M(D) : M(A, !1);
                  },
                  !0
                );
              }
              _(E, k);
            };
            H(S, (E) => {
              a() === "table" ? E(b) : E(x, !1);
            });
          }
          _(v, C);
        };
        H(w, (v) => {
          u()[a()] && v(m);
        });
      }
      _(y, g);
    };
    H(f, (y) => {
      a() ? y(h, !1) : y(p);
    });
  }
  _(e, d), _e();
}
function Ed() {
  return {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    hooks: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
}
let Ar = Ed();
function Yg(e) {
  Ar = e;
}
const Xg = /[&<>"']/, n9 = new RegExp(Xg.source, "g"), Jg = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, r9 = new RegExp(Jg.source, "g"), a9 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, Pp = (e) => a9[e];
function Rt(e, t) {
  if (t) {
    if (Xg.test(e))
      return e.replace(n9, Pp);
  } else if (Jg.test(e))
    return e.replace(r9, Pp);
  return e;
}
const i9 = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function Qg(e) {
  return e.replace(i9, (t, n) => (n = n.toLowerCase(), n === "colon" ? ":" : n.charAt(0) === "#" ? n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : ""));
}
const o9 = /(^|[^\[])\^/g;
function it(e, t) {
  e = typeof e == "string" ? e : e.source, t = t || "";
  const n = {
    replace: (r, a) => (a = a.source || a, a = a.replace(o9, "$1"), e = e.replace(r, a), n),
    getRegex: () => new RegExp(e, t)
  };
  return n;
}
const s9 = /[^\w:]/g, l9 = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function Mp(e, t, n) {
  if (e) {
    let r;
    try {
      r = decodeURIComponent(Qg(n)).replace(s9, "").toLowerCase();
    } catch {
      return null;
    }
    if (r.indexOf("javascript:") === 0 || r.indexOf("vbscript:") === 0 || r.indexOf("data:") === 0)
      return null;
  }
  t && !l9.test(n) && (n = f9(t, n));
  try {
    n = encodeURI(n).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return n;
}
const ms = {}, u9 = /^[^:]+:\/*[^/]*$/, c9 = /^([^:]+:)[\s\S]*$/, d9 = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function f9(e, t) {
  ms[" " + e] || (u9.test(e) ? ms[" " + e] = e + "/" : ms[" " + e] = Ps(e, "/", !0)), e = ms[" " + e];
  const n = e.indexOf(":") === -1;
  return t.substring(0, 2) === "//" ? n ? t : e.replace(c9, "$1") + t : t.charAt(0) === "/" ? n ? t : e.replace(d9, "$1") + t : e + t;
}
const Js = { exec: function() {
} };
function Ip(e, t) {
  const n = e.replace(/\|/g, (i, o, s) => {
    let l = !1, u = o;
    for (; --u >= 0 && s[u] === "\\"; ) l = !l;
    return l ? "|" : " |";
  }), r = n.split(/ \|/);
  let a = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), r.length > t)
    r.splice(t);
  else
    for (; r.length < t; ) r.push("");
  for (; a < r.length; a++)
    r[a] = r[a].trim().replace(/\\\|/g, "|");
  return r;
}
function Ps(e, t, n) {
  const r = e.length;
  if (r === 0)
    return "";
  let a = 0;
  for (; a < r; ) {
    const i = e.charAt(r - a - 1);
    if (i === t && !n)
      a++;
    else if (i !== t && n)
      a++;
    else
      break;
  }
  return e.slice(0, r - a);
}
function p9(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  const n = e.length;
  let r = 0, a = 0;
  for (; a < n; a++)
    if (e[a] === "\\")
      a++;
    else if (e[a] === t[0])
      r++;
    else if (e[a] === t[1] && (r--, r < 0))
      return a;
  return -1;
}
function h9(e, t) {
  !e || e.silent || (t && console.warn("marked(): callback is deprecated since version 5.0.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/using_pro#async"), (e.sanitize || e.sanitizer) && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options"), (e.highlight || e.langPrefix !== "language-") && console.warn("marked(): highlight and langPrefix parameters are deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-highlight."), e.mangle && console.warn("marked(): mangle parameter is enabled by default, but is deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install https://www.npmjs.com/package/marked-mangle, or disable by setting `{mangle: false}`."), e.baseUrl && console.warn("marked(): baseUrl parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-base-url."), e.smartypants && console.warn("marked(): smartypants parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-smartypants."), e.xhtml && console.warn("marked(): xhtml parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-xhtml."), (e.headerIds || e.headerPrefix) && console.warn("marked(): headerIds and headerPrefix parameters enabled by default, but are deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install  https://www.npmjs.com/package/marked-gfm-heading-id, or disable by setting `{headerIds: false}`."));
}
function Op(e, t, n, r) {
  const a = t.href, i = t.title ? Rt(t.title) : null, o = e[1].replace(/\\([\[\]])/g, "$1");
  if (e[0].charAt(0) !== "!") {
    r.state.inLink = !0;
    const s = {
      type: "link",
      raw: n,
      href: a,
      title: i,
      text: o,
      tokens: r.inlineTokens(o)
    };
    return r.state.inLink = !1, s;
  }
  return {
    type: "image",
    raw: n,
    href: a,
    title: i,
    text: Rt(o)
  };
}
function y9(e, t) {
  const n = e.match(/^(\s+)(?:```)/);
  if (n === null)
    return t;
  const r = n[1];
  return t.split(`
`).map((a) => {
    const i = a.match(/^\s+/);
    if (i === null)
      return a;
    const [o] = i;
    return o.length >= r.length ? a.slice(r.length) : a;
  }).join(`
`);
}
class Qs {
  constructor(t) {
    this.options = t || Ar;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const r = n[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? r : Ps(r, `
`)
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const r = n[0], a = y9(r, n[3] || "");
      return {
        type: "code",
        raw: r,
        lang: n[2] ? n[2].trim().replace(this.rules.inline._escapes, "$1") : n[2],
        text: a
      };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let r = n[2].trim();
      if (/#$/.test(r)) {
        const a = Ps(r, "#");
        (this.options.pedantic || !a || / $/.test(a)) && (r = a.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n)
      return {
        type: "hr",
        raw: n[0]
      };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      const r = n[0].replace(/^ *>[ \t]?/gm, ""), a = this.lexer.state.top;
      this.lexer.state.top = !0;
      const i = this.lexer.blockTokens(r);
      return this.lexer.state.top = a, {
        type: "blockquote",
        raw: n[0],
        tokens: i,
        text: r
      };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let r, a, i, o, s, l, u, d, f, p, h, y, g = n[1].trim();
      const w = g.length > 1, m = {
        type: "list",
        raw: "",
        ordered: w,
        start: w ? +g.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      g = w ? `\\d{1,9}\\${g.slice(-1)}` : `\\${g}`, this.options.pedantic && (g = w ? g : "[*+-]");
      const v = new RegExp(`^( {0,3}${g})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      for (; t && (y = !1, !(!(n = v.exec(t)) || this.rules.block.hr.test(t))); ) {
        if (r = n[0], t = t.substring(r.length), d = n[2].split(`
`, 1)[0].replace(/^\t+/, (S) => " ".repeat(3 * S.length)), f = t.split(`
`, 1)[0], this.options.pedantic ? (o = 2, h = d.trimLeft()) : (o = n[2].search(/[^ ]/), o = o > 4 ? 1 : o, h = d.slice(o), o += n[1].length), l = !1, !d && /^ *$/.test(f) && (r += f + `
`, t = t.substring(f.length + 1), y = !0), !y) {
          const S = new RegExp(`^ {0,${Math.min(3, o - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), b = new RegExp(`^ {0,${Math.min(3, o - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), x = new RegExp(`^ {0,${Math.min(3, o - 1)}}(?:\`\`\`|~~~)`), E = new RegExp(`^ {0,${Math.min(3, o - 1)}}#`);
          for (; t && (p = t.split(`
`, 1)[0], f = p, this.options.pedantic && (f = f.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(x.test(f) || E.test(f) || S.test(f) || b.test(t))); ) {
            if (f.search(/[^ ]/) >= o || !f.trim())
              h += `
` + f.slice(o);
            else {
              if (l || d.search(/[^ ]/) >= 4 || x.test(d) || E.test(d) || b.test(d))
                break;
              h += `
` + f;
            }
            !l && !f.trim() && (l = !0), r += p + `
`, t = t.substring(p.length + 1), d = f.slice(o);
          }
        }
        m.loose || (u ? m.loose = !0 : /\n *\n *$/.test(r) && (u = !0)), this.options.gfm && (a = /^\[[ xX]\] /.exec(h), a && (i = a[0] !== "[ ] ", h = h.replace(/^\[[ xX]\] +/, ""))), m.items.push({
          type: "list_item",
          raw: r,
          task: !!a,
          checked: i,
          loose: !1,
          text: h
        }), m.raw += r;
      }
      m.items[m.items.length - 1].raw = r.trimRight(), m.items[m.items.length - 1].text = h.trimRight(), m.raw = m.raw.trimRight();
      const C = m.items.length;
      for (s = 0; s < C; s++)
        if (this.lexer.state.top = !1, m.items[s].tokens = this.lexer.blockTokens(m.items[s].text, []), !m.loose) {
          const S = m.items[s].tokens.filter((x) => x.type === "space"), b = S.length > 0 && S.some((x) => /\n.*\n/.test(x.raw));
          m.loose = b;
        }
      if (m.loose)
        for (s = 0; s < C; s++)
          m.items[s].loose = !0;
      return m;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n) {
      const r = {
        type: "html",
        block: !0,
        raw: n[0],
        pre: !this.options.sanitizer && (n[1] === "pre" || n[1] === "script" || n[1] === "style"),
        text: n[0]
      };
      if (this.options.sanitize) {
        const a = this.options.sanitizer ? this.options.sanitizer(n[0]) : Rt(n[0]);
        r.type = "paragraph", r.text = a, r.tokens = this.lexer.inline(a);
      }
      return r;
    }
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n) {
      const r = n[1].toLowerCase().replace(/\s+/g, " "), a = n[2] ? n[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline._escapes, "$1") : n[3];
      return {
        type: "def",
        tag: r,
        raw: n[0],
        href: a,
        title: i
      };
    }
  }
  table(t) {
    const n = this.rules.block.table.exec(t);
    if (n) {
      const r = {
        type: "table",
        header: Ip(n[1]).map((a) => ({ text: a })),
        align: n[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: n[3] && n[3].trim() ? n[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (r.header.length === r.align.length) {
        r.raw = n[0];
        let a = r.align.length, i, o, s, l;
        for (i = 0; i < a; i++)
          /^ *-+: *$/.test(r.align[i]) ? r.align[i] = "right" : /^ *:-+: *$/.test(r.align[i]) ? r.align[i] = "center" : /^ *:-+ *$/.test(r.align[i]) ? r.align[i] = "left" : r.align[i] = null;
        for (a = r.rows.length, i = 0; i < a; i++)
          r.rows[i] = Ip(r.rows[i], r.header.length).map((u) => ({ text: u }));
        for (a = r.header.length, o = 0; o < a; o++)
          r.header[o].tokens = this.lexer.inline(r.header[o].text);
        for (a = r.rows.length, o = 0; o < a; o++)
          for (l = r.rows[o], s = 0; s < l.length; s++)
            l[s].tokens = this.lexer.inline(l[s].text);
        return r;
      }
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const r = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: Rt(n[1])
      };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return !this.lexer.state.inLink && /^<a /i.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(n[0]) : Rt(n[0]) : n[0]
      };
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const r = n[2].trim();
      if (!this.options.pedantic && /^</.test(r)) {
        if (!/>$/.test(r))
          return;
        const o = Ps(r.slice(0, -1), "\\");
        if ((r.length - o.length) % 2 === 0)
          return;
      } else {
        const o = p9(n[2], "()");
        if (o > -1) {
          const l = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + o;
          n[2] = n[2].substring(0, o), n[0] = n[0].substring(0, l).trim(), n[3] = "";
        }
      }
      let a = n[2], i = "";
      if (this.options.pedantic) {
        const o = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(a);
        o && (a = o[1], i = o[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return a = a.trim(), /^</.test(a) && (this.options.pedantic && !/>$/.test(r) ? a = a.slice(1) : a = a.slice(1, -1)), Op(n, {
        href: a && a.replace(this.rules.inline._escapes, "$1"),
        title: i && i.replace(this.rules.inline._escapes, "$1")
      }, n[0], this.lexer);
    }
  }
  reflink(t, n) {
    let r;
    if ((r = this.rules.inline.reflink.exec(t)) || (r = this.rules.inline.nolink.exec(t))) {
      let a = (r[2] || r[1]).replace(/\s+/g, " ");
      if (a = n[a.toLowerCase()], !a) {
        const i = r[0].charAt(0);
        return {
          type: "text",
          raw: i,
          text: i
        };
      }
      return Op(r, a, r[0], this.lexer);
    }
  }
  emStrong(t, n, r = "") {
    let a = this.rules.inline.emStrong.lDelim.exec(t);
    if (!a || a[3] && r.match(/[\p{L}\p{N}]/u)) return;
    if (!(a[1] || a[2] || "") || !r || this.rules.inline.punctuation.exec(r)) {
      const o = a[0].length - 1;
      let s, l, u = o, d = 0;
      const f = a[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (f.lastIndex = 0, n = n.slice(-1 * t.length + o); (a = f.exec(n)) != null; ) {
        if (s = a[1] || a[2] || a[3] || a[4] || a[5] || a[6], !s) continue;
        if (l = s.length, a[3] || a[4]) {
          u += l;
          continue;
        } else if ((a[5] || a[6]) && o % 3 && !((o + l) % 3)) {
          d += l;
          continue;
        }
        if (u -= l, u > 0) continue;
        l = Math.min(l, l + u + d);
        const p = t.slice(0, o + a.index + l + 1);
        if (Math.min(o, l) % 2) {
          const y = p.slice(1, -1);
          return {
            type: "em",
            raw: p,
            text: y,
            tokens: this.lexer.inlineTokens(y)
          };
        }
        const h = p.slice(2, -2);
        return {
          type: "strong",
          raw: p,
          text: h,
          tokens: this.lexer.inlineTokens(h)
        };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let r = n[2].replace(/\n/g, " ");
      const a = /[^ ]/.test(r), i = /^ /.test(r) && / $/.test(r);
      return a && i && (r = r.substring(1, r.length - 1)), r = Rt(r, !0), {
        type: "codespan",
        raw: n[0],
        text: r
      };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(t, n) {
    const r = this.rules.inline.autolink.exec(t);
    if (r) {
      let a, i;
      return r[2] === "@" ? (a = Rt(this.options.mangle ? n(r[1]) : r[1]), i = "mailto:" + a) : (a = Rt(r[1]), i = a), {
        type: "link",
        raw: r[0],
        text: a,
        href: i,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  url(t, n) {
    let r;
    if (r = this.rules.inline.url.exec(t)) {
      let a, i;
      if (r[2] === "@")
        a = Rt(this.options.mangle ? n(r[0]) : r[0]), i = "mailto:" + a;
      else {
        let o;
        do
          o = r[0], r[0] = this.rules.inline._backpedal.exec(r[0])[0];
        while (o !== r[0]);
        a = Rt(r[0]), r[1] === "www." ? i = "http://" + r[0] : i = r[0];
      }
      return {
        type: "link",
        raw: r[0],
        text: a,
        href: i,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  inlineText(t, n) {
    const r = this.rules.inline.text.exec(t);
    if (r) {
      let a;
      return this.lexer.state.inRawBlock ? a = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : Rt(r[0]) : r[0] : a = Rt(this.options.smartypants ? n(r[0]) : r[0]), {
        type: "text",
        raw: r[0],
        text: a
      };
    }
  }
}
const Ce = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: Js,
  lheading: /^((?:(?!^bull ).|\n(?!\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
Ce._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
Ce._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
Ce.def = it(Ce.def).replace("label", Ce._label).replace("title", Ce._title).getRegex();
Ce.bullet = /(?:[*+-]|\d{1,9}[.)])/;
Ce.listItemStart = it(/^( *)(bull) */).replace("bull", Ce.bullet).getRegex();
Ce.list = it(Ce.list).replace(/bull/g, Ce.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + Ce.def.source + ")").getRegex();
Ce._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
Ce._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
Ce.html = it(Ce.html, "i").replace("comment", Ce._comment).replace("tag", Ce._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
Ce.lheading = it(Ce.lheading).replace(/bull/g, Ce.bullet).getRegex();
Ce.paragraph = it(Ce._paragraph).replace("hr", Ce.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ce._tag).getRegex();
Ce.blockquote = it(Ce.blockquote).replace("paragraph", Ce.paragraph).getRegex();
Ce.normal = { ...Ce };
Ce.gfm = {
  ...Ce.normal,
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
Ce.gfm.table = it(Ce.gfm.table).replace("hr", Ce.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ce._tag).getRegex();
Ce.gfm.paragraph = it(Ce._paragraph).replace("hr", Ce.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", Ce.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ce._tag).getRegex();
Ce.pedantic = {
  ...Ce.normal,
  html: it(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", Ce._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Js,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: it(Ce.normal._paragraph).replace("hr", Ce.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Ce.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const ye = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: Js,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
    //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
    rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: Js,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^((?![*_])[\spunctuation])/
};
ye._punctuation = "\\p{P}$+<=>`^|~";
ye.punctuation = it(ye.punctuation, "u").replace(/punctuation/g, ye._punctuation).getRegex();
ye.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
ye.anyPunctuation = /\\[punct]/g;
ye._escapes = /\\([punct])/g;
ye._comment = it(Ce._comment).replace("(?:-->|$)", "-->").getRegex();
ye.emStrong.lDelim = it(ye.emStrong.lDelim, "u").replace(/punct/g, ye._punctuation).getRegex();
ye.emStrong.rDelimAst = it(ye.emStrong.rDelimAst, "gu").replace(/punct/g, ye._punctuation).getRegex();
ye.emStrong.rDelimUnd = it(ye.emStrong.rDelimUnd, "gu").replace(/punct/g, ye._punctuation).getRegex();
ye.anyPunctuation = it(ye.anyPunctuation, "gu").replace(/punct/g, ye._punctuation).getRegex();
ye._escapes = it(ye._escapes, "gu").replace(/punct/g, ye._punctuation).getRegex();
ye._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
ye._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
ye.autolink = it(ye.autolink).replace("scheme", ye._scheme).replace("email", ye._email).getRegex();
ye._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
ye.tag = it(ye.tag).replace("comment", ye._comment).replace("attribute", ye._attribute).getRegex();
ye._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
ye._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
ye._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
ye.link = it(ye.link).replace("label", ye._label).replace("href", ye._href).replace("title", ye._title).getRegex();
ye.reflink = it(ye.reflink).replace("label", ye._label).replace("ref", Ce._label).getRegex();
ye.nolink = it(ye.nolink).replace("ref", Ce._label).getRegex();
ye.reflinkSearch = it(ye.reflinkSearch, "g").replace("reflink", ye.reflink).replace("nolink", ye.nolink).getRegex();
ye.normal = { ...ye };
ye.pedantic = {
  ...ye.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: it(/^!?\[(label)\]\((.*?)\)/).replace("label", ye._label).getRegex(),
  reflink: it(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", ye._label).getRegex()
};
ye.gfm = {
  ...ye.normal,
  escape: it(ye.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
ye.gfm.url = it(ye.gfm.url, "i").replace("email", ye.gfm._extended_email).getRegex();
ye.breaks = {
  ...ye.gfm,
  br: it(ye.br).replace("{2,}", "*").getRegex(),
  text: it(ye.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
function g9(e) {
  return e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function Fp(e) {
  let t = "", n, r;
  const a = e.length;
  for (n = 0; n < a; n++)
    r = e.charCodeAt(n), Math.random() > 0.5 && (r = "x" + r.toString(16)), t += "&#" + r + ";";
  return t;
}
class ln {
  constructor(t) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || Ar, this.options.tokenizer = this.options.tokenizer || new Qs(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      block: Ce.normal,
      inline: ye.normal
    };
    this.options.pedantic ? (n.block = Ce.pedantic, n.inline = ye.pedantic) : this.options.gfm && (n.block = Ce.gfm, this.options.breaks ? n.inline = ye.breaks : n.inline = ye.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: Ce,
      inline: ye
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new ln(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new ln(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(/\r\n|\r/g, `
`), this.blockTokens(t, this.tokens);
    let n;
    for (; n = this.inlineQueue.shift(); )
      this.inlineTokens(n.src, n.tokens);
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(t, n = []) {
    this.options.pedantic ? t = t.replace(/\t/g, "    ").replace(/^ +$/gm, "") : t = t.replace(/^( *)(\t+)/gm, (s, l, u) => l + "    ".repeat(u.length));
    let r, a, i, o;
    for (; t; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((s) => (r = s.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.space(t)) {
          t = t.substring(r.raw.length), r.raw.length === 1 && n.length > 0 ? n[n.length - 1].raw += `
` : n.push(r);
          continue;
        }
        if (r = this.tokenizer.code(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.fences(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.heading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.hr(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.blockquote(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.list(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.html(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.def(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
            href: r.href,
            title: r.title
          });
          continue;
        }
        if (r = this.tokenizer.table(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.lheading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startBlock) {
          let s = 1 / 0;
          const l = t.slice(1);
          let u;
          this.options.extensions.startBlock.forEach(function(d) {
            u = d.call({ lexer: this }, l), typeof u == "number" && u >= 0 && (s = Math.min(s, u));
          }), s < 1 / 0 && s >= 0 && (i = t.substring(0, s + 1));
        }
        if (this.state.top && (r = this.tokenizer.paragraph(i))) {
          a = n[n.length - 1], o && a.type === "paragraph" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r), o = i.length !== t.length, t = t.substring(r.raw.length);
          continue;
        }
        if (r = this.tokenizer.text(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && a.type === "text" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (t) {
          const s = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(s);
            break;
          } else
            throw new Error(s);
        }
      }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    let r, a, i, o = t, s, l, u;
    if (this.tokens.links) {
      const d = Object.keys(this.tokens.links);
      if (d.length > 0)
        for (; (s = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          d.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (s = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (s = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, s.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; t; )
      if (l || (u = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((d) => (r = d.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.escape(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.tag(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.link(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.reflink(t, this.tokens.links)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.emStrong(t, o, u)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.codespan(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.br(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.del(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.autolink(t, Fp)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (!this.state.inLink && (r = this.tokenizer.url(t, Fp))) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startInline) {
          let d = 1 / 0;
          const f = t.slice(1);
          let p;
          this.options.extensions.startInline.forEach(function(h) {
            p = h.call({ lexer: this }, f), typeof p == "number" && p >= 0 && (d = Math.min(d, p));
          }), d < 1 / 0 && d >= 0 && (i = t.substring(0, d + 1));
        }
        if (r = this.tokenizer.inlineText(i, g9)) {
          t = t.substring(r.raw.length), r.raw.slice(-1) !== "_" && (u = r.raw.slice(-1)), l = !0, a = n[n.length - 1], a && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (t) {
          const d = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(d);
            break;
          } else
            throw new Error(d);
        }
      }
    return n;
  }
}
class $s {
  constructor(t) {
    this.options = t || Ar;
  }
  code(t, n, r) {
    const a = (n || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const i = this.options.highlight(t, a);
      i != null && i !== t && (r = !0, t = i);
    }
    return t = t.replace(/\n$/, "") + `
`, a ? '<pre><code class="' + this.options.langPrefix + Rt(a) + '">' + (r ? t : Rt(t, !0)) + `</code></pre>
` : "<pre><code>" + (r ? t : Rt(t, !0)) + `</code></pre>
`;
  }
  /**
   * @param {string} quote
   */
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t, n) {
    return t;
  }
  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(t, n, r, a) {
    if (this.options.headerIds) {
      const i = this.options.headerPrefix + a.slug(r);
      return `<h${n} id="${i}">${t}</h${n}>
`;
    }
    return `<h${n}>${t}</h${n}>
`;
  }
  hr() {
    return this.options.xhtml ? `<hr/>
` : `<hr>
`;
  }
  list(t, n, r) {
    const a = n ? "ol" : "ul", i = n && r !== 1 ? ' start="' + r + '"' : "";
    return "<" + a + i + `>
` + t + "</" + a + `>
`;
  }
  /**
   * @param {string} text
   */
  listitem(t) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  /**
   * @param {string} text
   */
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  /**
   * @param {string} header
   * @param {string} body
   */
  table(t, n) {
    return n && (n = `<tbody>${n}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + n + `</table>
`;
  }
  /**
   * @param {string} content
   */
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, n) {
    const r = n.header ? "th" : "td";
    return (n.align ? `<${r} align="${n.align}">` : `<${r}>`) + t + `</${r}>
`;
  }
  /**
   * span level renderer
   * @param {string} text
   */
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  /**
   * @param {string} text
   */
  em(t) {
    return `<em>${t}</em>`;
  }
  /**
   * @param {string} text
   */
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  /**
   * @param {string} text
   */
  del(t) {
    return `<del>${t}</del>`;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(t, n, r) {
    if (t = Mp(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let a = '<a href="' + t + '"';
    return n && (a += ' title="' + n + '"'), a += ">" + r + "</a>", a;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(t, n, r) {
    if (t = Mp(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let a = `<img src="${t}" alt="${r}"`;
    return n && (a += ` title="${n}"`), a += this.options.xhtml ? "/>" : ">", a;
  }
  text(t) {
    return t;
  }
}
class Td {
  // no need for block level renderers
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, n, r) {
    return "" + r;
  }
  image(t, n, r) {
    return "" + r;
  }
  br() {
    return "";
  }
}
class Hi {
  constructor() {
    this.seen = {};
  }
  /**
   * @param {string} value
   */
  serialize(t) {
    return t.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(t, n) {
    let r = t, a = 0;
    if (this.seen.hasOwnProperty(r)) {
      a = this.seen[t];
      do
        a++, r = t + "-" + a;
      while (this.seen.hasOwnProperty(r));
    }
    return n || (this.seen[t] = a, this.seen[r] = 0), r;
  }
  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(t, n = {}) {
    const r = this.serialize(t);
    return this.getNextSafeSlug(r, n.dryrun);
  }
}
class Cn {
  constructor(t) {
    this.options = t || Ar, this.options.renderer = this.options.renderer || new $s(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Td(), this.slugger = new Hi();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new Cn(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new Cn(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    let r = "", a, i, o, s, l, u, d, f, p, h, y, g, w, m, v, C, S, b, x;
    const E = t.length;
    for (a = 0; a < E; a++) {
      if (h = t[a], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[h.type] && (x = this.options.extensions.renderers[h.type].call({ parser: this }, h), x !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(h.type))) {
        r += x || "";
        continue;
      }
      switch (h.type) {
        case "space":
          continue;
        case "hr": {
          r += this.renderer.hr();
          continue;
        }
        case "heading": {
          r += this.renderer.heading(
            this.parseInline(h.tokens),
            h.depth,
            Qg(this.parseInline(h.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          r += this.renderer.code(
            h.text,
            h.lang,
            h.escaped
          );
          continue;
        }
        case "table": {
          for (f = "", d = "", s = h.header.length, i = 0; i < s; i++)
            d += this.renderer.tablecell(
              this.parseInline(h.header[i].tokens),
              { header: !0, align: h.align[i] }
            );
          for (f += this.renderer.tablerow(d), p = "", s = h.rows.length, i = 0; i < s; i++) {
            for (u = h.rows[i], d = "", l = u.length, o = 0; o < l; o++)
              d += this.renderer.tablecell(
                this.parseInline(u[o].tokens),
                { header: !1, align: h.align[o] }
              );
            p += this.renderer.tablerow(d);
          }
          r += this.renderer.table(f, p);
          continue;
        }
        case "blockquote": {
          p = this.parse(h.tokens), r += this.renderer.blockquote(p);
          continue;
        }
        case "list": {
          for (y = h.ordered, g = h.start, w = h.loose, s = h.items.length, p = "", i = 0; i < s; i++)
            v = h.items[i], C = v.checked, S = v.task, m = "", v.task && (b = this.renderer.checkbox(C), w ? v.tokens.length > 0 && v.tokens[0].type === "paragraph" ? (v.tokens[0].text = b + " " + v.tokens[0].text, v.tokens[0].tokens && v.tokens[0].tokens.length > 0 && v.tokens[0].tokens[0].type === "text" && (v.tokens[0].tokens[0].text = b + " " + v.tokens[0].tokens[0].text)) : v.tokens.unshift({
              type: "text",
              text: b
            }) : m += b), m += this.parse(v.tokens, w), p += this.renderer.listitem(m, S, C);
          r += this.renderer.list(p, y, g);
          continue;
        }
        case "html": {
          r += this.renderer.html(h.text, h.block);
          continue;
        }
        case "paragraph": {
          r += this.renderer.paragraph(this.parseInline(h.tokens));
          continue;
        }
        case "text": {
          for (p = h.tokens ? this.parseInline(h.tokens) : h.text; a + 1 < E && t[a + 1].type === "text"; )
            h = t[++a], p += `
` + (h.tokens ? this.parseInline(h.tokens) : h.text);
          r += n ? this.renderer.paragraph(p) : p;
          continue;
        }
        default: {
          const k = 'Token with "' + h.type + '" type was not found.';
          if (this.options.silent) {
            console.error(k);
            return;
          } else
            throw new Error(k);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n) {
    n = n || this.renderer;
    let r = "", a, i, o;
    const s = t.length;
    for (a = 0; a < s; a++) {
      if (i = t[a], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type] && (o = this.options.extensions.renderers[i.type].call({ parser: this }, i), o !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type))) {
        r += o || "";
        continue;
      }
      switch (i.type) {
        case "escape": {
          r += n.text(i.text);
          break;
        }
        case "html": {
          r += n.html(i.text);
          break;
        }
        case "link": {
          r += n.link(i.href, i.title, this.parseInline(i.tokens, n));
          break;
        }
        case "image": {
          r += n.image(i.href, i.title, i.text);
          break;
        }
        case "strong": {
          r += n.strong(this.parseInline(i.tokens, n));
          break;
        }
        case "em": {
          r += n.em(this.parseInline(i.tokens, n));
          break;
        }
        case "codespan": {
          r += n.codespan(i.text);
          break;
        }
        case "br": {
          r += n.br();
          break;
        }
        case "del": {
          r += n.del(this.parseInline(i.tokens, n));
          break;
        }
        case "text": {
          r += n.text(i.text);
          break;
        }
        default: {
          const l = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent) {
            console.error(l);
            return;
          } else
            throw new Error(l);
        }
      }
    }
    return r;
  }
}
class Pi {
  constructor(t) {
    this.options = t || Ar;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
}
Le(Pi, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
var $r, vc, $g;
class v9 {
  constructor(...t) {
    te(this, $r);
    Le(this, "defaults", Ed());
    Le(this, "options", this.setOptions);
    Le(this, "parse", qt(this, $r, vc).call(this, ln.lex, Cn.parse));
    Le(this, "parseInline", qt(this, $r, vc).call(this, ln.lexInline, Cn.parseInline));
    Le(this, "Parser", Cn);
    Le(this, "parser", Cn.parse);
    Le(this, "Renderer", $s);
    Le(this, "TextRenderer", Td);
    Le(this, "Lexer", ln);
    Le(this, "lexer", ln.lex);
    Le(this, "Tokenizer", Qs);
    Le(this, "Slugger", Hi);
    Le(this, "Hooks", Pi);
    this.use(...t);
  }
  walkTokens(t, n) {
    let r = [];
    for (const a of t)
      switch (r = r.concat(n.call(this, a)), a.type) {
        case "table": {
          for (const i of a.header)
            r = r.concat(this.walkTokens(i.tokens, n));
          for (const i of a.rows)
            for (const o of i)
              r = r.concat(this.walkTokens(o.tokens, n));
          break;
        }
        case "list": {
          r = r.concat(this.walkTokens(a.items, n));
          break;
        }
        default:
          this.defaults.extensions && this.defaults.extensions.childTokens && this.defaults.extensions.childTokens[a.type] ? this.defaults.extensions.childTokens[a.type].forEach((i) => {
            r = r.concat(this.walkTokens(a[i], n));
          }) : a.tokens && (r = r.concat(this.walkTokens(a.tokens, n)));
      }
    return r;
  }
  use(...t) {
    const n = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((r) => {
      const a = { ...r };
      if (a.async = this.defaults.async || a.async || !1, r.extensions && (r.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if (i.renderer) {
          const o = n.renderers[i.name];
          o ? n.renderers[i.name] = function(...s) {
            let l = i.renderer.apply(this, s);
            return l === !1 && (l = o.apply(this, s)), l;
          } : n.renderers[i.name] = i.renderer;
        }
        if (i.tokenizer) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          n[i.level] ? n[i.level].unshift(i.tokenizer) : n[i.level] = [i.tokenizer], i.start && (i.level === "block" ? n.startBlock ? n.startBlock.push(i.start) : n.startBlock = [i.start] : i.level === "inline" && (n.startInline ? n.startInline.push(i.start) : n.startInline = [i.start]));
        }
        i.childTokens && (n.childTokens[i.name] = i.childTokens);
      }), a.extensions = n), r.renderer) {
        const i = this.defaults.renderer || new $s(this.defaults);
        for (const o in r.renderer) {
          const s = i[o];
          i[o] = (...l) => {
            let u = r.renderer[o].apply(i, l);
            return u === !1 && (u = s.apply(i, l)), u;
          };
        }
        a.renderer = i;
      }
      if (r.tokenizer) {
        const i = this.defaults.tokenizer || new Qs(this.defaults);
        for (const o in r.tokenizer) {
          const s = i[o];
          i[o] = (...l) => {
            let u = r.tokenizer[o].apply(i, l);
            return u === !1 && (u = s.apply(i, l)), u;
          };
        }
        a.tokenizer = i;
      }
      if (r.hooks) {
        const i = this.defaults.hooks || new Pi();
        for (const o in r.hooks) {
          const s = i[o];
          Pi.passThroughHooks.has(o) ? i[o] = (l) => {
            if (this.defaults.async)
              return Promise.resolve(r.hooks[o].call(i, l)).then((d) => s.call(i, d));
            const u = r.hooks[o].call(i, l);
            return s.call(i, u);
          } : i[o] = (...l) => {
            let u = r.hooks[o].apply(i, l);
            return u === !1 && (u = s.apply(i, l)), u;
          };
        }
        a.hooks = i;
      }
      if (r.walkTokens) {
        const i = this.defaults.walkTokens;
        a.walkTokens = function(o) {
          let s = [];
          return s.push(r.walkTokens.call(this, o)), i && (s = s.concat(i.call(this, o))), s;
        };
      }
      this.defaults = { ...this.defaults, ...a };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
}
$r = new WeakSet(), vc = function(t, n) {
  return (r, a, i) => {
    typeof a == "function" && (i = a, a = null);
    const o = { ...a };
    a = { ...this.defaults, ...o };
    const s = qt(this, $r, $g).call(this, a.silent, a.async, i);
    if (typeof r > "u" || r === null)
      return s(new Error("marked(): input parameter is undefined or null"));
    if (typeof r != "string")
      return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(r) + ", string expected"));
    if (h9(a, i), a.hooks && (a.hooks.options = a), i) {
      const l = a.highlight;
      let u;
      try {
        a.hooks && (r = a.hooks.preprocess(r)), u = t(r, a);
      } catch (p) {
        return s(p);
      }
      const d = (p) => {
        let h;
        if (!p)
          try {
            a.walkTokens && this.walkTokens(u, a.walkTokens), h = n(u, a), a.hooks && (h = a.hooks.postprocess(h));
          } catch (y) {
            p = y;
          }
        return a.highlight = l, p ? s(p) : i(null, h);
      };
      if (!l || l.length < 3 || (delete a.highlight, !u.length)) return d();
      let f = 0;
      this.walkTokens(u, (p) => {
        p.type === "code" && (f++, setTimeout(() => {
          l(p.text, p.lang, (h, y) => {
            if (h)
              return d(h);
            y != null && y !== p.text && (p.text = y, p.escaped = !0), f--, f === 0 && d();
          });
        }, 0));
      }), f === 0 && d();
      return;
    }
    if (a.async)
      return Promise.resolve(a.hooks ? a.hooks.preprocess(r) : r).then((l) => t(l, a)).then((l) => a.walkTokens ? Promise.all(this.walkTokens(l, a.walkTokens)).then(() => l) : l).then((l) => n(l, a)).then((l) => a.hooks ? a.hooks.postprocess(l) : l).catch(s);
    try {
      a.hooks && (r = a.hooks.preprocess(r));
      const l = t(r, a);
      a.walkTokens && this.walkTokens(l, a.walkTokens);
      let u = n(l, a);
      return a.hooks && (u = a.hooks.postprocess(u)), u;
    } catch (l) {
      return s(l);
    }
  };
}, $g = function(t, n, r) {
  return (a) => {
    if (a.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
      const i = "<p>An error occurred:</p><pre>" + Rt(a.message + "", !0) + "</pre>";
      if (n)
        return Promise.resolve(i);
      if (r) {
        r(null, i);
        return;
      }
      return i;
    }
    if (n)
      return Promise.reject(a);
    if (r) {
      r(a);
      return;
    }
    throw a;
  };
};
const Qr = new v9(Ar);
function st(e, t, n) {
  return Qr.parse(e, t, n);
}
st.options = st.setOptions = function(e) {
  return Qr.setOptions(e), st.defaults = Qr.defaults, Yg(st.defaults), st;
};
st.getDefaults = Ed;
st.defaults = Ar;
st.use = function(...e) {
  return Qr.use(...e), st.defaults = Qr.defaults, Yg(st.defaults), st;
};
st.walkTokens = function(e, t) {
  return Qr.walkTokens(e, t);
};
st.parseInline = Qr.parseInline;
st.Parser = Cn;
st.parser = Cn.parse;
st.Renderer = $s;
st.TextRenderer = Td;
st.Lexer = ln;
st.lexer = ln.lex;
st.Tokenizer = Qs;
st.Slugger = Hi;
st.Hooks = Pi;
st.parse = st;
st.options;
st.setOptions;
st.use;
st.walkTokens;
st.parseInline;
Cn.parse;
ln.lex;
const ev = {};
var m9 = /* @__PURE__ */ O("<h1><!></h1>"), w9 = /* @__PURE__ */ O("<h2><!></h2>"), b9 = /* @__PURE__ */ O("<h3><!></h3>"), _9 = /* @__PURE__ */ O("<h4><!></h4>"), x9 = /* @__PURE__ */ O("<h5><!></h5>"), k9 = /* @__PURE__ */ O("<h6><!></h6>");
function S9(e, t) {
  be(t, !1);
  const n = We();
  let r = L(t, "depth", 8), a = L(t, "raw", 8), i = L(t, "text", 8);
  const { slug: o, getOptions: s } = Xl(ev), l = s();
  Xe(() => Qe(i()), () => {
    z(n, l.headerIds ? l.headerPrefix + o(i()) : void 0);
  }), Gl(), gn();
  var u = Z(), d = V(u);
  {
    var f = (h) => {
      var y = m9(), g = T(y);
      He(g, t, "default", {}, null), ee(() => he(y, "id", c(n))), _(h, y);
    }, p = (h) => {
      var y = Z(), g = V(y);
      {
        var w = (v) => {
          var C = w9(), S = T(C);
          He(S, t, "default", {}, null), ee(() => he(C, "id", c(n))), _(v, C);
        }, m = (v) => {
          var C = Z(), S = V(C);
          {
            var b = (E) => {
              var k = b9(), I = T(k);
              He(I, t, "default", {}, null), ee(() => he(k, "id", c(n))), _(E, k);
            }, x = (E) => {
              var k = Z(), I = V(k);
              {
                var D = (M) => {
                  var N = _9(), P = T(N);
                  He(P, t, "default", {}, null), ee(() => he(N, "id", c(n))), _(M, N);
                }, A = (M) => {
                  var N = Z(), P = V(N);
                  {
                    var Y = (q) => {
                      var J = x9(), $ = T(J);
                      He($, t, "default", {}, null), ee(() => he(J, "id", c(n))), _(q, J);
                    }, G = (q) => {
                      var J = Z(), $ = V(J);
                      {
                        var W = (B) => {
                          var K = k9(), U = T(K);
                          He(U, t, "default", {}, null), ee(() => he(K, "id", c(n))), _(B, K);
                        }, j = (B) => {
                          var K = qa();
                          ee(() => ke(K, a())), _(B, K);
                        };
                        H(
                          $,
                          (B) => {
                            r() === 6 ? B(W) : B(j, !1);
                          },
                          !0
                        );
                      }
                      _(q, J);
                    };
                    H(
                      P,
                      (q) => {
                        r() === 5 ? q(Y) : q(G, !1);
                      },
                      !0
                    );
                  }
                  _(M, N);
                };
                H(
                  I,
                  (M) => {
                    r() === 4 ? M(D) : M(A, !1);
                  },
                  !0
                );
              }
              _(E, k);
            };
            H(
              S,
              (E) => {
                r() === 3 ? E(b) : E(x, !1);
              },
              !0
            );
          }
          _(v, C);
        };
        H(
          g,
          (v) => {
            r() === 2 ? v(w) : v(m, !1);
          },
          !0
        );
      }
      _(h, y);
    };
    H(d, (h) => {
      r() === 1 ? h(f) : h(p, !1);
    });
  }
  _(e, u), _e();
}
var C9 = /* @__PURE__ */ O("<p><!></p>");
function E9(e, t) {
  var n = C9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
function T9(e, t) {
  L(t, "text", 8)(), L(t, "raw", 8)();
  var a = Z(), i = V(a);
  He(i, t, "default", {}, null), _(e, a);
}
var A9 = /* @__PURE__ */ O("<img>");
function P9(e, t) {
  let n = L(t, "href", 8, ""), r = L(t, "title", 8, void 0), a = L(t, "text", 8, "");
  var i = A9();
  ee(() => {
    he(i, "src", n()), he(i, "title", r()), he(i, "alt", a());
  }), _(e, i);
}
var M9 = /* @__PURE__ */ O("<a><!></a>");
function I9(e, t) {
  let n = L(t, "href", 8, ""), r = L(t, "title", 8, void 0);
  var a = M9(), i = T(a);
  He(i, t, "default", {}, null), ee(() => {
    he(a, "href", n()), he(a, "title", r());
  }), _(e, a);
}
var O9 = /* @__PURE__ */ O("<em><!></em>");
function F9(e, t) {
  var n = O9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var R9 = /* @__PURE__ */ O("<del><!></del>");
function L9(e, t) {
  var n = R9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var D9 = /* @__PURE__ */ O("<code> </code>");
function N9(e, t) {
  be(t, !1);
  let n = L(t, "raw", 8);
  gn();
  var r = D9(), a = T(r);
  ee(() => ke(a, n().replace(/`/g, ""))), _(e, r), _e();
}
var z9 = /* @__PURE__ */ O("<strong><!></strong>");
function V9(e, t) {
  var n = z9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var B9 = /* @__PURE__ */ O("<table><!></table>");
function j9(e, t) {
  var n = B9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var W9 = /* @__PURE__ */ O("<thead><!></thead>");
function H9(e, t) {
  var n = W9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var U9 = /* @__PURE__ */ O("<tbody><!></tbody>");
function q9(e, t) {
  var n = U9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var G9 = /* @__PURE__ */ O("<tr><!></tr>");
function K9(e, t) {
  var n = G9(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var Z9 = /* @__PURE__ */ O("<th><!></th>"), Y9 = /* @__PURE__ */ O("<td><!></td>");
function X9(e, t) {
  let n = L(t, "header", 8), r = L(t, "align", 8);
  var a = Z(), i = V(a);
  {
    var o = (l) => {
      var u = Z9(), d = T(u);
      He(d, t, "default", {}, null), ee(() => he(u, "align", r())), _(l, u);
    }, s = (l) => {
      var u = Y9(), d = T(u);
      He(d, t, "default", {}, null), ee(() => he(u, "align", r())), _(l, u);
    };
    H(i, (l) => {
      n() ? l(o) : l(s, !1);
    });
  }
  _(e, a);
}
var J9 = /* @__PURE__ */ O("<ol><!></ol>"), Q9 = /* @__PURE__ */ O("<ul><!></ul>");
function $9(e, t) {
  let n = L(t, "ordered", 8), r = L(t, "start", 8);
  var a = Z(), i = V(a);
  {
    var o = (l) => {
      var u = J9(), d = T(u);
      He(d, t, "default", {}, null), ee(() => he(u, "start", r())), _(l, u);
    }, s = (l) => {
      var u = Q9(), d = T(u);
      He(d, t, "default", {}, null), _(l, u);
    };
    H(i, (l) => {
      n() ? l(o) : l(s, !1);
    });
  }
  _(e, a);
}
var e6 = /* @__PURE__ */ O("<li><!></li>");
function t6(e, t) {
  var n = e6(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var n6 = /* @__PURE__ */ O("<hr>");
function r6(e) {
  var t = n6();
  _(e, t);
}
function a6(e, t) {
  let n = L(t, "text", 8);
  var r = Z(), a = V(r);
  dn(a, n), _(e, r);
}
var i6 = /* @__PURE__ */ O("<blockquote><!></blockquote>");
function o6(e, t) {
  var n = i6(), r = T(n);
  He(r, t, "default", {}, null), _(e, n);
}
var s6 = /* @__PURE__ */ O("<pre><code> </code></pre>");
function l6(e, t) {
  let n = L(t, "lang", 8), r = L(t, "text", 8);
  var a = s6(), i = T(a), o = T(i);
  ee(() => {
    Ve(a, n()), ke(o, r());
  }), _(e, a);
}
var u6 = /* @__PURE__ */ O("<br><!>", 1);
function c6(e, t) {
  var n = u6(), r = Q(V(n));
  He(r, t, "default", {}, null), _(e, n);
}
const d6 = {
  heading: S9,
  paragraph: E9,
  text: T9,
  image: P9,
  link: I9,
  em: F9,
  strong: V9,
  codespan: N9,
  del: L9,
  table: j9,
  tablehead: H9,
  tablebody: q9,
  tablerow: K9,
  tablecell: X9,
  list: $9,
  orderedlistitem: null,
  unorderedlistitem: null,
  listitem: t6,
  hr: r6,
  html: a6,
  blockquote: o6,
  code: l6,
  br: c6
}, f6 = {
  baseUrl: null,
  breaks: !1,
  gfm: !0,
  headerIds: !0,
  headerPrefix: "",
  highlight: null,
  langPrefix: "language-",
  mangle: !0,
  pedantic: !1,
  renderer: null,
  sanitize: !1,
  sanitizer: null,
  silent: !1,
  smartLists: !1,
  smartypants: !1,
  tokenizer: null,
  xhtml: !1
};
function tv(e, t) {
  be(t, !1);
  const n = We(), r = We(), a = We(), i = We();
  let o = L(t, "source", 24, () => []), s = L(t, "renderers", 24, () => ({})), l = L(t, "options", 24, () => ({})), u = L(t, "isInline", 8, !1);
  const d = Km();
  let f = We(), p = We(), h = We();
  Ih(ev, {
    slug: (y) => c(r) ? c(r).slug(y) : "",
    getOptions: () => c(a)
  }), Rn(() => {
    z(h, !0);
  }), Xe(() => Qe(o()), () => {
    z(n, Array.isArray(o()));
  }), Xe(() => (Qe(o()), Hi), () => {
    z(r, o() ? new Hi() : void 0);
  }), Xe(
    () => Qe(l()),
    () => {
      z(a, { ...f6, ...l() });
    }
  ), Xe(
    () => (c(n), c(f), Qe(o()), c(p), c(a), Qe(u())),
    () => {
      c(n) ? z(f, o()) : (z(p, new ln(c(a))), z(f, u() ? c(p).inlineTokens(o()) : c(p).lex(o())), d("parsed", { tokens: c(f) }));
    }
  ), Xe(
    () => Qe(s()),
    () => {
      z(i, { ...d6, ...s() });
    }
  ), Xe(
    () => (c(h), c(n), c(f)),
    () => {
      c(h) && !c(n) && d("parsed", { tokens: c(f) });
    }
  ), Gl(), gn(), Ir(e, {
    get tokens() {
      return c(f);
    },
    get renderers() {
      return c(i);
    }
  }), _e();
}
var p6 = /* @__PURE__ */ O('<a class="!layup-break-words !layup-text-accent !layup-no-underline visited:!layup-text-accent hover:!layup-text-accent" target="_blank" rel="noopener noreferrer"> </a>');
function nv(e, t) {
  var n = p6(), r = T(n);
  ee(() => {
    he(n, "href", t.href), he(n, "title", t.title), ke(r, t.text);
  }), _(e, n);
}
var h6 = /* @__PURE__ */ O('<li class="!layup-mb-1 !layup-flex !layup-items-start !layup-gap-2"><span class="!layup-flex-1 !layup-break-words"><!></span></li>'), y6 = /* @__PURE__ */ O('<ol class="!layup-my-2 !layup-list-decimal !layup-pl-2"></ol>'), g6 = /* @__PURE__ */ O('<li class="!layup-mb-1 !layup-flex !layup-items-start !layup-gap-2"><span class="!layup-mt-2 !layup-min-h-[6px] !layup-min-w-[6px] !layup-rounded-full !layup-bg-primary" style="margin-top: 8px !important;"></span> <span class="!layup-flex-1 !layup-break-words"><!></span></li>'), v6 = /* @__PURE__ */ O('<ul class="!layup-my-2 !layup-list-none !layup-pl-2"></ul>');
function rv(e, t) {
  let n = L(t, "ordered", 3, !1), r = L(t, "items", 19, () => []);
  function a(u) {
    let d = u.replace(/\*\*(.*?)\*\*/g, '<span class="!layup-font-bold">$1</span>');
    return d = d.replace(/\[(.*?)\]\((.*?)\)/g, '<a class="!layup-text-accent !layup-no-underline hover:!layup-text-accent visited:!layup-text-accent !layup-break-words" href="$2" target="_blank" rel="noopener noreferrer">$1</a>'), d;
  }
  var i = Z(), o = V(i);
  {
    var s = (u) => {
      var d = y6();
      at(d, 21, r, gt, (f, p) => {
        var h = h6(), y = T(h), g = T(y);
        dn(g, () => a(c(p).text)), _(f, h);
      }), _(u, d);
    }, l = (u) => {
      var d = v6();
      at(d, 21, r, gt, (f, p) => {
        var h = g6(), y = Q(T(h), 2), g = T(y);
        dn(g, () => a(c(p).text)), _(f, h);
      }), _(u, d);
    };
    H(o, (u) => {
      n() ? u(s) : u(l, !1);
    });
  }
  _(e, i);
}
var m6 = /* @__PURE__ */ O('<div class="!layup-max-h-fit !layup-whitespace-pre-wrap !layup-break-words !layup-text-base"><!></div>');
function mc(e, t) {
  var n = m6(), r = T(n);
  tv(r, {
    get source() {
      return t.responseContent;
    },
    renderers: { link: nv, list: rv },
    options: { breaks: !0, gfm: !0 }
  }), _(e, n);
}
var w6 = /* @__PURE__ */ O('<div class="[>p]:!layup-mb-0 [>p]:!layup-whitespace-pre-wrap !layup-text-wrap !layup-break-words !layup-text-base"><!></div>');
function av(e, t) {
  be(t, !0);
  let n = L(t, "showSuggestions", 15, !0), r = L(t, "transition", 15, !1), a = de(""), i = de(0), o;
  const s = () => {
    const p = o == null ? void 0 : o.closest(".layup-custom-scrollbar");
    p && requestAnimationFrame(() => {
      p.scrollTo({
        top: p.scrollHeight,
        behavior: "smooth"
      });
    });
  }, l = () => {
    r(!0), n(!1), z(i, 0), z(a, "");
  }, u = () => {
    var p;
    r(!1), n(!0), (p = t.onTransitionEnd) == null || p.call(t);
  };
  Se(() => {
    if (!t.content) return;
    l();
    const p = setInterval(
      () => {
        c(i) < t.content.length ? (z(a, c(a) + t.content[c(i)]), Nu(i), s()) : (clearInterval(p), u());
      },
      25
    );
    return () => clearInterval(p);
  });
  var d = w6(), f = T(d);
  tv(f, {
    get source() {
      return c(a);
    },
    renderers: { link: nv, list: rv },
    options: { breaks: !0, gfm: !0 }
  }), tn(d, (p) => o = p, () => o), _(e, d), _e();
}
var b6 = /* @__PURE__ */ O('<div class="layup-relative layup-z-50 layup-block layup-w-fit layup-overflow-hidden layup-rounded-lg !layup-border !layup-border-border layup-bg-transparent layup-p-[1.5px] layup-text-center layup-text-base layup-text-white layup-transition layup-duration-200"><div class="layup-relative layup-z-[53] !layup-max-w-[384px] !layup-rounded-md !layup-bg-background !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary dark:!layup-bg-background"> </div> <div class="layup-absolute layup-inset-0 -layup-z-[1] layup-h-full layup-w-full layup-animate-rotate-css layup-rounded-full layup-bg-[conic-gradient(var(--layup-accent)_60deg,transparent_250deg)]"></div></div>');
function _6(e, t) {
  var n = b6(), r = T(n), a = T(r);
  ee(() => ke(a, t.content || "Thinking...")), _(e, n);
}
var x6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-gap-2 !layup-rounded-full !layup-bg-accent-bg !layup-px-3 !layup-py-1"><span class="!layup-text-sm !layup-text-primary"> </span> <div class="!layup-relative !layup-size-4"><svg class="!layup-h-full !layup-w-full !layup--rotate-90 !layup-transform" viewBox="0 0 20 20"><circle class="!layup-text-accent-secondary svelte-1m9ls09" stroke="currentColor" stroke-width="2" fill="none" cx="10" cy="10"></circle><circle class="!layup-text-accent !layup-transition-all !layup-duration-300 svelte-1m9ls09" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" cx="10" cy="10"></circle></svg></div></div>');
function iv(e, t) {
  const r = 2 * Math.PI * 8, a = /* @__PURE__ */ R(() => r - t.progress * r);
  var i = x6(), o = T(i), s = T(o);
  ee(() => ke(s, `${Math.round(t.progress * 100) ?? ""}% complete`));
  var l = Q(o, 2), u = T(l), d = T(u);
  he(d, "r", 8);
  var f = Q(d);
  he(f, "r", 8), ee(() => he(f, "style", `stroke-dasharray: ${r ?? ""}; stroke-dashoffset: ${c(a) ?? ""}`)), _(e, i);
}
var k6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-row !layup-items-center !layup-justify-end"><div class="!layup-flex !layup-max-w-[70%] !layup-justify-end"><div class="layup-flex !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center !layup-whitespace-pre-wrap !layup-break-words !layup-rounded-sm !layup-border !layup-border-border layup-bg-background !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary dark:!layup-border-border"><p class="!layup-whitespace-pre-wrap !layup-break-words !layup-font-normal !layup-text-base !layup-m-0 !layup-w-full"> </p></div></div></div>'), S6 = /* @__PURE__ */ O('<!> <span class="!layup-text-white"> </span>', 1), C6 = /* @__PURE__ */ O("<div><!></div>"), E6 = /* @__PURE__ */ O("<div> </div>"), T6 = /* @__PURE__ */ O("<div><!></div>"), A6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-row !layup-flex-wrap !layup-gap-2"></div>'), P6 = /* @__PURE__ */ O("<!> <span> </span>", 1), M6 = /* @__PURE__ */ O('<div><a target="_blank" rel="noopener noreferrer"><!></a></div>'), I6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-row !layup-flex-wrap !layup-gap-2"></div>'), O6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-3"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div><!></div> <!></div> <!> <!></div>'), F6 = /* @__PURE__ */ O('<!> <span class="!layup-text-white"> </span>', 1), R6 = /* @__PURE__ */ O("<div><!></div>"), L6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-3"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div><!></div> <!></div></div>'), D6 = /* @__PURE__ */ O('<div class="layup-flex layup-w-full layup-items-start"><!></div>'), N6 = /* @__PURE__ */ O('<div class="!layup-flex !layup-h-[394px] !layup-w-full !layup-flex-col !layup-px-2"><div class="!layup-scrollbar-thin !layup-scrollbar-track-transparent hover:!layup-scrollbar-thumb-gray-400 dark:!layup-scrollbar-thumb-gray-600 dark:hover:!layup-scrollbar-thumb-gray-500 layup-custom-scrollbar !layup-inline-flex !layup-h-full !layup-max-h-full !layup-w-full !layup-flex-col !layup-gap-3 !layup-overflow-y-auto !layup-px-1 !layup-py-3"></div></div>'), z6 = (e, t, n) => {
  var r, a;
  t(((a = (r = c(n)) == null ? void 0 : r.flow) == null ? void 0 : a.name) || c(n).name);
}, V6 = /* @__PURE__ */ O('<button><div><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </span></div></button>'), B6 = /* @__PURE__ */ O('<div class="layup-flex layup-w-full layup-flex-col layup-gap-2 !layup-p-2"><div class="layup-flex layup-items-center layup-justify-between layup-p-2 !layup-pb-4 !layup-h-12 !layup-text-base layup-font-medium layup-text-secondary"><span class="layup-text-sm">Suggestions</span> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-2"></div></div>'), j6 = /* @__PURE__ */ O('<div class="!layup-hidden !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-fill-primary"><!></div>', 1), W6 = (e, t, n) => {
  var r, a;
  t(((a = (r = c(n)) == null ? void 0 : r.flow) == null ? void 0 : a.name) || c(n).name);
}, H6 = /* @__PURE__ */ O('<button><div class="layup-group layup-flex layup-h-10 layup-w-full layup-cursor-pointer layup-items-center !layup-gap-3 layup-rounded-sm !layup-border !layup-border-transparent layup-p-1 layup-px-2 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </span></div></button>'), U6 = /* @__PURE__ */ O('<div class="layup-flex !layup-h-full layup-w-full layup-flex-col layup-items-center !layup-p-3 !layup-py-1"><div class="layup-w-full !layup-p-1"><span class="layup-text-sm !layup-text-secondary">Top guides</span></div> <div class="layup-p1 layup-flex layup-w-full layup-flex-col layup-items-center layup-gap-2"></div></div>'), q6 = (e, t) => {
  t.send({ type: "history" });
}, G6 = (e, t) => {
  t.send({ type: "handleOnboarding" });
}, K6 = /* @__PURE__ */ O('<button class="layup-group layup-w-full"><div class="layup-flex layup-h-10 layup-w-full layup-items-center layup-rounded-sm !layup-border !layup-border-transparent layup-px-3 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"><div class="layup-flex layup-w-full layup-items-center layup-gap-3"><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary">Onboarding</span> <div class="!layup-ml-auto"><!></div></div></div></button>'), Z6 = (e, t, n) => {
  t().can({ type: "handleSeeAllUpdates" }) ? n.send({ type: "handleSeeAllUpdates" }) : n.send({ type: "handleFeatures" });
}, Y6 = /* @__PURE__ */ O('<div class="!layup-ml-auto"><!></div>'), X6 = /* @__PURE__ */ O('<button class="layup-group layup-w-full"><div class="layup-flex layup-h-10 layup-w-full layup-items-center layup-rounded-sm !layup-border !layup-border-transparent layup-px-3 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"><div class="layup-flex layup-w-full layup-items-center layup-gap-3"><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary">Announcements</span> <!></div></div></button>'), J6 = /* @__PURE__ */ O('<div class="layup-flex !layup-h-full layup-w-full layup-flex-col !layup-p-3 !layup-pt-0"><div class="layup-w-full !layup-p-1"><span class="layup-text-sm !layup-text-secondary">Modules</span></div> <div class="layup-flex layup-flex-col layup-gap-1"><button class="layup-group layup-w-full"><div class="layup-flex layup-h-10 layup-w-full layup-items-center layup-rounded-sm !layup-border !layup-border-transparent layup-px-3 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"><div class="layup-flex layup-items-center layup-gap-3"><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary">History</span></div></div></button> <!> <!></div></div>'), Q6 = /* @__PURE__ */ O('<div class="layup-flex layup-h-full layup-w-full layup-flex-col"><div class="layup-h-14 layup-w-full !layup-rounded-lg"><div class="layup-flex layup-h-14 layup-items-center layup-justify-between layup-px-4 layup-font-medium layup-text-primary"><div class="layup-flex layup-items-center layup-gap-2"><!></div> <!></div></div> <!> <!> <!></div>'), $6 = /* @__PURE__ */ O("<!> <!> <!>", 1), e8 = /* @__PURE__ */ O("<div><!></div>");
function t8(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(t.snapshot, "$snapshot", n);
  let a = /* @__PURE__ */ R(() => r().context.messages);
  const i = /* @__PURE__ */ R(() => r().context.suggestedFlowsByName), o = /* @__PURE__ */ R(() => r().context.topSuggestedFlows), s = /* @__PURE__ */ R(() => {
    var k;
    return (k = r().context.theme) == null ? void 0 : k.icons;
  }), l = (k) => {
    t.send({ type: "runTopSuggestedFlows", name: k });
  };
  let u = de(!1), d = de(0), f = de("");
  const p = () => {
    requestAnimationFrame(() => {
      var k;
      (k = c(h)) == null || k.scrollTo({
        top: c(h).scrollHeight,
        behavior: "smooth"
      });
    });
  };
  let h = de(void 0), y = de(0);
  const g = () => {
    c(h) && z(y, oe(c(h).scrollHeight));
  }, w = () => {
    c(h) && c(y) > 0 && requestAnimationFrame(() => {
      c(h).scrollTop = c(y);
    });
  };
  Se(() => {
    var I, D, A;
    const k = (I = c(a)) == null ? void 0 : I[c(a).length - 1];
    (((D = c(a)) == null ? void 0 : D.length) > c(d) || k != null && k.content && (k == null ? void 0 : k.content) !== c(f)) && (g(), z(d, oe(((A = c(a)) == null ? void 0 : A.length) || 0)), z(f, oe((k == null ? void 0 : k.content) || "")));
  }), Se(() => {
    c(u) || g();
  }), Se(() => {
    c(v) && g();
  }), Kg.bind(["h", "H"], () => {
    t.send({ type: "history" });
  });
  const m = /* @__PURE__ */ R(() => {
    var k, I;
    return (I = (k = r().context.plans) == null ? void 0 : k.onboarding_flows) != null && I.length ? r().context.plans.onboarding_flows.filter((D) => D.state.status === "Completed").length / r().context.plans.onboarding_flows.length : 0;
  });
  let v = de(!0), C = de(0), S = de(0);
  Se(() => {
    var k, I;
    z(C, oe(Gh((k = r().context) == null ? void 0 : k.plans))), z(S, oe(qh((I = r().context) == null ? void 0 : I.features)));
  });
  var b = e8();
  const x = /* @__PURE__ */ R(() => Ee("layup-chat-container !layup-relative !layup-flex !layup-h-full layup-w-full !layup-flex-col layup-items-center layup-justify-start !layup-rounded-border !layup-rounded-b-none layup-bg-background"));
  var E = T(b);
  Gr(E, () => c(a), (k) => {
    var I = $6(), D = V(I);
    {
      var A = (G) => {
        var q = N6(), J = T(q);
        at(J, 21, () => c(a), gt, ($, W, j) => {
          var B = Z(), K = V(B);
          {
            var U = (ue) => {
              var ae = k6(), se = T(ae), ge = T(se), pe = T(ge), ve = T(pe);
              ee(() => ke(ve, c(W).content)), _(ue, ae);
            }, ne = (ue) => {
              var ae = Z(), se = V(ae);
              {
                var ge = (ve) => {
                  var me = O6(), we = T(me), fe = T(we);
                  const Oe = /* @__PURE__ */ R(() => Ee("layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-sm !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-base !layup-font-medium layup-text-primary"));
                  var Ue = T(fe);
                  {
                    var Fe = (Ae) => {
                      var re = /* @__PURE__ */ R(() => {
                        var le;
                        return (le = c(W)) == null ? void 0 : le.content;
                      });
                      av(Ae, {
                        get content() {
                          return c(re);
                        },
                        onTransitionEnd: () => {
                          z(u, !1);
                        },
                        get showSuggestions() {
                          return c(v);
                        },
                        set showSuggestions(le) {
                          z(v, oe(le));
                        },
                        get transition() {
                          return c(u);
                        },
                        set transition(le) {
                          z(u, oe(le));
                        }
                      });
                    }, qe = (Ae) => {
                      var re = /* @__PURE__ */ R(() => c(W).content.trim());
                      mc(Ae, {
                        get responseContent() {
                          return c(re);
                        }
                      });
                    };
                    H(Ue, (Ae) => {
                      var re;
                      (re = c(W)) != null && re.showAnimation ? Ae(Fe) : Ae(qe, !1);
                    });
                  }
                  var tt = Q(fe, 2);
                  {
                    var pt = (Ae) => {
                      var re = C6();
                      const le = /* @__PURE__ */ R(() => c(W).flow.starting_url ? new URL(c(W).flow.starting_url) : null), Pe = /* @__PURE__ */ R(() => new URL(window.location.href)), Ne = /* @__PURE__ */ R(() => c(le) && c(le).pathname === c(Pe).pathname);
                      var xe = T(re);
                      Re(xe, {
                        onclick: () => {
                          c(Ne) ? t.send({ type: "play", item: c(W) }) : t.send({ type: "playNewPage", item: c(W) });
                        },
                        variant: "ghost",
                        size: "icon",
                        class: "!layup-mt-2 !layup-flex !layup-h-8 !layup-w-fit !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-sm !layup-bg-accent !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary !layup-transition-all !layup-duration-300 hover:!layup-scale-105 hover:!layup-bg-accent-secondary hover:!layup-text-primary",
                        children: (ft, At) => {
                          var mn = S6(), on = V(mn);
                          Tp(on, { class: "!layup-size-4 layup-fill-white" });
                          var wn = Q(on, 2), er = T(wn);
                          ee(() => ke(er, c(Ne) ? "Show me" : "Take me there")), _(ft, mn);
                        },
                        $$slots: { default: !0 }
                      }), _a(re, (ft) => p == null ? void 0 : p()), bt(5, re, () => qg, () => ({ duration: 400, delay: 1e3 })), _(Ae, re);
                    };
                    H(tt, (Ae) => {
                      var re;
                      (re = c(W)) != null && re.flow && Ae(pt);
                    });
                  }
                  var je = Q(we, 2);
                  {
                    var Ge = (Ae) => {
                      var re = A6();
                      at(re, 21, () => {
                        var le;
                        return (le = c(W)) == null ? void 0 : le.suggested_queries;
                      }, gt, (le, Pe, Ne) => {
                        var xe = T6(), ft = T(xe);
                        Re(ft, {
                          variant: "outline",
                          size: "sm",
                          class: "!layup-h-6 !layup-rounded-sm !layup-border !layup-border-accent-bg !layup-bg-accent-bg !layup-p-2 !layup-text-primary !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-accent-secondary hover:!layup-text-primary hover:!layup-no-underline dark:!layup-bg-accent-bg dark:!layup-text-primary hover:dark:!layup-text-primary",
                          onclick: () => {
                            t.send({
                              type: "request",
                              userMessages: c(Pe)
                            }), p();
                          },
                          children: (At, mn) => {
                            var on = E6(), wn = T(on);
                            ee(() => ke(wn, c(Pe))), _(At, on);
                          },
                          $$slots: { default: !0 }
                        }), bt(5, xe, () => Qt, () => ({
                          duration: 400,
                          delay: Ne * 50,
                          easing: Xr(0.4, 0, 0.2, 1)
                        })), _(le, xe);
                      }), ct("introend", re, p), _(Ae, re);
                    };
                    H(je, (Ae) => {
                      var re;
                      (re = c(W)) != null && re.suggested_queries && c(v) && Ae(Ge);
                    });
                  }
                  var mt = Q(je, 2);
                  {
                    var Ke = (Ae) => {
                      var re = I6();
                      at(re, 21, () => c(W).sources, gt, (le, Pe, Ne) => {
                        var xe = M6(), ft = T(xe), At = T(ft);
                        Re(At, {
                          variant: "outline",
                          size: "sm",
                          class: "layup-group !layup-flex !layup-h-6 !layup-items-center !layup-gap-1.5 !layup-rounded-sm !layup-border-accent layup-bg-accent-bg !layup-p-2 !layup-text-primary !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-bg-accent-secondary hover:!layup-text-primary hover:!layup-no-underline dark:!layup-bg-accent-secondary dark:!layup-text-primary hover:dark:!layup-text-primary",
                          children: (mn, on) => {
                            var wn = P6(), er = V(wn);
                            B4(er, {
                              class: "!layup-size-3 !layup-fill-secondary group-hover:!layup-fill-secondary"
                            });
                            var Me = Q(er, 2), Ye = T(Me);
                            ee(() => ke(Ye, c(Pe).title)), _(mn, wn);
                          },
                          $$slots: { default: !0 }
                        }), ee(() => he(ft, "href", c(Pe).url)), bt(5, xe, () => Qt, () => ({
                          duration: 400,
                          delay: Ne * 50,
                          easing: Xr(0.4, 0, 0.2, 1)
                        })), _(le, xe);
                      }), _(Ae, re);
                    };
                    H(mt, (Ae) => {
                      var re;
                      (re = c(W)) != null && re.sources && c(W).sources.length > 0 && c(v) && Ae(Ke);
                    });
                  }
                  ee(() => Ve(fe, c(Oe))), _(ve, me);
                }, pe = (ve) => {
                  var me = Z(), we = V(me);
                  {
                    var fe = (Ue) => {
                      var Fe = L6(), qe = T(Fe), tt = T(qe);
                      const pt = /* @__PURE__ */ R(() => Ee("layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-sm !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-base !layup-font-medium layup-text-primary"));
                      var je = T(tt), Ge = /* @__PURE__ */ R(() => c(W).content.trim());
                      mc(je, {
                        get responseContent() {
                          return c(Ge);
                        }
                      });
                      var mt = Q(tt, 2);
                      {
                        var Ke = (Ae) => {
                          var re = R6();
                          const le = /* @__PURE__ */ R(() => c(W).flow.starting_url ? new URL(c(W).flow.starting_url) : null), Pe = /* @__PURE__ */ R(() => new URL(window.location.href)), Ne = /* @__PURE__ */ R(() => c(le) && c(le).pathname === c(Pe).pathname);
                          var xe = T(re);
                          Re(xe, {
                            onclick: () => {
                              c(Ne) ? t.send({ type: "play", item: c(W) }) : t.send({ type: "playNewPage", item: c(W) });
                            },
                            variant: "ghost",
                            size: "icon",
                            class: "!layup-mt-2 !layup-flex !layup-h-8 !layup-w-fit !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-sm !layup-bg-accent !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary !layup-transition-all !layup-duration-300 hover:!layup-scale-105 hover:!layup-bg-accent-bg hover:!layup-text-primary",
                            children: (ft, At) => {
                              var mn = F6(), on = V(mn);
                              Tp(on, { class: "!layup-size-4 layup-fill-white" });
                              var wn = Q(on, 2), er = T(wn);
                              ee(() => ke(er, c(Ne) ? "Show me" : "Take me there")), _(ft, mn);
                            },
                            $$slots: { default: !0 }
                          }), _a(re, (ft) => p == null ? void 0 : p()), _(Ae, re);
                        };
                        H(mt, (Ae) => {
                          var re;
                          (re = c(W)) != null && re.flow && Ae(Ke);
                        });
                      }
                      ee(() => Ve(tt, c(pt))), _(Ue, Fe);
                    }, Oe = (Ue) => {
                      var Fe = Z(), qe = V(Fe);
                      {
                        var tt = (pt) => {
                          var je = D6(), Ge = T(je), mt = /* @__PURE__ */ R(() => {
                            var Ke;
                            return (Ke = c(W)) == null ? void 0 : Ke.status;
                          });
                          _6(Ge, {
                            get content() {
                              return c(mt);
                            }
                          }), _(pt, je);
                        };
                        H(
                          qe,
                          (pt) => {
                            var je, Ge;
                            c(W).role === "assistant" && j === ((je = c(a)) == null ? void 0 : je.length) - 1 && ((Ge = c(W)) == null ? void 0 : Ge.content.trim()) === "" && pt(tt);
                          },
                          !0
                        );
                      }
                      _(Ue, Fe);
                    };
                    H(
                      we,
                      (Ue) => {
                        var Fe, qe;
                        c(W).role === "assistant" && j !== ((Fe = c(a)) == null ? void 0 : Fe.length) - 1 && ((qe = c(W)) == null ? void 0 : qe.content.trim()) !== "" ? Ue(fe) : Ue(Oe, !1);
                      },
                      !0
                    );
                  }
                  _(ve, me);
                };
                H(
                  se,
                  (ve) => {
                    var me, we, fe;
                    ((me = c(W)) == null ? void 0 : me.role) === "assistant" && j === ((we = c(a)) == null ? void 0 : we.length) - 1 && ((fe = c(W)) == null ? void 0 : fe.content.trim()) !== "" ? ve(ge) : ve(pe, !1);
                  },
                  !0
                );
              }
              _(ue, ae);
            };
            H(K, (ue) => {
              c(W).role === "user" ? ue(U) : ue(ne, !1);
            });
          }
          _($, B);
        }), tn(J, ($) => z(h, $), () => c(h)), _a(J, ($) => w == null ? void 0 : w()), _(G, q);
      };
      H(D, (G) => {
        var q;
        ((q = c(a)) == null ? void 0 : q.length) > 0 && G(A);
      });
    }
    var M = Q(D, 2);
    {
      var N = (G) => {
        var q = B6(), J = T(q), $ = Q(T(J), 2);
        Re($, {
          variant: "ghost",
          size: "sm",
          class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
          get onclick() {
            return t.handleClose;
          },
          children: (j, B) => {
            kr(j, { class: "!layup-size-full" });
          },
          $$slots: { default: !0 }
        });
        var W = Q(J, 2);
        at(W, 21, () => c(i), gt, (j, B, K) => {
          var U = V6();
          const ne = /* @__PURE__ */ R(() => {
            var ve;
            return Ee("layup-w-full", K === ((ve = c(i)) == null ? void 0 : ve.length) - 1 && "!layup-mb-2");
          });
          U.__click = [z6, l, B];
          var ue = T(U);
          const ae = /* @__PURE__ */ R(() => Ee("layup-group layup-flex layup-h-10 layup-w-full layup-cursor-pointer layup-items-center !layup-gap-3 layup-rounded-sm !layup-border !layup-border-transparent layup-p-1 layup-px-3 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"));
          var se = T(ue);
          Ap(se, {
            class: "layup-size-4 layup-fill-none layup-stroke-secondary group-hover:layup-stroke-secondary"
          });
          var ge = Q(se, 2), pe = T(ge);
          ee(() => {
            var ve, me;
            Ve(U, c(ne)), Ve(ue, c(ae)), ke(pe, ((me = (ve = c(B)) == null ? void 0 : ve.flow) == null ? void 0 : me.name) || c(B).name);
          }), _(j, U);
        }), ct("introstart", q, () => {
          var j;
          (j = c(h)) == null || j.scrollTo({
            top: c(h).scrollHeight,
            behavior: "smooth"
          });
        }), ct("introend", q, () => {
          var j;
          (j = c(h)) == null || j.scrollTo({
            top: c(h).scrollHeight,
            behavior: "smooth"
          });
        }), _(G, q);
      };
      H(M, (G) => {
        var q, J;
        ((q = c(i)) == null ? void 0 : q.length) > 0 && ((J = c(a)) == null ? void 0 : J.length) === 0 && G(N);
      });
    }
    var P = Q(M, 2);
    {
      var Y = (G) => {
        var q = Q6(), J = T(q), $ = T(J), W = T($), j = T(W);
        {
          var B = (pe) => {
            var ve = j6(), me = V(ve), we = T(me);
            dn(we, () => {
              var Ue, Fe, qe;
              return (qe = (Fe = (Ue = c(s)) == null ? void 0 : Ue.logo) == null ? void 0 : Fe.dark_mode) == null ? void 0 : qe.xml;
            });
            var fe = Q(me, 2), Oe = T(fe);
            dn(Oe, () => {
              var Ue, Fe, qe;
              return (qe = (Fe = (Ue = c(s)) == null ? void 0 : Ue.logo) == null ? void 0 : Fe.light_mode) == null ? void 0 : qe.xml;
            }), _(pe, ve);
          }, K = (pe) => {
            su(pe, { class: "!layup-size-6" });
          };
          H(j, (pe) => {
            var ve, me, we;
            (we = (me = (ve = c(s)) == null ? void 0 : ve.logo) == null ? void 0 : me.dark_mode) != null && we.xml ? pe(B) : pe(K, !1);
          });
        }
        var U = Q(W, 2);
        Re(U, {
          variant: "ghost",
          size: "sm",
          class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
          get onclick() {
            return t.handleClose;
          },
          children: (pe, ve) => {
            kr(pe, { class: "!layup-size-full" });
          },
          $$slots: { default: !0 }
        });
        var ne = Q(J, 2);
        K4(ne, { class: "!layup-border-border" });
        var ue = Q(ne, 2);
        {
          var ae = (pe) => {
            var ve = U6(), me = Q(T(ve), 2);
            at(me, 21, () => c(o), gt, (we, fe) => {
              var Oe = H6();
              const Ue = /* @__PURE__ */ R(() => Ee("layup-w-full"));
              Oe.__click = [W6, l, fe];
              var Fe = T(Oe), qe = T(Fe);
              Ap(qe, {
                class: "layup-size-4 layup-fill-none layup-stroke-secondary group-hover:layup-stroke-secondary"
              });
              var tt = Q(qe, 2), pt = T(tt);
              ee(() => {
                var je, Ge;
                Ve(Oe, c(Ue)), ke(pt, ((Ge = (je = c(fe)) == null ? void 0 : je.flow) == null ? void 0 : Ge.name) || c(fe).name);
              }), _(we, Oe);
            }), _(pe, ve);
          };
          H(ue, (pe) => {
            var ve;
            ((ve = c(o)) == null ? void 0 : ve.length) > 0 && pe(ae);
          });
        }
        var se = Q(ue, 2);
        {
          var ge = (pe) => {
            var ve = J6(), me = Q(T(ve), 2), we = T(me);
            we.__click = [q6, t];
            var fe = T(we), Oe = T(fe), Ue = T(Oe);
            Zg(Ue, {
              class: "layup-h-4 layup-w-4 layup-fill-secondary"
            });
            var Fe = Q(we, 2);
            {
              var qe = (je) => {
                var Ge = K6();
                Ge.__click = [G6, t];
                var mt = T(Ge), Ke = T(mt), Ae = T(Ke);
                U4(Ae, {
                  class: "layup-h-4 layup-w-4 layup-stroke-secondary group-hover:layup-stroke-secondary"
                });
                var re = Q(Ae, 4), le = T(re);
                iv(le, {
                  get progress() {
                    return c(m);
                  }
                }), _(je, Ge);
              };
              H(Fe, (je) => {
                r().can({ type: "handleOnboarding" }) && je(qe);
              });
            }
            var tt = Q(Fe, 2);
            {
              var pt = (je) => {
                var Ge = X6();
                Ge.__click = [Z6, r, t];
                var mt = T(Ge), Ke = T(mt), Ae = T(Ke);
                N4(Ae, {
                  class: "layup-h-4 layup-w-4 layup-fill-secondary"
                });
                var re = Q(Ae, 4);
                {
                  var le = (Pe) => {
                    var Ne = Y6(), xe = T(Ne);
                    G4(xe, {
                      get count() {
                        return c(S);
                      }
                    }), _(Pe, Ne);
                  };
                  H(re, (Pe) => {
                    r().can({ type: "handleFeatures" }) && Pe(le);
                  });
                }
                _(je, Ge);
              };
              H(tt, (je) => {
                (r().can({ type: "handleSeeAllUpdates" }) || r().can({ type: "handleFeatures" })) && je(pt);
              });
            }
            _(pe, ve);
          };
          H(se, (pe) => {
            var ve, me;
            ((ve = c(a)) == null ? void 0 : ve.length) === 0 && ((me = c(i)) == null ? void 0 : me.length) === 0 && pe(ge);
          });
        }
        _(G, q);
      };
      H(P, (G) => {
        var q, J;
        ((q = c(a)) == null ? void 0 : q.length) === 0 && ((J = c(i)) == null ? void 0 : J.length) === 0 && G(Y);
      });
    }
    _(k, I);
  }), ee(() => Ve(b, c(x))), _(e, b), _e();
}
Er(["click"]);
var n8 = /* @__PURE__ */ vt("<title> </title>"), r8 = /* @__PURE__ */ vt("<desc> </desc>"), a8 = /* @__PURE__ */ vt('<svg><!><!><path fill-rule="evenodd" clip-rule="evenodd" d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"></path></svg>');
function i8(e, t) {
  var w, m;
  be(t, !0);
  const n = Xl("iconCtx") ?? {};
  let r = L(t, "size", 19, () => n.size || "24"), a = L(t, "role", 19, () => n.role || "img"), i = L(t, "color", 19, () => n.color || "currentColor"), o = L(t, "ariaLabel", 3, "chevron down"), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "size",
    "role",
    "color",
    "title",
    "desc",
    "ariaLabel"
  ]), l = `${((w = t.title) == null ? void 0 : w.id) || ""} ${((m = t.desc) == null ? void 0 : m.id) || ""}`;
  const u = /* @__PURE__ */ R(() => {
    var v, C;
    return !!((v = t.title) != null && v.id || (C = t.desc) != null && C.id);
  });
  var d = a8();
  let f;
  var p = T(d);
  {
    var h = (v) => {
      var C = n8(), S = T(C);
      ee(() => {
        he(C, "id", t.title.id), ke(S, t.title.title);
      }), _(v, C);
    };
    H(p, (v) => {
      var C;
      (C = t.title) != null && C.id && t.title.title && v(h);
    });
  }
  var y = Q(p);
  {
    var g = (v) => {
      var C = r8(), S = T(C);
      ee(() => {
        he(C, "id", t.desc.id), ke(S, t.desc.desc);
      }), _(v, C);
    };
    H(y, (v) => {
      var C;
      (C = t.desc) != null && C.id && t.desc.desc && v(g);
    });
  }
  ee(() => f = Je(
    d,
    f,
    {
      xmlns: "http://www.w3.org/2000/svg",
      ...s,
      role: a(),
      width: r(),
      height: r(),
      fill: i(),
      "aria-label": o(),
      "aria-describedby": c(u) ? l : void 0,
      viewBox: "0 0 15 15"
    },
    void 0,
    !0
  )), _(e, d), _e();
}
var o8 = /* @__PURE__ */ O('<div class="!layup-hidden !layup-h-6 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-size-6 [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-size-6 [&amp;>svg]:!layup-fill-primary"><!></div>', 1), s8 = /* @__PURE__ */ O("<div></div>"), l8 = /* @__PURE__ */ O('<div class="!layup-relative !layup-h-6 !layup-w-6 !layup-flex !layup-items-center !layup-justify-center"><div class="!layup-absolute !layup-h-6 !layup-w-6 !layup-flex !layup-items-center !layup-justify-center"><!></div> <div class="!layup-absolute !layup-h-6 !layup-w-6 !layup-flex !layup-items-center !layup-justify-center"><!></div></div> <!>', 1), u8 = /* @__PURE__ */ O("<div>Start cursor-based guidance</div>"), c8 = /* @__PURE__ */ O('<div class="!layup-relative"><!> <!></div>');
function Rp(e, t) {
  be(t, !0);
  let n = de(!1), r = de(0), a = de(1), i = de(0);
  Se(() => {
    t.isOpen ? (z(r, 120), setTimeout(
      () => {
        z(a, 0), z(i, 1);
      },
      150
    )) : (z(r, 0), z(a, 1), z(i, 0));
  });
  var o = c8(), s = T(o);
  Re(s, {
    variant: "ghost",
    class: "!layup-pointer-events-auto !layup-relative !layup-h-12 !layup-w-12 !layup-rounded-full !layup-border !layup-border-background-secondary !layup-bg-background !layup-p-2 !layup-shadow-sm hover:!layup-bg-background dark:!layup-border-gray-700/50 dark:!layup-bg-background dark:hover:!layup-bg-background",
    onmouseenter: () => z(n, !0),
    onmouseleave: () => z(n, !1),
    get onclick() {
      return t.handleClick;
    },
    children: (d, f) => {
      var p = l8(), h = V(p), y = T(h), g = T(y);
      {
        var w = (x) => {
          var E = o8(), k = V(E), I = T(k);
          dn(I, () => {
            var M, N, P;
            return (P = (N = (M = t.icons) == null ? void 0 : M.trigger_icon) == null ? void 0 : N.dark_mode) == null ? void 0 : P.xml;
          });
          var D = Q(k, 2), A = T(D);
          dn(A, () => {
            var M, N, P;
            return (P = (N = (M = t.icons) == null ? void 0 : M.trigger_icon) == null ? void 0 : N.light_mode) == null ? void 0 : P.xml;
          }), _(x, E);
        }, m = (x) => {
          su(x, { class: "!layup-size-5" });
        };
        H(g, (x) => {
          var E, k, I;
          (I = (k = (E = t.icons) == null ? void 0 : E.trigger_icon) == null ? void 0 : k.dark_mode) != null && I.xml ? x(w) : x(m, !1);
        });
      }
      var v = Q(y, 2), C = T(v);
      i8(C, { class: "!layup-size-5 !layup-fill-primary" });
      var S = Q(h, 2);
      {
        var b = (x) => {
          var E = s8();
          const k = /* @__PURE__ */ R(() => Ee("!layup-absolute !layup-right-1 !layup-top-1 !layup-size-3 !layup-translate-x-1/3 !layup-translate-y-[-25%] !layup-rounded-full !layup-bg-accent", c(n) ? "!layup-opacity-0" : ""));
          ee(() => Ve(E, c(k))), bt(5, E, () => Qt, () => ({ duration: 200 })), _(x, E);
        };
        H(S, (x) => {
          t.count && !t.isOpen && x(b);
        });
      }
      ee(() => {
        he(y, "style", `opacity: ${c(a) ?? ""}; transform: rotate(${c(r) ?? ""}deg); transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease;`), he(v, "style", `opacity: ${c(i) ?? ""}; transition: opacity 0.15s ease;`);
      }), _(d, p);
    },
    $$slots: { default: !0 }
  });
  var l = Q(s, 2);
  {
    var u = (d) => {
      var f = u8();
      const p = /* @__PURE__ */ R(() => Ee("!layup-absolute !layup-bottom-full !layup-mb-2 !layup-whitespace-nowrap !layup-rounded-md !layup-bg-white !layup-px-3 !layup-py-2 !layup-text-base !layup-text-[#999999] !layup-shadow-md dark:!layup-bg-black", t.widget_position === "BottomCenter" ? "!layup-left-1/2 !-layup-translate-x-1/2" : "!-layup-left-[60px] !-layup-translate-x-1/2"));
      ee(() => Ve(f, c(p))), bt(5, f, () => Qt, () => ({ duration: 400 })), _(d, f);
    };
    H(l, (d) => {
      c(n) && !t.isOpen && d(u);
    });
  }
  bt(1, o, () => Qt, () => ({ duration: 500 })), _(e, o), _e();
}
var d8 = /* @__PURE__ */ vt('<svg><path d="M14.9888 9.8125L14.2388 3.8125C14.1931 3.44993 14.0166 3.1165 13.7425 2.87483C13.4684 2.63316 13.1154 2.49987 12.75 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89464 1.73478 10 2 10H4.69125L7.0525 14.7238C7.09407 14.8068 7.15795 14.8767 7.237 14.9255C7.31604 14.9743 7.40711 15.0001 7.5 15C8.16304 15 8.79893 14.7366 9.26777 14.2678C9.73661 13.7989 10 13.163 10 12.5V11.5H13.5C13.7129 11.5001 13.9233 11.4548 14.1173 11.3673C14.3113 11.2798 14.4845 11.152 14.6253 10.9923C14.7662 10.8327 14.8714 10.645 14.9341 10.4415C14.9967 10.2381 15.0154 10.0237 14.9888 9.8125ZM4.5 9H2V3.5H4.5V9ZM13.875 10.3306C13.8284 10.3842 13.7708 10.4271 13.706 10.4564C13.6413 10.4856 13.571 10.5005 13.5 10.5H9.5C9.36739 10.5 9.24021 10.5527 9.14645 10.6464C9.05268 10.7402 9 10.8674 9 11V12.5C9.0001 12.8468 8.88002 13.1829 8.66021 13.4512C8.4404 13.7194 8.13443 13.9032 7.79437 13.9712L5.5 9.38188V3.5H12.75C12.8718 3.49996 12.9895 3.54439 13.0808 3.62494C13.1722 3.7055 13.231 3.81664 13.2463 3.9375L13.9963 9.9375C14.0056 10.0079 13.9996 10.0795 13.9787 10.1473C13.9578 10.2152 13.9224 10.2777 13.875 10.3306Z"></path></svg>');
function f8(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = d8();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      class: t.class,
      ...n,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var p8 = /* @__PURE__ */ vt('<svg><path d="M14.625 5.0075C14.4842 4.84795 14.3111 4.72019 14.1171 4.63269C13.9231 4.54519 13.7128 4.49996 13.5 4.5H10V3.5C10 2.83696 9.73661 2.20107 9.26777 1.73223C8.79893 1.26339 8.16304 1 7.5 1C7.40711 0.999934 7.31604 1.02574 7.237 1.07454C7.15795 1.12333 7.09407 1.19318 7.0525 1.27625L4.69125 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V12.5C1 12.7652 1.10536 13.0196 1.29289 13.2071C1.48043 13.3946 1.73478 13.5 2 13.5H12.75C13.1154 13.5001 13.4684 13.3668 13.7425 13.1252C14.0166 12.8835 14.1931 12.5501 14.2388 12.1875L14.9888 6.1875C15.0153 5.97626 14.9966 5.76179 14.9339 5.55833C14.8712 5.35488 14.7659 5.16711 14.625 5.0075ZM2 7H4.5V12.5H2V7ZM13.9963 6.0625L13.2463 12.0625C13.231 12.1834 13.1722 12.2945 13.0808 12.3751C12.9895 12.4556 12.8718 12.5 12.75 12.5H5.5V6.61812L7.79437 2.02875C8.13443 2.09681 8.4404 2.2806 8.66021 2.54884C8.88002 2.81708 9.0001 3.1532 9 3.5V5C9 5.13261 9.05268 5.25979 9.14645 5.35355C9.24021 5.44732 9.36739 5.5 9.5 5.5H13.5C13.571 5.49998 13.6411 5.51505 13.7058 5.54423C13.7704 5.5734 13.8282 5.61601 13.8751 5.66922C13.9221 5.72242 13.9571 5.78501 13.978 5.85282C13.9989 5.92063 14.0051 5.9921 13.9963 6.0625Z"></path></svg>');
function h8(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = p8();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      class: t.class,
      ...n,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var y8 = /* @__PURE__ */ O('<!> <span class="layup-text-base layup-text-primary"> </span>', 1), g8 = /* @__PURE__ */ O('<!> <span class="layup-text-base layup-text-primary"> </span>', 1), v8 = /* @__PURE__ */ O('<div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex !layup-w-fit !layup-flex-row !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-md !layup-border !layup-border-background-secondary !layup-bg-background layup-p-2"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-sm !layup-bg-accent layup-text-base layup-font-medium !layup-text-primary"><span class="layup-text-base layup-text-accent-text">?</span></div> <span class="layup-text-base layup-text-primary"> </span> <!> <!></div></div>');
function m8(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => {
    var o, s;
    return (s = (o = t.guideMachineContext) == null ? void 0 : o.context) == null ? void 0 : s.status;
  });
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = Z(), l = V(s);
      {
        var u = (d) => {
          var f = v8(), p = T(f), h = Q(T(p), 2), y = T(h), g = Q(h, 2);
          Re(g, {
            variant: "outline",
            size: "sm",
            class: "!layup-pointer-events-auto !layup-h-7 layup-w-fit !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
            onclick: () => {
              var m;
              return (m = t.guideMachineRef) == null ? void 0 : m.send({ type: "POSITIVE" });
            },
            children: (m, v) => {
              var C = y8(), S = V(C);
              h8(S, { class: "!layup-fill-primary" });
              var b = Q(S, 2), x = T(b);
              ee(() => ke(x, c(n) === "TERMINATE" ? "Helpful" : "Yes")), _(m, C);
            },
            $$slots: { default: !0 }
          });
          var w = Q(g, 2);
          Re(w, {
            variant: "outline",
            size: "sm",
            class: "!layup-pointer-events-auto !layup-h-7 layup-w-fit !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
            onclick: () => {
              var m;
              return (m = t.guideMachineRef) == null ? void 0 : m.send({ type: "NEGATIVE" });
            },
            children: (m, v) => {
              var C = g8(), S = V(C);
              f8(S, { class: "!layup-fill-primary" });
              var b = Q(S, 2), x = T(b);
              ee(() => ke(x, c(n) === "TERMINATE" ? "Not helpful" : "No")), _(m, C);
            },
            $$slots: { default: !0 }
          }), ee(() => ke(y, c(n) === "TERMINATE" ? "You finished early?" : "Did we help?")), _(d, f);
        };
        H(l, (d) => {
          var f, p;
          (p = (f = t.guideMachineContext) == null ? void 0 : f.context) != null && p.feedback || d(u);
        });
      }
      _(o, s);
    };
    H(a, (o) => {
      var s;
      (s = t.guideMachineContext) != null && s.matches("completed") && o(i);
    });
  }
  _(e, r), _e();
}
var w8 = /* @__PURE__ */ O('<div role="button" tabindex="0"><!></div>');
function b8(e, t) {
  var g, w, m, v, C;
  be(t, !0);
  let n = !1, r = de(oe((g = t.positionStyles) == null ? void 0 : g.left)), a = de(oe((w = t.positionStyles) == null ? void 0 : w.right)), i = de(oe((m = t.positionStyles) == null ? void 0 : m.top)), o = de(oe((v = t.positionStyles) == null ? void 0 : v.bottom)), s = de(oe((C = t.positionStyles) == null ? void 0 : C.transform));
  function l() {
    const S = document.getElementById(t.id);
    if (!S) return !0;
    const b = S.getBoundingClientRect();
    return b.top >= 0 && b.left >= 0 && b.bottom <= window.innerHeight && b.right <= window.innerWidth;
  }
  function u() {
    var b, x, E, k, I;
    z(r, oe((b = t.positionStyles) == null ? void 0 : b.left)), z(a, oe((x = t.positionStyles) == null ? void 0 : x.right)), z(i, oe((E = t.positionStyles) == null ? void 0 : E.top)), z(o, oe((k = t.positionStyles) == null ? void 0 : k.bottom)), z(s, oe((I = t.positionStyles) == null ? void 0 : I.transform));
    const S = document.getElementById(t.id);
    S && (c(r) !== void 0 && (S.style.left = c(r)), c(a) !== void 0 && (S.style.right = c(a)), c(i) !== void 0 && (S.style.top = c(i)), c(o) !== void 0 && (S.style.bottom = c(o)), c(s) !== void 0 && (S.style.transform = c(s)));
  }
  function d(S) {
    if (S.preventDefault(), S.stopPropagation(), !t.isDraggable) return;
    const b = document.getElementById(t.id);
    b && (S.target === b || b.contains(S.target)) && (n = !0, document.addEventListener("mousemove", f), document.addEventListener("mouseup", p));
  }
  function f(S) {
    var x, E, k, I;
    if (!n || !t.isDraggable) return;
    const b = (D, A, M, N) => {
      if (A === "rem")
        return `${parseFloat(D) + M / 16}${A}`;
      if (A === "%") {
        const Y = N === "horizontal" ? window.innerWidth : window.innerHeight, G = M / Y * 100 * 1;
        return `${Math.max(0, Math.min(100, parseFloat(D) + G))}${A}`;
      }
      return `${parseFloat(D) + M}px`;
    };
    if (c(r) !== void 0) {
      const D = parseFloat(c(r)), A = ((x = c(r).match(/[a-z%]+$/i)) == null ? void 0 : x[0]) || "px";
      z(r, oe(b(D, A, S.movementX, "horizontal")));
    }
    if (c(a) !== void 0) {
      const D = parseFloat(c(a)), A = ((E = c(a).match(/[a-z%]+$/i)) == null ? void 0 : E[0]) || "px";
      z(a, oe(b(D, A, -S.movementX, "horizontal")));
    }
    if (c(i) !== void 0) {
      const D = parseFloat(c(i)), A = ((k = c(i).match(/[a-z%]+$/i)) == null ? void 0 : k[0]) || "px";
      z(i, oe(b(D, A, S.movementY, "vertical")));
    }
    if (c(o) !== void 0) {
      const D = parseFloat(c(o)), A = ((I = c(o).match(/[a-z%]+$/i)) == null ? void 0 : I[0]) || "px";
      z(o, oe(b(D, A, -S.movementY, "vertical")));
    }
    l() || u();
  }
  function p() {
    n = !1, document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", p);
  }
  Rn(() => {
    l() || u();
    const S = new MutationObserver(() => {
      l() || u();
    }), b = document.getElementById(t.id);
    return b && S.observe(b, {
      attributes: !0,
      attributeFilter: ["style"]
    }), () => {
      S.disconnect();
    };
  }), Se(() => {
    var S, b, x, E, k;
    z(r, oe((S = t.positionStyles) == null ? void 0 : S.left)), z(a, oe((b = t.positionStyles) == null ? void 0 : b.right)), z(i, oe((x = t.positionStyles) == null ? void 0 : x.top)), z(o, oe((E = t.positionStyles) == null ? void 0 : E.bottom)), z(s, oe((k = t.positionStyles) == null ? void 0 : k.transform));
  });
  var h = w8();
  h.__mousedown = d;
  var y = T(h);
  lt(y, () => t.children ?? De), ee(() => {
    he(h, "id", t.id), Ve(h, `${(t.isDraggable ? "!layup-cursor-move" : "!layup-cursor-default") ?? ""} !layup-flex !layup-select-none !layup-flex-col !layup-items-center !layup-justify-center focus-visible:!layup-outline-none focus-visible:!layup-ring-0 ${t.className ?? ""}`), he(h, "style", `position: fixed;
        ${(c(r) !== void 0 ? `left: ${c(r)};` : "") ?? ""}
        ${(c(a) !== void 0 ? `right: ${c(a)};` : "") ?? ""}
        ${(c(i) !== void 0 ? `top: ${c(i)};` : "") ?? ""}
        ${(c(o) !== void 0 ? `bottom: ${c(o)};` : "") ?? ""}
        ${(c(s) ? `transform: ${c(s)};` : "") ?? ""}`);
  }), bt(1, h, () => Qt, () => ({ duration: 500, start: 0.5, opacity: 0 })), _(e, h), _e();
}
Er(["mousedown"]);
var _8 = /* @__PURE__ */ O('<span class="layup-text-base layup-text-primary"> </span>'), x8 = /* @__PURE__ */ O('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-md !layup-border !layup-border-border !layup-bg-background layup-p-2 layup-shadow-sm"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-sm !layup-bg-accent layup-text-sm layup-font-medium !layup-text-accent-text"><span class="layup-text-base">?</span></div> <span class="layup-text-base layup-font-medium layup-text-primary"> </span> <!></div></div></div>');
function k8(e, t) {
  be(t, !0);
  const n = /* @__PURE__ */ R(() => {
    var s;
    const o = (s = t.guideMachineContext) == null ? void 0 : s.context.error;
    return {
      message: (o == null ? void 0 : o.message) || "Something went wrong",
      type: (o == null ? void 0 : o.type) || "Error"
    };
  });
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = x8(), l = T(s), u = T(l), d = Q(T(u), 2), f = T(d), p = Q(d, 2);
      Re(p, {
        variant: "outline",
        size: "sm",
        id: "error-button",
        class: "!layup-pointer-events-auto !layup-h-7 layup-w-fit !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
        onclick: () => {
          var h, y;
          c(n).type === "FirstElementNotFound" ? (h = t.guideMachineRef) == null || h.send({ type: "RELOAD" }) : (y = t.guideMachineRef) == null || y.send({ type: "BACK" });
        },
        children: (h, y) => {
          var g = _8(), w = T(g);
          ee(() => ke(w, c(n).type === "FirstElementNotFound" ? "Reload" : "Back")), _(h, g);
        },
        $$slots: { default: !0 }
      }), ee(() => ke(f, c(n).message)), bt(1, l, () => Qt, () => ({ start: 0.95, duration: 300 })), bt(1, s, () => ns, () => ({ y: 20, duration: 300 })), _(o, s);
    };
    H(a, (o) => {
      var s;
      (s = t.guideMachineContext) != null && s.matches("error") && o(i);
    });
  }
  _(e, r), _e();
}
var S8 = /* @__PURE__ */ vt('<svg><path d="M18.0006 8.00042C18.0006 8.19933 17.9216 8.39009 17.7809 8.53075C17.6403 8.6714 17.4495 8.75042 17.2506 8.75042H2.5609L8.03122 14.2198C8.1009 14.2895 8.15617 14.3722 8.19389 14.4632C8.2316 14.5543 8.25101 14.6519 8.25101 14.7504C8.25101 14.849 8.2316 14.9465 8.19389 15.0376C8.15617 15.1286 8.1009 15.2114 8.03122 15.281C7.96153 15.3507 7.87881 15.406 7.78776 15.4437C7.69672 15.4814 7.59914 15.5008 7.50059 15.5008C7.40204 15.5008 7.30446 15.4814 7.21342 15.4437C7.12237 15.406 7.03965 15.3507 6.96996 15.281L0.219965 8.53104C0.150233 8.46139 0.0949134 8.37867 0.0571702 8.28762C0.019427 8.19657 0 8.09898 0 8.00042C0 7.90185 0.019427 7.80426 0.0571702 7.71321C0.0949134 7.62216 0.150233 7.53945 0.219965 7.46979L6.96996 0.719792C7.1107 0.579062 7.30157 0.5 7.50059 0.5C7.69961 0.5 7.89048 0.579062 8.03122 0.719792C8.17195 0.860522 8.25101 1.05139 8.25101 1.25042C8.25101 1.44944 8.17195 1.64031 8.03122 1.78104L2.5609 7.25042H17.2506C17.4495 7.25042 17.6403 7.32943 17.7809 7.47009C17.9216 7.61074 18.0006 7.8015 18.0006 8.00042Z"></path></svg>');
function Ui(e, t) {
  let n = L(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var a = S8();
  let i;
  ee(() => i = Je(
    a,
    i,
    {
      viewBox: "0 0 18 16",
      class: n(),
      ...r,
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, a);
}
function C8(e, t) {
  be(t, !0);
  let n = L(t, "ref", 15, null), r = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class"
  ]);
  var a = Z(), i = V(a), o = /* @__PURE__ */ R(() => Ee("fixed inset-0 z-[9990] bg-black/30  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", t.class));
  rt(i, () => R3, (s, l) => {
    l(s, ot(
      {
        get class() {
          return c(o);
        }
      },
      () => r,
      {
        get ref() {
          return n();
        },
        set ref(u) {
          n(u);
        }
      }
    ));
  }), _(e, a), _e();
}
var E8 = /* @__PURE__ */ O('<!> <span class="!layup-sr-only">Close</span>', 1), T8 = /* @__PURE__ */ O("<!> <!>", 1), A8 = /* @__PURE__ */ O("<!> <!>", 1);
function ov(e, t) {
  be(t, !0);
  let n = L(t, "ref", 15, null), r = L(t, "hideCloseButton", 3, !1), a = L(t, "hideOverlay", 3, !1), i = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class",
    "children",
    "hideCloseButton",
    "hideOverlay"
  ]);
  var o = Z(), s = V(o);
  rt(s, () => P8, (l, u) => {
    u(l, {
      children: (d, f) => {
        var p = A8(), h = V(p);
        {
          var y = (m) => {
            var v = Z(), C = V(v);
            rt(C, () => C8, (S, b) => {
              b(S, {
                class: "layup-fixed layup-inset-0 layup-z-[9999999] layup-bg-black/50"
              });
            }), _(m, v);
          };
          H(h, (m) => {
            a() || m(y);
          });
        }
        var g = Q(h, 2), w = /* @__PURE__ */ R(() => Ee("layup-sm:layup-rounded-lg layup-fixed layup-left-[50%] layup-top-[50%] layup-z-[9999999] layup-grid layup-w-full layup-max-w-lg layup-translate-x-[-50%] layup-translate-y-[-50%] layup-gap-4 layup-border layup-bg-background layup-p-6 layup-shadow-xl !layup-backdrop-blur-md layup-duration-300 data-[state=open]:layup-animate-in data-[state=closed]:layup-animate-out data-[state=closed]:layup-fade-out-0 data-[state=open]:layup-fade-in-0 data-[state=closed]:layup-zoom-out-95 data-[state=open]:layup-zoom-in-95 data-[state=closed]:layup-slide-out-to-left-1/2 data-[state=closed]:layup-slide-out-to-top-[48%] data-[state=open]:layup-slide-in-from-left-1/2 data-[state=open]:layup-slide-in-from-top-[48%]", t.class));
        rt(g, () => l4, (m, v) => {
          v(m, ot(
            {
              get class() {
                return c(w);
              }
            },
            () => i,
            {
              get ref() {
                return n();
              },
              set ref(C) {
                n(C);
              },
              children: (C, S) => {
                var b = T8(), x = V(b);
                lt(x, () => t.children ?? De);
                var E = Q(x, 2);
                {
                  var k = (I) => {
                    var D = Z(), A = V(D);
                    rt(A, () => i4, (M, N) => {
                      N(M, {
                        class: "data-[state=open]:layup-bg-accentdata-[state=open]:layup-text-muted-foreground !layup-absolute !layup-right-4 !layup-top-4 !layup-rounded-sm !layup-opacity-70 !layup-ring-offset-background !layup-transition-opacity hover:!layup-opacity-100 focus:!layup-outline-none focus:!layup-ring-2 focus:!layup-ring-ring focus:!layup-ring-offset-2 disabled:!layup-pointer-events-none",
                        children: (P, Y) => {
                          var G = E8(), q = V(G);
                          kr(q, { class: "layup-size-4" }), _(P, G);
                        },
                        $$slots: { default: !0 }
                      });
                    }), _(I, D);
                  };
                  H(E, (I) => {
                    r() || I(k);
                  });
                }
                _(C, b);
              },
              $$slots: { default: !0 }
            }
          ));
        }), _(d, p);
      },
      $$slots: { default: !0 }
    });
  }), _(e, o), _e();
}
const sv = r4, P8 = Cg;
var M8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-h-full !layup-min-h-[200px] !layup-w-full !layup-items-center !layup-justify-center !layup-rounded-sm !layup-bg-transparent"><div class="!layup-text-center !layup-text-primary"><span class="!layup-flex !layup-items-center !layup-justify-center !layup-gap-1"> </span></div></div>');
function wc(e, t) {
  var n = M8(), r = T(n), a = T(r), i = T(a);
  ee(() => ke(i, t.title)), _(e, n);
}
var I8 = /* @__PURE__ */ O('<div class="layup-flex layup-h-fit layup-w-full layup-items-center layup-justify-start layup-rounded-sm layup-p-1 layup-text-primary"><span class="!layup-shrink-0 !layup-text-left !layup-text-sm !layup-text-secondary"> </span></div>'), O8 = /* @__PURE__ */ O('<span class="layup-flex layup-items-center layup-text-sm">Show me</span>'), F8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-1 !layup-bg-transparent !layup-p-3"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-center"><div class="!layup-flex !layup-w-full !layup-items-center layup-justify-start !layup-gap-2"><div class="layup-h-2 layup-w-2 layup-shrink-0 layup-rounded-full layup-bg-accent"></div> <h3 class="layup-text-wrap layup-text-left !layup-text-base !layup-font-medium !layup-text-primary"> </h3></div> <!></div> <p class="!layup-w-full !layup-text-wrap !layup-break-words !layup-text-left !layup-text-sm !layup-leading-relaxed !layup-text-primary"> </p> <div class="!layup-flex !layup-w-full !layup-flex-row-reverse"><!></div></div>'), R8 = /* @__PURE__ */ O("<div><!></div>"), L8 = /* @__PURE__ */ O('<div class="layup-flex layup-h-fit layup-w-fit layup-items-center layup-justify-center layup-rounded-sm layup-text-primary"><span class="!layup-shrink-0 !layup-text-sm !layup-text-secondary"> </span></div>'), D8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-bg-transparent !layup-p-3"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-start !layup-justify-start"><div class="!layup-flex !layup-items-center !layup-gap-4"><h3 class="!layup-text-base !layup-font-medium !layup-text-primary"> </h3></div> <!></div></div>'), N8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-h-fit !layup-w-full !layup-flex-col layup-items-start !layup-rounded-lg !layup-bg-transparent"><!></div>'), z8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <span class="layup-text-base">Back</span></div>'), V8 = /* @__PURE__ */ O('<!> <span class="layup-text-sm">See all</span>', 1), B8 = /* @__PURE__ */ O("<!> <!>", 1), j8 = /* @__PURE__ */ O("<!> <!>", 1), W8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-col !layup-rounded-lg !layup-bg-background"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between !layup-p-4 !layup-h-14"><!> <!></div> <div class="!layup-scrollbar-thin !layup-scrollbar-track-transparent hover:!layup-scrollbar-thumb-gray-400 dark:!layup-scrollbar-thumb-gray-600 dark:hover:!layup-scrollbar-thumb-gray-500 layup-custom-scrollbar !layup-flex !layup-max-h-[450px] !layup-flex-col !layup-gap-3 !layup-overflow-y-auto !layup-overscroll-contain !layup-p-6 !layup-pt-0 !layup-h-full"><div class="!layup-flex !layup-h-full !layup-flex-col !layup-gap-4 !layup-pb-4"><div class="!layup-flex !layup-h-[30px] !layup-w-full !layup-items-center !layup-justify-between"><h2 class="!layup-text-xl !layup-font-medium !layup-leading-none !layup-text-primary">Announcements</h2> <div class="!layup-flex !layup-h-[30px] !layup-items-center"><!></div></div> <div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-4 !layup-h-full"><!></div></div></div></div>'), H8 = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <span class="layup-text-base">Back</span></div>'), U8 = /* @__PURE__ */ O('<p class="!layup-text-sm !layup-text-secondary"> </p>'), q8 = (e, t, n) => t("image", c(n).template_announcement.image), G8 = /* @__PURE__ */ O('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), K8 = (e, t, n) => t("video", c(n).template_announcement.image), Z8 = /* @__PURE__ */ O('<video autoplay loop playsinline="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-cover"><source type="video/mp4"></video>', 2), Y8 = (e, t, n) => t("image", c(n).template_announcement.image), X8 = /* @__PURE__ */ O('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), J8 = /* @__PURE__ */ O('<div class="layup-bg-background-secondary/50 layup-flex layup-h-[200px] layup-w-full layup-items-center layup-justify-center layup-overflow-hidden layup-rounded-lg"><!></div>'), Q8 = /* @__PURE__ */ O('<span class="layup-flex layup-items-center">Show me</span>'), $8 = /* @__PURE__ */ O('<div class="layup-flex layup-w-full layup-justify-between layup-h-full layup-flex-col !layup-gap-4 layup-rounded-lg layup-bg-background layup-p-4"><div class="layup-flex layup-w-full layup-flex-col"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between !layup-h-6"><!> <!></div> <div class="!layup-flex !layup-flex-col !layup-gap-2 !layup-p-2"><h2 class="!layup-text-wrap !layup-text-xl !layup-font-semibold !layup-text-primary"> </h2> <!></div> <div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-center !layup-justify-center layup-gap-4 !layup-p-2"><!> <p class="!layup-w-full !layup-text-wrap !layup-break-words !layup-text-left !layup-text-sm !layup-leading-relaxed !layup-text-primary"> </p></div></div> <!></div>'), e7 = (e) => e.stopPropagation(), t7 = /* @__PURE__ */ O('<img alt="" class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-object-contain layup-shadow-2xl">'), n7 = (e) => e.stopPropagation(), r7 = /* @__PURE__ */ O('<video autoplay controls class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-shadow-2xl"><source type="video/mp4"> <track kind="captions" src="" label="English captions"></video>', 2), a7 = /* @__PURE__ */ O("<!> <!>", 1);
function i7(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(t.snapshot, "$snapshot", n), a = (b, x = De) => {
    var E = R8(), k = T(E);
    Re(k, {
      variant: "ghost",
      class: "layup-group !layup-flex !layup-h-full !layup-w-full !layup-items-start !layup-rounded-sm !layup-border !layup-border-background-secondary !layup-text-primary hover:!layup-border-accent-bg  hover:!layup-bg-accent-secondary hover:!layup-text-primary",
      onclick: () => {
        p(x());
      },
      children: (I, D) => {
        var A = F8(), M = T(A), N = T(M), P = Q(T(N), 2), Y = T(P);
        ee(() => {
          var B, K, U, ne, ue, ae;
          return ke(Y, ((U = (K = (B = x()) == null ? void 0 : B.template_announcement) == null ? void 0 : K.title) == null ? void 0 : U.split(" ").slice(0, 5).join(" ")) + (((ae = (ue = (ne = x()) == null ? void 0 : ne.template_announcement) == null ? void 0 : ue.title) == null ? void 0 : ae.split(" ").length) > 5 ? "..." : ""));
        });
        var G = Q(N, 2);
        {
          var q = (B) => {
            var K = I8(), U = T(K), ne = T(U);
            ee(() => {
              var ue, ae;
              return ke(ne, new Date(((ae = (ue = x()) == null ? void 0 : ue.template_announcement) == null ? void 0 : ae.created_at) * 1e3).toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric"
              }));
            }), _(B, K);
          };
          H(G, (B) => {
            var K, U;
            (U = (K = x()) == null ? void 0 : K.template_announcement) != null && U.created_at && B(q);
          });
        }
        var J = Q(M, 2), $ = T(J);
        ee(() => {
          var B, K, U, ne, ue, ae;
          return ke($, ((U = (K = (B = x()) == null ? void 0 : B.template_announcement) == null ? void 0 : K.description) == null ? void 0 : U.split(" ").slice(0, 5).join(" ")) + (((ae = (ue = (ne = x()) == null ? void 0 : ne.template_announcement) == null ? void 0 : ue.description) == null ? void 0 : ae.split(" ").length) > 5 ? "..." : ""));
        });
        var W = Q(J, 2), j = T(W);
        Re(j, {
          variant: "outline",
          type: "button",
          onclick: (B) => {
            B.preventDefault(), B.stopPropagation(), p(x());
          },
          class: "layup-h-7 !layup-items-center !layup-justify-center !layup-gap-[4px] !layup-rounded-sm !layup-border-[0.5px] !layup-border-border !layup-bg-accent !layup-px-2 !layup-py-1 !layup-text-base !layup-text-primary !layup-duration-200 hover:!layup-scale-105 hover:!layup-bg-accent-secondary hover:!layup-text-primary hover:!layup-opacity-90 dark:!layup-border-border dark:!layup-bg-accent dark:hover:!layup-bg-accent-secondary",
          children: (B, K) => {
            var U = O8();
            _(B, U);
          },
          $$slots: { default: !0 }
        }), _(I, A);
      },
      $$slots: { default: !0 }
    }), ee(() => Ve(E, `!layup-flex !layup-h-fit !layup-w-full !layup-flex-col layup-items-start !layup-rounded-lg !layup-bg-transparent ${(x().isLast && "layup-pb-4") ?? ""}`)), _(b, E);
  }, i = (b, x = De) => {
    var E = N8(), k = T(E), I = /* @__PURE__ */ R(() => Ee("layup-group !layup-flex !layup-h-full !layup-w-full !layup-items-start !layup-rounded-sm !layup-border !layup-border-background-secondary hover:!layup-border-accent-bg hover:!layup-bg-accent-secondary dark:hover:!layup-bg-accent-secondary"));
    Re(k, {
      variant: "ghost",
      get class() {
        return c(I);
      },
      onclick: () => {
        p(x());
      },
      children: (D, A) => {
        var M = D8(), N = T(M), P = T(N), Y = T(P), G = T(Y);
        ee(() => {
          var $, W, j, B, K, U;
          return ke(G, ((j = (W = ($ = x()) == null ? void 0 : $.template_announcement) == null ? void 0 : W.title) == null ? void 0 : j.split(" ").slice(0, 5).join(" ")) + (((U = (K = (B = x()) == null ? void 0 : B.template_announcement) == null ? void 0 : K.title) == null ? void 0 : U.split(" ").length) > 5 ? "..." : ""));
        });
        var q = Q(P, 2);
        {
          var J = ($) => {
            var W = L8(), j = T(W), B = T(j);
            ee(() => {
              var K, U;
              return ke(B, new Date(((U = (K = x()) == null ? void 0 : K.template_announcement) == null ? void 0 : U.created_at) * 1e3).toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric"
              }));
            }), _($, W);
          };
          H(q, ($) => {
            var W, j;
            (j = (W = x()) == null ? void 0 : W.template_announcement) != null && j.created_at && $(J);
          });
        }
        _(D, M);
      },
      $$slots: { default: !0 }
    }), _(b, E);
  };
  let o = /* @__PURE__ */ R(() => r().context.features.filter((b) => b.state.status === "NotStarted")), s = /* @__PURE__ */ R(() => r().context.features.filter((b) => b.state.status !== "NotStarted")), l = /* @__PURE__ */ R(() => r().can({ type: "seen" })), u = de(null), d = de(!1), f = de(oe({ type: "", url: "" }));
  const p = (b) => {
    z(u, oe(b)), r().matches({ features: "seen_features" }) ? t.send({ type: "openFeature", item: b }) : t.send({ type: "openFeature", item: b });
  }, h = (b, x) => {
    z(f, oe({ type: b, url: x })), z(d, !0);
  }, y = () => {
    z(d, !1);
  };
  var g = a7(), w = V(g);
  {
    var m = (b) => {
      var x = W8(), E = T(x), k = T(E);
      Re(k, {
        variant: "ghost",
        size: "sm",
        class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
        get onclick() {
          return t.onTerminate;
        },
        children: (W, j) => {
          var B = z8(), K = T(B);
          Ui(K, { class: "!layup-size-4" }), _(W, B);
        },
        $$slots: { default: !0 }
      });
      var I = Q(k, 2);
      Re(I, {
        variant: "ghost",
        size: "sm",
        class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
        get onclick() {
          return t.onClose;
        },
        children: (W, j) => {
          kr(W, { class: "!layup-size-full" });
        },
        $$slots: { default: !0 }
      });
      var D = Q(E, 2), A = T(D), M = T(A), N = Q(T(M), 2), P = T(N);
      {
        var Y = (W) => {
          Re(W, {
            variant: "ghost",
            size: "sm",
            class: "hover:!layup-bg-background-secondary/80 layup-flex !layup-h-8 !layup-items-center !layup-gap-2 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out dark:hover:!layup-bg-background-secondary",
            onclick: () => {
              t.send({ type: "seen" });
            },
            children: (j, B) => {
              var K = V8(), U = V(K);
              Zg(U, { class: "!layup-size-4" }), _(j, K);
            },
            $$slots: { default: !0 }
          });
        };
        H(P, (W) => {
          c(l) && W(Y);
        });
      }
      var G = Q(M, 2), q = T(G);
      {
        var J = (W) => {
          var j = B8(), B = V(j);
          at(B, 19, () => c(s), (ne) => ne.id, (ne, ue, ae) => {
            i(ne, () => ({
              ...c(ue),
              isLast: c(ae) === c(s).length - 1
            }));
          });
          var K = Q(B, 2);
          {
            var U = (ne) => {
              wc(ne, { title: "No Updates" });
            };
            H(K, (ne) => {
              c(s).length === 0 && ne(U);
            });
          }
          _(W, j);
        }, $ = (W) => {
          var j = j8(), B = V(j);
          at(B, 19, () => c(o), (ne) => ne.id, (ne, ue, ae) => {
            a(ne, () => ({
              ...c(ue),
              index: c(ae),
              isLast: c(ae) === c(o).length - 1
            }));
          });
          var K = Q(B, 2);
          {
            var U = (ne) => {
              wc(ne, { title: "No new updates" });
            };
            H(K, (ne) => {
              c(o).length === 0 && ne(U);
            });
          }
          _(W, j);
        };
        H(q, (W) => {
          r().matches({ features: "seen_features" }) ? W(J) : W($, !1);
        });
      }
      _(b, x);
    }, v = (b) => {
      var x = $8(), E = T(x), k = T(E), I = T(k);
      Re(I, {
        variant: "ghost",
        size: "sm",
        class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
        get onclick() {
          return t.onTerminate;
        },
        children: (B, K) => {
          var U = H8(), ne = T(U);
          Ui(ne, { class: "!layup-size-4" }), _(B, U);
        },
        $$slots: { default: !0 }
      });
      var D = Q(I, 2);
      Re(D, {
        variant: "ghost",
        size: "sm",
        class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
        get onclick() {
          return t.onClose;
        },
        children: (B, K) => {
          kr(B, { class: "!layup-size-full" });
        },
        $$slots: { default: !0 }
      });
      var A = Q(k, 2), M = T(A), N = T(M), P = Q(M, 2);
      {
        var Y = (B) => {
          var K = U8(), U = T(K);
          ee(() => {
            var ne, ue;
            return ke(U, new Date(((ue = (ne = c(u)) == null ? void 0 : ne.template_announcement) == null ? void 0 : ue.created_at) * 1e3).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric"
            }));
          }), _(B, K);
        };
        H(P, (B) => {
          var K, U;
          (U = (K = c(u)) == null ? void 0 : K.template_announcement) != null && U.created_at && B(Y);
        });
      }
      var G = Q(A, 2), q = T(G);
      {
        var J = (B) => {
          var K = J8(), U = T(K);
          {
            var ne = (ae) => {
              var se = G8();
              se.__click = [q8, h, u];
              var ge = T(se);
              ee(() => he(ge, "src", c(u).template_announcement.image)), _(ae, se);
            }, ue = (ae) => {
              var se = Z(), ge = V(se);
              {
                var pe = (me) => {
                  var we = Z8();
                  we.muted = !0, we.__click = [K8, h, u];
                  var fe = T(we);
                  ee(() => he(fe, "src", c(u).template_announcement.image)), _(me, we);
                }, ve = (me) => {
                  var we = X8();
                  we.__click = [Y8, h, u];
                  var fe = T(we);
                  ee(() => he(fe, "src", c(u).template_announcement.image)), _(me, we);
                };
                H(
                  ge,
                  (me) => {
                    c(u).template_announcement.image.endsWith(".mp4") ? me(pe) : me(ve, !1);
                  },
                  !0
                );
              }
              _(ae, se);
            };
            H(U, (ae) => {
              c(u).template_announcement.image.endsWith(".svg") ? ae(ne) : ae(ue, !1);
            });
          }
          _(B, K);
        };
        H(q, (B) => {
          var K, U;
          (U = (K = c(u)) == null ? void 0 : K.template_announcement) != null && U.image && B(J);
        });
      }
      var $ = Q(q, 2), W = T($), j = Q(E, 2);
      Re(j, {
        variant: "ghost",
        type: "button",
        onclick: () => {
          t.send({ type: "run", item: c(u) });
        },
        class: "layup-h-8 !layup-w-full !layup-items-center !layup-justify-center !layup-gap-[4px] !layup-rounded-sm !layup-border-none !layup-bg-accent !layup-px-3 !layup-py-1.5 !layup-text-sm !layup-text-white/90 !layup-duration-200 hover:!layup-bg-accent-secondary hover:!layup-text-white hover:!layup-opacity-90 ",
        children: (B, K) => {
          var U = Q8();
          _(B, U);
        },
        $$slots: { default: !0 }
      }), ee(() => {
        var B, K, U, ne;
        ke(N, (K = (B = c(u)) == null ? void 0 : B.template_announcement) == null ? void 0 : K.title), ke(W, (ne = (U = c(u)) == null ? void 0 : U.template_announcement) == null ? void 0 : ne.description);
      }), _(b, x);
    };
    H(w, (b) => {
      !r().matches({ features: "open_new_feature" }) && !r().matches({ features: "open_seen_feature" }) ? b(m) : b(v, !1);
    });
  }
  var C = Q(w, 2);
  {
    var S = (b) => {
      var x = Z(), E = V(x);
      rt(E, () => sv, (k, I) => {
        I(k, {
          get open() {
            return c(d);
          },
          controlledOpen: !0,
          onOpenChange: (D) => {
            var A;
            (A = D == null ? void 0 : D.stopPropagation) == null || A.call(D), z(d, !c(d));
          },
          children: (D, A) => {
            var M = Z(), N = V(M);
            rt(N, () => ov, (P, Y) => {
              Y(P, {
                trapFocus: !1,
                hideCloseButton: !0,
                class: "layup-feature !layup-left-1/2 !layup-top-1/2 !layup-z-[999999999] !layup-m-0 layup-translate-x-[-50%] layup-translate-y-[-50%] !layup-cursor-pointer !layup-border-none !layup-bg-transparent !layup-p-0 focus:layup-outline-none",
                onclick: (G) => {
                  G.stopPropagation(), y();
                },
                onkeydown: (G) => {
                  G.key === "Escape" && (G.stopPropagation(), y());
                },
                children: (G, q) => {
                  var J = Z(), $ = V(J);
                  {
                    var W = (B) => {
                      var K = t7();
                      K.__click = [e7], ee(() => he(K, "src", c(f).url)), _(B, K);
                    }, j = (B) => {
                      var K = Z(), U = V(K);
                      {
                        var ne = (ue) => {
                          var ae = r7();
                          ae.__click = [n7];
                          var se = T(ae);
                          ee(() => he(se, "src", c(f).url)), _(ue, ae);
                        };
                        H(
                          U,
                          (ue) => {
                            c(f).type === "video" && ue(ne);
                          },
                          !0
                        );
                      }
                      _(B, K);
                    };
                    H($, (B) => {
                      c(f).type === "image" ? B(W) : B(j, !1);
                    });
                  }
                  _(G, J);
                },
                $$slots: { default: !0 }
              });
            }), _(D, M);
          },
          $$slots: { default: !0 }
        });
      }), _(b, x);
    };
    H(C, (b) => {
      c(d) && b(S);
    });
  }
  _(e, g), _e();
}
Er(["click"]);
var o7 = /* @__PURE__ */ O('<span class="animated-letter !layup-font-light !layup-text-primary dark:!layup-text-primary svelte-s3fx26"> </span>'), s7 = /* @__PURE__ */ O("<div></div>");
function l7(e, t) {
  be(t, !0);
  let n = [];
  Rn(() => {
    const a = () => {
      const s = n.filter((f) => f.textContent !== " "), l = 50, u = 300, d = s.length * l + u;
      return s.forEach((f) => {
        f.style.transform = "translateY(0)", f.style.opacity = "0.7", f.style.textShadow = "0 0 5px rgba(255, 255, 255, 0.3)";
      }), s.forEach((f, p) => {
        setTimeout(
          () => {
            f.style.transform = "translateY(-2px)", f.style.opacity = "1", f.style.textShadow = "0 0 8px rgba(255, 255, 255, 0.8)", setTimeout(
              () => {
                f.style.transform = "translateY(0)", f.style.opacity = "0.7", f.style.textShadow = "0 0 5px rgba(255, 255, 255, 0.3)";
              },
              u
            );
          },
          p * l
        );
      }), d + 200;
    };
    let i = a();
    const o = setInterval(
      () => {
        i = a();
      },
      i
    );
    return () => clearInterval(o);
  });
  var r = s7();
  at(r, 21, () => {
    var a;
    return (a = t.text) == null ? void 0 : a.split("");
  }, gt, (a, i, o) => {
    var s = o7(), l = T(s);
    tn(s, (u, d) => n[d] = u, (u) => n == null ? void 0 : n[u], () => [o]), ee(() => {
      he(s, "style", `display: ${(c(i) === " " ? "inline" : "inline-block") ?? ""}`), ke(l, c(i));
    }), _(a, s);
  }), ee(() => {
    Ve(r, `layup-relative layup-z-50 !layup-w-full !layup-rounded-lg !layup-text-base
    !layup-font-light !layup-text-primary dark:!layup-text-primary ${t.padding ?? ""} svelte-s3fx26`), he(r, "style", `background-color: ${t.backgroundColor ?? ""}; text-align: ${t.textAlign ?? ""}`);
  }), _(e, r), _e();
}
var u7 = /* @__PURE__ */ vt('<svg><path d="M11 17V5.414l3.293 3.293a.999.999 0 101.414-1.414l-5-5a.999.999 0 00-1.414 0l-5 5a.997.997 0 000 1.414.999.999 0 001.414 0L9 5.414V17a1 1 0 102 0z"></path></svg>');
function Ad(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "fill"]);
  var r = u7();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      ...n,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var c7 = /* @__PURE__ */ O("<textarea></textarea>");
function lv(e, t) {
  be(t, !0);
  let n = L(t, "ref", 15, null), r = L(t, "value", 15), a = L(t, "initialHeight", 3, 20), i = L(t, "resizeVertical", 3, !1), o = L(t, "submitOnEnter", 3, void 0), s = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "value",
    "class",
    "initialHeight",
    "resizeVertical",
    "submitOnEnter"
  ]);
  const l = (g, w) => {
    const m = (v) => {
      g.style.height = `${a()}px`;
      const C = parseInt(getComputedStyle(g).paddingTop) + parseInt(getComputedStyle(g).paddingBottom), S = g.scrollHeight - C;
      g.style.height = S + "px";
    };
    return w && g.addEventListener("input", m), {
      update(v) {
        w && g.removeEventListener("input", m), v && g.addEventListener("input", m), w = v;
      },
      destroy() {
        w && g.removeEventListener("input", m);
      }
    };
  }, u = (g, w) => {
    const m = (v) => {
      if (v.key === "Enter" && !v.shiftKey) {
        v.preventDefault();
        const C = document.getElementById(w ?? "");
        C && C.dispatchEvent(new Event("submit", { cancelable: !0 }));
      }
    };
    return w && g.addEventListener("keydown", m), {
      update(v) {
        w && g.removeEventListener("keydown", m), v && g.addEventListener("keydown", m), w = v;
      },
      destroy() {
        g.removeEventListener("keydown", m);
      }
    };
  };
  var d = c7(), f = (g) => {
    var w;
    (w = g == null ? void 0 : g.target) == null || w.focus(), g.stopPropagation();
  }, p = (g) => {
    g.stopPropagation();
  }, h = (g) => {
    g.stopPropagation();
  };
  let y;
  tn(d, (g) => n(g), () => n()), ri(() => qm(d, r)), _a(d, (g, w) => l == null ? void 0 : l(g, w), i), _a(d, (g, w) => u == null ? void 0 : u(g, w), o), ee(() => y = Je(d, y, {
    onfocus: f,
    onmousedown: p,
    onpointerdown: h,
    class: Ee("focus-visible:outline-none layup-flex layup-w-full layup-resize-none layup-rounded-md layup-border layup-border-input layup-bg-transparent layup-px-3 layup-py-2 layup-shadow-sm placeholder:!layup-text-muted-foreground disabled:layup-cursor-not-allowed disabled:layup-opacity-50", t.class),
    ...s
  })), _(e, d), _e();
}
var d7 = /* @__PURE__ */ O('<div class=" !layup-text-base layup-text-primary svelte-17sq7v2">Need a guide?</div>'), f7 = /* @__PURE__ */ O('<div><form id="layup-ai-form"><!> <div><!></div> <!></form> <!></div>'), p7 = /* @__PURE__ */ O('<div class="!layup-text-base layup-text-primary svelte-17sq7v2">Need a guide?</div>'), h7 = /* @__PURE__ */ O("<!> <!>", 1);
function y7(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(t.snapshot, "$snapshot", n);
  let a = de(""), i = de(!1), o, s = de(void 0);
  Se(() => {
    var b;
    r().matches("query") && ((b = document.getElementById("layup-ai-form-input")) == null || b.focus());
  });
  const l = (b) => {
    b.altKey && b.code === "KeyH" && t.send({ type: "history" });
  }, u = (b) => {
    b.preventDefault(), c(a).trim() !== "" && (t.send({
      type: "request",
      userMessages: c(a)
    }), z(a, ""), z(i, !0), setTimeout(
      () => {
        z(i, !1);
      },
      100
    ));
  }, d = r().can({ type: "handleOnboarding" }), f = r().can({ type: "handleFeatures" }), p = (b) => {
    b.preventDefault(), b.stopPropagation(), t.send({ type: "handleQuery" });
  }, h = (b) => {
    b.preventDefault(), b.stopPropagation(), r().context.messages.length === 0 && t.send({ type: "search", query: c(a) });
  };
  let y = /* @__PURE__ */ R(() => r().context.messages);
  const g = D1(h, 1e3), w = /* @__PURE__ */ R(() => r().matches({ thinking: "getQuery" }));
  var m = h7(), v = V(m);
  Gr(v, () => c(i), (b) => {
    var x = f7();
    const E = /* @__PURE__ */ R(() => `${Ee("!layup-flex layup-max-h-[56px] !layup-min-w-full !layup-items-center !layup-justify-center !layup-rounded-sm !layup-p-2 !layup-px-1", r().matches("query") || r().matches({ thinking: "getQuery" }) ? "animate-expand-width " : "animate-collapse-width") ?? ""} svelte-17sq7v2`);
    var k = T(x);
    const I = /* @__PURE__ */ R(() => `${Ee("!layup-mx-auto !layup-flex !layup-h-fit !layup-w-full !layup-flex-row !layup-items-center !layup-gap-1 !layup-rounded-lg !layup-p-0", !(r().matches("query") || r().matches({ thinking: "getQuery" })) && "!layup-hidden") ?? ""} svelte-17sq7v2`);
    var D = T(k);
    {
      var A = (j) => {
        var B = /* @__PURE__ */ R(() => Ee("!layup-flex !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-center !layup-rounded-sm !layup-bg-transparent !layup-fill-secondary hover:!layup-bg-background  hover:!layup-fill-primary"));
        Re(j, {
          variant: "ghost",
          size: "icon",
          get class() {
            return c(B);
          },
          onclick: () => {
            r().context.isHistory ? t.send({ type: "goToHistory" }) : (t.send({ type: "esc" }), t.send({ type: "terminate" }));
          },
          children: (K, U) => {
            Ui(K, { class: "!layup-size-4 " });
          },
          $$slots: { default: !0 }
        });
      };
      H(D, (j) => {
        var B;
        ((B = c(y)) == null ? void 0 : B.length) > 0 && j(A);
      });
    }
    var M = Q(D, 2);
    const N = /* @__PURE__ */ R(() => `${Ee("!layup-flex layup-h-14 !layup-flex-1 !layup-items-center !layup-justify-between !layup-rounded-lg !layup-bg-transparent !layup-p-1 !layup-transition-[width] !layup-duration-300 !layup-ease-in-out") ?? ""} svelte-17sq7v2`);
    var P = T(M), Y = /* @__PURE__ */ R(() => Ee("!layup-mb-2 !layup-mt-2 !layup-max-h-12 !layup-min-h-[24px] !layup-w-full !layup-resize-none !layup-overflow-y-auto !layup-rounded-none !layup-border-none !layup-bg-transparent !layup-text-base !layup-text-primary layup-caret-primary !layup-shadow-none placeholder:!layup-pl-[1px] placeholder:!layup-text-base placeholder:!layup-text-secondary focus-visible:!layup-outline-none focus-visible:!layup-ring-0"));
    tn(
      lv(P, {
        id: "layup-ai-form-input",
        onkeydown: l,
        get ref() {
          return o;
        },
        placeholder: "How can Layup guide you?",
        get class() {
          return c(Y);
        },
        resizeVertical: !0,
        rows: 1,
        oninput: g,
        submitOnEnter: "layup-ai-form",
        get disabled() {
          return c(w);
        },
        get value() {
          return c(a);
        },
        set value(j) {
          z(a, oe(j));
        }
      }),
      (j) => z(s, oe(j)),
      () => c(s)
    );
    var G = Q(M, 2), q = /* @__PURE__ */ R(() => Ee("!layup-flex !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-center !layup-rounded-sm !layup-border-accent !layup-bg-accent layup-fill-primary hover:!layup-bg-accent-secondary hover:!layup-fill-accent-text disabled:!layup-border-none disabled:!layup-bg-background-secondary dark:disabled:!layup-bg-background-secondary", c(w) && "!layup-cursor-not-allowed !layup-opacity-50")), J = /* @__PURE__ */ R(() => c(a).length === 0 || c(w));
    Re(G, {
      variant: "default",
      size: "icon",
      get class() {
        return c(q);
      },
      type: "submit",
      get disabled() {
        return c(J);
      },
      children: (j, B) => {
        Ad(j, { class: "!layup-size-5" });
      },
      $$slots: { default: !0 }
    });
    var $ = Q(k, 2), W = /* @__PURE__ */ R(() => Ee("animate-collapse-width layup-flex layup-h-[36px] !layup-w-full !layup-min-w-20 !layup-items-center !layup-justify-center !layup-rounded-sm !layup-p-4 !layup-text-primary hover:!layup-rounded-sm hover:!layup-bg-accent-secondary hover:!layup-text-primary", d && f ? "!layup-justify-start" : "!layup-justify-center", (r().matches("query") || r().matches({ thinking: "getQuery" })) && "!layup-hidden"));
    Re($, {
      variant: "ghost",
      get class() {
        return c(W);
      },
      onclick: p,
      children: (j, B) => {
        var K = d7();
        _(j, K);
      },
      $$slots: { default: !0 }
    }), ee(() => {
      Ve(x, c(E)), Ve(k, c(I)), Ve(M, c(N));
    }), ct("submit", k, u), _(b, x);
  });
  var C = Q(v, 2), S = /* @__PURE__ */ R(() => Ee("animate-collapse-width layup-flex layup-h-[36px] !layup-w-full !layup-min-w-20 !layup-items-center !layup-justify-center !layup-rounded-sm !layup-p-4 !layup-text-primary hover:!layup-rounded-sm hover:!layup-bg-accent-secondary hover:!layup-text-primary", d && f ? "!layup-justify-start" : "!layup-justify-center", (r().matches("query") || r().matches({ thinking: "getQuery" })) && "!layup-hidden"));
  Re(C, {
    variant: "ghost",
    get class() {
      return c(S);
    },
    onclick: p,
    children: (b, x) => {
      var E = p7();
      _(b, E);
    },
    $$slots: { default: !0 }
  }), _(e, m), _e();
}
var g7 = /* @__PURE__ */ O('<div class="confetti svelte-15ksp55"></div>'), v7 = /* @__PURE__ */ O('<div class="confetti-holder svelte-15ksp55"></div>');
function m7(e, t) {
  be(t, !0);
  const n = L(t, "size", 3, 10), r = L(t, "x", 19, () => [-0.5, 0.5]), a = L(t, "y", 19, () => [0.25, 1]), i = L(t, "duration", 3, 2e3), o = L(t, "infinite", 3, !1), s = L(t, "delay", 19, () => [0, 50]), l = L(t, "colorRange", 19, () => [0, 360]), u = L(t, "colorArray", 19, () => []), d = L(t, "amount", 3, 50), f = L(t, "iterationCount", 3, 1), p = L(t, "fallDistance", 3, "100px"), h = L(t, "rounded", 3, !1), y = L(t, "cone", 3, !1), g = L(t, "noGravity", 3, !1), w = L(t, "xSpread", 3, 0.15), m = L(t, "destroyOnComplete", 3, !0), v = L(t, "disableForReducedMotion", 3, !1);
  let C = de(!1);
  Rn(() => {
    !m() || o() || typeof f() == "string" || setTimeout(() => z(C, !0), (i() + s()[1]) * f());
  });
  function S(I, D) {
    return Math.random() * (D - I) + I;
  }
  function b() {
    return u().length ? u()[Math.round(Math.random() * (u().length - 1))] : `hsl(${Math.round(S(l()[0], l()[1]))}, 75%, 50%)`;
  }
  var x = Z(), E = V(x);
  {
    var k = (I) => {
      var D = v7();
      at(D, 21, () => ({ length: d() }), gt, (A, M) => {
        var N = g7();
        const P = /* @__PURE__ */ R(() => b() ?? ""), Y = /* @__PURE__ */ R(() => S(-45, 45) ?? ""), G = /* @__PURE__ */ R(() => S(-45, 45) ?? ""), q = /* @__PURE__ */ R(() => S(-10, 10) ?? ""), J = /* @__PURE__ */ R(() => S(-10, 10) ?? ""), $ = /* @__PURE__ */ R(() => S(-10, 10) ?? ""), W = /* @__PURE__ */ R(() => S(0, 360) ?? ""), j = /* @__PURE__ */ R(() => S(a()[0], a()[1]) ?? ""), B = /* @__PURE__ */ R(() => S(r()[0], r()[1]) ?? ""), K = /* @__PURE__ */ R(() => 0.1 * S(2, 10)), U = /* @__PURE__ */ R(() => S(s()[0], s()[1]) ?? ""), ne = /* @__PURE__ */ R(() => (o() ? `calc(${i()}ms * var(--scale))` : `${i()}ms`) ?? ""), ue = /* @__PURE__ */ R(() => `
        --color: ${c(P)};
        --skew: ${c(Y)}deg,${c(G)}deg;
        --rotation-xyz: ${c(q)}, ${c(J)}, ${c($)};
        --rotation-deg: ${c(W)}deg;
        --translate-y-multiplier: ${c(j)};
        --translate-x-multiplier: ${c(B)};
        --scale: ${c(K)};
        --transition-delay: ${c(U)}ms;
        --transition-duration: ${c(ne)};`);
        ee(() => he(N, "style", c(ue))), _(A, N);
      }), ee(() => {
        he(D, "style", `
    --fall-distance: ${p() ?? ""};
    --size: ${n() ?? ""}px;
    --x-spread: ${1 - w()};
    --transition-iteration-count: ${(o() ? "infinite" : f()) ?? ""};`), os(D, "rounded", h()), os(D, "cone", y()), os(D, "no-gravity", g()), os(D, "reduced-motion", v());
      }), _(I, D);
    };
    H(E, (I) => {
      c(C) || I(k);
    });
  }
  _(e, x), _e();
}
function Ms(e) {
  const t = e - 1;
  return t * t * t + 1;
}
function w7(e, { from: t, to: n }, r = {}) {
  var a = getComputedStyle(e), i = b7(e), o = a.transform === "none" ? "" : a.transform, [s, l] = a.transformOrigin.split(" ").map(parseFloat), u = t.width / n.width, d = t.height / n.height, f = (t.left + u * s - (n.left + s)) / i, p = (t.top + d * l - (n.top + l)) / i, { delay: h = 0, duration: y = (w) => Math.sqrt(w) * 120, easing: g = Ms } = r;
  return {
    delay: h,
    duration: typeof y == "function" ? y(Math.sqrt(f * f + p * p)) : y,
    easing: g,
    css: (w, m) => {
      var v = m * f, C = m * p, S = w + m * u, b = w + m * d;
      return `transform: ${o} scale(${S}, ${b}) translate(${v}px, ${C}px);`;
    }
  };
}
function b7(e) {
  if ("currentCSSZoom" in e)
    return (
      /** @type {number} */
      e.currentCSSZoom
    );
  for (var t = e, n = 1; t !== null; )
    n *= +getComputedStyle(t).zoom, t = /** @type {Element | null} */
    t.parentElement;
  return n;
}
const _7 = (e) => {
  var t = k7();
  _(e, t);
}, x7 = (e) => {
  var t = S7();
  _(e, t);
};
var k7 = /* @__PURE__ */ O('<div class="layup-relative layup-h-3 layup-w-3 layup-overflow-hidden layup-rounded-[4px] !layup-border-[0px] !layup-border-accent !layup-bg-accent layup-outline-none"><div class="layup-absolute layup-inset-0 layup-rounded-[4px] layup-border layup-border-accent layup-bg-accent layup-transition-all layup-duration-300 hover:layup-scale-110 hover:layup-bg-accent"></div></div>'), S7 = /* @__PURE__ */ O('<div class="layup-relative layup-h-3 layup-w-3 layup-overflow-hidden layup-rounded-[4px] !layup-border-[0px]"><div class="layup-absolute layup-inset-0 layup-rounded-[4px] layup-border layup-border-accent layup-bg-accent-bg layup-transition-all layup-duration-300 hover:layup-scale-110 hover:layup-bg-accent"></div></div>'), C7 = /* @__PURE__ */ O('<div class="!layup-relative !layup-h-3 !layup-w-3 !layup-rounded-[4px] !layup-bg-background-secondary layup-transition-transform hover:layup-scale-110" role="progressbar" aria-valuemin="1"><!></div>'), E7 = /* @__PURE__ */ O('<div class="layup-flex layup-w-fit layup-items-center layup-justify-center layup-gap-2 layup-overflow-hidden layup-px-1 layup-py-2"></div>');
function Lp(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => Math.max(0, Math.min(t.currentStep - 2, t.totalBars - 5))), r = /* @__PURE__ */ R(() => Math.min(c(n) + 5, t.totalBars));
  const a = {
    duration: 300,
    // Slightly reduced for snappier feedback
    easing: Ms,
    delay: 0
  }, i = { duration: 250, easing: Ms }, o = {
    duration: 300,
    easing: Ms,
    x: 16
    // Slightly reduced for more subtle movement
  };
  var s = E7();
  at(s, 31, () => Array(t.totalBars).slice(c(n), c(r)), (l, u) => u + c(n), (l, u, d) => {
    var f = C7();
    const p = /* @__PURE__ */ R(() => c(d) === 0), h = /* @__PURE__ */ R(() => c(d) === c(r) - c(n) - 1), y = /* @__PURE__ */ R(() => c(d) + c(n));
    var g = T(f);
    {
      var w = (v) => {
        x7(v);
      }, m = (v) => {
        var C = Z(), S = V(C);
        {
          var b = (x) => {
            _7(x);
          };
          H(
            S,
            (x) => {
              c(y) < t.currentStep && x(b);
            },
            !0
          );
        }
        _(v, C);
      };
      H(g, (v) => {
        c(y) === t.currentStep ? v(w) : v(m, !1);
      });
    }
    ee(() => {
      he(f, "aria-valuenow", c(y) + 1), he(f, "aria-valuemax", t.totalBars), he(f, "aria-label", `Step ${c(y) + 1} of ${t.totalBars}`);
    }), ct("mouseenter", f, () => c(y)), ct("mouseleave", f, () => -1), Um(f, () => w7, () => a), bt(1, f, () => yc, () => c(h) ? o : void 0), bt(2, f, () => qg, () => c(p) ? i : void 0), _(l, f);
  }), _(e, s), _e();
}
var T7 = /* @__PURE__ */ O('<span class="layup-text-base layup-text-white">Next step</span>'), A7 = /* @__PURE__ */ O('<span class="layup-text-base layup-text-accent-text">Ask</span>'), P7 = /* @__PURE__ */ O('<span class="layup-text-base layup-text-primary">Close</span>'), M7 = /* @__PURE__ */ O("<!> <!>", 1), I7 = /* @__PURE__ */ O('<div class="layup-absolute layup-left-1/2 layup-top-1/2 layup-translate-x-[-50%] layup-translate-y-[-50%] layup-transform"><!></div>'), O7 = /* @__PURE__ */ O('<!> <div class="layup-min-w-[80px] layup-select-none layup-text-center layup-text-base layup-text-primary" style="-webkit-user-select: none;"> </div>', 1), F7 = /* @__PURE__ */ O("<!> All done!", 1), R7 = /* @__PURE__ */ O('<span class="layup-text-base">Finish</span>'), L7 = /* @__PURE__ */ O('<span class="layup-text-base"><!></span>'), D7 = /* @__PURE__ */ O('<div class="!layup-pointer-events-none layup-flex layup-h-fit layup-items-center layup-justify-between layup-gap-2 layup-p-2 layup-text-center layup-text-base layup-font-medium layup-text-primary"><div><!></div> <!> <div class="layup-flex layup-items-center layup-justify-center layup-gap-4"><!></div> <div class="layup-flex layup-items-center"><!></div></div>');
function N7(e, t) {
  be(t, !0);
  const n = /* @__PURE__ */ R(() => {
    var S, b;
    return ((b = (S = t.guideMachineContext) == null ? void 0 : S.context) == null ? void 0 : b.currentStepIndex) || 0;
  }), r = /* @__PURE__ */ R(() => {
    var S;
    return ((S = t.guideMachineContext) == null ? void 0 : S.can({ type: "LAST_STEP" })) ?? !1;
  });
  let a = de(!1);
  Se(() => {
    var S;
    (S = t.guideMachineContext) != null && S.matches("completed") && z(a, !0);
  });
  const i = /* @__PURE__ */ R(() => {
    var S, b;
    return ((b = (S = t.guideMachineContext) == null ? void 0 : S.context) == null ? void 0 : b.steps.length) || 0;
  });
  var o = D7(), s = T(o), l = T(s);
  {
    var u = (S) => {
      var b = M7(), x = V(b);
      {
        var E = (A) => {
          var M = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 layup-w-fit !layup-rounded-sm !layup-border-[1px] !layup-border-background-secondary !layup-bg-accent !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-accent-secondary hover:!layup-no-underline"));
          Re(A, {
            variant: "outline",
            get class() {
              return c(M);
            },
            onclick: (N) => {
              var P;
              N.preventDefault(), N.stopPropagation(), (P = t.guideMachineRef) == null || P.send({ type: "NEXT_STEP" });
            },
            children: (N, P) => {
              var Y = T7();
              _(N, Y);
            },
            $$slots: { default: !0 }
          });
        };
        H(x, (A) => {
          var M, N;
          (M = t.guideMachineContext) != null && M.can({ type: "NEXT_STEP" }) && !((N = t.guideMachineContext) != null && N.can({ type: "LAST_STEP" })) && A(E);
        });
      }
      var k = Q(x, 2);
      {
        var I = (A) => {
          var M = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 layup-w-14 !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary"));
          Re(A, {
            variant: "outline",
            get class() {
              return c(M);
            },
            onclick: (N) => {
              var P;
              N.preventDefault(), N.stopPropagation(), (P = t.guideMachineRef) == null || P.send({ type: "SHOW_KNOWLEDGE" });
            },
            children: (N, P) => {
              var Y = A7();
              _(N, Y);
            },
            $$slots: { default: !0 }
          });
        }, D = (A) => {
          var M = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 layup-w-14 !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary"));
          Re(A, {
            variant: "outline",
            get class() {
              return c(M);
            },
            onclick: (N) => {
              var P;
              N.preventDefault(), N.stopPropagation(), (P = t.guideMachineRef) == null || P.send({ type: "HIDE_KNOWLEDGE" });
            },
            children: (N, P) => {
              var Y = P7();
              _(N, Y);
            },
            $$slots: { default: !0 }
          });
        };
        H(k, (A) => {
          var M, N;
          (N = (M = t.guideMachineContext) == null ? void 0 : M.context) != null && N.showKnowledge ? A(D, !1) : A(I);
        });
      }
      _(S, b);
    };
    H(l, (S) => {
      c(a) || S(u);
    });
  }
  var d = Q(s, 2);
  {
    var f = (S) => {
      var b = I7(), x = T(b);
      m7(x, {
        x: [-0.5, 0.5],
        y: [-0.5, 0.5],
        size: 5
      }), _(S, b);
    };
    H(d, (S) => {
      c(a) && S(f);
    });
  }
  var p = Q(d, 2), h = T(p);
  {
    var y = (S) => {
      var b = O7(), x = V(b), E = /* @__PURE__ */ R(() => {
        var A, M;
        return c(i) > 1 ? c(i) : ((M = (A = t.guideMachineContext) == null ? void 0 : A.context) == null ? void 0 : M.progressSteps[0]) || 1;
      }), k = /* @__PURE__ */ R(() => {
        var A, M;
        return c(i) > 1 ? c(n) : ((M = (A = t.guideMachineContext) == null ? void 0 : A.context) == null ? void 0 : M.currentActionsMap.length) - 1;
      });
      Lp(x, {
        get totalBars() {
          return c(E);
        },
        get currentStep() {
          return c(k);
        }
      });
      var I = Q(x, 2), D = T(I);
      ee(() => {
        var A, M, N, P, Y, G, q, J;
        return ke(D, (((M = (A = t.guideMachineContext) == null ? void 0 : A.context) == null ? void 0 : M.progressSteps[0]) || 1) - (((P = (N = t.guideMachineContext) == null ? void 0 : N.context) == null ? void 0 : P.currentActionsMap.length) || 0) === 0 ? "Last step!" : `${(((G = (Y = t.guideMachineContext) == null ? void 0 : Y.context) == null ? void 0 : G.progressSteps[0]) || 1) - (((J = (q = t.guideMachineContext) == null ? void 0 : q.context) == null ? void 0 : J.currentActionsMap.length) - 1 || 0)} steps left`);
      }), _(S, b);
    }, g = (S) => {
      var b = F7(), x = V(b), E = /* @__PURE__ */ R(() => {
        var I, D;
        return (D = (I = t.guideMachineContext) == null ? void 0 : I.context) == null ? void 0 : D.progressSteps[0];
      }), k = /* @__PURE__ */ R(() => {
        var I, D;
        return (D = (I = t.guideMachineContext) == null ? void 0 : I.context) == null ? void 0 : D.progressSteps[0];
      });
      Lp(x, {
        get totalBars() {
          return c(E);
        },
        get currentStep() {
          return c(k);
        }
      }), _(S, b);
    };
    H(h, (S) => {
      c(a) ? S(g, !1) : S(y);
    });
  }
  var w = Q(p, 2), m = T(w);
  {
    var v = (S) => {
      var b = /* @__PURE__ */ R(() => Ee("!layup-pointer-events-auto !layup-h-7 !layup-rounded-sm !layup-border-none !layup-border-success !layup-bg-success/90  !layup-p-2 !layup-text-white !layup-shadow-lg !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:layup-scale-105 hover:!layup-bg-success hover:!layup-text-white hover:!layup-no-underline dark:!layup-text-white  dark:hover:!layup-bg-success"));
      Re(S, {
        variant: "ghost",
        size: "sm",
        get class() {
          return c(b);
        },
        onclick: (x) => {
          var E, k;
          x.preventDefault(), x.stopPropagation(), c(a) ? (k = t.guideMachineRef) == null || k.send({ type: "EXIT" }) : (E = t.guideMachineRef) == null || E.send({ type: "TERMINATE" });
        },
        children: (x, E) => {
          var k = R7();
          _(x, k);
        },
        $$slots: { default: !0 }
      });
    }, C = (S) => {
      var b = /* @__PURE__ */ R(() => Ee(" !layup-pointer-events-auto !layup-h-8 !layup-rounded-sm !layup-p-2 !layup-text-primary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:layup-scale-105 hover:!layup-bg-background-secondary hover:!layup-text-primary hover:!layup-ease-in-out dark:hover:!layup-bg-background-secondary", c(a) ? "!layup-pointer-events-auto !layup-h-7 layup-w-fit !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary" : ""));
      Re(S, {
        variant: "ghost",
        size: "sm",
        get class() {
          return c(b);
        },
        onclick: (x) => {
          var E, k;
          x.preventDefault(), x.stopPropagation(), c(a) ? (k = t.guideMachineRef) == null || k.send({ type: "EXIT" }) : (E = t.guideMachineRef) == null || E.send({ type: "TERMINATE" });
        },
        children: (x, E) => {
          var k = L7(), I = T(k);
          {
            var D = (M) => {
              var N = qa("Finish");
              _(M, N);
            }, A = (M) => {
              var N = qa("Exit");
              _(M, N);
            };
            H(I, (M) => {
              c(a) ? M(A, !1) : M(D);
            });
          }
          _(x, k);
        },
        $$slots: { default: !0 }
      });
    };
    H(m, (S) => {
      c(r) ? S(v) : S(C, !1);
    });
  }
  _(e, o), _e();
}
var z7 = /* @__PURE__ */ O('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), V7 = /* @__PURE__ */ O('<p class="!layup-text-sm !layup-text-primary"> </p>'), B7 = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-4 layup-rounded-md layup-bg-background !layup-p-6 !layup-pb-1"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div> <div class="!layup-flex !layup-flex-col !layup-gap-0.5"><h2 class="!layup-text-xl !layup-font-semibold !layup-text-primary"> </h2> <!></div></div>');
function j7(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(t.snapshot, "$snapshot", n), a = /* @__PURE__ */ R(() => {
    var v;
    return (v = r().context.theme) == null ? void 0 : v.icons;
  });
  let i = /* @__PURE__ */ R(() => t.features.filter((v) => v.state.status === "NotStarted").sort((v, C) => {
    var S, b;
    return (((S = C.template_announcement) == null ? void 0 : S.created_at) || 0) - (((b = v.template_announcement) == null ? void 0 : b.created_at) || 0);
  })[0]);
  var o = B7(), s = T(o), l = T(s), u = T(l);
  {
    var d = (v) => {
      var C = z7(), S = V(C), b = T(S);
      dn(b, () => {
        var k, I, D;
        return (D = (I = (k = c(a)) == null ? void 0 : k.logo) == null ? void 0 : I.dark_mode) == null ? void 0 : D.xml;
      });
      var x = Q(S, 2), E = T(x);
      dn(E, () => {
        var k, I, D;
        return (D = (I = (k = c(a)) == null ? void 0 : k.logo) == null ? void 0 : I.light_mode) == null ? void 0 : D.xml;
      }), _(v, C);
    }, f = (v) => {
      su(v, { class: "!layup-size-6" });
    };
    H(u, (v) => {
      var C, S, b;
      (b = (S = (C = c(a)) == null ? void 0 : C.logo) == null ? void 0 : S.dark_mode) != null && b.xml ? v(d) : v(f, !1);
    });
  }
  var p = Q(l, 2);
  Re(p, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (v, C) => {
      kr(v, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var h = Q(s, 2), y = T(h), g = T(y), w = Q(y, 2);
  {
    var m = (v) => {
      var C = V7(), S = T(C);
      ee(() => ke(S, new Date(c(i).template_announcement.created_at * 1e3).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      }))), _(v, C);
    };
    H(w, (v) => {
      var C, S;
      (S = (C = c(i)) == null ? void 0 : C.template_announcement) != null && S.created_at && v(m);
    });
  }
  ee(() => {
    var v, C;
    return ke(g, (C = (v = c(i)) == null ? void 0 : v.template_announcement) == null ? void 0 : C.title);
  }), _(e, o), _e();
}
var W7 = /* @__PURE__ */ O('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), H7 = /* @__PURE__ */ O(`<div class="!layup-flex !layup-flex-col !layup-gap-6 layup-rounded-md layup-bg-background !layup-p-6 !layup-pb-0"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div> <div class="!layup-flex !layup-flex-col !layup-gap-1"><h2 class="!layup-text-2xl !layup-font-semibold !layup-text-primary"> </h2> <p class="!layup-text-base !layup-text-secondary">Let's get you onboarded.</p></div></div>`);
function U7(e, t) {
  be(t, !0);
  const n = /* @__PURE__ */ R(() => {
    var h;
    return (h = t.snapshot.context.theme) == null ? void 0 : h.icons;
  });
  var r = H7(), a = T(r), i = T(a), o = T(i);
  {
    var s = (h) => {
      var y = W7(), g = V(y), w = T(g);
      dn(w, () => {
        var C, S, b;
        return (b = (S = (C = c(n)) == null ? void 0 : C.logo) == null ? void 0 : S.dark_mode) == null ? void 0 : b.xml;
      });
      var m = Q(g, 2), v = T(m);
      dn(v, () => {
        var C, S, b;
        return (b = (S = (C = c(n)) == null ? void 0 : C.logo) == null ? void 0 : S.light_mode) == null ? void 0 : b.xml;
      }), _(h, y);
    }, l = (h) => {
      su(h, { class: "!layup-size-6" });
    };
    H(o, (h) => {
      var y, g, w;
      (w = (g = (y = c(n)) == null ? void 0 : y.logo) == null ? void 0 : g.dark_mode) != null && w.xml ? h(s) : h(l, !1);
    });
  }
  var u = Q(i, 2);
  Re(u, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (h, y) => {
      kr(h, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var d = Q(a, 2), f = T(d), p = T(f);
  ee(() => {
    var h;
    return ke(p, `Welcome to ${(((h = X == null ? void 0 : X.config) == null ? void 0 : h.name) || "Layup") ?? ""}!`);
  }), _(e, r), _e();
}
var q7 = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <span class="layup-text-base">Back</span></div>'), G7 = /* @__PURE__ */ O(`<div class="!layup-flex !layup-flex-col !layup-gap-4 layup-rounded-md layup-rounded-bl-none layup-rounded-br-none !layup-bg-background"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between !layup-p-4 !layup-h-14"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <div class="!layup-flex !layup-items-center !layup-gap-2"><!></div></div> <div class="!layup-flex !layup-flex-col !layup-gap-1 !layup-p-6 !layup-py-0"><h2 class="!layup-text-xl !layup-font-medium !layup-text-primary"> </h2> <p class="!layup-text-base !layup-text-secondary">Let's get you onboarded.</p></div></div>`);
function K7(e, t) {
  be(t, !0);
  const n = /* @__PURE__ */ R(() => {
    var p, h;
    return (h = (p = t.snapshot.context.plans) == null ? void 0 : p.onboarding_flows) != null && h.length ? t.snapshot.context.plans.onboarding_flows.filter((y) => y.state.status === "Completed").length / t.snapshot.context.plans.onboarding_flows.length : 0;
  });
  var r = G7(), a = T(r), i = T(a), o = T(i);
  Re(o, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (p, h) => {
      var y = q7(), g = T(y);
      Ui(g, { class: "!layup-size-4" }), _(p, y);
    },
    $$slots: { default: !0 }
  });
  var s = Q(i, 2), l = T(s);
  iv(l, {
    get progress() {
      return c(n);
    }
  });
  var u = Q(a, 2), d = T(u), f = T(d);
  ee(() => {
    var p;
    return ke(f, `Welcome to ${(((p = X == null ? void 0 : X.config) == null ? void 0 : p.name) || "Layup") ?? ""}!`);
  }), _(e, r), _e();
}
var Z7 = /* @__PURE__ */ O('<span class="layup-text-base layup-text-primary">Show</span>'), Y7 = /* @__PURE__ */ O('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-md !layup-border !layup-border-border !layup-bg-background layup-p-2 layup-shadow-sm"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-sm !layup-bg-accent layup-text-sm layup-font-medium !layup-text-accent-text"><span class="layup-text-base">!</span></div> <span class=" layup-text-base layup-font-medium layup-text-primary">The guide text is hidden</span> <!></div></div></div>');
function X7(e, t) {
  be(t, !0);
  const n = /* @__PURE__ */ R(() => {
    var i;
    return (i = t.guideMachineContext) == null ? void 0 : i.can({ type: "SHOW_TEXT" });
  });
  var r = Z(), a = V(r);
  Gr(a, () => c(n), (i) => {
    var o = Z(), s = V(o);
    {
      var l = (u) => {
        var d = Y7(), f = T(d), p = T(f), h = Q(T(p), 4);
        Re(h, {
          variant: "outline",
          size: "sm",
          class: "!layup-pointer-events-auto !layup-h-7 layup-w-14 !layup-rounded-sm !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
          onclick: () => {
            var y;
            (y = t.guideMachineRef) == null || y.send({ type: "SHOW_TEXT" });
          },
          children: (y, g) => {
            var w = Z7();
            _(y, w);
          },
          $$slots: { default: !0 }
        }), bt(5, f, () => Qt, () => ({ start: 0.95, duration: 300 })), bt(5, d, () => ns, () => ({ y: 20, duration: 300 })), _(u, d);
      };
      H(s, (u) => {
        c(n) && u(l);
      });
    }
    _(i, o);
  }), _(e, r), _e();
}
var J7 = /* @__PURE__ */ O("<div></div>");
function Dp(e, t) {
  const n = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(n, ["class"]);
  be(t, !1);
  let a = L(t, "class", 8, void 0);
  gn();
  var i = J7();
  let o;
  ee(() => o = Je(i, o, {
    class: Ee("layup-animate-pulse layup-rounded-md layup-bg-accent-secondary", a()),
    ...r
  })), _(e, i), _e();
}
var Q7 = (e, t, n) => t.send({ type: "openHistory", item: n() }), $7 = /* @__PURE__ */ O('<div class="!layup-rounded-sm layup-text-left !layup-text-secondary"><span class="!layup-text-sm"> </span></div>'), ek = /* @__PURE__ */ O('<button class="group layup-group !layup-flex !layup-flex-row !layup-items-center !layup-justify-between !layup-gap-1 !layup-rounded-lg !layup-border !layup-border-background-secondary !layup-bg-transparent !layup-p-3 !layup-transition-all !layup-duration-300 hover:!layup-border-accent-bg hover:!layup-bg-accent-secondary"><div class="!layup-flex !layup-flex-col !layup-gap-1"><h3 class="layup-text-left !layup-text-base !layup-font-medium !layup-text-primary"> </h3> <!></div> <div class="!layup-flex !layup-w-fit !layup-items-center !layup-gap-2 !layup-opacity-0 !layup-transition-opacity !layup-duration-200 group-hover:!layup-opacity-100"><!></div></button>'), tk = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <span class="layup-text-base">Back</span></div>'), nk = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-2 !layup-rounded-lg !layup-border !layup-border-background-secondary !layup-p-3"><div class="!layup-flex !layup-flex-col !layup-gap-2"><!> <!></div></div>'), rk = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-4"></div>'), ak = /* @__PURE__ */ O('<div class="!layup-flex !layup-h-full !layup-w-full !layup-items-center !layup-justify-center"><!></div>'), ik = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-4 !layup-pb-4"></div>'), ok = /* @__PURE__ */ O('<div class="!layup-flex layup-h-full !layup-w-full !layup-flex-col !layup-rounded-lg !layup-bg-background"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between !layup-p-4 !layup-h-14"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div> <div><div class="!layup-flex !layup-h-full !layup-flex-col layup-gap-4"><div class="!layup-flex !layup-flex-col !layup-gap-1"><h2 class="!layup-text-xl !layup-font-medium !layup-text-primary">History</h2></div> <!></div></div></div>');
function sk(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(t.snapshot, "$snapshot", n), a = (v, C = De, S = De) => {
    var b = ek();
    b.__click = [Q7, t, C];
    var x = T(b), E = T(x), k = T(E), I = Q(E, 2);
    {
      var D = (N) => {
        var P = $7(), Y = T(P), G = T(Y);
        ee(() => ke(G, new Date(C().created_at * 1e3).toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        }))), _(N, P);
      };
      H(I, (N) => {
        C().created_at && N(D);
      });
    }
    var A = Q(x, 2), M = T(A);
    Re(M, {
      size: "icon",
      variant: "ghost",
      onclick: () => t.send({ type: "delete", id: C().id }),
      class: "!layup-item-center !layup-pointer-events-auto !layup-flex !layup-justify-center !layup-rounded-sm !layup-border-[1px] !layup-border-red-600 !layup-bg-red-600 !layup-text-gray-700 !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-red-700 hover:!layup-text-gray-900 hover:!layup-no-underline dark:!layup-border-red-600 dark:!layup-bg-red-600 dark:!layup-text-primary dark:hover:!layup-bg-red-700 dark:hover:!layup-text-primary",
      children: (N, P) => {
        X4(N, {
          class: "layup-h-4 layup-w-4 layup-stroke-white"
        });
      },
      $$slots: { default: !0 }
    }), ee(() => ke(k, C().query)), _(v, b);
  };
  let i = /* @__PURE__ */ R(() => r().context.history), o;
  var s = ok(), l = T(s), u = T(l), d = T(u);
  Re(d, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (v, C) => {
      var S = tk(), b = T(S);
      Ui(b, { class: "!layup-size-4" }), _(v, S);
    },
    $$slots: { default: !0 }
  });
  var f = Q(u, 2);
  Re(f, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-5 layup-flex layup-items-center layup-justify-center !layup-w-5 !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onClose;
    },
    children: (v, C) => {
      kr(v, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var p = Q(l, 2);
  const h = /* @__PURE__ */ R(() => Ee("!layup-transaition-height !layup-scrollbar-thin !layup-scrollbar-track-transparent hover:!layup-scrollbar-thumb-gray-400 dark:!layup-scrollbar-thumb-gray-600 dark:hover:!layup-scrollbar-thumb-gray-500 layup-custom-scrollbar !layup-flex !layup-flex-col !layup-gap-3 !layup-overflow-y-auto !layup-overscroll-contain !layup-p-6 !layup-pt-0 !layup-duration-300 !layup-h-full"));
  var y = T(p), g = Q(T(y), 2);
  {
    var w = (v) => {
      var C = rk();
      at(C, 20, () => Array(4), gt, (S, b) => {
        var x = nk(), E = T(x), k = T(E);
        Dp(k, { class: "!layup-h-5 !layup-w-[300px]" });
        var I = Q(k, 2);
        Dp(I, { class: "!layup-h-4 !layup-w-[150px]" }), _(S, x);
      }), _(v, C);
    }, m = (v) => {
      var C = Z(), S = V(C);
      {
        var b = (E) => {
          var k = ak(), I = T(k);
          wc(I, { title: "No history available" }), _(E, k);
        }, x = (E) => {
          var k = ik();
          at(k, 23, () => [...c(i)], (I) => I.id, (I, D, A) => {
            a(I, () => c(D), () => c(A));
          }), _(E, k);
        };
        H(
          S,
          (E) => {
            c(i).length === 0 ? E(b) : E(x, !1);
          },
          !0
        );
      }
      _(v, C);
    };
    H(g, (v) => {
      t.isLoading ? v(w) : v(m, !1);
    });
  }
  tn(p, (v) => o = v, () => o), ee(() => Ve(p, c(h))), _(e, s), _e();
}
Er(["click"]);
var lk = /* @__PURE__ */ vt('<svg><path d="M7.00044 0.5C5.87823 0.499755 4.77508 0.790055 3.79835 1.34264C2.82162 1.89523 2.0046 2.69128 1.4268 3.65331C0.849003 4.61534 0.530118 5.71058 0.501185 6.83241C0.472251 7.95425 0.734254 9.06446 1.26169 10.055L0.552317 12.1831C0.493558 12.3593 0.48503 12.5484 0.527691 12.7292C0.570351 12.9099 0.662514 13.0753 0.793849 13.2066C0.925184 13.3379 1.0905 13.4301 1.27127 13.4728C1.45204 13.5154 1.64112 13.5069 1.81732 13.4481L3.94544 12.7388C4.81717 13.2024 5.78308 13.4614 6.76983 13.496C7.75659 13.5306 8.73827 13.34 9.64036 12.9386C10.5424 12.5372 11.3412 11.9355 11.9761 11.1793C12.6109 10.4231 13.0651 9.53218 13.3043 8.57421C13.5434 7.61624 13.5611 6.61638 13.3561 5.65052C13.1512 4.68467 12.7288 3.77821 12.1212 2.99995C11.5136 2.22169 10.7367 1.59208 9.84938 1.15891C8.96211 0.725743 7.98781 0.500405 7.00044 0.5ZM7.00044 12.5C6.03355 12.5007 5.08363 12.246 4.24669 11.7619C4.18541 11.7263 4.11729 11.7042 4.04682 11.697C3.97635 11.6898 3.90515 11.6976 3.83794 11.72L1.50044 12.5L2.27982 10.1625C2.30228 10.0953 2.31022 10.0242 2.30311 9.95369C2.296 9.88323 2.274 9.81507 2.23857 9.75375C1.6323 8.70557 1.38889 7.48661 1.54609 6.28598C1.70329 5.08534 2.25231 3.97014 3.108 3.11337C3.96368 2.2566 5.07819 1.70617 6.27863 1.54745C7.47906 1.38873 8.69833 1.63061 9.74727 2.23555C10.7962 2.8405 11.6162 3.77469 12.08 4.89322C12.5439 6.01175 12.6256 7.25208 12.3126 8.42181C11.9996 9.59153 11.3093 10.6253 10.3488 11.3626C9.3883 12.1 8.21133 12.4998 7.00044 12.5Z"></path></svg>');
function uk(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = lk();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      class: t.class,
      ...n,
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var ck = /* @__PURE__ */ O('<div class="!layup-flex !layup-w-full !layup-flex-row !layup-items-center !layup-justify-end"><div class="!layup-flex !layup-max-w-[70%] !layup-justify-end"><div class="layup-flex !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center !layup-whitespace-pre-wrap !layup-break-words !layup-rounded-sm !layup-border !layup-border-border layup-bg-background !layup-p-2 !layup-text-sm !layup-font-medium !layup-text-primary dark:!layup-border-border"><p class="!layup-whitespace-pre-wrap !layup-break-words !layup-font-normal !layup-text-base !layup-m-0 !layup-w-full"> </p></div></div></div>'), dk = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-3"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-sm !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-sm !layup-font-medium layup-text-primary"><!></div></div></div>'), fk = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-3"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-sm !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-sm !layup-font-medium layup-text-primary"><!></div></div></div>'), pk = /* @__PURE__ */ O('<div class="!layup-flex !layup-flex-col !layup-gap-2"><div class="!layup-flex !layup-w-fit !layup-max-w-[90%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] layup-max-w-sm layup-items-center layup-justify-center layup-rounded-sm !layup-border !layup-border-border !layup-bg-accent-bg !layup-px-3 !layup-py-2 !layup-text-sm !layup-font-medium layup-text-accent dark:!layup-border-accent-secondary"><!></div></div></div>'), hk = /* @__PURE__ */ O('<div class="!layup-scrollbar-thin !layup-scrollbar-track-transparent hover:!layup-scrollbar-thumb-gray-400 dark:!layup-scrollbar-thumb-gray-600 dark:hover:!layup-scrollbar-thumb-gray-500 layup-custom-scrollbar !layup-max-h-[300px] !layup-w-full !layup-flex-1 !layup-overflow-y-auto !layup-p-3"><div class="!layup-w-full"><div class="!layup-flex !layup-flex-col !layup-gap-3"><!> <!></div></div></div>'), yk = (e, t, n) => {
  var r;
  (r = t.guideMachineRef) == null || r.send({
    type: "sendTipsMessage",
    data: c(n)
  });
}, gk = /* @__PURE__ */ O('<button class="layup-w-full"><div class="layup-group layup-flex layup-h-10 layup-w-full layup-cursor-pointer layup-items-center !layup-gap-3 layup-rounded-sm !layup-border !layup-border-transparent layup-p-1 layup-px-3 hover:!layup-border-accent-secondary hover:!layup-bg-accent-bg"><!> <span class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </span></div></button>'), vk = /* @__PURE__ */ O('<div class="!layup-w-full !layup-overflow-hidden !layup-border-t !layup-border-border"><div class="!layup-w-full !layup-p-2"><div class="layup-w-full !layup-p-1"><span class="layup-text-sm !layup-text-secondary">Suggestions</span></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-2"></div></div></div>'), mk = /* @__PURE__ */ O('<div class="layup-chat-container !layup-relative !layup-mb-2 !layup-flex layup-w-full !layup-flex-col !layup-items-center layup-justify-center !layup-overflow-hidden !layup-rounded-md !layup-border !layup-border-background-secondary !layup-bg-background !layup-shadow-sm"><!> <form id="layup-ai-form" class="!layup-m-0 !layup-w-full !layup-bg-background-secondary !layup-p-0"><div><!> <!></div></form> <!></div>');
function wk(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => {
    var b, x;
    return (x = (b = t.guideMachineContext) == null ? void 0 : b.context) == null ? void 0 : x.knowledgeMessage;
  }), r = de(!1), a = de(void 0), i = de(""), o = /* @__PURE__ */ R(() => {
    var b, x;
    return (x = (b = t.guideMachineContext) == null ? void 0 : b.context) == null ? void 0 : x.knowledgeFetching;
  });
  const s = () => {
    c(a) && setTimeout(
      () => {
        var b;
        (b = c(a)) == null || b.scrollTo({
          top: c(a).scrollHeight,
          behavior: "smooth"
        });
      },
      200
    );
  };
  Se(() => {
    var b, x, E;
    ((b = c(n)) != null && b.length || (E = (x = t.guideMachineContext) == null ? void 0 : x.context) != null && E.knowledgeFetching) && s();
  }), Se(() => {
    c(r) || s();
  });
  const l = () => {
    var b, x;
    (b = c(i)) != null && b.trim() && ((x = t.guideMachineRef) == null || x.send({
      type: "sendKnowledgeMessage",
      data: c(i)
    }), z(i, ""), s());
  }, u = (b) => {
    b.preventDefault(), l();
  };
  let d = /* @__PURE__ */ R(() => {
    var b, x, E, k, I;
    return (I = (k = (b = t.guideMachineContext) == null ? void 0 : b.context) == null ? void 0 : k.currentActionsMap[((E = (x = t.guideMachineContext) == null ? void 0 : x.context) == null ? void 0 : E.currentActionsMap.length) - 1]) == null ? void 0 : I.tips;
  });
  var f = mk(), p = T(f);
  {
    var h = (b) => {
      var x = hk(), E = T(x), k = T(E), I = T(k);
      at(I, 17, () => c(n), gt, (M, N, P) => {
        var Y = Z(), G = V(Y);
        {
          var q = ($) => {
            var W = ck(), j = T(W), B = T(j), K = T(B), U = T(K);
            ee(() => ke(U, c(N).content)), _($, W);
          }, J = ($) => {
            var W = Z(), j = V(W);
            {
              var B = (U) => {
                var ne = dk(), ue = T(ne), ae = T(ue), se = T(ae), ge = /* @__PURE__ */ R(() => c(N).content.trim());
                mc(se, {
                  get responseContent() {
                    return c(ge);
                  }
                }), _(U, ne);
              }, K = (U) => {
                var ne = Z(), ue = V(ne);
                {
                  var ae = (se) => {
                    var ge = fk(), pe = T(ge), ve = T(pe), me = T(ve), we = /* @__PURE__ */ R(() => c(N).content.trim());
                    av(me, {
                      get content() {
                        return c(we);
                      },
                      onTransitionEnd: () => {
                        setTimeout(
                          () => {
                            var fe;
                            (fe = c(a)) == null || fe.scrollTo({
                              top: c(a).scrollHeight,
                              behavior: "smooth"
                            });
                          },
                          50
                        );
                      },
                      get transition() {
                        return c(r);
                      },
                      set transition(fe) {
                        z(r, oe(fe));
                      }
                    }), _(se, ge);
                  };
                  H(
                    ue,
                    (se) => {
                      var ge, pe;
                      ((ge = c(N)) == null ? void 0 : ge.role) === "assistant" && P === ((pe = c(n)) == null ? void 0 : pe.length) - 1 && se(ae);
                    },
                    !0
                  );
                }
                _(U, ne);
              };
              H(
                j,
                (U) => {
                  var ne, ue;
                  ((ne = c(N)) == null ? void 0 : ne.role) === "assistant" && P !== ((ue = c(n)) == null ? void 0 : ue.length) - 1 ? U(B) : U(K, !1);
                },
                !0
              );
            }
            _($, W);
          };
          H(G, ($) => {
            c(N).role === "user" ? $(q) : $(J, !1);
          });
        }
        _(M, Y);
      });
      var D = Q(I, 2);
      {
        var A = (M) => {
          var N = pk(), P = T(N), Y = T(P), G = T(Y);
          pg(G, {
            text: "Thinking...",
            textAlign: "left",
            textColor: "text-primary",
            padding: "!layup-p-0"
          }), bt(5, N, () => yc, () => ({ duration: 200, y: 10 })), _(M, N);
        };
        H(D, (M) => {
          var N, P;
          (P = (N = t.guideMachineContext) == null ? void 0 : N.context) != null && P.knowledgeFetching && M(A);
        });
      }
      tn(x, (M) => z(a, M), () => c(a)), ct("introend", E, s), bt(5, E, () => yc, () => ({ duration: 400, y: 20 })), _(b, x);
    };
    H(p, (b) => {
      var x;
      ((x = c(n)) == null ? void 0 : x.length) > 0 && b(h);
    });
  }
  var y = Q(p, 2), g = T(y), w = T(g);
  lv(w, {
    id: "layup-ai-form-input",
    placeholder: "Tell me what's you're looking for",
    class: "!layup-m-0 !layup-max-h-[72px] !layup-min-h-[48px] !layup-w-full !layup-resize-none !layup-overflow-y-auto !layup-rounded-none !layup-border-none !layup-bg-transparent !layup-py-3 !layup-pl-4 !layup-pr-12 !layup-text-base !layup-text-primary layup-caret-primary !layup-shadow-none [-ms-overflow-style:none] [scrollbar-width:none] placeholder:!layup-text-base placeholder:!layup-text-secondary focus-visible:!layup-outline-none focus-visible:!layup-ring-0 [&::-webkit-scrollbar]:!layup-hidden",
    rows: 1,
    get disabled() {
      return c(o);
    },
    onkeydown: (b) => {
      b.key === "Enter" && !b.shiftKey && (b.preventDefault(), l());
    },
    get value() {
      return c(i);
    },
    set value(b) {
      z(i, oe(b));
    }
  });
  var m = Q(w, 2), v = /* @__PURE__ */ R(() => {
    var b;
    return ((b = c(i)) == null ? void 0 : b.trim()) === "" || c(o);
  });
  Re(m, {
    variant: "default",
    size: "icon",
    class: "!layup-absolute !layup-right-3 !layup-top-[8px] !layup-flex !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-center !layup-rounded-sm !layup-border-accent !layup-bg-accent layup-fill-primary hover:!layup-bg-accent-secondary hover:!layup-fill-accent-text disabled:!layup-border-none disabled:!layup-bg-background-secondary dark:disabled:!layup-bg-background-secondary",
    type: "submit",
    get disabled() {
      return c(v);
    },
    children: (b, x) => {
      Ad(b, { class: "!layup-size-5" });
    },
    $$slots: { default: !0 }
  });
  var C = Q(y, 2);
  {
    var S = (b) => {
      var x = vk(), E = T(x), k = Q(T(E), 2);
      at(k, 21, () => c(d), gt, (I, D) => {
        var A = gk();
        A.__click = [yk, t, D];
        var M = T(A), N = T(M);
        uk(N, {
          class: "!layup-size-4 !layup-fill-secondary group-hover:!layup-fill-secondary"
        });
        var P = Q(N, 2), Y = T(P);
        ee(() => ke(Y, c(D).title)), _(I, A);
      }), _(b, x);
    };
    H(C, (b) => {
      var x, E, k, I;
      ((x = c(d)) == null ? void 0 : x.length) > 0 && ((I = (k = (E = t.guideMachineContext) == null ? void 0 : E.context) == null ? void 0 : k.knowledgeMessage) == null ? void 0 : I.length) === 0 && b(S);
    });
  }
  ee(() => {
    var b;
    return Ve(g, `!layup-relative !layup-w-full ${(((b = c(n)) == null ? void 0 : b.length) > 0 ? "!layup-border-t !layup-border-border" : "") ?? ""}`);
  }), ct("submit", y, u), _(e, f), _e();
}
Er(["click"]);
var bk = /* @__PURE__ */ O('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), _k = (e, t, n) => t("video", c(n).template_announcement.image), xk = /* @__PURE__ */ O('<video autoplay loop playsinline="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-cover"><source type="video/mp4"></video>', 2), kk = (e, t, n) => t("image", c(n).template_announcement.image), Sk = /* @__PURE__ */ O('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), Ck = /* @__PURE__ */ O('<div class="layup-bg-background-secondary/50 layup-flex layup-h-[200px] layup-w-full layup-items-center layup-justify-center layup-overflow-hidden layup-rounded-lg"><!></div>'), Ek = /* @__PURE__ */ O('<div class="layup-flex layup-items-center">Show me</div>'), Tk = (e) => e.stopPropagation(), Ak = /* @__PURE__ */ O('<img alt="" class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-object-contain layup-shadow-2xl">'), Pk = (e) => e.stopPropagation(), Mk = /* @__PURE__ */ O('<video autoplay controls class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-shadow-2xl"><source type="video/mp4"> <track kind="captions" src="" label="English captions"></video>', 2), Ik = /* @__PURE__ */ O('<div class="layup-flex layup-w-full layup-flex-col !layup-h-full !layup-gap-3 layup-rounded-b-lg layup-bg-background layup-p-6 !layup-pt-3"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-3 !layup-h-full layup-justify-between"><!> <p class="!layup-w-full !layup-text-wrap !layup-break-words !layup-text-left !layup-text-sm !layup-leading-relaxed !layup-text-primary"> </p> <!></div></div> <!>', 1);
function Ok(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => t.features.filter((m) => m.state.status === "NotStarted").sort((m, v) => {
    var C, S;
    return (((C = v.template_announcement) == null ? void 0 : C.created_at) || 0) - (((S = m.template_announcement) == null ? void 0 : S.created_at) || 0);
  })[0]), r = de(!1), a = de(oe({ type: "", url: "" }));
  const i = (m, v) => {
    z(a, oe({ type: m, url: v })), z(r, !0);
  }, o = () => {
    z(r, !1);
  };
  var s = Ik(), l = V(s), u = T(l), d = T(u);
  {
    var f = (m) => {
      var v = Ck(), C = T(v);
      {
        var S = (x) => {
          var E = bk(), k = T(E);
          ee(() => he(k, "src", c(n).template_announcement.image)), _(x, E);
        }, b = (x) => {
          var E = Z(), k = V(E);
          {
            var I = (A) => {
              var M = xk();
              M.muted = !0, M.__click = [_k, i, n];
              var N = T(M);
              ee(() => he(N, "src", c(n).template_announcement.image)), _(A, M);
            }, D = (A) => {
              var M = Sk();
              M.__click = [kk, i, n];
              var N = T(M);
              ee(() => he(N, "src", c(n).template_announcement.image)), _(A, M);
            };
            H(
              k,
              (A) => {
                c(n).template_announcement.image.endsWith(".mp4") ? A(I) : A(D, !1);
              },
              !0
            );
          }
          _(x, E);
        };
        H(C, (x) => {
          c(n).template_announcement.image.endsWith(".svg") ? x(S) : x(b, !1);
        });
      }
      _(m, v);
    };
    H(d, (m) => {
      var v, C;
      (C = (v = c(n)) == null ? void 0 : v.template_announcement) != null && C.image && m(f);
    });
  }
  var p = Q(d, 2), h = T(p), y = Q(p, 2);
  Re(y, {
    variant: "outline",
    type: "button",
    onclick: () => {
      t.send({ type: "run", item: c(n) });
    },
    class: "layup-h-8 !layup-w-full !layup-items-center !layup-justify-center !layup-gap-[4px] !layup-rounded-sm !layup-border-none !layup-bg-accent !layup-px-3 !layup-py-1.5 !layup-text-sm !layup-text-white/90 !layup-duration-200 hover:!layup-bg-accent-bg hover:!layup-text-white hover:!layup-opacity-90",
    children: (m, v) => {
      var C = Ek();
      _(m, C);
    },
    $$slots: { default: !0 }
  });
  var g = Q(l, 2);
  {
    var w = (m) => {
      var v = Z(), C = V(v);
      rt(C, () => sv, (S, b) => {
        b(S, {
          get open() {
            return c(r);
          },
          controlledOpen: !0,
          onOpenChange: (x) => {
            var E;
            (E = x == null ? void 0 : x.stopPropagation) == null || E.call(x), z(r, !c(r));
          },
          children: (x, E) => {
            var k = Z(), I = V(k);
            rt(I, () => ov, (D, A) => {
              A(D, {
                trapFocus: !1,
                autofocus: !1,
                hideCloseButton: !0,
                class: "layup-feature !layup-left-1/2 !layup-top-1/2 !layup-z-[999999999] !layup-m-0 layup-translate-x-[-50%] layup-translate-y-[-50%] !layup-cursor-pointer !layup-border-none !layup-bg-transparent !layup-p-0 focus:layup-outline-none",
                onclick: (M) => {
                  M.stopPropagation(), o();
                },
                onkeydown: (M) => {
                  M.key === "Escape" && (M.stopPropagation(), o());
                },
                children: (M, N) => {
                  var P = Z(), Y = V(P);
                  {
                    var G = (J) => {
                      var $ = Ak();
                      $.__click = [Tk], ee(() => he($, "src", c(a).url)), _(J, $);
                    }, q = (J) => {
                      var $ = Z(), W = V($);
                      {
                        var j = (B) => {
                          var K = Mk();
                          K.__click = [Pk];
                          var U = T(K);
                          ee(() => he(U, "src", c(a).url)), _(B, K);
                        };
                        H(
                          W,
                          (B) => {
                            c(a).type === "video" && B(j);
                          },
                          !0
                        );
                      }
                      _(J, $);
                    };
                    H(Y, (J) => {
                      c(a).type === "image" ? J(G) : J(q, !1);
                    });
                  }
                  _(M, P);
                },
                $$slots: { default: !0 }
              });
            }), _(x, k);
          },
          $$slots: { default: !0 }
        });
      }), _(m, v);
    };
    H(g, (m) => {
      c(r) && m(w);
    });
  }
  ee(() => {
    var m, v;
    return ke(h, (v = (m = c(n)) == null ? void 0 : m.template_announcement) == null ? void 0 : v.description);
  }), _(e, s), _e();
}
Er(["click"]);
var Fk = /* @__PURE__ */ O('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-md !layup-border !layup-border-background-secondary !layup-bg-background layup-p-2"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-sm !layup-bg-background-secondary layup-text-sm layup-font-medium !layup-text-primary"><span class="layup-text-base">!</span></div> <span class=" layup-text-base layup-text-primary"> </span></div></div></div>');
function Rk(e, t) {
  be(t, !0);
  let n = L(t, "notification", 15);
  Se(() => {
    n() && setTimeout(
      () => {
        n(null);
      },
      3e3
    );
  });
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = Fk(), l = T(s), u = T(l), d = Q(T(u), 2), f = T(d);
      ee(() => ke(f, n())), bt(3, l, () => Qt, () => ({ start: 0.95, duration: 300 })), bt(3, s, () => ns, () => ({ y: 20, duration: 300 })), _(o, s);
    };
    H(a, (o) => {
      n() && o(i);
    });
  }
  _(e, r), _e();
}
var Lk = (e, t, n, r) => {
  var a, i;
  return c(t) && ((i = (a = n()) == null ? void 0 : a.state) == null ? void 0 : i.status) !== "Completed" && r.onShowItem(n());
}, Dk = (e, t, n, r) => {
  var a, i;
  return e.key === "Enter" && c(t) && ((i = (a = n()) == null ? void 0 : a.state) == null ? void 0 : i.status) !== "Completed" && r.onShowItem(n());
}, Nk = /* @__PURE__ */ O('<div class="!layup-flex !layup-size-5 !layup-items-center !layup-justify-center !layup-rounded-full !layup-bg-accent !layup-opacity-70"><!></div>'), zk = /* @__PURE__ */ O('<div class="!layup-absolute !layup-bottom-full !layup-left-1/2 !layup-mb-2 !layup-hidden !-layup-translate-x-1/2 !layup-whitespace-nowrap !layup-rounded-sm !layup-border !layup-border-background-secondary !layup-bg-background !layup-px-2 !layup-py-1 !layup-text-sm !layup-shadow-md group-hover/item:!layup-flex"><div class="!layup-mt-0.5 !layup-text-sm !layup-text-primary">Mark as completed</div></div>'), Vk = /* @__PURE__ */ O('<div class="layup-group/item !layup-relative"><!> <!></div>'), Bk = /* @__PURE__ */ O('<div class="!layup-my-1 !layup-flex !layup-h-10 !layup-w-full !layup-items-center"><div role="button" tabindex="0"><div class="!layup-flex !layup-w-full !layup-items-center !layup-gap-3"><!> <span> </span></div></div></div>'), jk = /* @__PURE__ */ O('<div class="!layup-flex !layup-items-center !layup-justify-center !layup-gap-2"><!> <span class="layup-text-base"> </span></div>'), Wk = /* @__PURE__ */ O('<div><div class="!layup-flex !layup-w-full !layup-h-full !layup-flex-col !layup-gap-5 !layup-p-6  !layup-justify-between"><div class="!layup-mb-2 !layup-rounded-lg !layup-bg-accent-bg !layup-py-1"></div> <!></div></div>');
function Hk(e, t) {
  be(t, !0);
  const n = (y, g = De, w = De, m = De) => {
    var v = Bk();
    const C = /* @__PURE__ */ R(() => {
      var N, P;
      return !t.strictOrder || w() === 0 || ((P = (N = r()[w() - 1]) == null ? void 0 : N.state) == null ? void 0 : P.status) === "Completed";
    });
    var S = T(v);
    const b = /* @__PURE__ */ R(() => {
      var N, P;
      return Ee("!layup-mx-2 !layup-flex !layup-h-10 !layup-w-full !layup-cursor-default !layup-items-center !layup-rounded-sm !layup-px-4", c(C) && ((P = (N = g()) == null ? void 0 : N.state) == null ? void 0 : P.status) !== "Completed" ? "!layup-cursor-pointer hover:!layup-bg-accent-bg" : !c(C) && "!layup-opacity-60");
    });
    S.__click = [Lk, C, g, t], S.__keydown = [Dk, C, g, t];
    var x = T(S), E = T(x);
    {
      var k = (N) => {
        var P = Z();
        const Y = /* @__PURE__ */ R(() => t.strictOrder && w() === r().findIndex(($) => $.state.status !== "Completed") - 1);
        var G = V(P);
        {
          var q = ($) => {
            var W = Nk(), j = T(W);
            vs(j, { class: "!layup-size-3 !layup-text-white" }), _($, W);
          }, J = ($) => {
            Re($, {
              variant: "ghost",
              size: "icon",
              class: "!layup-flex !layup-size-5 !layup-cursor-pointer !layup-items-center !layup-justify-center !layup-rounded-full !layup-bg-accent !layup-opacity-70 hover:!layup-bg-accent hover:!layup-opacity-100",
              onclick: (W) => {
                W.preventDefault(), W.stopPropagation(), t.send({ type: "markAsNotStarted", item: g() });
              },
              children: (W, j) => {
                vs(W, { class: "!layup-size-3 !layup-text-white" });
              },
              $$slots: { default: !0 }
            });
          };
          H(G, ($) => {
            t.strictOrder && !c(Y) ? $(q) : $(J, !1);
          });
        }
        _(N, P);
      }, I = (N) => {
        var P = Vk(), Y = T(P), G = /* @__PURE__ */ R(() => Ee("!layup-flex !layup-size-5 !layup-items-center !layup-justify-center !layup-rounded-full !layup-border-2", c(C) ? "!layup-cursor-pointer !layup-border-accent group-hover/item:!layup-bg-background-secondary" : "!layup-cursor-default !layup-border-accent-secondary")), q = /* @__PURE__ */ R(() => !c(C));
        Re(Y, {
          variant: "ghost",
          size: "icon",
          get class() {
            return c(G);
          },
          get disabled() {
            return c(q);
          },
          onclick: (W) => {
            W.preventDefault(), W.stopPropagation(), c(C) && t.send({ type: "markAsCompleted", item: g() });
          },
          children: (W, j) => {
            var B = /* @__PURE__ */ R(() => Ee("!layup-size-3", c(C) ? "layup-stroke-accent-text !layup-opacity-0 group-hover/item:!layup-opacity-100" : "!layup-opacity-0"));
            vs(W, {
              get class() {
                return c(B);
              }
            });
          },
          $$slots: { default: !0 }
        });
        var J = Q(Y, 2);
        {
          var $ = (W) => {
            var j = zk();
            _(W, j);
          };
          H(J, (W) => {
            c(C) && W($);
          });
        }
        _(N, P);
      };
      H(E, (N) => {
        var P, Y;
        ((Y = (P = g()) == null ? void 0 : P.state) == null ? void 0 : Y.status) === "Completed" ? N(k) : N(I, !1);
      });
    }
    var D = Q(E, 2);
    const A = /* @__PURE__ */ R(() => {
      var N, P;
      return Ee("!layup-text-base", ((P = (N = g()) == null ? void 0 : N.state) == null ? void 0 : P.status) === "Completed" ? "!layup-text-secondary" : c(C) ? "!layup-text-primary" : "!layup-text-secondary");
    });
    var M = T(D);
    ee(() => {
      Ve(S, c(b)), Ve(D, c(A)), ke(M, g().template_onboarding_flow.title);
    }), _(y, v);
  };
  L(t, "open", 11, !1), L(t, "progress", 3, 0);
  let r = L(t, "plan", 19, () => []), a = /* @__PURE__ */ et(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "open",
    "title",
    "progress",
    "plan",
    "onShowItem",
    "styles",
    "strictOrder",
    "send"
  ]), i = /* @__PURE__ */ R(() => {
    var y, g;
    if (!r().length) return null;
    if (t.strictOrder) {
      const w = r().findIndex((m) => m.state.status !== "Completed");
      return w === 0 || ((g = (y = r()[w - 1]) == null ? void 0 : y.state) == null ? void 0 : g.status) === "Completed" ? r()[w] : null;
    } else
      return r().find((w) => w.state.status !== "Completed");
  }), o = /* @__PURE__ */ R(() => {
    const y = r().filter((g) => g.state.status === "Completed").length;
    return y === r().length ? "You're all set!" : y === 0 ? "Let's get started" : y === r().length - 1 ? "Finish last step" : "Start next step";
  });
  var s = Wk();
  let l;
  var u = T(s), d = T(u);
  at(d, 23, r, (y) => y == null ? void 0 : y.id, (y, g, w) => {
    n(y, () => ({ ...c(g) }), () => c(w), () => {
      var m;
      return c(w) === ((m = r()) == null ? void 0 : m.length) - 1;
    });
  });
  var f = Q(d, 2), p = /* @__PURE__ */ R(() => Ee("!layup-h-9 !layup-w-full !layup-rounded-md !layup-text-sm !layup-font-medium !layup-transition-all !layup-duration-200 disabled:!layup-border-0 disabled:!layup-text-primary disabled:layup-opacity-100", c(i) ? "!layup-bg-accent !layup-text-white !layup-shadow-md hover:!layup-bg-accent-bg hover:!layup-shadow-lg active:!layup-scale-[0.98]" : "!layup-cursor-default !layup-border-0 !layup-text-primary")), h = /* @__PURE__ */ R(() => !c(i));
  Re(f, {
    variant: "default",
    get class() {
      return c(p);
    },
    get disabled() {
      return c(h);
    },
    onclick: () => c(i) && t.onShowItem(c(i)),
    children: (y, g) => {
      var w = jk(), m = T(w);
      {
        var v = (b) => {
          vs(b, { class: "!layup-size-4" });
        };
        H(m, (b) => {
          c(i) || b(v);
        });
      }
      var C = Q(m, 2), S = T(C);
      ee(() => ke(S, c(o))), _(y, w);
    },
    $$slots: { default: !0 }
  }), ee(() => {
    l = Je(s, l, {
      id: "layup-onboarding-plan",
      class: "!layup-z-[9999999] !layup-m-0 !layup-h-full !layup-w-full !layup-border-none !layup-p-0 !layup-shadow-none",
      ...a,
      style: t.styles
    }), he(u, "style", t.styles);
  }), _(e, s), _e();
}
Er(["click", "keydown"]);
var Uk = /* @__PURE__ */ O('<div class="layup-onboarding-plan layup-w-full layup-rounded-bl-md layup-rounded-br-md layup-border layup-border-background-secondary layup-bg-background layup-h-full"><!></div>');
function Np(e, t) {
  be(t, !0);
  function n(u) {
    t.send({ type: "run", item: u });
  }
  let r = null;
  X.config.styles;
  const a = /* @__PURE__ */ R(() => {
    var u, d;
    return (d = (u = t.snapshot.context.plans) == null ? void 0 : u.onboarding_flows) != null && d.length ? t.snapshot.context.plans.onboarding_flows.filter((f) => f.state.status === "Completed").length / t.snapshot.context.plans.onboarding_flows.length : 0;
  }), i = /* @__PURE__ */ R(() => {
    var d;
    const u = t.snapshot.context.plans;
    return u != null && u.onboarding_flows && ((d = u == null ? void 0 : u.onboarding_flows) == null || d.sort((f, p) => (f == null ? void 0 : f.template_onboarding_flow.index) - (p == null ? void 0 : p.template_onboarding_flow.index))), u;
  }), o = /* @__PURE__ */ R(() => c(i).onboarding_flows.map((u) => {
    var d;
    return ((d = u.template_onboarding_plan) == null ? void 0 : d.strict_order) || !1;
  }));
  var s = Uk(), l = T(s);
  Gr(l, () => c(i), (u) => {
    var d = /* @__PURE__ */ R(() => t.snapshot.matches("onboarding")), f = /* @__PURE__ */ R(() => {
      var p, h, y;
      return (y = (h = (p = t.snapshot.context) == null ? void 0 : p.plans) == null ? void 0 : h.template_onboarding_plan) == null ? void 0 : y.name;
    });
    Hk(u, {
      get send() {
        return t.send;
      },
      get open() {
        return c(d);
      },
      get title() {
        return c(f);
      },
      side: "left",
      align: "end",
      get strictOrder() {
        return c(o);
      },
      sideOffset: 20,
      get progress() {
        return c(a);
      },
      alignOffset: 0,
      get customAnchor() {
        return r;
      },
      get plan() {
        return c(i).onboarding_flows;
      },
      onShowItem: n
    });
  }), _(e, s), _e();
}
var qk = /* @__PURE__ */ vt('<svg><path d="M10.707 17.707l5-5a.999.999 0 10-1.414-1.414L11 14.586V3a1 1 0 10-2 0v11.586l-3.293-3.293a.999.999 0 10-1.414 1.414l5 5a.999.999 0 001.414 0z"></path></svg>');
function Gk(e, t) {
  let n = /* @__PURE__ */ et(t, ["$$slots", "$$events", "$$legacy", "fill"]);
  var r = qk();
  let a;
  ee(() => a = Je(
    r,
    a,
    {
      ...n,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), _(e, r);
}
var Kk = /* @__PURE__ */ O('<div class="layup-flex layup-h-fit layup-w-fit layup-items-center layup-justify-center !layup-gap-2 layup-p-2 layup-font-medium layup-text-primary"><!> <span class="layup-text-base layup-font-medium layup-text-accent-text">Scroll down</span></div>'), Zk = /* @__PURE__ */ O('<div class="layup-flex layup-flex-col layup-items-center"><!></div>');
function Yk(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => {
    var o, s;
    return (s = (o = t.guideMachineContext) == null ? void 0 : o.context) == null ? void 0 : s.scrollDown;
  });
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = Zk(), l = T(s);
      Re(l, {
        variant: "ghost",
        class: `layup-flex !layup-h-fit !layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-md !layup-border-none
    !layup-bg-accent !layup-shadow-none !layup-outline-none hover:!layup-bg-accent-secondary hover:!layup-text-accent-text`,
        onclick: () => {
          var u;
          return (u = t.guideMachineRef) == null ? void 0 : u.send({ type: "SCROLL_TO_ELEMENT" });
        },
        children: (u, d) => {
          var f = Z(), p = V(f);
          {
            var h = (y) => {
              var g = Kk(), w = T(g);
              Gk(w, {
                class: "!layup-h-4 !layup-w-4 layup-fill-accent-text"
              }), _(y, g);
            };
            H(p, (y) => {
              var g, w;
              (w = (g = t.guideMachineContext) == null ? void 0 : g.context) != null && w.feedback || y(h);
            });
          }
          _(u, f);
        },
        $$slots: { default: !0 }
      }), bt(1, s, () => ns, () => ({ y: 20, duration: 300 })), _(o, s);
    };
    H(a, (o) => {
      c(n) && o(i);
    });
  }
  _(e, r), _e();
}
var Xk = /* @__PURE__ */ O('<div class="layup-flex layup-h-fit layup-w-fit layup-items-center layup-justify-center !layup-gap-2 layup-p-2 layup-font-medium layup-text-primary"><!> <span class="layup-text-base layup-font-medium layup-text-accent-text">Scroll up</span></div>'), Jk = /* @__PURE__ */ O('<div class="layup-flex layup-flex-col layup-items-center"><!></div>');
function Qk(e, t) {
  be(t, !0);
  let n = /* @__PURE__ */ R(() => {
    var o, s;
    return (s = (o = t.guideMachineContext) == null ? void 0 : o.context) == null ? void 0 : s.scrollUp;
  });
  var r = Z(), a = V(r);
  {
    var i = (o) => {
      var s = Jk(), l = T(s);
      Re(l, {
        variant: "ghost",
        class: `layup-flex !layup-h-fit !layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2  layup-rounded-md !layup-border-none
    !layup-bg-accent !layup-shadow-none !layup-outline-none hover:!layup-bg-accent-secondary hover:!layup-text-white`,
        onclick: () => {
          var u;
          return (u = t.guideMachineRef) == null ? void 0 : u.send({ type: "SCROLL_TO_ELEMENT" });
        },
        children: (u, d) => {
          var f = Z(), p = V(f);
          {
            var h = (y) => {
              var g = Xk(), w = T(g);
              Ad(w, {
                class: "!layup-h-4 !layup-w-4 layup-fill-accent-text"
              }), _(y, g);
            };
            H(p, (y) => {
              var g, w;
              (w = (g = t.guideMachineContext) == null ? void 0 : g.context) != null && w.feedback || y(h);
            });
          }
          _(u, f);
        },
        $$slots: { default: !0 }
      }), bt(1, s, () => ns, () => ({ y: 20, duration: 300 })), _(o, s);
    };
    H(a, (o) => {
      c(n) && o(i);
    });
  }
  _(e, r), _e();
}
var $k = /* @__PURE__ */ O("<!> <!>", 1), eS = /* @__PURE__ */ O("<!> <!>", 1), tS = /* @__PURE__ */ O('<div><div class="layup-h-full layup-w-full layup-overflow-hidden layup-rounded-sm"><div class="layup-flex layup-h-full layup-w-full layup-flex-col layup-items-center !layup-rounded-sm layup-p-0 layup-transition-[width,transform,height] layup-duration-300 layup-ease-in-out"><div class="layup-flex layup-w-full !layup-min-w-[120px] layup-justify-center !layup-rounded-sm layup-p-1 layup-py-0 layup-transition-[width,transform] layup-duration-300 layup-ease-in-out"><!></div></div></div></div>'), nS = /* @__PURE__ */ O("<div><!></div>"), rS = /* @__PURE__ */ O("<div><!></div>"), aS = /* @__PURE__ */ O('<div class="layup-mb-2"><div class="layup-flex layup-w-full layup-flex-col layup-items-center layup-justify-center layup-gap-2"><!> <!> <!> <!> <!> <!></div></div> <div><!> <!> <!> <!> <!> <!> <!> <!> <!> <!> <!></div>', 1), iS = /* @__PURE__ */ O("<div><!></div>"), oS = /* @__PURE__ */ O('<div class="layup-flex layup-flex-col layup-items-center"><!> <!></div>'), sS = /* @__PURE__ */ O("<!> <!>", 1);
function lS(e, t) {
  be(t, !0);
  const n = Tr(), r = () => un(o, "$snapshot", n), a = (A) => {
    var M = aS(), N = V(M), P = T(N), Y = T(P);
    m8(Y, {
      get guideMachineContext() {
        return c(x);
      },
      get guideMachineRef() {
        return c(b);
      }
    });
    var G = Q(Y, 2);
    k8(G, {
      get guideMachineContext() {
        return c(x);
      },
      get guideMachineRef() {
        return c(b);
      }
    });
    var q = Q(G, 2);
    Qk(q, {
      get guideMachineContext() {
        return c(x);
      },
      get guideMachineRef() {
        return c(b);
      }
    });
    var J = Q(q, 2);
    Yk(J, {
      get guideMachineContext() {
        return c(x);
      },
      get guideMachineRef() {
        return c(b);
      }
    });
    var $ = Q(J, 2);
    Rk($, {
      get notification() {
        return c(C);
      },
      set notification(re) {
        z(C, oe(re));
      }
    });
    var W = Q($, 2);
    {
      var j = (re) => {
        X7(re, {
          get guideMachineContext() {
            return c(x);
          },
          get guideMachineRef() {
            return c(b);
          }
        });
      };
      H(W, (re) => {
        var le;
        (le = c(x)) != null && le.matches("completed") || re(j);
      });
    }
    var B = Q(N, 2);
    const K = /* @__PURE__ */ R(() => Ee("layup-flex layup-flex-col layup-rounded-lg layup-bg-transparent layup-p-0", r().matches("query") || r().matches("onboarding") || r().matches("features") || r().matches("history") || r().matches("initializeHistory") || r().matches({ thinking: "getQuery" }) || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) || r().matches("newUserOnboarding") || r().matches("newUserFeatures") ? "!layup-border !layup-border-background-secondary !layup-h-[464px] !layup-bg-background !layup-shadow-xl  dark:!layup-bg-background" : "", r().matches("newUserOnboarding") || r().matches("newUserFeatures") || c(d) || c(u) || r().matches("guideMachine") ? "layup-w-[450px]" : "layup-w-[400px]"));
    var U = T(B);
    {
      var ne = (re) => {
        var le = $k(), Pe = V(le);
        U7(Pe, {
          title: "Onboarding",
          get snapshot() {
            return r();
          },
          onTerminate: () => s({ type: "terminate" })
        });
        var Ne = Q(Pe, 2);
        Np(Ne, {
          send: s,
          get snapshot() {
            return r();
          }
        }), _(re, le);
      };
      H(U, (re) => {
        r().matches("newUserOnboarding") && re(ne);
      });
    }
    var ue = Q(U, 2);
    {
      var ae = (re) => {
        var le = eS(), Pe = V(le), Ne = /* @__PURE__ */ R(() => {
          var At;
          return (At = r().context) == null ? void 0 : At.features;
        });
        j7(Pe, {
          snapshot: o,
          send: s,
          get features() {
            return c(Ne);
          },
          onTerminate: () => s({ type: "terminate" })
        });
        var xe = Q(Pe, 2), ft = /* @__PURE__ */ R(() => {
          var At;
          return (At = r().context) == null ? void 0 : At.features;
        });
        Ok(xe, {
          snapshot: o,
          send: s,
          get features() {
            return c(ft);
          }
        }), _(re, le);
      };
      H(ue, (re) => {
        r().matches("newUserFeatures") && re(ae);
      });
    }
    var se = Q(ue, 2);
    {
      var ge = (re) => {
        K7(re, {
          title: "Onboarding",
          onClose: () => {
            var le, Pe;
            (Pe = (le = X.config).onClose) == null || Pe.call(le), s({ type: "exit_everything" });
          },
          get snapshot() {
            return r();
          },
          onTerminate: () => s({ type: "terminate" })
        });
      };
      H(se, (re) => {
        r().matches("onboarding") && re(ge);
      });
    }
    var pe = Q(se, 2);
    {
      var ve = (re) => {
        var le = /* @__PURE__ */ R(() => r().matches("initializeHistory"));
        sk(re, {
          send: s,
          onTerminate: () => s({ type: "esc" }),
          snapshot: o,
          get isLoading() {
            return c(le);
          },
          onClose: () => {
            var Pe, Ne;
            (Ne = (Pe = X.config).onClose) == null || Ne.call(Pe), s({ type: "exit_everything" });
          }
        });
      };
      H(pe, (re) => {
        (r().matches("history") || r().matches("initializeHistory")) && re(ve);
      });
    }
    var me = Q(pe, 2);
    {
      var we = (re) => {
        t8(re, { snapshot: o, send: s, handleClose: S });
      };
      H(me, (re) => {
        (r().matches("query") || r().matches({ thinking: "getQuery" })) && re(we);
      });
    }
    var fe = Q(me, 2);
    {
      var Oe = (re) => {
        Np(re, {
          send: s,
          get snapshot() {
            return r();
          }
        });
      };
      H(fe, (re) => {
        r().matches("onboarding") && re(Oe);
      });
    }
    var Ue = Q(fe, 2);
    {
      var Fe = (re) => {
        i7(re, {
          snapshot: o,
          send: s,
          onClose: () => {
            var le, Pe;
            (Pe = (le = X.config).onClose) == null || Pe.call(le), s({ type: "exit_everything" });
          },
          onTerminate: () => s({ type: "esc" })
        });
      };
      H(Ue, (re) => {
        r().matches("features") && re(Fe);
      });
    }
    var qe = Q(Ue, 2);
    {
      var tt = (re) => {
        wk(re, {
          get guideMachineRef() {
            return c(b);
          },
          get guideMachineContext() {
            return c(x);
          }
        });
      };
      H(qe, (re) => {
        var le, Pe;
        (Pe = (le = c(x)) == null ? void 0 : le.context) != null && Pe.showKnowledge && re(tt);
      });
    }
    var pt = Q(qe, 2);
    {
      var je = (re) => {
        var le = tS();
        const Pe = /* @__PURE__ */ R(() => Ee("layup-h-fit layup-justify-center layup-rounded-b-border", r().matches("guideMachine") ? "!layup-rounded-lg !layup-border !layup-border-border !layup-bg-background" : "!layup-border-t-[1px] !layup-border-border !layup-bg-background-secondary"));
        var Ne = T(le), xe = T(Ne), ft = T(xe), At = T(ft);
        y7(At, { send: s, snapshot: o }), ee(() => Ve(le, c(Pe))), ct("transitionend", xe, () => {
          (r().matches("onboarding") || r().matches("features")) && z(g, !0);
        }), ct("transitionstart", xe, () => {
          z(g, !1);
        }), _(re, le);
      };
      H(pt, (re) => {
        !r().matches("newUserOnboarding") && !r().matches("newUserFeatures") && !r().matches("guideMachine") && !r().matches("history") && !r().matches("initializeHistory") && !r().matches({ thinking: "getFlow" }) && !r().matches({ thinking: "getFlowForOnboarding" }) && !r().matches({ thinking: "getFlowById" }) && !r().matches("onboarding") && !r().matches("features") && re(je);
      });
    }
    var Ge = Q(pt, 2);
    {
      var mt = (re) => {
        var le = nS();
        const Pe = /* @__PURE__ */ R(() => Ee("layup-h-fit layup-min-h-[48px] layup-justify-center layup-rounded-b-lg layup-shadow-lg", r().matches("guideMachine") || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) ? "!layup-rounded-lg !layup-border !layup-border-background-secondary !layup-bg-background" : "!layup-bg-background-secondary"));
        var Ne = T(le);
        N7(Ne, {
          get guideMachineContext() {
            return c(x);
          },
          get guideMachineRef() {
            return c(b);
          }
        }), ee(() => Ve(le, c(Pe))), _(re, le);
      };
      H(Ge, (re) => {
        r().matches("guideMachine") && re(mt);
      });
    }
    var Ke = Q(Ge, 2);
    {
      var Ae = (re) => {
        var le = rS();
        const Pe = /* @__PURE__ */ R(() => Ee("layup-h-fit layup-min-h-10 !layup-w-full layup-justify-center layup-rounded-b-lg", r().matches("guideMachine") || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) ? "!layup-rounded-lg !layup-border !layup-border-background-secondary !layup-bg-background" : "!layup-bg-background-secondary"));
        var Ne = T(le);
        l7(Ne, {
          text: "Thinking...",
          textAlign: "center",
          backgroundColor: "transparent",
          textColor: "text-textPrimary",
          padding: "!layup-p-3"
        }), ee(() => Ve(le, c(Pe))), _(re, le);
      };
      H(Ke, (re) => {
        (r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" })) && re(Ae);
      });
    }
    ee(() => Ve(B, c(K))), _(A, M);
  }, i = localStorage.getItem("uiMachine-event");
  oe(i ? JSON.parse(i) : []);
  const { snapshot: o, send: s } = R4(I4);
  Se(() => {
    const A = X.config.URLpath;
    c(h) && s({ type: "locationChange", path: A });
  });
  let l = /* @__PURE__ */ R(() => {
    var A;
    return (A = r().context) == null ? void 0 : A.showWidget;
  }), u = /* @__PURE__ */ R(() => X.config.variant === "modal"), d = /* @__PURE__ */ R(() => X.config.variant === "sidebar"), f = /* @__PURE__ */ R(() => X.config.variant === "compact"), p = /* @__PURE__ */ R(() => c(d) && c(l)), h = /* @__PURE__ */ R(() => {
    var A;
    return (A = r().context) == null ? void 0 : A.isInitialized;
  });
  Se(() => {
    var A, M;
    c(h) && ((M = (A = X.config).onInit) == null || M.call(A));
  });
  let y = /* @__PURE__ */ R(() => {
    var A, M;
    switch ((M = (A = r().context) == null ? void 0 : A.theme) == null ? void 0 : M.widget_position) {
      case "BottomRight":
        return { bottom: "1.25rem", right: "1.25rem" };
      case "BottomLeft":
        return { bottom: "1.25rem", left: "1.25rem" };
      case "TopRight":
        return { top: "1.25rem", right: "1.25rem" };
      case "TopLeft":
        return { top: "1.25rem", left: "1.25rem" };
      default:
        return {
          bottom: "1.25rem",
          left: "50%",
          transform: "translateX(-50%)"
        };
    }
  });
  Kg.bind(["command+k", "ctrl+k"], () => {
    c(d) || (X.config.show_widget = !0, s({ type: "showWidgetOn", showWidget: !0 }), s({ type: "dialogOn" }), s({ type: "guide" }));
  }), Se(() => {
    c(u) && c(v) && r().matches("idle") && s({ type: "handleQuery" }), c(f) && c(l) && r().matches("idle") && s({ type: "handleQuery" }), c(d) && c(l) && r().matches("idle") && s({ type: "handleQuery" });
  });
  let g = de(!1), w = de(0), m = de(0);
  Se(() => {
    var A, M;
    z(w, oe(Gh((A = r().context) == null ? void 0 : A.plans))), z(m, oe(qh((M = r().context) == null ? void 0 : M.features)));
  });
  let v = /* @__PURE__ */ R(() => {
    var A;
    return (A = r().context) == null ? void 0 : A.showDialog;
  }), C = de(!1);
  Se(() => {
    s({
      type: "showWidgetOn",
      showWidget: X.config.show_widget
    });
  });
  const S = () => {
    var A, M;
    r().matches("guideMachine") || (s({ type: "dialogOff" }), X.config.show_widget = !1, s({ type: "showWidgetOn", showWidget: !1 }), (M = (A = X.config).onClose) == null || M.call(A), s({ type: "terminate" }), s({ type: "esc" }));
  };
  let b = /* @__PURE__ */ R(() => r().children.guideMachine), x = de(null);
  Se(() => {
    var A;
    (A = c(b)) == null || A.subscribe((M) => {
      z(x, oe(M));
    });
  });
  var E = sS();
  ct("click", Ti, (A) => {
    var M;
    ((M = A == null ? void 0 : A.target) == null ? void 0 : M.id) === "layup-widget" && S();
  }), ct("keydown", Ti, (A) => {
    A.key === "Escape" && S();
  }), ct("layup-run-guide", Ti, (A) => {
    s({
      type: "getAndRunFlow",
      flow_id: A.detail.flow_id
    });
  });
  var k = V(E);
  {
    var I = (A) => {
      var M = /* @__PURE__ */ R(() => r().matches("guideMachine")), N = /* @__PURE__ */ R(() => Ee("tailwind-preflight layup-fixed layup-z-[9999999] !layup-rounded-sm !layup-text-base", (c(v) && c(u) || c(p)) && !r().matches("guideMachine") && !r().matches("newUserOnboarding") && !r().matches("newUserFeatures") && !r().matches({ thinking: "getFlow" }) && !r().matches({ thinking: "getFlowForOnboarding" }) && !r().matches({ thinking: "getFlowById" }) ? "layup-min-w-screen !layup-left-[50%] !layup-top-[50%] layup-flex layup-h-screen layup-min-h-screen layup-w-screen !layup-translate-x-[-50%] !layup-translate-y-[-50%] layup-items-center  layup-justify-center !layup-backdrop-blur-sm backdrop:layup-bg-background/50 backdrop:!layup-backdrop-blur-xl" : ""));
      b8(A, {
        get isDraggable() {
          return c(M);
        },
        id: "layup-widget",
        get className() {
          return c(N);
        },
        get positionStyles() {
          return c(y);
        },
        children: (P, Y) => {
          var G = Z(), q = V(G);
          {
            var J = (W) => {
              var j = oS(), B = T(j);
              {
                var K = (ue) => {
                  a(ue);
                };
                H(B, (ue) => {
                  c(l) && ue(K);
                });
              }
              var U = Q(B, 2);
              {
                var ne = (ue) => {
                  var ae = iS();
                  const se = /* @__PURE__ */ R(() => {
                    var we, fe;
                    return Ee("layup-w-full layup-flex layup-mt-2", ((fe = (we = r().context) == null ? void 0 : we.theme) == null ? void 0 : fe.widget_position) === "BottomRight" ? "layup-justify-end" : "layup-justify-center");
                  });
                  var ge = T(ae), pe = /* @__PURE__ */ R(() => c(w) + c(m)), ve = /* @__PURE__ */ R(() => {
                    var we, fe;
                    return (fe = (we = r().context) == null ? void 0 : we.theme) == null ? void 0 : fe.icons;
                  }), me = /* @__PURE__ */ R(() => {
                    var we, fe;
                    return (fe = (we = r().context) == null ? void 0 : we.theme) == null ? void 0 : fe.widget_position;
                  });
                  Rp(ge, {
                    isCompact: !0,
                    get isOpen() {
                      return c(l);
                    },
                    get count() {
                      return c(pe);
                    },
                    get icons() {
                      return c(ve);
                    },
                    get widget_position() {
                      return c(me);
                    },
                    handleClick: () => {
                      c(l) ? S() : (s({ type: "dialogOn" }), X.config.show_widget = !0, s({ type: "showWidgetOn", showWidget: !0 }));
                    }
                  }), ee(() => Ve(ae, c(se))), _(ue, ae);
                };
                H(U, (ue) => {
                  r().matches("guideMachine") || ue(ne);
                });
              }
              _(W, j);
            }, $ = (W) => {
              var j = Z(), B = V(j);
              {
                var K = (ne) => {
                  var ue = Z(), ae = V(ue);
                  {
                    var se = (pe) => {
                      var ve = /* @__PURE__ */ R(() => c(w) + c(m)), me = /* @__PURE__ */ R(() => {
                        var fe, Oe;
                        return (Oe = (fe = r().context) == null ? void 0 : fe.theme) == null ? void 0 : Oe.icons;
                      }), we = /* @__PURE__ */ R(() => {
                        var fe, Oe;
                        return (Oe = (fe = r().context) == null ? void 0 : fe.theme) == null ? void 0 : Oe.widget_position;
                      });
                      Rp(pe, {
                        isCompact: !1,
                        get isOpen() {
                          return c(l);
                        },
                        get count() {
                          return c(ve);
                        },
                        get icons() {
                          return c(me);
                        },
                        get widget_position() {
                          return c(we);
                        },
                        handleClick: () => {
                          c(l) ? S() : (s({ type: "dialogOn" }), X.config.show_widget = !0, s({ type: "showWidgetOn", showWidget: !0 }));
                        }
                      });
                    }, ge = (pe) => {
                      a(pe);
                    };
                    H(ae, (pe) => {
                      c(v) ? pe(ge, !1) : pe(se);
                    });
                  }
                  _(ne, ue);
                }, U = (ne) => {
                  var ue = Z(), ae = V(ue);
                  {
                    var se = (ge) => {
                      var pe = Z(), ve = V(pe);
                      {
                        var me = (we) => {
                          a(we);
                        };
                        H(ve, (we) => {
                          c(l) && we(me);
                        });
                      }
                      _(ge, pe);
                    };
                    H(
                      ae,
                      (ge) => {
                        c(d) && ge(se);
                      },
                      !0
                    );
                  }
                  _(ne, ue);
                };
                H(
                  B,
                  (ne) => {
                    c(u) ? ne(K) : ne(U, !1);
                  },
                  !0
                );
              }
              _(W, j);
            };
            H(q, (W) => {
              c(f) ? W(J) : W($, !1);
            });
          }
          _(P, G);
        },
        $$slots: { default: !0 }
      });
    };
    H(k, (A) => {
      !r().matches("initializing") && !r().matches("updates") && !r().matches("error") && A(I);
    });
  }
  var D = Q(k, 2);
  y0(D, {}), _(e, E), _e();
}
var bc = function() {
  return bc = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, bc.apply(this, arguments);
};
function Dn(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(d) {
      try {
        u(r.next(d));
      } catch (f) {
        o(f);
      }
    }
    function l(d) {
      try {
        u(r.throw(d));
      } catch (f) {
        o(f);
      }
    }
    function u(d) {
      d.done ? i(d.value) : a(d.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function Nn(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, a, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(d) {
      return l([u, d]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, a && (i = u[0] & 2 ? a.return : u[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, u[1])).done) return i;
      switch (a = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
        case 0:
        case 1:
          i = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = u;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(u);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (d) {
      u = [6, d], a = 0;
    } finally {
      r = i = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function uv(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, i; r < a; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var cv = "4.5.1";
function el(e, t) {
  return new Promise(function(n) {
    return setTimeout(n, e, t);
  });
}
function uS() {
  return new Promise(function(e) {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(null);
  });
}
function cS(e, t) {
  t === void 0 && (t = 1 / 0);
  var n = window.requestIdleCallback;
  return n ? new Promise(function(r) {
    return n.call(window, function() {
      return r();
    }, { timeout: t });
  }) : el(Math.min(e, t));
}
function dv(e) {
  return !!e && typeof e.then == "function";
}
function zp(e, t) {
  try {
    var n = e();
    dv(n) ? n.then(function(r) {
      return t(!0, r);
    }, function(r) {
      return t(!1, r);
    }) : t(!0, n);
  } catch (r) {
    t(!1, r);
  }
}
function Vp(e, t, n) {
  return n === void 0 && (n = 16), Dn(this, void 0, void 0, function() {
    var r, a, i, o;
    return Nn(this, function(s) {
      switch (s.label) {
        case 0:
          r = Array(e.length), a = Date.now(), i = 0, s.label = 1;
        case 1:
          return i < e.length ? (r[i] = t(e[i], i), o = Date.now(), o >= a + n ? (a = o, [4, uS()]) : [3, 3]) : [3, 4];
        case 2:
          s.sent(), s.label = 3;
        case 3:
          return ++i, [3, 1];
        case 4:
          return [2, r];
      }
    });
  });
}
function qi(e) {
  return e.then(void 0, function() {
  }), e;
}
function dS(e, t) {
  for (var n = 0, r = e.length; n < r; ++n)
    if (e[n] === t)
      return !0;
  return !1;
}
function fS(e, t) {
  return !dS(e, t);
}
function Pd(e) {
  return parseInt(e);
}
function sn(e) {
  return parseFloat(e);
}
function Un(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function Ht(e) {
  return e.reduce(function(t, n) {
    return t + (n ? 1 : 0);
  }, 0);
}
function fv(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var n = 1 / t;
  return Math.round(e * n) / n;
}
function pS(e) {
  for (var t, n, r = "Unexpected syntax '".concat(e, "'"), a = /^\s*([a-z-]*)(.*)$/i.exec(e), i = a[1] || void 0, o = {}, s = /([.:#][\w-]+|\[.+?\])/gi, l = function(p, h) {
    o[p] = o[p] || [], o[p].push(h);
  }; ; ) {
    var u = s.exec(a[2]);
    if (!u)
      break;
    var d = u[0];
    switch (d[0]) {
      case ".":
        l("class", d.slice(1));
        break;
      case "#":
        l("id", d.slice(1));
        break;
      case "[": {
        var f = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(d);
        if (f)
          l(f[1], (n = (t = f[4]) !== null && t !== void 0 ? t : f[5]) !== null && n !== void 0 ? n : "");
        else
          throw new Error(r);
        break;
      }
      default:
        throw new Error(r);
    }
  }
  return [i, o];
}
function hS(e) {
  for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
    var r = e.charCodeAt(n);
    if (r > 127)
      return new TextEncoder().encode(e);
    t[n] = r;
  }
  return t;
}
function rr(e, t) {
  var n = e[0] >>> 16, r = e[0] & 65535, a = e[1] >>> 16, i = e[1] & 65535, o = t[0] >>> 16, s = t[0] & 65535, l = t[1] >>> 16, u = t[1] & 65535, d = 0, f = 0, p = 0, h = 0;
  h += i + u, p += h >>> 16, h &= 65535, p += a + l, f += p >>> 16, p &= 65535, f += r + s, d += f >>> 16, f &= 65535, d += n + o, d &= 65535, e[0] = d << 16 | f, e[1] = p << 16 | h;
}
function nn(e, t) {
  var n = e[0] >>> 16, r = e[0] & 65535, a = e[1] >>> 16, i = e[1] & 65535, o = t[0] >>> 16, s = t[0] & 65535, l = t[1] >>> 16, u = t[1] & 65535, d = 0, f = 0, p = 0, h = 0;
  h += i * u, p += h >>> 16, h &= 65535, p += a * u, f += p >>> 16, p &= 65535, p += i * l, f += p >>> 16, p &= 65535, f += r * u, d += f >>> 16, f &= 65535, f += a * l, d += f >>> 16, f &= 65535, f += i * s, d += f >>> 16, f &= 65535, d += n * u + r * l + a * s + i * o, d &= 65535, e[0] = d << 16 | f, e[1] = p << 16 | h;
}
function fa(e, t) {
  var n = e[0];
  t %= 64, t === 32 ? (e[0] = e[1], e[1] = n) : t < 32 ? (e[0] = n << t | e[1] >>> 32 - t, e[1] = e[1] << t | n >>> 32 - t) : (t -= 32, e[0] = e[1] << t | n >>> 32 - t, e[1] = n << t | e[1] >>> 32 - t);
}
function Yt(e, t) {
  t %= 64, t !== 0 && (t < 32 ? (e[0] = e[1] >>> 32 - t, e[1] = e[1] << t) : (e[0] = e[1] << t - 32, e[1] = 0));
}
function yt(e, t) {
  e[0] ^= t[0], e[1] ^= t[1];
}
var yS = [4283543511, 3981806797], gS = [3301882366, 444984403];
function Bp(e) {
  var t = [0, e[0] >>> 1];
  yt(e, t), nn(e, yS), t[1] = e[0] >>> 1, yt(e, t), nn(e, gS), t[1] = e[0] >>> 1, yt(e, t);
}
var ws = [2277735313, 289559509], bs = [1291169091, 658871167], jp = [0, 5], vS = [0, 1390208809], mS = [0, 944331445];
function wS(e, t) {
  var n = hS(e);
  t = t || 0;
  var r = [0, n.length], a = r[1] % 16, i = r[1] - a, o = [0, t], s = [0, t], l = [0, 0], u = [0, 0], d;
  for (d = 0; d < i; d = d + 16)
    l[0] = n[d + 4] | n[d + 5] << 8 | n[d + 6] << 16 | n[d + 7] << 24, l[1] = n[d] | n[d + 1] << 8 | n[d + 2] << 16 | n[d + 3] << 24, u[0] = n[d + 12] | n[d + 13] << 8 | n[d + 14] << 16 | n[d + 15] << 24, u[1] = n[d + 8] | n[d + 9] << 8 | n[d + 10] << 16 | n[d + 11] << 24, nn(l, ws), fa(l, 31), nn(l, bs), yt(o, l), fa(o, 27), rr(o, s), nn(o, jp), rr(o, vS), nn(u, bs), fa(u, 33), nn(u, ws), yt(s, u), fa(s, 31), rr(s, o), nn(s, jp), rr(s, mS);
  l[0] = 0, l[1] = 0, u[0] = 0, u[1] = 0;
  var f = [0, 0];
  switch (a) {
    case 15:
      f[1] = n[d + 14], Yt(f, 48), yt(u, f);
    case 14:
      f[1] = n[d + 13], Yt(f, 40), yt(u, f);
    case 13:
      f[1] = n[d + 12], Yt(f, 32), yt(u, f);
    case 12:
      f[1] = n[d + 11], Yt(f, 24), yt(u, f);
    case 11:
      f[1] = n[d + 10], Yt(f, 16), yt(u, f);
    case 10:
      f[1] = n[d + 9], Yt(f, 8), yt(u, f);
    case 9:
      f[1] = n[d + 8], yt(u, f), nn(u, bs), fa(u, 33), nn(u, ws), yt(s, u);
    case 8:
      f[1] = n[d + 7], Yt(f, 56), yt(l, f);
    case 7:
      f[1] = n[d + 6], Yt(f, 48), yt(l, f);
    case 6:
      f[1] = n[d + 5], Yt(f, 40), yt(l, f);
    case 5:
      f[1] = n[d + 4], Yt(f, 32), yt(l, f);
    case 4:
      f[1] = n[d + 3], Yt(f, 24), yt(l, f);
    case 3:
      f[1] = n[d + 2], Yt(f, 16), yt(l, f);
    case 2:
      f[1] = n[d + 1], Yt(f, 8), yt(l, f);
    case 1:
      f[1] = n[d], yt(l, f), nn(l, ws), fa(l, 31), nn(l, bs), yt(o, l);
  }
  return yt(o, r), yt(s, r), rr(o, s), rr(s, o), Bp(o), Bp(s), rr(o, s), rr(s, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[1] >>> 0).toString(16)).slice(-8);
}
function bS(e) {
  var t;
  return bc({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function _S(e) {
  return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(e));
}
function xS(e) {
  return typeof e != "function";
}
function kS(e, t) {
  var n = qi(new Promise(function(r) {
    var a = Date.now();
    zp(e.bind(null, t), function() {
      for (var i = [], o = 0; o < arguments.length; o++)
        i[o] = arguments[o];
      var s = Date.now() - a;
      if (!i[0])
        return r(function() {
          return { error: i[1], duration: s };
        });
      var l = i[1];
      if (xS(l))
        return r(function() {
          return { value: l, duration: s };
        });
      r(function() {
        return new Promise(function(u) {
          var d = Date.now();
          zp(l, function() {
            for (var f = [], p = 0; p < arguments.length; p++)
              f[p] = arguments[p];
            var h = s + Date.now() - d;
            if (!f[0])
              return u({ error: f[1], duration: h });
            u({ value: f[1], duration: h });
          });
        });
      });
    });
  }));
  return function() {
    return n.then(function(a) {
      return a();
    });
  };
}
function SS(e, t, n, r) {
  var a = Object.keys(e).filter(function(o) {
    return fS(n, o);
  }), i = qi(Vp(a, function(o) {
    return kS(e[o], t);
  }, r));
  return function() {
    return Dn(this, void 0, void 0, function() {
      var s, l, u, d, f;
      return Nn(this, function(p) {
        switch (p.label) {
          case 0:
            return [4, i];
          case 1:
            return s = p.sent(), [4, Vp(s, function(h) {
              return qi(h());
            }, r)];
          case 2:
            return l = p.sent(), [
              4,
              Promise.all(l)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (u = p.sent(), d = {}, f = 0; f < a.length; ++f)
              d[a[f]] = u[f];
            return [2, d];
        }
      });
    });
  };
}
function pv() {
  var e = window, t = navigator;
  return Ht([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function CS() {
  var e = window, t = navigator;
  return Ht(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !pv();
}
function rs() {
  var e = window, t = navigator;
  return Ht([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function vn() {
  var e = window, t = navigator;
  return Ht([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "RGBColor" in e,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function Md() {
  var e = window, t = e.HTMLElement, n = e.Document;
  return Ht([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    t && !("autocapitalize" in t.prototype),
    n && "pointerLockElement" in n.prototype
  ]) >= 4;
}
function as() {
  var e = window;
  return (
    // Filters-out Chrome, Yandex, DuckDuckGo (macOS and iOS), Edge
    _S(e.print) && // Doesn't work in Safari < 15.4
    String(e.browser) === "[object WebPageNamespace]"
  );
}
function hv() {
  var e, t, n = window;
  return Ht([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in n,
    "mozInnerScreenX" in n,
    "CSSMozDocumentRule" in n,
    "CanvasCaptureMediaStream" in n
  ]) >= 4;
}
function ES() {
  var e = window;
  return Ht([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function TS() {
  var e = window, t = e.URLPattern;
  return Ht([
    "union" in Set.prototype,
    "Iterator" in e,
    t && "hasRegExpGroups" in t.prototype,
    "RGB8" in WebGLRenderingContext.prototype
  ]) >= 3;
}
function AS() {
  var e = window;
  return Ht([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function is() {
  var e = window, t = navigator, n = e.CSS, r = e.HTMLButtonElement;
  return Ht([
    !("getStorageUpdates" in t),
    r && "popover" in r.prototype,
    "CSSCounterStyleRule" in e,
    n.supports("font-size-adjust: ex-height 0.5"),
    n.supports("text-transform: full-width")
  ]) >= 4;
}
function PS() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return Ht([
    // Since iOS 13. Doesn't work in Chrome on iPadOS <15, but works in desktop mode.
    "MediaSource" in window,
    // Since iOS 12. Doesn't work in Chrome on iPadOS.
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this, but it is not supported
    // Doesn't work in incognito mode of Safari ≥17 with split screen because of tracking prevention
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function MS() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function IS() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function Id() {
  var e = rs(), t = hv(), n = window, r = navigator, a = "connection";
  return e ? Ht([
    !("SharedWorker" in n),
    // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
    // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
    // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
    r[a] && "ontypechange" in r[a],
    !("sinkId" in new Audio())
  ]) >= 2 : t ? Ht(["onorientationchange" in n, "orientation" in n, /android/i.test(r.appVersion)]) >= 2 : !1;
}
function OS() {
  var e = navigator, t = window, n = Audio.prototype, r = t.visualViewport;
  return Ht([
    "srLatency" in n,
    "srChannelCount" in n,
    "devicePosture" in e,
    r && "segments" in r,
    "getTextInformation" in Image.prototype
    // Not available in Samsung Internet 21
  ]) >= 3;
}
function FS() {
  return DS() ? -4 : RS();
}
function RS() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (LS())
    return -1;
  var n = 4500, r = 5e3, a = new t(1, r, 44100), i = a.createOscillator();
  i.type = "triangle", i.frequency.value = 1e4;
  var o = a.createDynamicsCompressor();
  o.threshold.value = -50, o.knee.value = 40, o.ratio.value = 12, o.attack.value = 0, o.release.value = 0.25, i.connect(o), o.connect(a.destination), i.start(0);
  var s = NS(a), l = s[0], u = s[1], d = qi(l.then(function(f) {
    return zS(f.getChannelData(0).subarray(n));
  }, function(f) {
    if (f.name === "timeout" || f.name === "suspended")
      return -3;
    throw f;
  }));
  return function() {
    return u(), d;
  };
}
function LS() {
  return vn() && !Md() && !AS();
}
function DS() {
  return (
    // Safari ≥17
    vn() && is() && as() || // Samsung Internet ≥26
    rs() && OS() && TS()
  );
}
function NS(e) {
  var t = 3, n = 500, r = 500, a = 5e3, i = function() {
  }, o = new Promise(function(s, l) {
    var u = !1, d = 0, f = 0;
    e.oncomplete = function(y) {
      return s(y.renderedBuffer);
    };
    var p = function() {
      setTimeout(function() {
        return l(Wp(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(r, f + a - Date.now()));
    }, h = function() {
      try {
        var y = e.startRendering();
        switch (dv(y) && qi(y), e.state) {
          case "running":
            f = Date.now(), u && p();
            break;
          case "suspended":
            document.hidden || d++, u && d >= t ? l(Wp(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(h, n);
            break;
        }
      } catch (g) {
        l(g);
      }
    };
    h(), i = function() {
      u || (u = !0, f > 0 && p());
    };
  });
  return [o, i];
}
function zS(e) {
  for (var t = 0, n = 0; n < e.length; ++n)
    t += Math.abs(e[n]);
  return t;
}
function Wp(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function yv(e, t, n) {
  var r, a, i;
  return n === void 0 && (n = 50), Dn(this, void 0, void 0, function() {
    var o, s;
    return Nn(this, function(l) {
      switch (l.label) {
        case 0:
          o = document, l.label = 1;
        case 1:
          return o.body ? [3, 3] : [4, el(n)];
        case 2:
          return l.sent(), [3, 1];
        case 3:
          s = o.createElement("iframe"), l.label = 4;
        case 4:
          return l.trys.push([4, , 10, 11]), [4, new Promise(function(u, d) {
            var f = !1, p = function() {
              f = !0, u();
            }, h = function(w) {
              f = !0, d(w);
            };
            s.onload = p, s.onerror = h;
            var y = s.style;
            y.setProperty("display", "block", "important"), y.position = "absolute", y.top = "0", y.left = "0", y.visibility = "hidden", t && "srcdoc" in s ? s.srcdoc = t : s.src = "about:blank", o.body.appendChild(s);
            var g = function() {
              var w, m;
              f || (((m = (w = s.contentWindow) === null || w === void 0 ? void 0 : w.document) === null || m === void 0 ? void 0 : m.readyState) === "complete" ? p() : setTimeout(g, 10));
            };
            g();
          })];
        case 5:
          l.sent(), l.label = 6;
        case 6:
          return !((a = (r = s.contentWindow) === null || r === void 0 ? void 0 : r.document) === null || a === void 0) && a.body ? [3, 8] : [4, el(n)];
        case 7:
          return l.sent(), [3, 6];
        case 8:
          return [4, e(s, s.contentWindow)];
        case 9:
          return [2, l.sent()];
        case 10:
          return (i = s.parentNode) === null || i === void 0 || i.removeChild(s), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function VS(e) {
  for (var t = pS(e), n = t[0], r = t[1], a = document.createElement(n ?? "div"), i = 0, o = Object.keys(r); i < o.length; i++) {
    var s = o[i], l = r[s].join(" ");
    s === "style" ? BS(a.style, l) : a.setAttribute(s, l);
  }
  return a;
}
function BS(e, t) {
  for (var n = 0, r = t.split(";"); n < r.length; n++) {
    var a = r[n], i = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(a);
    if (i) {
      var o = i[1], s = i[2], l = i[4];
      e.setProperty(o, s, l || "");
    }
  }
}
function jS() {
  for (var e = window; ; ) {
    var t = e.parent;
    if (!t || t === e)
      return !1;
    try {
      if (t.location.origin !== e.location.origin)
        return !0;
    } catch (n) {
      if (n instanceof Error && n.name === "SecurityError")
        return !0;
      throw n;
    }
    e = t;
  }
}
var WS = "mmMwWLliI0O&1", HS = "48px", pa = ["monospace", "sans-serif", "serif"], Hp = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function US() {
  var e = this;
  return yv(function(t, n) {
    var r = n.document;
    return Dn(e, void 0, void 0, function() {
      var a, i, o, s, l, u, d, f, p, h, y, g;
      return Nn(this, function(w) {
        for (a = r.body, a.style.fontSize = HS, i = r.createElement("div"), i.style.setProperty("visibility", "hidden", "important"), o = {}, s = {}, l = function(m) {
          var v = r.createElement("span"), C = v.style;
          return C.position = "absolute", C.top = "0", C.left = "0", C.fontFamily = m, v.textContent = WS, i.appendChild(v), v;
        }, u = function(m, v) {
          return l("'".concat(m, "',").concat(v));
        }, d = function() {
          return pa.map(l);
        }, f = function() {
          for (var m = {}, v = function(x) {
            m[x] = pa.map(function(E) {
              return u(x, E);
            });
          }, C = 0, S = Hp; C < S.length; C++) {
            var b = S[C];
            v(b);
          }
          return m;
        }, p = function(m) {
          return pa.some(function(v, C) {
            return m[C].offsetWidth !== o[v] || m[C].offsetHeight !== s[v];
          });
        }, h = d(), y = f(), a.appendChild(i), g = 0; g < pa.length; g++)
          o[pa[g]] = h[g].offsetWidth, s[pa[g]] = h[g].offsetHeight;
        return [2, Hp.filter(function(m) {
          return p(y[m]);
        })];
      });
    });
  });
}
function qS() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], n = 0; n < e.length; ++n) {
      var r = e[n];
      if (r) {
        for (var a = [], i = 0; i < r.length; ++i) {
          var o = r[i];
          a.push({
            type: o.type,
            suffixes: o.suffixes
          });
        }
        t.push({
          name: r.name,
          description: r.description,
          mimeTypes: a
        });
      }
    }
    return t;
  }
}
function GS() {
  return KS(eC());
}
function KS(e) {
  var t, n = !1, r, a, i = ZS(), o = i[0], s = i[1];
  return YS(o, s) ? (n = XS(s), e ? r = a = "skipped" : (t = JS(o, s), r = t[0], a = t[1])) : r = a = "unsupported", { winding: n, geometry: r, text: a };
}
function ZS() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function YS(e, t) {
  return !!(t && e.toDataURL);
}
function XS(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function JS(e, t) {
  QS(e, t);
  var n = Mu(e), r = Mu(e);
  if (n !== r)
    return [
      "unstable",
      "unstable"
      /* ImageStatus.Unstable */
    ];
  $S(e, t);
  var a = Mu(e);
  return [a, n];
}
function QS(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var n = "Cwm fjordbank gly ".concat(
    "😃"
    /* 😃 */
  );
  t.fillText(n, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(n, 4, 45);
}
function $S(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var n = 0, r = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; n < r.length; n++) {
    var a = r[n], i = a[0], o = a[1], s = a[2];
    t.fillStyle = i, t.beginPath(), t.arc(o, s, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function Mu(e) {
  return e.toDataURL();
}
function eC() {
  return vn() && is() && as();
}
function tC() {
  var e = navigator, t = 0, n;
  e.maxTouchPoints !== void 0 ? t = Pd(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), n = !0;
  } catch {
    n = !1;
  }
  var r = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: n,
    touchStart: r
  };
}
function nC() {
  return navigator.oscpu;
}
function rC() {
  var e = navigator, t = [], n = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (n !== void 0 && t.push([n]), Array.isArray(e.languages))
    rs() && ES() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var r = e.languages;
    r && t.push(r.split(","));
  }
  return t;
}
function aC() {
  return window.screen.colorDepth;
}
function iC() {
  return Un(sn(navigator.deviceMemory), void 0);
}
function oC() {
  if (!(vn() && is() && as()))
    return sC();
}
function sC() {
  var e = screen, t = function(r) {
    return Un(Pd(r), null);
  }, n = [t(e.width), t(e.height)];
  return n.sort().reverse(), n;
}
var lC = 2500, uC = 10, Is, Iu;
function cC() {
  if (Iu === void 0) {
    var e = function() {
      var t = _c();
      xc(t) ? Iu = setTimeout(e, lC) : (Is = t, Iu = void 0);
    };
    e();
  }
}
function dC() {
  var e = this;
  return cC(), function() {
    return Dn(e, void 0, void 0, function() {
      var t;
      return Nn(this, function(n) {
        switch (n.label) {
          case 0:
            return t = _c(), xc(t) ? Is ? [2, uv([], Is, !0)] : MS() ? [4, IS()] : [3, 2] : [3, 2];
          case 1:
            n.sent(), t = _c(), n.label = 2;
          case 2:
            return xc(t) || (Is = t), [2, t];
        }
      });
    });
  };
}
function fC() {
  var e = this;
  if (vn() && is() && as())
    return function() {
      return Promise.resolve(void 0);
    };
  var t = dC();
  return function() {
    return Dn(e, void 0, void 0, function() {
      var n, r;
      return Nn(this, function(a) {
        switch (a.label) {
          case 0:
            return [4, t()];
          case 1:
            return n = a.sent(), r = function(i) {
              return i === null ? null : fv(i, uC);
            }, [2, [r(n[0]), r(n[1]), r(n[2]), r(n[3])]];
        }
      });
    });
  };
}
function _c() {
  var e = screen;
  return [
    Un(sn(e.availTop), null),
    Un(sn(e.width) - sn(e.availWidth) - Un(sn(e.availLeft), 0), null),
    Un(sn(e.height) - sn(e.availHeight) - Un(sn(e.availTop), 0), null),
    Un(sn(e.availLeft), null)
  ];
}
function xc(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function pC() {
  return Un(Pd(navigator.hardwareConcurrency), void 0);
}
function hC() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var n = new t().resolvedOptions().timeZone;
    if (n)
      return n;
  }
  var r = -yC();
  return "UTC".concat(r >= 0 ? "+" : "").concat(r);
}
function yC() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    sn(new Date(e, 0, 1).getTimezoneOffset()),
    sn(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function gC() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function vC() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function mC() {
  if (!(pv() || CS()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function wC() {
  return !!window.openDatabase;
}
function bC() {
  return navigator.cpuClass;
}
function _C() {
  var e = navigator.platform;
  return e === "MacIntel" && vn() && !Md() ? PS() ? "iPad" : "iPhone" : e;
}
function xC() {
  return navigator.vendor || "";
}
function kC() {
  for (var e = [], t = 0, n = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < n.length; t++) {
    var r = n[t], a = window[r];
    a && typeof a == "object" && e.push(r);
  }
  return e.sort();
}
function SC() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function CC() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function EC(e) {
  var t = e === void 0 ? {} : e, n = t.debug;
  return Dn(this, void 0, void 0, function() {
    var r, a, i, o, s, l;
    return Nn(this, function(u) {
      switch (u.label) {
        case 0:
          return TC() ? (r = CC(), a = Object.keys(r), i = (l = []).concat.apply(l, a.map(function(d) {
            return r[d];
          })), [4, AC(i)]) : [2, void 0];
        case 1:
          return o = u.sent(), n && PC(r, o), s = a.filter(function(d) {
            var f = r[d], p = Ht(f.map(function(h) {
              return o[h];
            }));
            return p > f.length * 0.6;
          }), s.sort(), [2, s];
      }
    });
  });
}
function TC() {
  return vn() || Id();
}
function AC(e) {
  var t;
  return Dn(this, void 0, void 0, function() {
    var n, r, a, i, l, o, s, l;
    return Nn(this, function(u) {
      switch (u.label) {
        case 0:
          for (n = document, r = n.createElement("div"), a = new Array(e.length), i = {}, Up(r), l = 0; l < e.length; ++l)
            o = VS(e[l]), o.tagName === "DIALOG" && o.show(), s = n.createElement("div"), Up(s), s.appendChild(o), r.appendChild(s), a[l] = o;
          u.label = 1;
        case 1:
          return n.body ? [3, 3] : [4, el(50)];
        case 2:
          return u.sent(), [3, 1];
        case 3:
          n.body.appendChild(r);
          try {
            for (l = 0; l < e.length; ++l)
              a[l].offsetParent || (i[e[l]] = !0);
          } finally {
            (t = r.parentNode) === null || t === void 0 || t.removeChild(r);
          }
          return [2, i];
      }
    });
  });
}
function Up(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function PC(e, t) {
  for (var n = "DOM blockers debug:\n```", r = 0, a = Object.keys(e); r < a.length; r++) {
    var i = a[r];
    n += `
`.concat(i, ":");
    for (var o = 0, s = e[i]; o < s.length; o++) {
      var l = s[o];
      n += `
  `.concat(t[l] ? "🚫" : "➡️", " ").concat(l);
    }
  }
  console.log("".concat(n, "\n```"));
}
function MC() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var n = t[e];
    if (matchMedia("(color-gamut: ".concat(n, ")")).matches)
      return n;
  }
}
function IC() {
  if (qp("inverted"))
    return !0;
  if (qp("none"))
    return !1;
}
function qp(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function OC() {
  if (Gp("active"))
    return !0;
  if (Gp("none"))
    return !1;
}
function Gp(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var FC = 100;
function RC() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= FC; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function LC() {
  if (ha("no-preference"))
    return 0;
  if (ha("high") || ha("more"))
    return 1;
  if (ha("low") || ha("less"))
    return -1;
  if (ha("forced"))
    return 10;
}
function ha(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function DC() {
  if (Kp("reduce"))
    return !0;
  if (Kp("no-preference"))
    return !1;
}
function Kp(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function NC() {
  if (Zp("reduce"))
    return !0;
  if (Zp("no-preference"))
    return !1;
}
function Zp(e) {
  return matchMedia("(prefers-reduced-transparency: ".concat(e, ")")).matches;
}
function zC() {
  if (Yp("high"))
    return !0;
  if (Yp("standard"))
    return !1;
}
function Yp(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var nt = Math, Vt = function() {
  return 0;
};
function VC() {
  var e = nt.acos || Vt, t = nt.acosh || Vt, n = nt.asin || Vt, r = nt.asinh || Vt, a = nt.atanh || Vt, i = nt.atan || Vt, o = nt.sin || Vt, s = nt.sinh || Vt, l = nt.cos || Vt, u = nt.cosh || Vt, d = nt.tan || Vt, f = nt.tanh || Vt, p = nt.exp || Vt, h = nt.expm1 || Vt, y = nt.log1p || Vt, g = function(k) {
    return nt.pow(nt.PI, k);
  }, w = function(k) {
    return nt.log(k + nt.sqrt(k * k - 1));
  }, m = function(k) {
    return nt.log(k + nt.sqrt(k * k + 1));
  }, v = function(k) {
    return nt.log((1 + k) / (1 - k)) / 2;
  }, C = function(k) {
    return nt.exp(k) - 1 / nt.exp(k) / 2;
  }, S = function(k) {
    return (nt.exp(k) + 1 / nt.exp(k)) / 2;
  }, b = function(k) {
    return nt.exp(k) - 1;
  }, x = function(k) {
    return (nt.exp(2 * k) - 1) / (nt.exp(2 * k) + 1);
  }, E = function(k) {
    return nt.log(1 + k);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: w(1e154),
    asin: n(0.12312423423423424),
    asinh: r(1),
    asinhPf: m(1),
    atanh: a(0.5),
    atanhPf: v(0.5),
    atan: i(0.5),
    sin: o(-1e300),
    sinh: s(1),
    sinhPf: C(1),
    cos: l(10.000000000123),
    cosh: u(1),
    coshPf: S(1),
    tan: d(-1e300),
    tanh: f(1),
    tanhPf: x(1),
    exp: p(1),
    expm1: h(1),
    expm1Pf: b(1),
    log1p: y(10),
    log1pPf: E(10),
    powPI: g(-100)
  };
}
var BC = "mmMwWLliI0fiflO&1", Ou = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function jC() {
  return WC(function(e, t) {
    for (var n = {}, r = {}, a = 0, i = Object.keys(Ou); a < i.length; a++) {
      var o = i[a], s = Ou[o], l = s[0], u = l === void 0 ? {} : l, d = s[1], f = d === void 0 ? BC : d, p = e.createElement("span");
      p.textContent = f, p.style.whiteSpace = "nowrap";
      for (var h = 0, y = Object.keys(u); h < y.length; h++) {
        var g = y[h], w = u[g];
        w !== void 0 && (p.style[g] = w);
      }
      n[o] = p, t.append(e.createElement("br"), p);
    }
    for (var m = 0, v = Object.keys(Ou); m < v.length; m++) {
      var o = v[m];
      r[o] = n[o].getBoundingClientRect().width;
    }
    return r;
  });
}
function WC(e, t) {
  return t === void 0 && (t = 4e3), yv(function(n, r) {
    var a = r.document, i = a.body, o = i.style;
    o.width = "".concat(t, "px"), o.webkitTextSizeAdjust = o.textSizeAdjust = "none", rs() ? i.style.zoom = "".concat(1 / r.devicePixelRatio) : vn() && (i.style.zoom = "reset");
    var s = a.createElement("div");
    return s.textContent = uv([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), i.appendChild(s), e(a, i);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function HC() {
  return navigator.pdfViewerEnabled;
}
function UC() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
function qC() {
  var e = window.ApplePaySession;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return -1;
  if (GC())
    return -3;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (t) {
    return KC(t);
  }
}
var GC = jS;
function KC(e) {
  if (e instanceof Error && e.name === "InvalidAccessError" && /\bfrom\b.*\binsecure\b/i.test(e.message))
    return -2;
  throw e;
}
function ZC() {
  var e, t = document.createElement("a"), n = (e = t.attributionSourceId) !== null && e !== void 0 ? e : t.attributionsourceid;
  return n === void 0 ? void 0 : String(n);
}
var gv = -1, vv = -2, YC = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
  // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
  // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]), XC = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
  // MAX_VIEWS_OVR
]), JC = ["FRAGMENT_SHADER", "VERTEX_SHADER"], QC = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], mv = "WEBGL_debug_renderer_info", $C = "WEBGL_polygon_mode";
function eE(e) {
  var t, n, r, a, i, o, s = e.cache, l = wv(s);
  if (!l)
    return gv;
  if (!_v(l))
    return vv;
  var u = bv() ? null : l.getExtension(mv);
  return {
    version: ((t = l.getParameter(l.VERSION)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendor: ((n = l.getParameter(l.VENDOR)) === null || n === void 0 ? void 0 : n.toString()) || "",
    vendorUnmasked: u ? (r = l.getParameter(u.UNMASKED_VENDOR_WEBGL)) === null || r === void 0 ? void 0 : r.toString() : "",
    renderer: ((a = l.getParameter(l.RENDERER)) === null || a === void 0 ? void 0 : a.toString()) || "",
    rendererUnmasked: u ? (i = l.getParameter(u.UNMASKED_RENDERER_WEBGL)) === null || i === void 0 ? void 0 : i.toString() : "",
    shadingLanguageVersion: ((o = l.getParameter(l.SHADING_LANGUAGE_VERSION)) === null || o === void 0 ? void 0 : o.toString()) || ""
  };
}
function tE(e) {
  var t = e.cache, n = wv(t);
  if (!n)
    return gv;
  if (!_v(n))
    return vv;
  var r = n.getSupportedExtensions(), a = n.getContextAttributes(), i = [], o = [], s = [], l = [], u = [];
  if (a)
    for (var d = 0, f = Object.keys(a); d < f.length; d++) {
      var p = f[d];
      o.push("".concat(p, "=").concat(a[p]));
    }
  for (var h = Xp(n), y = 0, g = h; y < g.length; y++) {
    var w = g[y], m = n[w];
    s.push("".concat(w, "=").concat(m).concat(YC.has(m) ? "=".concat(n.getParameter(m)) : ""));
  }
  if (r)
    for (var v = 0, C = r; v < C.length; v++) {
      var S = C[v];
      if (!(S === mv && bv() || S === $C && aE())) {
        var b = n.getExtension(S);
        if (!b) {
          i.push(S);
          continue;
        }
        for (var x = 0, E = Xp(b); x < E.length; x++) {
          var w = E[x], m = b[w];
          l.push("".concat(w, "=").concat(m).concat(XC.has(m) ? "=".concat(n.getParameter(m)) : ""));
        }
      }
    }
  for (var k = 0, I = JC; k < I.length; k++)
    for (var D = I[k], A = 0, M = QC; A < M.length; A++) {
      var N = M[A], P = nE(n, D, N);
      u.push("".concat(D, ".").concat(N, "=").concat(P.join(",")));
    }
  return l.sort(), s.sort(), {
    contextAttributes: o,
    parameters: s,
    shaderPrecisions: u,
    extensions: r,
    extensionParameters: l,
    unsupportedExtensions: i
  };
}
function wv(e) {
  if (e.webgl)
    return e.webgl.context;
  var t = document.createElement("canvas"), n;
  t.addEventListener("webglCreateContextError", function() {
    return n = void 0;
  });
  for (var r = 0, a = ["webgl", "experimental-webgl"]; r < a.length; r++) {
    var i = a[r];
    try {
      n = t.getContext(i);
    } catch {
    }
    if (n)
      break;
  }
  return e.webgl = { context: n }, n;
}
function nE(e, t, n) {
  var r = e.getShaderPrecisionFormat(e[t], e[n]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
function Xp(e) {
  var t = Object.keys(e.__proto__);
  return t.filter(rE);
}
function rE(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function bv() {
  return hv();
}
function aE() {
  return rs() || vn();
}
function _v(e) {
  return typeof e.getParameter == "function";
}
function iE() {
  var e, t = Id() || vn();
  return t ? window.AudioContext && (e = new AudioContext().baseLatency) !== null && e !== void 0 ? e : -1 : -2;
}
var oE = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: US,
  domBlockers: EC,
  fontPreferences: jC,
  audio: FS,
  screenFrame: fC,
  canvas: GS,
  osCpu: nC,
  languages: rC,
  colorDepth: aC,
  deviceMemory: iC,
  screenResolution: oC,
  hardwareConcurrency: pC,
  timezone: hC,
  sessionStorage: gC,
  localStorage: vC,
  indexedDB: mC,
  openDatabase: wC,
  cpuClass: bC,
  platform: _C,
  plugins: qS,
  touchSupport: tC,
  vendor: xC,
  vendorFlavors: kC,
  cookiesEnabled: SC,
  colorGamut: MC,
  invertedColors: IC,
  forcedColors: OC,
  monochrome: RC,
  contrast: LC,
  reducedMotion: DC,
  reducedTransparency: NC,
  hdr: zC,
  math: VC,
  pdfViewerEnabled: HC,
  architecture: UC,
  applePay: qC,
  privateClickMeasurement: ZC,
  audioBaseLatency: iE,
  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: eE,
  webGlExtensions: tE
};
function sE(e) {
  return SS(oE, e, []);
}
var lE = "$ if upgrade to Pro: https://fpjs.dev/pro";
function uE(e) {
  var t = cE(e), n = dE(t);
  return { score: t, comment: lE.replace(/\$/g, "".concat(n)) };
}
function cE(e) {
  if (Id())
    return 0.4;
  if (vn())
    return Md() && !(is() && as()) ? 0.5 : 0.3;
  var t = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function dE(e) {
  return fv(0.99 + 0.01 * e, 1e-4);
}
function fE(e) {
  for (var t = "", n = 0, r = Object.keys(e).sort(); n < r.length; n++) {
    var a = r[n], i = e[a], o = "error" in i ? "error" : JSON.stringify(i.value);
    t += "".concat(t ? "|" : "").concat(a.replace(/([:|\\])/g, "\\$1"), ":").concat(o);
  }
  return t;
}
function xv(e) {
  return JSON.stringify(e, function(t, n) {
    return n instanceof Error ? bS(n) : n;
  }, 2);
}
function kv(e) {
  return wS(fE(e));
}
function pE(e) {
  var t, n = uE(e);
  return {
    get visitorId() {
      return t === void 0 && (t = kv(this.components)), t;
    },
    set visitorId(r) {
      t = r;
    },
    confidence: n,
    components: e,
    version: cv
  };
}
function hE(e) {
  return e === void 0 && (e = 50), cS(e, e * 2);
}
function yE(e, t) {
  var n = Date.now();
  return {
    get: function(r) {
      return Dn(this, void 0, void 0, function() {
        var a, i, o;
        return Nn(this, function(s) {
          switch (s.label) {
            case 0:
              return a = Date.now(), [4, e()];
            case 1:
              return i = s.sent(), o = pE(i), (t || r != null && r.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(o.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(a - n, `
visitorId: `).concat(o.visitorId, `
components: `).concat(xv(i), "\n```")), [2, o];
          }
        });
      });
    }
  };
}
function gE() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(cv, "/npm-monitoring"), !0), e.send();
    } catch (t) {
      console.error(t);
    }
}
function vE(e) {
  var t;
  return e === void 0 && (e = {}), Dn(this, void 0, void 0, function() {
    var n, r, a;
    return Nn(this, function(i) {
      switch (i.label) {
        case 0:
          return (!((t = e.monitoring) !== null && t !== void 0) || t) && gE(), n = e.delayFallback, r = e.debug, [4, hE(n)];
        case 1:
          return i.sent(), a = sE({ cache: {}, debug: r }), [2, yE(a, r)];
      }
    });
  });
}
var mE = { load: vE, hashComponents: kv, componentsToDebugString: xv };
const wE = () => {
  let e = !1;
  const t = /* @__PURE__ */ new Map(), n = (l, u) => {
    var d;
    return t.has(l) || t.set(l, /* @__PURE__ */ new Set()), (d = t.get(l)) == null || d.add(u), () => r(l, u);
  }, r = (l, u) => {
    var d;
    (d = t.get(l)) == null || d.delete(u);
  }, a = (l) => {
    var u;
    (u = t.get(l)) == null || u.forEach((d) => d());
  };
  async function i(l, u, d, f) {
    var p, h;
    try {
      if (document.getElementById("layup-app") || e)
        return;
      e = !0;
      const y = (p = u.platform_user_data) == null ? void 0 : p.user_id;
      if (!y || typeof y != "string" || y.trim() === "") {
        const v = await mE.load(), { visitorId: C } = await v.get();
        u.platform_user_data = {
          user_id: C,
          ...u.platform_user_data
        };
      } else
        u.platform_user_data = { user_id: y, ...u.platform_user_data };
      X.config.api_host = u.guidance_endpoint, X.internal_config.api_key = l, X.config.group_id = u.group_id, X.config.platform_user_data = u.platform_user_data, X.config.variant = u.variant || "sidebar", X.config.show_widget = u.show_widget || !1, f && (X.config.onClose = f), d && (X.config.onInit = d);
      const g = document.createElement("layup-widget");
      g.id = "layup-app", u.mountElement ? u.mountElement.appendChild(g) : document.body.appendChild(g);
      const w = (v) => {
        v === "system" ? (localStorage.setItem("layup-widget-theme", v), X.config.theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", g.setAttribute("data-layup-mode", X.config.theme)) : (g.setAttribute("data-layup-mode", v), localStorage.setItem("layup-widget-theme", v), X.config.theme = v);
      }, m = ((h = u == null ? void 0 : u.theme) == null ? void 0 : h.mode) || "light";
      return w(m || "light"), X.config = {
        ...X.config,
        ...u,
        theme: {
          ...X.config.theme,
          ...u.theme,
          mode: m
        }
      }, Mc(lS, { target: g }), a("init"), !0;
    } catch (y) {
      return console.warn("[Layup] Error during initialization:", y), !1;
    }
  }
  return {
    getConfig() {
      return X.config;
    },
    init: i,
    setConfig: (l) => {
      var f, p, h, y, g, w, m, v, C, S, b, x, E, k, I;
      l.URLpath && (X.config.URLpath = l.URLpath), l.group_id && (X.config.group_id = l.group_id), l.guidance_endpoint && (X.config.api_host = l.guidance_endpoint), l.platform_user_data && (X.config.platform_user_data = {
        ...X.config.platform_user_data,
        ...l.platform_user_data
      }), l.variant && (X.config.variant = l.variant), l.show_widget && (X.config.show_widget = l.show_widget);
      let u = !1;
      ((f = X.config.theme) == null ? void 0 : f.mode) !== ((p = l.theme) == null ? void 0 : p.mode) && (u = !0, X.config.theme = {
        ...X.config.theme,
        mode: (h = l.theme) == null ? void 0 : h.mode
      });
      const d = {
        ...X.config.theme,
        colors: {
          ...(y = l == null ? void 0 : l.theme) == null ? void 0 : y.colors,
          dark_mode: {
            ...(w = (g = l == null ? void 0 : l.theme) == null ? void 0 : g.colors) == null ? void 0 : w.dark_mode,
            ...(C = (v = (m = X.config) == null ? void 0 : m.theme) == null ? void 0 : v.colors) == null ? void 0 : C.dark_mode
          },
          light_mode: {
            ...(b = (S = l == null ? void 0 : l.theme) == null ? void 0 : S.colors) == null ? void 0 : b.light_mode,
            ...(k = (E = (x = X.config) == null ? void 0 : x.theme) == null ? void 0 : E.colors) == null ? void 0 : k.light_mode
          }
        }
      };
      if (X.config.theme = d, u) {
        const D = document.getElementById("layup-app"), A = (M) => {
          var P, Y, G;
          if (!D || !M || M === "system")
            return;
          D.setAttribute("data-layup-mode", M), localStorage.setItem("layup-widget-theme", M);
          const N = (G = (Y = (P = X == null ? void 0 : X.config) == null ? void 0 : P.theme) == null ? void 0 : Y.colors) == null ? void 0 : G[`${M}_mode`];
          X.config.styles = ks(X.config.theme, N), Ss(X.config.theme, N);
        };
        if (D && ((I = l.theme) != null && I.mode)) {
          const M = l.theme.mode;
          M === "light" || M === "dark" ? A(M) : window.matchMedia("(prefers-color-scheme: dark)").matches ? A("dark") : A("light");
        }
      }
    },
    on: n,
    off: r,
    destroy: () => {
      var l;
      document.getElementById("layup-app") && ((l = document.getElementById("layup-app")) == null || l.remove()), X.internal_config.api_key = void 0, X.config = {
        api_host: "https://api.layuplabs.ai",
        user_id: void 0
      }, a("destroy");
    }
  };
}, kE = wE();
export {
  kE as default
};
